// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjA5IiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgMjA5IDM2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTkyLjk5MyAyMy42NTgyVjE1LjcxMTdIMTc5LjQ1MkwxNzEuNTA1IDIzLjY1ODJIMTkyLjk5M1oiIGZpbGw9IiM5QjlCOUIiLz4KPHBhdGggZD0iTTIwOC4yNSAzLjk1MDgxSDE5MS4yNzZMMTgzLjI2NiAxMS44OTczSDIwOC4yNVYzLjk1MDgxWiIgZmlsbD0iIzlCOUI5QiIvPgo8cGF0aCBkPSJNMTYzLjYyMiAzMS42MDQ4TDE2Ny42OTEgMjcuNTM2MUgxODEuNDIzVjM1LjQ4MjdIMTYzLjYyMlYzMS42MDQ4WiIgZmlsbD0iIzlCOUI5QiIvPgo8cGF0aCBkPSJNMTY2LjYxIDE5Ljc4MDNIMTc1LjM4M0wxODMuMzkzIDExLjgzMzdIMTY2LjYxVjE5Ljc4MDNaIiBmaWxsPSIjOUI5QjlCIi8+CjxwYXRoIGQ9Ik0xNTcuMDExIDMxLjYwNDdIMTYzLjYyMkwxNzEuNTA1IDIzLjY1ODJIMTU3LjAxMVYzMS42MDQ3WiIgZmlsbD0iIzlCOUI5QiIvPgo8cGF0aCBkPSJNMTkxLjI3NiAzLjk1MDgxTDE4Ny4yMDggOC4wMTk0MUgxNjEuMjdWMC4wNzI4NzZIMTkxLjI3NlYzLjk1MDgxWiIgZmlsbD0iIzlCOUI5QiIvPgo8cGF0aCBkPSJNMjAuODM5MSAzMC4yMDYxSDguMzc4OTJMNi4yMTc0NSAzNS41NDYySDAuNzUwMjQ0TDEyLjI1NjggOC41OTE1NUgxNy4wMjQ3TDI4LjUzMTMgMzUuNTQ2MkgyMy4wMDA1TDIwLjgzOTEgMzAuMjA2MVpNMTkuMTIyNyAyNS45NDY4TDE0LjYwOSAxNC45NDg4TDEwLjA5NTQgMjUuOTQ2OEgxOS4xMjI3WiIgZmlsbD0iIzlCOUI5QiIvPgo8cGF0aCBkPSJNMTA0LjQzNyAxOC41MDg5QzEwNi4wMjYgMTYuMTU2NyAxMTAuMDMxIDE1LjkwMjQgMTExLjY4NCAxNS45MDI0VjIwLjQ3OTZDMTA5LjY1IDIwLjQ3OTYgMTA3LjYxNSAyMC41NDMyIDEwNi40MDcgMjEuNDMzMkMxMDUuMiAyMi4zMjMyIDEwNC41NjQgMjMuNTMxMSAxMDQuNTY0IDI0Ljk5MzJWMzUuNTQ2Mkg5OS42MDUxVjE1LjkwMjRIMTA0LjM3M0wxMDQuNDM3IDE4LjUwODlaIiBmaWxsPSIjOUI5QjlCIi8+CjxwYXRoIGQ9Ik0xMTkuMzc2IDE1LjkwMjRIMTE0LjQxOFYzNS41NDYySDExOS4zNzZWMTUuOTAyNFoiIGZpbGw9IiM5QjlCOUIiLz4KPHBhdGggZD0iTTExOS4zNzYgNy4xMjkzOUgxMTQuNDE4VjEyLjk3OEgxMTkuMzc2VjcuMTI5MzlaIiBmaWxsPSIjOUI5QjlCIi8+CjxwYXRoIGQ9Ik0xNDMuOTc5IDcuMTI5MzlWMzUuNTQ2MkgxMzkuMjExTDEzOS4wODQgMzIuNTU4M0MxMzguMzg0IDMzLjU3NTUgMTM3LjQ5NCAzNC40MDE5IDEzNi40MTQgMzUuMDM3NkMxMzUuMzMzIDM1LjYwOTggMTMzLjk5OCAzNS45Mjc2IDEzMi40NzIgMzUuOTI3NkMxMzEuMTM3IDM1LjkyNzYgMTI5Ljg2NiAzNS42NzMzIDEyOC43ODUgMzUuMjI4M0MxMjcuNjQxIDM0LjcxOTcgMTI2LjYyMyAzNC4wODQgMTI1Ljc5NyAzMy4xOTRDMTI0Ljk3MSAzMi4zMDQgMTI0LjI3MSAzMS4yMjMzIDEyMy44MjYgMzAuMDE1NEMxMjMuMzE4IDI4LjgwNzUgMTIzLjEyNyAyNy40MDkgMTIzLjEyNyAyNS44ODMyQzEyMy4xMjcgMjQuMzU3NSAxMjMuMzgxIDIyLjk1ODkgMTIzLjgyNiAyMS42ODc0QzEyNC4zMzUgMjAuNDE2IDEyNC45NzEgMTkuMzM1MyAxMjUuNzk3IDE4LjQ0NTNDMTI2LjYyMyAxNy41NTUyIDEyNy42NDEgMTYuODU2IDEyOC43ODUgMTYuMzQ3NEMxMjkuOTI5IDE1LjgzODggMTMxLjEzNyAxNS41ODQ1IDEzMi40NzIgMTUuNTg0NUMxMzMuOTk4IDE1LjU4NDUgMTM1LjI2OSAxNS44Mzg4IDEzNi4zNSAxNi40MTA5QzEzNy40MzEgMTYuOTgzMSAxMzguMzIxIDE3Ljc0NTkgMTM5LjAyIDE4LjgyNjdWNy4xOTI5NUgxNDMuOTc5VjcuMTI5MzlaTTEzMy41NTMgMzEuNjY4M0MxMzUuMjA2IDMxLjY2ODMgMTM2LjQ3NyAzMS4wOTYyIDEzNy40OTQgMzAuMDE1NEMxMzguNTExIDI4LjkzNDcgMTM5LjAyIDI3LjQ3MjUgMTM5LjAyIDI1LjY5MjVDMTM5LjAyIDIzLjkxMjUgMTM4LjUxMSAyMi41MTM5IDEzNy40OTQgMjEuMzY5NkMxMzYuNDc3IDIwLjI4ODggMTM1LjIwNiAxOS43MTY3IDEzMy41NTMgMTkuNzE2N0MxMzEuOTYzIDE5LjcxNjcgMTMwLjYyOCAyMC4yODg4IDEyOS42NzUgMjEuMzY5NkMxMjguNjU4IDIyLjQ1MDMgMTI4LjE0OSAyMy45MTI1IDEyOC4xNDkgMjUuNjkyNUMxMjguMTQ5IDI3LjQ3MjUgMTI4LjY1OCAyOC44NzExIDEyOS42NzUgMjkuOTUxOEMxMzAuNjkyIDMxLjA5NjEgMTMxLjk2MyAzMS42NjgzIDEzMy41NTMgMzEuNjY4M1oiIGZpbGw9IiM5QjlCOUIiLz4KPHBhdGggZD0iTTU3LjIwMjQgMjAuMzUyNUg0NC45MzNWMjQuNjExOEg1MS45MjU5QzUxLjczNTIgMjYuNzczMyA1MC45MDg4IDI4LjQyNjEgNDkuNTEwMiAyOS43NjExQzQ4LjExMTYgMzEuMDMyNiA0Ni4zMzE1IDMxLjY2ODMgNDQuMDQyOSAzMS42NjgzQzQyLjc3MTUgMzEuNjY4MyA0MS41NjM2IDMxLjQxNCA0MC41NDY1IDMwLjk2OUMzOS40NjU3IDMwLjUyNCAzOC41NzU3IDI5Ljg4ODMgMzcuODEyOSAyOC45OTgzQzM3LjA1IDI4LjE3MTggMzYuNDc3OCAyNy4xNTQ3IDM2LjAzMjggMjUuOTQ2OEMzNS41ODc4IDI0LjczODkgMzUuMzk3MSAyMy40Njc1IDM1LjM5NzEgMjIuMDA1M0MzNS4zOTcxIDIwLjU0MzIgMzUuNTg3OCAxOS4yNzE3IDM2LjAzMjggMTguMDYzOEMzNi40MTQzIDE2Ljg1NiAzNy4wNSAxNS45MDI0IDM3LjgxMjkgMTUuMDEyNEMzOC41NzU3IDE0LjE4NTkgMzkuNDY1NyAxMy41NTAyIDQwLjU0NjUgMTMuMDQxNkM0MS42MjcyIDEyLjU5NjYgNDIuNzcxNSAxMi4zNDIzIDQ0LjEwNjUgMTIuMzQyM0M0Ni43NzY2IDEyLjM0MjMgNDguODEwOSAxMi45NzggNTAuMjA5NSAxNC4yNDk1TDUzLjUxNTIgMTAuOTQzOEM1MS4wMzU5IDkuMDM2NTkgNDcuODU3MyA4LjAxOTQxIDQ0LjEwNjUgOC4wMTk0MUM0Mi4wMDg2IDguMDE5NDEgNDAuMTAxNSA4LjMzNzI5IDM4LjM4NSA5LjAzNjU5QzM2LjY2ODYgOS43MzU4OCAzNS4yMDY0IDEwLjYyNTkgMzMuOTk4NSAxMS44MzM3QzMyLjc5MDYgMTMuMDQxNiAzMS44MzcxIDE0LjUwMzggMzEuMjAxNCAxNi4yMjAzQzMwLjU2NTYgMTcuOTM2NyAzMC4yNDc4IDE5Ljg0MzggMzAuMjQ3OCAyMS44NzgyQzMwLjI0NzggMjMuOTEyNSAzMC41NjU2IDI1LjgxOTcgMzEuMjY0OSAyNy41MzYxQzMxLjk2NDIgMjkuMjUyNiAzMi44NTQyIDMwLjcxNDcgMzQuMDYyMSAzMS45MjI2QzM1LjI3IDMzLjEzMDUgMzYuNzMyMSAzNC4wODQxIDM4LjQ0ODYgMzQuNzE5OEM0MC4xNjUgMzUuNDE5MSA0Mi4wNzIyIDM1LjczNyA0NC4xMDY1IDM1LjczN0M0Ni4xNDA4IDM1LjczNyA0Ny45ODQ0IDM1LjQxOTEgNDkuNjM3MyAzNC43MTk4QzUxLjI5MDIgMzQuMDIwNSA1Mi42ODg4IDMzLjEzMDUgNTMuODMzMSAzMS45MjI2QzU0Ljk3NzQgMzAuNzE0NyA1NS44Njc0IDI5LjI1MjYgNTYuNTAzMSAyNy41MzYxQzU3LjEzODggMjUuODE5NyA1Ny40NTY3IDIzLjkxMjUgNTcuNDU2NyAyMS44NzgyVjIxLjA1MTdDNTcuMjY2IDIwLjkyNDYgNTcuMjAyNCAyMC42MDY3IDU3LjIwMjQgMjAuMzUyNVoiIGZpbGw9IiM5QjlCOUIiLz4KPHBhdGggZD0iTTk1Ljk4MTUgMjAuMzUyNUg4My43MTIxVjI0LjYxMThIOTAuNzA1QzkwLjUxNDMgMjYuNzczMyA4OS42ODc5IDI4LjQyNjEgODguMjg5MyAyOS43NjExQzg2Ljg5MDcgMzEuMDMyNiA4NS4xMTA2IDMxLjY2ODMgODIuODIyIDMxLjY2ODNDODEuNTUwNiAzMS42NjgzIDgwLjM0MjcgMzEuNDE0IDc5LjMyNTYgMzAuOTY5Qzc4LjI0NDggMzAuNTI0IDc3LjM1NDggMjkuODg4MyA3Ni41OTIgMjguOTk4M0M3NS44MjkxIDI4LjE3MTggNzUuMjU3IDI3LjE1NDcgNzQuODExOSAyNS45NDY4Qzc0LjM2NjkgMjQuNzM4OSA3NC4xNzYyIDIzLjQ2NzUgNzQuMTc2MiAyMi4wMDUzQzc0LjE3NjIgMjAuNTQzMiA3NC4zNjY5IDE5LjI3MTcgNzQuODExOSAxOC4wNjM4Qzc1LjE5MzQgMTYuODU2IDc1LjgyOTEgMTUuOTAyNCA3Ni41OTIgMTUuMDEyNEM3Ny4zNTQ4IDE0LjE4NTkgNzguMjQ0OCAxMy41NTAyIDc5LjMyNTYgMTMuMDQxNkM4MC40MDYzIDEyLjU5NjYgODEuNTUwNiAxMi4zNDIzIDgyLjg4NTYgMTIuMzQyM0M4NS41NTU3IDEyLjM0MjMgODcuNTkgMTIuOTc4IDg4Ljk4ODYgMTQuMjQ5NUw5Mi4yOTQzIDEwLjk0MzhDODkuODE1IDkuMDM2NTkgODYuNjM2NCA4LjAxOTQxIDgyLjg4NTYgOC4wMTk0MUM4MC43ODc4IDguMDE5NDEgNzguODgwNiA4LjMzNzI5IDc3LjE2NDEgOS4wMzY1OUM3NS40NDc3IDkuNzM1ODggNzMuOTg1NSAxMC42MjU5IDcyLjc3NzYgMTEuODMzN0M3MS41Njk4IDEzLjA0MTYgNzAuNjE2MiAxNC41MDM4IDY5Ljk4MDUgMTYuMjIwM0M2OS4zNDQ3IDE3LjkzNjcgNjkuMDI2OSAxOS44NDM4IDY5LjAyNjkgMjEuODc4MkM2OS4wMjY5IDIzLjkxMjUgNjkuMzQ0NyAyNS44MTk3IDcwLjA0NCAyNy41MzYxQzcwLjc0MzMgMjkuMjUyNiA3MS42MzM0IDMwLjcxNDcgNzIuODQxMiAzMS45MjI2Qzc0LjA0OTEgMzMuMTMwNSA3NS41MTEyIDM0LjA4NDEgNzcuMjI3NyAzNC43MTk4Qzc4Ljk0NDEgMzUuNDE5MSA4MC44NTEzIDM1LjczNyA4Mi44ODU2IDM1LjczN0M4NC45MiAzNS43MzcgODYuNzYzNiAzNS40MTkxIDg4LjQxNjQgMzQuNzE5OEM5MC4wNjkzIDM0LjAyMDUgOTEuNDY3OSAzMy4xMzA1IDkyLjYxMjIgMzEuOTIyNkM5My43NTY1IDMwLjcxNDcgOTQuNjQ2NSAyOS4yNTI2IDk1LjI4MjIgMjcuNTM2MUM5NS45MTggMjUuODE5NyA5Ni4yMzU4IDIzLjkxMjUgOTYuMjM1OCAyMS44NzgyVjIxLjA1MTdDOTYuMDQ1MSAyMC45MjQ2IDk1Ljk4MTUgMjAuNjA2NyA5NS45ODE1IDIwLjM1MjVaIiBmaWxsPSIjOUI5QjlCIi8+Cjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%224%22 height=%224%22><rect x=%220%22 y=%220%22 width=%224%22 height=%224%22 fill=%22%23fff%22/><path d=%22M0 0H2V4H4V2H0Z%22 fill=%22%23b2b2b2%22/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjU7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEuNTc4NCwwLDAsMS44NjQyOSwtNC40MTM0OSwtNy4yMTIxMikiPgogICAgICAgIDxwYXRoIGQ9Ik0zLjQ0NSw4LjkxMUwzLjQ0NSw3LjQwOUw5Ljc1LDcuNDA5TDkuNzUsNi4wMTRMMTIuMjg1LDguMTZMOS43NSwxMC4zMDZMOS43NSw4LjkxMUwzLjQ0NSw4LjkxMVoiIHN0eWxlPSJzdHJva2U6d2hpdGU7c3Ryb2tlLXdpZHRoOjAuNDFweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjU7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEuNTc4NCwwLDAsMS44NjQyOSwtNC40MTM0OSwtNy4yMTIxMikiPgogICAgICAgIDxwYXRoIGQ9Ik01Ljk3OSw4LjkxMUw1Ljk3OSwxMC4zMDZMMy40NDUsOC4xNkw1Ljk3OSw2LjAxNEw1Ljk3OSw3LjQwOUwxMi4yODUsNy40MDlMMTIuMjg1LDguOTExTDUuOTc5LDguOTExWiIgc3R5bGU9InN0cm9rZTp3aGl0ZTtzdHJva2Utd2lkdGg6MC40MXB4OyIvPgogICAgPC9nPgo8L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:font/woff2;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    /* Dependancy CSS Files */

    /* AG Grid */
.ag-filter-panel-buttons {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0;
  flex-wrap: wrap;
  gap: var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing);
}
.ag-filter-panel-buttons-button {
  line-height: 1.5;
}
.ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button {
  color: var(--ag-filter-panel-apply-button-color);
  background-color: var(--ag-filter-panel-apply-button-background-color);
}
.ag-filter-panel > *:where(:last-child) {
  padding-bottom: var(--ag-widget-container-vertical-padding);
}
.ag-row.ag-row-pinned-source {
  color: var(--ag-pinned-source-row-text-color);
  background-color: var(--ag-pinned-source-row-background-color);
  font-weight: var(--ag-pinned-source-row-font-weight);
}
.ag-row.ag-row-pinned {
  color: var(--ag-pinned-row-text-color);
  background-color: var(--ag-pinned-row-background-color);
  font-weight: var(--ag-pinned-row-font-weight);
}
.ag-floating-top-viewport {
  border-bottom: var(--ag-pinned-row-border);
}
.ag-floating-bottom-viewport {
  border-top: var(--ag-pinned-row-border);
}
.ag-measurement-container {
  --ag-legacy-styles-loaded: "true";
}
.ag-icon {
  font-family: var(--ag-icon-font-family);
  font-weight: var(--ag-icon-font-weight);
  color: var(--ag-icon-font-color);
  font-size: var(--ag-icon-size);
  line-height: var(--ag-icon-size);
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: var(--ag-icon-size);
  height: var(--ag-icon-size);
  position: relative;
}
.ag-icon::before {
  content: "";
  font-family: inherit;
}
.ag-icon::after {
  background: transparent var(--ag-icon-image, none) center/contain no-repeat;
  display: var(--ag-icon-image-display);
  opacity: var(--ag-icon-image-opacity, 0.9);
  position: absolute;
  inset: 0;
  content: "";
}
.ag-icon-aggregation {
  font-family: var(--ag-icon-font-family-aggregation, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-aggregation, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-aggregation, var(--ag-icon-font-color));
}
.ag-icon-aggregation::before {
  content: var(--ag-icon-font-code-aggregation, "\\f101");
  display: var(--ag-icon-font-display-aggregation, var(--ag-icon-font-display));
}
.ag-icon-aggregation::after {
  background-image: var(--ag-icon-image-aggregation, var(--ag-icon-image));
  display: var(--ag-icon-image-display-aggregation, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-aggregation, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-arrows {
  font-family: var(--ag-icon-font-family-arrows, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-arrows, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-arrows, var(--ag-icon-font-color));
}
.ag-icon-arrows::before {
  content: var(--ag-icon-font-code-arrows, "\\f102");
  display: var(--ag-icon-font-display-arrows, var(--ag-icon-font-display));
}
.ag-icon-arrows::after {
  background-image: var(--ag-icon-image-arrows, var(--ag-icon-image));
  display: var(--ag-icon-image-display-arrows, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-arrows, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-asc {
  font-family: var(--ag-icon-font-family-asc, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-asc, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-asc, var(--ag-icon-font-color));
}
.ag-icon-asc::before {
  content: var(--ag-icon-font-code-asc, "\\f103");
  display: var(--ag-icon-font-display-asc, var(--ag-icon-font-display));
}
.ag-icon-asc::after {
  background-image: var(--ag-icon-image-asc, var(--ag-icon-image));
  display: var(--ag-icon-image-display-asc, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-asc, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-cancel {
  font-family: var(--ag-icon-font-family-cancel, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-cancel, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-cancel, var(--ag-icon-font-color));
}
.ag-icon-cancel::before {
  content: var(--ag-icon-font-code-cancel, "\\f104");
  display: var(--ag-icon-font-display-cancel, var(--ag-icon-font-display));
}
.ag-icon-cancel::after {
  background-image: var(--ag-icon-image-cancel, var(--ag-icon-image));
  display: var(--ag-icon-image-display-cancel, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-cancel, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-chart {
  font-family: var(--ag-icon-font-family-chart, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-chart, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-chart, var(--ag-icon-font-color));
}
.ag-icon-chart::before {
  content: var(--ag-icon-font-code-chart, "\\f105");
  display: var(--ag-icon-font-display-chart, var(--ag-icon-font-display));
}
.ag-icon-chart::after {
  background-image: var(--ag-icon-image-chart, var(--ag-icon-image));
  display: var(--ag-icon-image-display-chart, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-chart, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-checkbox-checked {
  font-family: var(--ag-icon-font-family-checkbox-checked, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-checkbox-checked, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-checkbox-checked, var(--ag-icon-font-color));
}
.ag-icon-checkbox-checked::before {
  content: var(--ag-icon-font-code-checkbox-checked, "\\f106");
  display: var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display));
}
.ag-icon-checkbox-checked::after {
  background-image: var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));
  display: var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-checkbox-indeterminate {
  font-family: var(--ag-icon-font-family-checkbox-indeterminate, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-checkbox-indeterminate, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-checkbox-indeterminate, var(--ag-icon-font-color));
}
.ag-icon-checkbox-indeterminate::before {
  content: var(--ag-icon-font-code-checkbox-indeterminate, "\\f107");
  display: var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display));
}
.ag-icon-checkbox-indeterminate::after {
  background-image: var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));
  display: var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-checkbox-unchecked {
  font-family: var(--ag-icon-font-family-checkbox-unchecked, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-checkbox-unchecked, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-checkbox-unchecked, var(--ag-icon-font-color));
}
.ag-icon-checkbox-unchecked::before {
  content: var(--ag-icon-font-code-checkbox-unchecked, "\\f108");
  display: var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display));
}
.ag-icon-checkbox-unchecked::after {
  background-image: var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));
  display: var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-color-picker {
  font-family: var(--ag-icon-font-family-color-picker, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-color-picker, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-color-picker, var(--ag-icon-font-color));
}
.ag-icon-color-picker::before {
  content: var(--ag-icon-font-code-color-picker, "\\f109");
  display: var(--ag-icon-font-display-color-picker, var(--ag-icon-font-display));
}
.ag-icon-color-picker::after {
  background-image: var(--ag-icon-image-color-picker, var(--ag-icon-image));
  display: var(--ag-icon-image-display-color-picker, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-color-picker, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-columns {
  font-family: var(--ag-icon-font-family-columns, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-columns, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-columns, var(--ag-icon-font-color));
}
.ag-icon-columns::before {
  content: var(--ag-icon-font-code-columns, "\\f10a");
  display: var(--ag-icon-font-display-columns, var(--ag-icon-font-display));
}
.ag-icon-columns::after {
  background-image: var(--ag-icon-image-columns, var(--ag-icon-image));
  display: var(--ag-icon-image-display-columns, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-columns, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-contracted {
  font-family: var(--ag-icon-font-family-contracted, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-contracted, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-contracted, var(--ag-icon-font-color));
}
.ag-icon-contracted::before {
  content: var(--ag-icon-font-code-contracted, "\\f10b");
  display: var(--ag-icon-font-display-contracted, var(--ag-icon-font-display));
}
.ag-icon-contracted::after {
  background-image: var(--ag-icon-image-contracted, var(--ag-icon-image));
  display: var(--ag-icon-image-display-contracted, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-contracted, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-copy {
  font-family: var(--ag-icon-font-family-copy, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-copy, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-copy, var(--ag-icon-font-color));
}
.ag-icon-copy::before {
  content: var(--ag-icon-font-code-copy, "\\f10c");
  display: var(--ag-icon-font-display-copy, var(--ag-icon-font-display));
}
.ag-icon-copy::after {
  background-image: var(--ag-icon-image-copy, var(--ag-icon-image));
  display: var(--ag-icon-image-display-copy, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-copy, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-cross {
  font-family: var(--ag-icon-font-family-cross, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-cross, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-cross, var(--ag-icon-font-color));
}
.ag-icon-cross::before {
  content: var(--ag-icon-font-code-cross, "\\f10d");
  display: var(--ag-icon-font-display-cross, var(--ag-icon-font-display));
}
.ag-icon-cross::after {
  background-image: var(--ag-icon-image-cross, var(--ag-icon-image));
  display: var(--ag-icon-image-display-cross, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-cross, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-csv {
  font-family: var(--ag-icon-font-family-csv, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-csv, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-csv, var(--ag-icon-font-color));
}
.ag-icon-csv::before {
  content: var(--ag-icon-font-code-csv, "\\f10e");
  display: var(--ag-icon-font-display-csv, var(--ag-icon-font-display));
}
.ag-icon-csv::after {
  background-image: var(--ag-icon-image-csv, var(--ag-icon-image));
  display: var(--ag-icon-image-display-csv, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-csv, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-cut {
  font-family: var(--ag-icon-font-family-cut, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-cut, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-cut, var(--ag-icon-font-color));
}
.ag-icon-cut::before {
  content: var(--ag-icon-font-code-cut, "\\f10f");
  display: var(--ag-icon-font-display-cut, var(--ag-icon-font-display));
}
.ag-icon-cut::after {
  background-image: var(--ag-icon-image-cut, var(--ag-icon-image));
  display: var(--ag-icon-image-display-cut, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-cut, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-desc {
  font-family: var(--ag-icon-font-family-desc, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-desc, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-desc, var(--ag-icon-font-color));
}
.ag-icon-desc::before {
  content: var(--ag-icon-font-code-desc, "\\f110");
  display: var(--ag-icon-font-display-desc, var(--ag-icon-font-display));
}
.ag-icon-desc::after {
  background-image: var(--ag-icon-image-desc, var(--ag-icon-image));
  display: var(--ag-icon-image-display-desc, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-desc, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-excel {
  font-family: var(--ag-icon-font-family-excel, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-excel, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-excel, var(--ag-icon-font-color));
}
.ag-icon-excel::before {
  content: var(--ag-icon-font-code-excel, "\\f111");
  display: var(--ag-icon-font-display-excel, var(--ag-icon-font-display));
}
.ag-icon-excel::after {
  background-image: var(--ag-icon-image-excel, var(--ag-icon-image));
  display: var(--ag-icon-image-display-excel, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-excel, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-expanded {
  font-family: var(--ag-icon-font-family-expanded, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-expanded, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-expanded, var(--ag-icon-font-color));
}
.ag-icon-expanded::before {
  content: var(--ag-icon-font-code-expanded, "\\f112");
  display: var(--ag-icon-font-display-expanded, var(--ag-icon-font-display));
}
.ag-icon-expanded::after {
  background-image: var(--ag-icon-image-expanded, var(--ag-icon-image));
  display: var(--ag-icon-image-display-expanded, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-expanded, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-eye-slash {
  font-family: var(--ag-icon-font-family-eye-slash, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-eye-slash, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-eye-slash, var(--ag-icon-font-color));
}
.ag-icon-eye-slash::before {
  content: var(--ag-icon-font-code-eye-slash, "\\f113");
  display: var(--ag-icon-font-display-eye-slash, var(--ag-icon-font-display));
}
.ag-icon-eye-slash::after {
  background-image: var(--ag-icon-image-eye-slash, var(--ag-icon-image));
  display: var(--ag-icon-image-display-eye-slash, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-eye-slash, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-eye {
  font-family: var(--ag-icon-font-family-eye, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-eye, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-eye, var(--ag-icon-font-color));
}
.ag-icon-eye::before {
  content: var(--ag-icon-font-code-eye, "\\f114");
  display: var(--ag-icon-font-display-eye, var(--ag-icon-font-display));
}
.ag-icon-eye::after {
  background-image: var(--ag-icon-image-eye, var(--ag-icon-image));
  display: var(--ag-icon-image-display-eye, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-eye, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-filter {
  font-family: var(--ag-icon-font-family-filter, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-filter, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-filter, var(--ag-icon-font-color));
}
.ag-icon-filter::before {
  content: var(--ag-icon-font-code-filter, "\\f115");
  display: var(--ag-icon-font-display-filter, var(--ag-icon-font-display));
}
.ag-icon-filter::after {
  background-image: var(--ag-icon-image-filter, var(--ag-icon-image));
  display: var(--ag-icon-image-display-filter, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-filter, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-first {
  font-family: var(--ag-icon-font-family-first, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-first, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-first, var(--ag-icon-font-color));
}
.ag-icon-first::before {
  content: var(--ag-icon-font-code-first, "\\f116");
  display: var(--ag-icon-font-display-first, var(--ag-icon-font-display));
}
.ag-icon-first::after {
  background-image: var(--ag-icon-image-first, var(--ag-icon-image));
  display: var(--ag-icon-image-display-first, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-first, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-grip {
  font-family: var(--ag-icon-font-family-grip, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-grip, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-grip, var(--ag-icon-font-color));
}
.ag-icon-grip::before {
  content: var(--ag-icon-font-code-grip, "\\f117");
  display: var(--ag-icon-font-display-grip, var(--ag-icon-font-display));
}
.ag-icon-grip::after {
  background-image: var(--ag-icon-image-grip, var(--ag-icon-image));
  display: var(--ag-icon-image-display-grip, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-grip, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-group {
  font-family: var(--ag-icon-font-family-group, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-group, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-group, var(--ag-icon-font-color));
}
.ag-icon-group::before {
  content: var(--ag-icon-font-code-group, "\\f118");
  display: var(--ag-icon-font-display-group, var(--ag-icon-font-display));
}
.ag-icon-group::after {
  background-image: var(--ag-icon-image-group, var(--ag-icon-image));
  display: var(--ag-icon-image-display-group, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-group, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-last {
  font-family: var(--ag-icon-font-family-last, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-last, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-last, var(--ag-icon-font-color));
}
.ag-icon-last::before {
  content: var(--ag-icon-font-code-last, "\\f119");
  display: var(--ag-icon-font-display-last, var(--ag-icon-font-display));
}
.ag-icon-last::after {
  background-image: var(--ag-icon-image-last, var(--ag-icon-image));
  display: var(--ag-icon-image-display-last, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-last, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-left {
  font-family: var(--ag-icon-font-family-left, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-left, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-left, var(--ag-icon-font-color));
}
.ag-icon-left::before {
  content: var(--ag-icon-font-code-left, "\\f11a");
  display: var(--ag-icon-font-display-left, var(--ag-icon-font-display));
}
.ag-icon-left::after {
  background-image: var(--ag-icon-image-left, var(--ag-icon-image));
  display: var(--ag-icon-image-display-left, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-left, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-linked {
  font-family: var(--ag-icon-font-family-linked, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-linked, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-linked, var(--ag-icon-font-color));
}
.ag-icon-linked::before {
  content: var(--ag-icon-font-code-linked, "\\f11b");
  display: var(--ag-icon-font-display-linked, var(--ag-icon-font-display));
}
.ag-icon-linked::after {
  background-image: var(--ag-icon-image-linked, var(--ag-icon-image));
  display: var(--ag-icon-image-display-linked, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-linked, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-loading {
  font-family: var(--ag-icon-font-family-loading, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-loading, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-loading, var(--ag-icon-font-color));
}
.ag-icon-loading::before {
  content: var(--ag-icon-font-code-loading, "\\f11c");
  display: var(--ag-icon-font-display-loading, var(--ag-icon-font-display));
}
.ag-icon-loading::after {
  background-image: var(--ag-icon-image-loading, var(--ag-icon-image));
  display: var(--ag-icon-image-display-loading, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-loading, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-maximize {
  font-family: var(--ag-icon-font-family-maximize, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-maximize, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-maximize, var(--ag-icon-font-color));
}
.ag-icon-maximize::before {
  content: var(--ag-icon-font-code-maximize, "\\f11d");
  display: var(--ag-icon-font-display-maximize, var(--ag-icon-font-display));
}
.ag-icon-maximize::after {
  background-image: var(--ag-icon-image-maximize, var(--ag-icon-image));
  display: var(--ag-icon-image-display-maximize, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-maximize, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-menu {
  font-family: var(--ag-icon-font-family-menu, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-menu, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-menu, var(--ag-icon-font-color));
}
.ag-icon-menu::before {
  content: var(--ag-icon-font-code-menu, "\\f11e");
  display: var(--ag-icon-font-display-menu, var(--ag-icon-font-display));
}
.ag-icon-menu::after {
  background-image: var(--ag-icon-image-menu, var(--ag-icon-image));
  display: var(--ag-icon-image-display-menu, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-menu, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-minimize {
  font-family: var(--ag-icon-font-family-minimize, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-minimize, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-minimize, var(--ag-icon-font-color));
}
.ag-icon-minimize::before {
  content: var(--ag-icon-font-code-minimize, "\\f11f");
  display: var(--ag-icon-font-display-minimize, var(--ag-icon-font-display));
}
.ag-icon-minimize::after {
  background-image: var(--ag-icon-image-minimize, var(--ag-icon-image));
  display: var(--ag-icon-image-display-minimize, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-minimize, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-next {
  font-family: var(--ag-icon-font-family-next, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-next, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-next, var(--ag-icon-font-color));
}
.ag-icon-next::before {
  content: var(--ag-icon-font-code-next, "\\f120");
  display: var(--ag-icon-font-display-next, var(--ag-icon-font-display));
}
.ag-icon-next::after {
  background-image: var(--ag-icon-image-next, var(--ag-icon-image));
  display: var(--ag-icon-image-display-next, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-next, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-none {
  font-family: var(--ag-icon-font-family-none, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-none, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-none, var(--ag-icon-font-color));
}
.ag-icon-none::before {
  content: var(--ag-icon-font-code-none, "\\f121");
  display: var(--ag-icon-font-display-none, var(--ag-icon-font-display));
}
.ag-icon-none::after {
  background-image: var(--ag-icon-image-none, var(--ag-icon-image));
  display: var(--ag-icon-image-display-none, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-none, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-not-allowed {
  font-family: var(--ag-icon-font-family-not-allowed, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-not-allowed, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-not-allowed, var(--ag-icon-font-color));
}
.ag-icon-not-allowed::before {
  content: var(--ag-icon-font-code-not-allowed, "\\f122");
  display: var(--ag-icon-font-display-not-allowed, var(--ag-icon-font-display));
}
.ag-icon-not-allowed::after {
  background-image: var(--ag-icon-image-not-allowed, var(--ag-icon-image));
  display: var(--ag-icon-image-display-not-allowed, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-not-allowed, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-paste {
  font-family: var(--ag-icon-font-family-paste, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-paste, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-paste, var(--ag-icon-font-color));
}
.ag-icon-paste::before {
  content: var(--ag-icon-font-code-paste, "\\f123");
  display: var(--ag-icon-font-display-paste, var(--ag-icon-font-display));
}
.ag-icon-paste::after {
  background-image: var(--ag-icon-image-paste, var(--ag-icon-image));
  display: var(--ag-icon-image-display-paste, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-paste, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-pin {
  font-family: var(--ag-icon-font-family-pin, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-pin, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-pin, var(--ag-icon-font-color));
}
.ag-icon-pin::before {
  content: var(--ag-icon-font-code-pin, "\\f124");
  display: var(--ag-icon-font-display-pin, var(--ag-icon-font-display));
}
.ag-icon-pin::after {
  background-image: var(--ag-icon-image-pin, var(--ag-icon-image));
  display: var(--ag-icon-image-display-pin, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-pin, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-pivot {
  font-family: var(--ag-icon-font-family-pivot, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-pivot, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-pivot, var(--ag-icon-font-color));
}
.ag-icon-pivot::before {
  content: var(--ag-icon-font-code-pivot, "\\f125");
  display: var(--ag-icon-font-display-pivot, var(--ag-icon-font-display));
}
.ag-icon-pivot::after {
  background-image: var(--ag-icon-image-pivot, var(--ag-icon-image));
  display: var(--ag-icon-image-display-pivot, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-pivot, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-previous {
  font-family: var(--ag-icon-font-family-previous, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-previous, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-previous, var(--ag-icon-font-color));
}
.ag-icon-previous::before {
  content: var(--ag-icon-font-code-previous, "\\f126");
  display: var(--ag-icon-font-display-previous, var(--ag-icon-font-display));
}
.ag-icon-previous::after {
  background-image: var(--ag-icon-image-previous, var(--ag-icon-image));
  display: var(--ag-icon-image-display-previous, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-previous, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-radio-button-off {
  font-family: var(--ag-icon-font-family-radio-button-off, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-radio-button-off, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-radio-button-off, var(--ag-icon-font-color));
}
.ag-icon-radio-button-off::before {
  content: var(--ag-icon-font-code-radio-button-off, "\\f127");
  display: var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display));
}
.ag-icon-radio-button-off::after {
  background-image: var(--ag-icon-image-radio-button-off, var(--ag-icon-image));
  display: var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-radio-button-on {
  font-family: var(--ag-icon-font-family-radio-button-on, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-radio-button-on, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-radio-button-on, var(--ag-icon-font-color));
}
.ag-icon-radio-button-on::before {
  content: var(--ag-icon-font-code-radio-button-on, "\\f128");
  display: var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display));
}
.ag-icon-radio-button-on::after {
  background-image: var(--ag-icon-image-radio-button-on, var(--ag-icon-image));
  display: var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-right {
  font-family: var(--ag-icon-font-family-right, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-right, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-right, var(--ag-icon-font-color));
}
.ag-icon-right::before {
  content: var(--ag-icon-font-code-right, "\\f129");
  display: var(--ag-icon-font-display-right, var(--ag-icon-font-display));
}
.ag-icon-right::after {
  background-image: var(--ag-icon-image-right, var(--ag-icon-image));
  display: var(--ag-icon-image-display-right, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-right, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-save {
  font-family: var(--ag-icon-font-family-save, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-save, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-save, var(--ag-icon-font-color));
}
.ag-icon-save::before {
  content: var(--ag-icon-font-code-save, "\\f12a");
  display: var(--ag-icon-font-display-save, var(--ag-icon-font-display));
}
.ag-icon-save::after {
  background-image: var(--ag-icon-image-save, var(--ag-icon-image));
  display: var(--ag-icon-image-display-save, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-save, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-small-down {
  font-family: var(--ag-icon-font-family-small-down, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-small-down, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-small-down, var(--ag-icon-font-color));
}
.ag-icon-small-down::before {
  content: var(--ag-icon-font-code-small-down, "\\f12b");
  display: var(--ag-icon-font-display-small-down, var(--ag-icon-font-display));
}
.ag-icon-small-down::after {
  background-image: var(--ag-icon-image-small-down, var(--ag-icon-image));
  display: var(--ag-icon-image-display-small-down, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-small-down, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-small-left {
  font-family: var(--ag-icon-font-family-small-left, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-small-left, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-small-left, var(--ag-icon-font-color));
}
.ag-icon-small-left::before {
  content: var(--ag-icon-font-code-small-left, "\\f12c");
  display: var(--ag-icon-font-display-small-left, var(--ag-icon-font-display));
}
.ag-icon-small-left::after {
  background-image: var(--ag-icon-image-small-left, var(--ag-icon-image));
  display: var(--ag-icon-image-display-small-left, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-small-left, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-small-right {
  font-family: var(--ag-icon-font-family-small-right, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-small-right, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-small-right, var(--ag-icon-font-color));
}
.ag-icon-small-right::before {
  content: var(--ag-icon-font-code-small-right, "\\f12d");
  display: var(--ag-icon-font-display-small-right, var(--ag-icon-font-display));
}
.ag-icon-small-right::after {
  background-image: var(--ag-icon-image-small-right, var(--ag-icon-image));
  display: var(--ag-icon-image-display-small-right, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-small-right, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-small-up {
  font-family: var(--ag-icon-font-family-small-up, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-small-up, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-small-up, var(--ag-icon-font-color));
}
.ag-icon-small-up::before {
  content: var(--ag-icon-font-code-small-up, "\\f12e");
  display: var(--ag-icon-font-display-small-up, var(--ag-icon-font-display));
}
.ag-icon-small-up::after {
  background-image: var(--ag-icon-image-small-up, var(--ag-icon-image));
  display: var(--ag-icon-image-display-small-up, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-small-up, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-tick {
  font-family: var(--ag-icon-font-family-tick, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-tick, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-tick, var(--ag-icon-font-color));
}
.ag-icon-tick::before {
  content: var(--ag-icon-font-code-tick, "\\f12f");
  display: var(--ag-icon-font-display-tick, var(--ag-icon-font-display));
}
.ag-icon-tick::after {
  background-image: var(--ag-icon-image-tick, var(--ag-icon-image));
  display: var(--ag-icon-image-display-tick, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-tick, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-tree-closed {
  font-family: var(--ag-icon-font-family-tree-closed, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-tree-closed, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-tree-closed, var(--ag-icon-font-color));
}
.ag-icon-tree-closed::before {
  content: var(--ag-icon-font-code-tree-closed, "\\f130");
  display: var(--ag-icon-font-display-tree-closed, var(--ag-icon-font-display));
}
.ag-icon-tree-closed::after {
  background-image: var(--ag-icon-image-tree-closed, var(--ag-icon-image));
  display: var(--ag-icon-image-display-tree-closed, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-tree-closed, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-tree-indeterminate {
  font-family: var(--ag-icon-font-family-tree-indeterminate, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-tree-indeterminate, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-tree-indeterminate, var(--ag-icon-font-color));
}
.ag-icon-tree-indeterminate::before {
  content: var(--ag-icon-font-code-tree-indeterminate, "\\f131");
  display: var(--ag-icon-font-display-tree-indeterminate, var(--ag-icon-font-display));
}
.ag-icon-tree-indeterminate::after {
  background-image: var(--ag-icon-image-tree-indeterminate, var(--ag-icon-image));
  display: var(--ag-icon-image-display-tree-indeterminate, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-tree-indeterminate, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-tree-open {
  font-family: var(--ag-icon-font-family-tree-open, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-tree-open, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-tree-open, var(--ag-icon-font-color));
}
.ag-icon-tree-open::before {
  content: var(--ag-icon-font-code-tree-open, "\\f132");
  display: var(--ag-icon-font-display-tree-open, var(--ag-icon-font-display));
}
.ag-icon-tree-open::after {
  background-image: var(--ag-icon-image-tree-open, var(--ag-icon-image));
  display: var(--ag-icon-image-display-tree-open, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-tree-open, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-unlinked {
  font-family: var(--ag-icon-font-family-unlinked, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-unlinked, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-unlinked, var(--ag-icon-font-color));
}
.ag-icon-unlinked::before {
  content: var(--ag-icon-font-code-unlinked, "\\f133");
  display: var(--ag-icon-font-display-unlinked, var(--ag-icon-font-display));
}
.ag-icon-unlinked::after {
  background-image: var(--ag-icon-image-unlinked, var(--ag-icon-image));
  display: var(--ag-icon-image-display-unlinked, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-unlinked, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-up {
  font-family: var(--ag-icon-font-family-up, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-up, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-up, var(--ag-icon-font-color));
}
.ag-icon-up::before {
  content: var(--ag-icon-font-code-up, "\\f134");
  display: var(--ag-icon-font-display-up, var(--ag-icon-font-display));
}
.ag-icon-up::after {
  background-image: var(--ag-icon-image-up, var(--ag-icon-image));
  display: var(--ag-icon-image-display-up, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-up, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-down {
  font-family: var(--ag-icon-font-family-down, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-down, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-down, var(--ag-icon-font-color));
}
.ag-icon-down::before {
  content: var(--ag-icon-font-code-down, "\\f135");
  display: var(--ag-icon-font-display-down, var(--ag-icon-font-display));
}
.ag-icon-down::after {
  background-image: var(--ag-icon-image-down, var(--ag-icon-image));
  display: var(--ag-icon-image-display-down, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-down, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-plus {
  font-family: var(--ag-icon-font-family-plus, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-plus, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-plus, var(--ag-icon-font-color));
}
.ag-icon-plus::before {
  content: var(--ag-icon-font-code-plus, "\\f136");
  display: var(--ag-icon-font-display-plus, var(--ag-icon-font-display));
}
.ag-icon-plus::after {
  background-image: var(--ag-icon-image-plus, var(--ag-icon-image));
  display: var(--ag-icon-image-display-plus, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-plus, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-minus {
  font-family: var(--ag-icon-font-family-minus, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-minus, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-minus, var(--ag-icon-font-color));
}
.ag-icon-minus::before {
  content: var(--ag-icon-font-code-minus, "\\f137");
  display: var(--ag-icon-font-display-minus, var(--ag-icon-font-display));
}
.ag-icon-minus::after {
  background-image: var(--ag-icon-image-minus, var(--ag-icon-image));
  display: var(--ag-icon-image-display-minus, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-minus, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-menu-alt {
  font-family: var(--ag-icon-font-family-menu-alt, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-menu-alt, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-menu-alt, var(--ag-icon-font-color));
}
.ag-icon-menu-alt::before {
  content: var(--ag-icon-font-code-menu-alt, "\\f138");
  display: var(--ag-icon-font-display-menu-alt, var(--ag-icon-font-display));
}
.ag-icon-menu-alt::after {
  background-image: var(--ag-icon-image-menu-alt, var(--ag-icon-image));
  display: var(--ag-icon-image-display-menu-alt, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-menu-alt, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-settings {
  font-family: var(--ag-icon-font-family-settings, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-settings, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-settings, var(--ag-icon-font-color));
}
.ag-icon-settings::before {
  content: var(--ag-icon-font-code-settings, "\\f139");
  display: var(--ag-icon-font-display-settings, var(--ag-icon-font-display));
}
.ag-icon-settings::after {
  background-image: var(--ag-icon-image-settings, var(--ag-icon-image));
  display: var(--ag-icon-image-display-settings, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-settings, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-column-arrow {
  font-family: var(--ag-icon-font-family-column-arrow, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-column-arrow, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-column-arrow, var(--ag-icon-font-color));
}
.ag-icon-column-arrow::before {
  content: var(--ag-icon-font-code-column-arrow, "\\f13a");
  display: var(--ag-icon-font-display-column-arrow, var(--ag-icon-font-display));
}
.ag-icon-column-arrow::after {
  background-image: var(--ag-icon-image-column-arrow, var(--ag-icon-image));
  display: var(--ag-icon-image-display-column-arrow, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-column-arrow, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-un-pin {
  font-family: var(--ag-icon-font-family-un-pin, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-un-pin, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-un-pin, var(--ag-icon-font-color));
}
.ag-icon-un-pin::before {
  content: var(--ag-icon-font-code-un-pin, "\\f13b");
  display: var(--ag-icon-font-display-un-pin, var(--ag-icon-font-display));
}
.ag-icon-un-pin::after {
  background-image: var(--ag-icon-image-un-pin, var(--ag-icon-image));
  display: var(--ag-icon-image-display-un-pin, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-un-pin, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-pinned-bottom {
  font-family: var(--ag-icon-font-family-pinned-bottom, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-pinned-bottom, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-pinned-bottom, var(--ag-icon-font-color));
}
.ag-icon-pinned-bottom::before {
  content: var(--ag-icon-font-code-pinned-bottom, "\\f13e");
  display: var(--ag-icon-font-display-pinned-bottom, var(--ag-icon-font-display));
}
.ag-icon-pinned-bottom::after {
  background-image: var(--ag-icon-image-pinned-bottom, var(--ag-icon-image));
  display: var(--ag-icon-image-display-pinned-bottom, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-pinned-bottom, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-pinned-top {
  font-family: var(--ag-icon-font-family-pinned-top, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-pinned-top, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-pinned-top, var(--ag-icon-font-color));
}
.ag-icon-pinned-top::before {
  content: var(--ag-icon-font-code-pinned-top, "\\f13f");
  display: var(--ag-icon-font-display-pinned-top, var(--ag-icon-font-display));
}
.ag-icon-pinned-top::after {
  background-image: var(--ag-icon-image-pinned-top, var(--ag-icon-image));
  display: var(--ag-icon-image-display-pinned-top, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-pinned-top, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-chevron-up {
  font-family: var(--ag-icon-font-family-chevron-up, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-chevron-up, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-chevron-up, var(--ag-icon-font-color));
}
.ag-icon-chevron-up::before {
  content: var(--ag-icon-font-code-chevron-up, "\\f140");
  display: var(--ag-icon-font-display-chevron-up, var(--ag-icon-font-display));
}
.ag-icon-chevron-up::after {
  background-image: var(--ag-icon-image-chevron-up, var(--ag-icon-image));
  display: var(--ag-icon-image-display-chevron-up, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-chevron-up, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-chevron-down {
  font-family: var(--ag-icon-font-family-chevron-down, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-chevron-down, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-chevron-down, var(--ag-icon-font-color));
}
.ag-icon-chevron-down::before {
  content: var(--ag-icon-font-code-chevron-down, "\\f141");
  display: var(--ag-icon-font-display-chevron-down, var(--ag-icon-font-display));
}
.ag-icon-chevron-down::after {
  background-image: var(--ag-icon-image-chevron-down, var(--ag-icon-image));
  display: var(--ag-icon-image-display-chevron-down, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-chevron-down, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-chevron-left {
  font-family: var(--ag-icon-font-family-chevron-left, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-chevron-left, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-chevron-left, var(--ag-icon-font-color));
}
.ag-icon-chevron-left::before {
  content: var(--ag-icon-font-code-chevron-left, "\\f142");
  display: var(--ag-icon-font-display-chevron-left, var(--ag-icon-font-display));
}
.ag-icon-chevron-left::after {
  background-image: var(--ag-icon-image-chevron-left, var(--ag-icon-image));
  display: var(--ag-icon-image-display-chevron-left, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-chevron-left, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-chevron-right {
  font-family: var(--ag-icon-font-family-chevron-right, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-chevron-right, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-chevron-right, var(--ag-icon-font-color));
}
.ag-icon-chevron-right::before {
  content: var(--ag-icon-font-code-chevron-right, "\\f143");
  display: var(--ag-icon-font-display-chevron-right, var(--ag-icon-font-display));
}
.ag-icon-chevron-right::after {
  background-image: var(--ag-icon-image-chevron-right, var(--ag-icon-image));
  display: var(--ag-icon-image-display-chevron-right, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-chevron-right, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-filter-add {
  font-family: var(--ag-icon-font-family-filter-add, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-filter-add, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-filter-add, var(--ag-icon-font-color));
}
.ag-icon-filter-add::before {
  content: var(--ag-icon-font-code-filter-add, "\\f144");
  display: var(--ag-icon-font-display-filter-add, var(--ag-icon-font-display));
}
.ag-icon-filter-add::after {
  background-image: var(--ag-icon-image-filter-add, var(--ag-icon-image));
  display: var(--ag-icon-image-display-filter-add, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-filter-add, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-edit {
  font-family: var(--ag-icon-font-family-edit, var(--ag-icon-font-family));
  font-weight: var(--ag-icon-font-weight-edit, var(--ag-icon-font-weight));
  color: var(--ag-icon-font-color-edit, var(--ag-icon-font-color));
}
.ag-icon-edit::before {
  content: var(--ag-icon-font-code-edit, "\\f145");
  display: var(--ag-icon-font-display-edit, var(--ag-icon-font-display));
}
.ag-icon-edit::after {
  background-image: var(--ag-icon-image-edit, var(--ag-icon-image));
  display: var(--ag-icon-image-display-edit, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-edit, var(--ag-icon-image-opacity, 0.9));
}
.ag-icon-row-drag::before {
  content: var(--ag-icon-font-code-grip);
}
.ag-left-arrow::before {
  content: var(--ag-icon-font-code-left);
}
.ag-right-arrow::before {
  content: var(--ag-icon-font-code-right);
}
[class*=ag-theme-] {
  --ag-foreground-color: #000;
  --ag-data-color: var(--ag-foreground-color);
  --ag-secondary-foreground-color: var(--ag-foreground-color);
  --ag-header-foreground-color: var(--ag-secondary-foreground-color);
  --ag-disabled-foreground-color: rgba(0, 0, 0, 0.5);
  --ag-background-color: #fff;
  --ag-header-background-color: transparent;
  --ag-tooltip-background-color: transparent;
  --ag-tooltip-error-background-color: color-mix(
      in srgb,
      var(--ag-background-color),
      var(--ag-invalid-color) 10%
  );
  --ag-tooltip-error-text-color: var(--ag-invalid-color);
  --ag-tooltip-error-border-color: color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 25%);
  --ag-subheader-background-color: transparent;
  --ag-subheader-toolbar-background-color: transparent;
  --ag-control-panel-background-color: transparent;
  --ag-side-button-selected-background-color: var(--ag-control-panel-background-color);
  --ag-selected-row-background-color: #bbb;
  --ag-data-background-color: var(--ag-background-color);
  --ag-odd-row-background-color: var(--ag-data-background-color);
  --ag-modal-overlay-background-color: rgba(255, 255, 255, 0.66);
  --ag-menu-background-color: var(--ag-background-color);
  --ag-menu-border-color: var(--ag-border-color);
  --ag-panel-background-color: var(--ag-background-color);
  --ag-panel-border-color: var(--ag-border-color);
  --ag-row-hover-color: transparent;
  --ag-column-hover-color: transparent;
  --ag-range-selection-border-color: var(--ag-foreground-color);
  --ag-range-selection-border-style: solid;
  --ag-range-selection-background-color: rgba(0, 0, 0, 0.2);
  --ag-range-selection-background-color-2: var(--ag-range-selection-background-color);
  --ag-range-selection-background-color-3: var(--ag-range-selection-background-color);
  --ag-range-selection-background-color-4: var(--ag-range-selection-background-color);
  --ag-range-selection-highlight-color: var(--ag-range-selection-border-color);
  --ag-range-header-highlight-color: color-mix(
      in srgb,
      var(--ag-header-background-color),
      var(--ag-foreground-color) 8%
  );
  --ag-selected-tab-underline-color: var(--ag-range-selection-border-color);
  --ag-selected-tab-underline-width: 0;
  --ag-selected-tab-underline-transition-speed: 0s;
  --ag-range-selection-chart-category-background-color: rgba(0, 255, 132, 0.1);
  --ag-range-selection-chart-background-color: rgba(0, 88, 255, 0.1);
  --ag-header-cell-hover-background-color: transparent;
  --ag-header-cell-moving-background-color: var(--ag-background-color);
  --ag-value-change-value-highlight-background-color: rgba(22, 160, 133, 0.5);
  --ag-value-change-delta-up-color: #43a047;
  --ag-value-change-delta-down-color: #e53935;
  --ag-row-loading-skeleton-effect-color: rgba(66, 66, 66, 0.2);
  --ag-chip-background-color: transparent;
  --ag-chip-border-color: var(--ag-chip-background-color);
  --ag-borders: solid 1px;
  --ag-border-color: rgba(0, 0, 0, 0.25);
  --ag-borders-critical: var(--ag-borders);
  --ag-borders-secondary: var(--ag-borders);
  --ag-secondary-border-color: var(--ag-border-color);
  --ag-row-border-style: solid;
  --ag-row-border-color: var(--ag-secondary-border-color);
  --ag-row-border-width: 1px;
  --ag-cell-horizontal-border: solid transparent;
  --ag-borders-input: var(--ag-borders-secondary);
  --ag-input-border-color: var(--ag-secondary-border-color);
  --ag-borders-input-invalid: solid 2px;
  --ag-input-border-color-invalid: var(--ag-invalid-color);
  --ag-full-row-invalid-background-color: color-mix(
      in srgb,
      var(--ag-background-color),
      var(--ag-invalid-color) 25%
  );
  --ag-borders-side-button: var(--ag-borders);
  --ag-border-radius: 0px;
  --ag-wrapper-border-radius: var(--ag-border-radius);
  --ag-row-border-color: var(--ag-secondary-border-color);
  --ag-header-column-separator-display: none;
  --ag-header-column-separator-height: 100%;
  --ag-header-column-separator-width: 1px;
  --ag-header-column-separator-color: var(--ag-secondary-border-color);
  --ag-header-column-resize-handle-display: none;
  --ag-header-column-resize-handle-height: 50%;
  --ag-header-column-resize-handle-width: 1px;
  --ag-header-column-resize-handle-color: var(--ag-secondary-border-color);
  --ag-invalid-color: red;
  --ag-input-disabled-border-color: var(--ag-input-border-color);
  --ag-input-disabled-background-color: transparent;
  --ag-checkbox-background-color: transparent;
  --ag-checkbox-border-radius: var(--ag-border-radius);
  --ag-checkbox-checked-color: var(--ag-foreground-color);
  --ag-checkbox-unchecked-color: var(--ag-foreground-color);
  --ag-checkbox-indeterminate-color: var(--ag-checkbox-unchecked-color);
  --ag-toggle-button-off-border-color: var(--ag-checkbox-unchecked-color);
  --ag-toggle-button-off-background-color: var(--ag-checkbox-unchecked-color);
  --ag-toggle-button-on-border-color: var(--ag-checkbox-checked-color);
  --ag-toggle-button-on-background-color: var(--ag-checkbox-checked-color);
  --ag-toggle-button-switch-background-color: var(--ag-background-color);
  --ag-toggle-button-switch-border-color: var(--ag-toggle-button-off-border-color);
  --ag-toggle-button-border-width: 1px;
  --ag-toggle-button-height: var(--ag-icon-size);
  --ag-toggle-button-width: calc(var(--ag-toggle-button-height) * 2);
  --ag-input-focus-box-shadow: none;
  --ag-input-error-focus-box-shadow: none;
  --ag-input-focus-border-color: none;
  --ag-minichart-selected-chart-color: var(--ag-checkbox-checked-color);
  --ag-minichart-selected-page-color: var(--ag-checkbox-checked-color);
  --ag-grid-size: 4px;
  --ag-icon-size: 12px;
  --ag-icon-font-weight: normal;
  --ag-icon-font-color: var(--ag-foreground-color);
  --ag-icon-image-display: block;
  --ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 1.5);
  --ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 1.5);
  --ag-widget-horizontal-spacing: calc(var(--ag-grid-size) * 2);
  --ag-widget-vertical-spacing: var(--ag-grid-size);
  --ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);
  --ag-cell-widget-spacing: var(--ag-cell-horizontal-padding);
  --ag-row-height: calc(var(--ag-grid-size) * 6 + 1px);
  --ag-header-height: var(--ag-row-height);
  --ag-pagination-panel-height: var(--ag-header-height);
  --ag-list-item-height: calc(var(--ag-grid-size) * 5);
  --ag-column-select-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));
  --ag-set-filter-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));
  --ag-advanced-filter-builder-indent-size: calc(var(--ag-grid-size) * 2 + var(--ag-icon-size));
  --ag-row-group-indent-size: calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size));
  --ag-row-numbers-selected-color: #bbb;
  --ag-filter-tool-panel-group-indent: 16px;
  --ag-tab-min-width: 220px;
  --ag-chart-menu-panel-width: var(--ag-tab-min-width);
  --ag-menu-min-width: 181px;
  --ag-side-bar-panel-width: 200px;
  --ag-font-family: "Helvetica Neue", sans-serif;
  --ag-font-size: 14px;
  --ag-card-radius: var(--ag-border-radius);
  --ag-card-shadow: none;
  --ag-popup-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
  --ag-advanced-filter-join-pill-color: #f08e8d;
  --ag-advanced-filter-column-pill-color: #a6e194;
  --ag-advanced-filter-option-pill-color: #f3c08b;
  --ag-advanced-filter-value-pill-color: #85c0e4;
  --ag-find-match-color: var(--ag-foreground-color);
  --ag-find-active-match-color: var(--ag-foreground-color);
  --ag-find-match-background-color: #ffff00;
  --ag-find-active-match-background-color: #ffa500;
  --ag-cell-batch-edit-background-color: rgb(220 181 139 / 16%);
  --ag-cell-batch-edit-text-color: #422f00;
  --ag-row-batch-edit-background-color: var(--ag-cell-batch-edit-background-color);
  --ag-row-batch-edit-text-color: var(--ag-cell-batch-edit-text-color);
  --ag-filter-panel-apply-button-color: var(--ag-foreground-color);
  --ag-filter-panel-apply-button-background-color: var(--ag-background-color);
  --ag-filter-panel-card-subtle-color: var(--ag-foreground-color);
  --ag-filter-panel-card-subtle-hover-color: var(--ag-foreground-color);
}
.ag-root-wrapper,
.ag-dnd-ghost {
  background-color: var(--ag-background-color);
}
.ag-sticky-top,
.ag-sticky-bottom {
  background-color: var(--ag-data-background-color);
}
.ag-sticky-bottom {
  border-top: var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width);
}
.ag-root-wrapper,
.ag-popup {
  --ag-indentation-level: 0;
}
[class*=ag-theme-] {
  -webkit-font-smoothing: antialiased;
  font-family: var(--ag-font-family);
  font-size: var(--ag-font-size);
  line-height: normal;
  color: var(--ag-foreground-color);
}
ag-grid,
ag-grid-angular,
ag-grid-ng2,
ag-grid-polymer,
ag-grid-aurelia {
  display: block;
}
.ag-aria-description-container {
  z-index: 9999;
  border: 0px;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  position: absolute;
  overflow: hidden;
  padding: 0px;
  white-space: nowrap;
}
.ag-hidden {
  display: none !important;
}
.ag-invisible {
  visibility: hidden !important;
}
.ag-drag-handle {
  cursor: grab;
}
.ag-column-drop-wrapper {
  display: flex;
}
.ag-column-drop-horizontal-half-width {
  display: inline-block;
  width: 50% !important;
}
.ag-unselectable {
  -webkit-user-select: none;
  user-select: none;
}
.ag-selectable {
  -webkit-user-select: text;
  user-select: text;
}
.ag-tab {
  position: relative;
}
.ag-tab-guard {
  position: absolute;
  width: 0;
  height: 0;
  display: block;
}
.ag-virtual-list-viewport .ag-tab-guard {
  position: -webkit-sticky;
  position: sticky;
}
.ag-tab-guard-top {
  top: 1px;
}
.ag-tab-guard-bottom {
  bottom: 1px;
}
.ag-select-agg-func-popup {
  position: absolute;
}
.ag-input-wrapper,
.ag-picker-field-wrapper {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  line-height: normal;
  position: relative;
}
.ag-shake-left-to-right {
  animation-direction: alternate;
  animation-duration: 0.2s;
  animation-iteration-count: infinite;
  animation-name: ag-shake-left-to-right;
}
@keyframes ag-shake-left-to-right {
from {
    padding-left: 6px;
    padding-right: 2px;
}
to {
    padding-left: 2px;
    padding-right: 6px;
}
}
.ag-root-wrapper {
  cursor: default;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: normal;
}
.ag-root-wrapper.ag-layout-normal {
  height: 100%;
}
.ag-watermark {
  position: absolute;
  bottom: 20px;
  right: 25px;
  opacity: 0.7;
  transition: opacity 1s ease-out 3s;
  color: #9b9b9b;
}
.ag-watermark::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 170px 40px;
  display: block;
  height: 40px;
  width: 170px;
}
.ag-watermark-text {
  opacity: 0.5;
  font-weight: bold;
  font-family: Impact, sans-serif;
  font-size: 19px;
  padding-left: 0.7rem;
}
.ag-root-wrapper-body {
  display: flex;
  flex-direction: row;
}
.ag-root-wrapper-body.ag-layout-normal {
  flex: 1 1 auto;
  height: 0;
  min-height: 0;
}
.ag-root {
  position: relative;
  display: flex;
  flex-direction: column;
}
.ag-root.ag-layout-normal, .ag-root.ag-layout-auto-height {
  overflow: hidden;
  flex: 1 1 auto;
  width: 0;
}
.ag-root.ag-layout-normal {
  height: 100%;
}
.ag-header-viewport,
.ag-floating-top-viewport,
.ag-body-viewport,
.ag-center-cols-viewport,
.ag-floating-bottom-viewport,
.ag-body-horizontal-scroll-viewport,
.ag-body-vertical-scroll-viewport,
.ag-virtual-list-viewport,
.ag-sticky-top-viewport,
.ag-sticky-bottom-viewport {
  position: relative;
  height: 100%;
  min-width: 0px;
  overflow: hidden;
  flex: 1 1 auto;
}
.ag-body-viewport,
.ag-center-cols-viewport,
.ag-header-viewport,
.ag-floating-top-viewport,
.ag-floating-bottom-viewport,
.ag-sticky-top-viewport,
.ag-sticky-bottom-viewport {
  overflow-x: auto;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}
.ag-body-viewport::-webkit-scrollbar,
.ag-center-cols-viewport::-webkit-scrollbar,
.ag-header-viewport::-webkit-scrollbar,
.ag-floating-top-viewport::-webkit-scrollbar,
.ag-floating-bottom-viewport::-webkit-scrollbar,
.ag-sticky-top-viewport::-webkit-scrollbar,
.ag-sticky-bottom-viewport::-webkit-scrollbar {
  display: none !important;
}
.ag-body-viewport {
  display: flex;
  overflow-x: hidden;
}
.ag-body-viewport.ag-layout-normal {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.ag-viewport {
  position: relative;
}
.ag-spanning-container {
  position: absolute;
  top: 0;
  z-index: 1;
}
.ag-sticky-top-container,
.ag-sticky-bottom-container,
.ag-floating-top-container,
.ag-floating-bottom-container {
  min-height: 1px;
}
.ag-sticky-top,
.ag-sticky-bottom {
  z-index: 1;
}
.ag-center-cols-viewport {
  min-height: 100%;
  width: 100%;
}
.ag-body-horizontal-scroll-viewport {
  overflow-x: scroll;
}
.ag-body-vertical-scroll-viewport {
  overflow-y: scroll;
}
.ag-virtual-list-viewport {
  overflow: auto;
  width: 100%;
}
.ag-header-container,
.ag-floating-top-container,
.ag-body-container,
.ag-pinned-right-cols-container,
.ag-center-cols-container,
.ag-pinned-left-cols-container,
.ag-floating-bottom-container,
.ag-body-horizontal-scroll-container,
.ag-body-vertical-scroll-container,
.ag-full-width-container,
.ag-floating-bottom-full-width-container,
.ag-virtual-list-container,
.ag-sticky-top-container,
.ag-sticky-bottom-container {
  position: relative;
}
.ag-header-container,
.ag-floating-top-container,
.ag-pinned-left-floating-top,
.ag-pinned-right-floating-top,
.ag-floating-bottom-container,
.ag-pinned-left-floating-bottom,
.ag-pinned-right-floating-bottom,
.ag-sticky-top-container,
.ag-sticky-bottom-container {
  height: 100%;
  white-space: nowrap;
}
.ag-center-cols-container {
  display: block;
}
.ag-pinned-right-cols-container {
  display: block;
}
.ag-body-horizontal-scroll-container {
  height: 100%;
}
.ag-body-vertical-scroll-container {
  width: 100%;
}
.ag-full-width-container,
.ag-floating-top-full-width-container,
.ag-floating-bottom-full-width-container,
.ag-sticky-top-full-width-container,
.ag-sticky-bottom-full-width-container {
  position: absolute;
  top: 0px;
  pointer-events: none;
}
.ag-ltr .ag-full-width-container,
.ag-ltr .ag-floating-top-full-width-container,
.ag-ltr .ag-floating-bottom-full-width-container,
.ag-ltr .ag-sticky-top-full-width-container,
.ag-ltr .ag-sticky-bottom-full-width-container {
  left: 0;
}
.ag-rtl .ag-full-width-container,
.ag-rtl .ag-floating-top-full-width-container,
.ag-rtl .ag-floating-bottom-full-width-container,
.ag-rtl .ag-sticky-top-full-width-container,
.ag-rtl .ag-sticky-bottom-full-width-container {
  right: 0;
}
.ag-full-width-container {
  width: 100%;
}
.ag-floating-bottom-full-width-container,
.ag-floating-top-full-width-container {
  display: inline-block;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.ag-virtual-list-container {
  overflow: hidden;
}
.ag-body {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: row !important;
  min-height: 0;
}
.ag-body-horizontal-scroll,
.ag-body-vertical-scroll {
  min-height: 0;
  min-width: 0;
  display: flex;
  position: relative;
}
.ag-body-horizontal-scroll.ag-scrollbar-invisible,
.ag-body-vertical-scroll.ag-scrollbar-invisible {
  position: absolute;
  bottom: 0;
}
.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar,
.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar {
  opacity: 0;
  transition: opacity 400ms;
  visibility: hidden;
}
.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling, .ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active,
.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling,
.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active {
  visibility: visible;
  opacity: 1;
}
.ag-body-horizontal-scroll {
  width: 100%;
}
.ag-body-horizontal-scroll.ag-scrollbar-invisible {
  left: 0;
  right: 0;
}
.ag-body-vertical-scroll {
  height: 100%;
}
.ag-body-vertical-scroll.ag-scrollbar-invisible {
  top: 0;
  z-index: 10;
}
.ag-ltr .ag-body-vertical-scroll.ag-scrollbar-invisible {
  right: 0;
}
.ag-rtl .ag-body-vertical-scroll.ag-scrollbar-invisible {
  left: 0;
}
.ag-force-vertical-scroll {
  overflow-y: scroll !important;
}
.ag-horizontal-left-spacer,
.ag-horizontal-right-spacer {
  height: 100%;
  min-width: 0;
  overflow-x: scroll;
}
.ag-horizontal-left-spacer.ag-scroller-corner,
.ag-horizontal-right-spacer.ag-scroller-corner {
  overflow-x: hidden;
}
.ag-header,
.ag-pinned-left-header,
.ag-pinned-right-header {
  display: inline-block;
  overflow: hidden;
  position: relative;
}
.ag-header-cell-sortable .ag-header-cell-label {
  cursor: pointer;
}
.ag-header {
  display: flex;
  width: 100%;
  white-space: nowrap;
}
.ag-pinned-left-header {
  height: 100%;
}
.ag-pinned-right-header {
  height: 100%;
}
.ag-header-row {
  position: absolute;
}
.ag-header-row:not(.ag-header-row-column-group) {
  overflow: hidden;
}
.ag-header.ag-header-allow-overflow .ag-header-row {
  overflow: visible;
}
.ag-header-cell {
  display: inline-flex;
  align-items: center;
  position: absolute;
  height: 100%;
  overflow: hidden;
}
.ag-header-cell.ag-header-active .ag-header-cell-menu-button,
.ag-header-cell-filter-button {
  opacity: 1;
}
.ag-header-cell-menu-button:not(.ag-header-menu-always-show) {
  transition: opacity 0.2s;
  opacity: 0;
}
.ag-header-group-cell-label,
.ag-header-cell-label {
  display: flex;
  flex: 1 1 auto;
  align-self: stretch;
  align-items: center;
  overflow: hidden;
}
.ag-header-cell-label {
  text-overflow: ellipsis;
}
.ag-header-group-cell-label.ag-sticky-label {
  position: -webkit-sticky;
  position: sticky;
  flex: none;
  max-width: 100%;
  overflow: visible;
}
.ag-header-group-text {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-header-cell-text {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.ag-header-group-cell .ag-header-cell-comp-wrapper {
  display: flex;
}
.ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
}
.ag-header-cell-comp-wrapper {
  width: 100%;
}
.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper {
  white-space: normal;
}
.ag-header-cell-comp-wrapper-limited-height > div {
  overflow: hidden;
}
.ag-right-aligned-header .ag-header-cell-label {
  flex-direction: row-reverse;
}
.ag-header-cell-resize {
  position: absolute;
  z-index: 2;
  height: 100%;
  width: 8px;
  top: 0;
  cursor: ew-resize;
}
.ag-ltr .ag-header-cell-resize {
  right: -3px;
}
.ag-rtl .ag-header-cell-resize {
  left: -3px;
}
.ag-pinned-left-header .ag-header-cell-resize {
  right: -3px;
}
.ag-pinned-right-header .ag-header-cell-resize {
  left: -3px;
}
.ag-header-select-all {
  display: flex;
}
.ag-header-cell-menu-button,
.ag-header-cell-filter-button,
.ag-side-button-button,
.ag-panel-title-bar-button,
.ag-floating-filter-button-button {
  cursor: pointer;
}
.ag-column-moving .ag-cell {
  transition: left 0.2s;
}
.ag-column-moving .ag-header-cell {
  transition: left 0.2s;
}
.ag-column-moving .ag-spanned-cell-wrapper {
  transition: left 0.2s;
}
.ag-column-moving .ag-header-group-cell {
  transition: left 0.2s, width 0.2s;
}
.ag-column-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1 auto;
}
.ag-column-select {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 3 1 0px;
}
.ag-column-select-header {
  position: relative;
  display: flex;
  flex: none;
}
.ag-column-select-header-icon {
  position: relative;
}
.ag-column-select-header-filter-wrapper {
  flex: 1 1 auto;
}
.ag-column-select-header-filter {
  width: 100%;
}
.ag-column-select-list {
  flex: 1 1 0px;
  overflow: hidden;
}
.ag-column-drop {
  position: relative;
  display: inline-flex;
  align-items: center;
  overflow: auto;
  width: 100%;
}
.ag-column-drop-list {
  display: flex;
  align-items: center;
}
.ag-column-drop-cell {
  position: relative;
  display: flex;
  align-items: center;
}
.ag-column-drop-cell-text {
  overflow: hidden;
  flex: 1 1 auto;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ag-column-drop-vertical {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: stretch;
  flex: 1 1 0px;
}
.ag-column-drop-vertical-title-bar {
  display: flex;
  align-items: center;
  flex: none;
}
.ag-column-drop-vertical-list {
  position: relative;
  align-items: stretch;
  flex-grow: 1;
  flex-direction: column;
  overflow-x: auto;
}
.ag-column-drop-vertical-list > * {
  flex: none;
}
.ag-column-drop-empty .ag-column-drop-vertical-list {
  overflow: hidden;
}
.ag-column-drop-vertical-empty-message {
  display: block;
}
.ag-column-drop.ag-column-drop-horizontal {
  white-space: nowrap;
  overflow: hidden;
}
.ag-column-drop-cell-button {
  cursor: pointer;
}
.ag-filter-toolpanel {
  flex: 1 1 0px;
  min-width: 0;
}
.ag-filter-toolpanel-header {
  position: relative;
}
.ag-filter-toolpanel-header,
.ag-filter-toolpanel-search {
  display: flex;
  align-items: center;
}
.ag-filter-toolpanel-header > *,
.ag-filter-toolpanel-search > * {
  display: flex;
  align-items: center;
}
.ag-filter-apply-panel {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
}
.ag-row-animation .ag-row {
  transition: transform 0.4s, top 0.4s, opacity 0.2s;
}
.ag-row-animation .ag-row.ag-after-created {
  transition: transform 0.4s, top 0.4s, height 0.4s, opacity 0.2s;
}
.ag-row-animation.ag-prevent-animation .ag-row,
.ag-row-animation.ag-prevent-animation .ag-row.ag-after-created {
  transition: none !important;
}
.ag-row-no-animation .ag-row {
  transition: none;
}
.ag-row {
  white-space: nowrap;
  width: 100%;
}
.ag-row-loading {
  display: flex;
  align-items: center;
}
.ag-row-position-absolute {
  position: absolute;
}
.ag-row-position-relative {
  position: relative;
}
.ag-full-width-row {
  overflow: hidden;
  pointer-events: all;
}
.ag-row-inline-editing {
  z-index: 1;
}
.ag-row-dragging {
  z-index: 2;
}
.ag-stub-cell {
  display: flex;
  align-items: center;
}
.ag-cell {
  display: inline-block;
  position: absolute;
  white-space: nowrap;
  height: 100%;
}
.ag-cell-value {
  flex: 1 1 auto;
}
.ag-cell-value:not(.ag-allow-overflow),
.ag-group-value {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-cell-wrapper {
  display: flex;
  align-items: center;
}
.ag-cell-wrapper.ag-row-group {
  align-items: flex-start;
}
.ag-cell-wrap-text {
  white-space: normal;
  word-break: break-word;
}
.ag-cell-wrap-text:not(.ag-cell-auto-height) .ag-cell-wrapper {
  align-items: normal;
  height: 100%;
}
.ag-cell-wrap-text:not(.ag-cell-auto-height) .ag-cell-wrapper .ag-cell-value {
  height: 100%;
}
.ag-sparkline-wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  line-height: initial;
}
.ag-full-width-row .ag-cell-wrapper.ag-row-group {
  height: 100%;
  align-items: center;
}
.ag-cell-inline-editing {
  z-index: 1;
}
.ag-cell-inline-editing .ag-cell-wrapper,
.ag-cell-inline-editing .ag-cell-edit-wrapper,
.ag-cell-inline-editing .ag-cell-editor,
.ag-cell-inline-editing .ag-cell-editor .ag-wrapper,
.ag-cell-inline-editing .ag-cell-editor.ag-cell-editor.ag-cell-editor input {
  height: 100%;
  min-height: 100%;
  width: 100%;
  line-height: normal;
}
.ag-row.ag-row-editing-invalid .ag-cell-inline-editing {
  opacity: 0.8;
}
.ag-cell .ag-icon {
  display: inline-block;
  vertical-align: middle;
}
.ag-set-filter-item {
  display: flex;
  align-items: center;
  height: 100%;
}
.ag-set-filter-item-checkbox {
  display: flex;
  width: 100%;
  height: 100%;
}
.ag-set-filter-group-icons {
  display: block;
}
.ag-set-filter-group-icons > * {
  cursor: pointer;
}
.ag-filter-body-wrapper {
  display: flex;
  flex-direction: column;
}
.ag-filter-filter {
  flex: 1 1 0px;
}
.ag-filter-condition {
  display: flex;
  justify-content: center;
}
.ag-floating-filter-body {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  height: 100%;
}
.ag-floating-filter-full-body {
  display: flex;
  flex: 1 1 auto;
  height: 100%;
  width: 100%;
  align-items: center;
  overflow: hidden;
}
.ag-floating-filter-full-body > div {
  flex: 1 1 auto;
}
.ag-floating-filter-input {
  align-items: center;
  display: flex;
  width: 100%;
}
.ag-floating-filter-input > * {
  flex: 1 1 auto;
}
.ag-floating-filter-button {
  display: flex;
  flex: none;
}
.ag-date-floating-filter-wrapper {
  display: flex;
}
.ag-set-floating-filter-input input[disabled] {
  pointer-events: none;
}
.ag-dnd-ghost {
  display: inline-flex;
  align-items: center;
  cursor: move;
  white-space: nowrap;
}
.ag-overlay {
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}
.ag-overlay-panel {
  display: flex;
  height: 100%;
  width: 100%;
}
.ag-overlay-wrapper {
  display: flex;
  flex: none;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.ag-overlay-loading-wrapper {
  pointer-events: all;
}
.ag-popup-child {
  z-index: 5;
  top: 0;
}
.ag-popup-editor {
  position: absolute;
  -webkit-user-select: none;
  user-select: none;
}
.ag-large-text-input {
  display: block;
}
.ag-virtual-list-item {
  position: absolute;
  width: 100%;
}
.ag-floating-top,
.ag-floating-bottom {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  position: relative;
  display: flex;
}
.ag-pinned-left-floating-top,
.ag-pinned-right-floating-top,
.ag-pinned-left-floating-bottom,
.ag-pinned-right-floating-bottom {
  overflow: hidden;
  position: relative;
  min-width: 0px;
}
.ag-sticky-top,
.ag-sticky-bottom {
  position: absolute;
  display: flex;
  width: 100%;
  overflow: hidden;
  height: 0px;
}
.ag-sticky-bottom {
  box-sizing: content-box !important;
}
.ag-pinned-left-sticky-top,
.ag-pinned-right-sticky-top {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.ag-sticky-top-full-width-container,
.ag-sticky-bottom-full-width-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.ag-dialog,
.ag-panel {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.ag-panel-title-bar {
  display: flex;
  flex: none;
  align-items: center;
  cursor: default;
}
.ag-panel-title-bar-title {
  flex: 1 1 auto;
}
.ag-panel-title-bar-buttons {
  display: flex;
}
.ag-panel-title-bar-button {
  cursor: pointer;
}
.ag-panel-content-wrapper {
  display: flex;
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
}
.ag-dialog {
  position: absolute;
}
.ag-resizer {
  position: absolute;
  pointer-events: none;
  z-index: 1;
  -webkit-user-select: none;
  user-select: none;
}
.ag-resizer.ag-resizer-topLeft {
  top: 0;
  left: 0;
  height: 5px;
  width: 5px;
  cursor: nwse-resize;
}
.ag-resizer.ag-resizer-top {
  top: 0;
  left: 5px;
  right: 5px;
  height: 5px;
  cursor: ns-resize;
}
.ag-resizer.ag-resizer-topRight {
  top: 0;
  right: 0;
  height: 5px;
  width: 5px;
  cursor: nesw-resize;
}
.ag-resizer.ag-resizer-right {
  top: 5px;
  right: 0;
  bottom: 5px;
  width: 5px;
  cursor: ew-resize;
}
.ag-resizer.ag-resizer-bottomRight {
  bottom: 0;
  right: 0;
  height: 5px;
  width: 5px;
  cursor: nwse-resize;
}
.ag-resizer.ag-resizer-bottom {
  bottom: 0;
  left: 5px;
  right: 5px;
  height: 5px;
  cursor: ns-resize;
}
.ag-resizer.ag-resizer-bottomLeft {
  bottom: 0;
  left: 0;
  height: 5px;
  width: 5px;
  cursor: nesw-resize;
}
.ag-resizer.ag-resizer-left {
  left: 0;
  top: 5px;
  bottom: 5px;
  width: 5px;
  cursor: ew-resize;
}
.ag-tooltip {
  position: absolute;
  z-index: 99999;
}
.ag-tooltip-custom {
  position: absolute;
  z-index: 99999;
}
.ag-tooltip:not(.ag-tooltip-interactive),
.ag-tooltip-custom:not(.ag-tooltip-interactive) {
  pointer-events: none;
}
.ag-value-slide-out {
  margin-right: 5px;
  opacity: 1;
  transition: opacity 3s, margin-right 3s;
  transition-timing-function: linear;
}
.ag-value-slide-out-end {
  margin-right: 10px;
  opacity: 0;
}
.ag-opacity-zero {
  opacity: 0 !important;
}
.ag-menu {
  max-height: 100%;
  overflow-y: auto;
  position: absolute;
  -webkit-user-select: none;
  user-select: none;
}
.ag-menu-column-select-wrapper {
  height: 265px;
  overflow: auto;
}
.ag-menu-column-select-wrapper .ag-column-select {
  height: 100%;
}
.ag-dialog .ag-panel-content-wrapper .ag-column-select {
  -webkit-user-select: none;
          user-select: none;
}
.ag-menu-list {
  display: table;
  width: 100%;
}
.ag-menu-option,
.ag-menu-separator {
  display: table-row;
}
.ag-menu-option-part,
.ag-menu-separator-part {
  display: table-cell;
  vertical-align: middle;
}
.ag-menu-option-text {
  white-space: nowrap;
}
.ag-menu-option-custom {
  display: contents;
}
.ag-compact-menu-option {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}
.ag-compact-menu-option-text {
  white-space: nowrap;
  flex: 1 1 auto;
}
.ag-context-menu-loading-icon {
  position: absolute;
  pointer-events: none;
}
.ag-pill-container {
  display: flex;
  gap: 0.25rem;
  flex-wrap: nowrap;
}
.ag-pill {
  display: flex;
  white-space: nowrap;
  padding: 0 0.25rem;
  align-items: center;
}
.ag-pill .ag-pill-button {
  border: none;
  padding: 0;
}
.ag-rich-select {
  cursor: default;
  outline: none;
  height: 100%;
}
.ag-rich-select-value {
  display: flex;
  align-items: center;
  height: 100%;
}
.ag-rich-select-value .ag-picker-field-display {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-rich-select-value .ag-picker-field-display.ag-display-as-placeholder {
  opacity: 0.5;
}
.ag-rich-select-list {
  position: relative;
}
.ag-rich-select-list .ag-loading-text {
  min-height: 2rem;
}
.ag-rich-select-row {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  height: 100%;
}
.ag-rich-select-field-input {
  flex: 1 1 auto;
}
.ag-rich-select-field-input .ag-input-field-input {
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  text-overflow: ellipsis;
}
.ag-rich-select-field-input .ag-input-field-input::placeholder {
  opacity: 0.8;
}
.ag-autocomplete {
  align-items: center;
  display: flex;
}
.ag-autocomplete > * {
  flex: 1 1 auto;
}
.ag-autocomplete-list-popup {
  position: absolute;
  -webkit-user-select: none;
  user-select: none;
}
.ag-autocomplete-list {
  position: relative;
}
.ag-autocomplete-virtual-list-item {
  display: flex;
}
.ag-autocomplete-row {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  overflow: hidden;
}
.ag-autocomplete-row-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-paging-panel {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.ag-paging-page-summary-panel {
  display: flex;
  align-items: center;
}
.ag-paging-button {
  position: relative;
}
.ag-disabled .ag-paging-page-summary-panel {
  pointer-events: none;
}
.ag-tool-panel-wrapper {
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}
.ag-column-select-column,
.ag-column-select-column-group,
.ag-select-agg-func-item {
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
}
.ag-column-select-column > *,
.ag-column-select-column-group > *,
.ag-select-agg-func-item > * {
  flex: none;
}
.ag-select-agg-func-item,
.ag-column-select-column-label {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ag-column-select-checkbox {
  display: flex;
}
.ag-tool-panel-horizontal-resize {
  cursor: ew-resize;
  height: 100%;
  position: absolute;
  top: 0;
  width: 5px;
  z-index: 1;
}
.ag-ltr .ag-side-bar-left .ag-tool-panel-horizontal-resize {
  right: -3px;
}
.ag-rtl .ag-side-bar-left .ag-tool-panel-horizontal-resize {
  left: -3px;
}
.ag-ltr .ag-side-bar-right .ag-tool-panel-horizontal-resize {
  left: -3px;
}
.ag-rtl .ag-side-bar-right .ag-tool-panel-horizontal-resize {
  right: -3px;
}
.ag-details-row {
  width: 100%;
}
.ag-details-row-fixed-height {
  height: 100%;
}
.ag-details-grid {
  width: 100%;
}
.ag-details-grid-fixed-height {
  height: 100%;
}
.ag-header-group-cell {
  display: flex;
  align-items: center;
  height: 100%;
  position: absolute;
  contain: paint;
}
.ag-header-group-cell-no-group.ag-header-span-height {
  display: none;
}
.ag-cell-label-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
  height: 100%;
  width: 100%;
}
.ag-header-group-cell-label,
.ag-cell-label-container {
  padding: 5px 0px;
}
.ag-right-aligned-header .ag-cell-label-container {
  flex-direction: row;
}
.ag-right-aligned-header .ag-header-cell-text {
  text-align: end;
}
.ag-side-bar {
  display: flex;
  flex-direction: row-reverse;
}
.ag-side-bar-left {
  order: -1;
  flex-direction: row;
}
.ag-side-button-button {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}
.ag-side-button-label {
  writing-mode: vertical-lr;
}
.ag-status-bar {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
.ag-status-panel,
.ag-status-panel.ag-status-panel-aggregations .ag-status-name-value {
  display: inline-flex;
}
.ag-status-name-value {
  white-space: nowrap;
}
.ag-status-bar-left {
  display: inline-flex;
}
.ag-status-bar-center {
  display: inline-flex;
}
.ag-status-bar-right {
  display: inline-flex;
}
.ag-row-number-cell {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}
.ag-ltr .ag-row-number-cell {
  text-align: right;
}
.ag-rtl .ag-row-number-cell {
  text-align: left;
}
.ag-row-numbers-resizer {
  position: absolute;
  bottom: -2px;
  left: 0;
  height: 4px;
  width: 100%;
  cursor: ns-resize;
}
.ag-floating-bottom .ag-row-numbers-resizer {
  bottom: unset;
  top: -2px;
}
.ag-icon {
  display: block;
  speak: none;
}
.ag-group {
  position: relative;
  width: 100%;
}
.ag-group-title-bar {
  display: flex;
  align-items: center;
}
.ag-group-title {
  display: inline;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ag-group-title-bar .ag-group-title {
  cursor: default;
}
.ag-group-toolbar {
  display: flex;
  align-items: center;
}
.ag-group-container {
  display: flex;
}
.ag-disabled .ag-group-container {
  pointer-events: none;
}
.ag-group-container-horizontal {
  flex-direction: row;
  flex-wrap: wrap;
}
.ag-group-container-vertical {
  flex-direction: column;
}
.ag-column-group-icons {
  display: block;
}
.ag-column-group-icons > * {
  cursor: pointer;
}
.ag-group-item-alignment-stretch .ag-group-item {
  align-items: stretch;
}
.ag-group-item-alignment-start .ag-group-item {
  align-items: flex-start;
}
.ag-group-item-alignment-end .ag-group-item {
  align-items: flex-end;
}
.ag-toggle-button-icon {
  transition: right 0.3s;
  position: absolute;
  top: -1px;
}
.ag-input-field,
.ag-select {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ag-input-field-input {
  flex: 1 1 auto;
}
.ag-floating-filter-input .ag-input-field-input[type=date],
.ag-floating-filter-input .ag-input-field-input[type=datetime-local] {
  width: 1px;
}
.ag-range-field {
  display: flex;
  align-items: center;
}
.ag-angle-select {
  display: flex;
  align-items: center;
}
.ag-angle-select-wrapper {
  display: flex;
}
.ag-angle-select-parent-circle {
  display: block;
  position: relative;
}
.ag-angle-select-child-circle {
  position: absolute;
}
.ag-slider-wrapper {
  display: flex;
}
.ag-slider-wrapper .ag-input-field {
  flex: 1 1 auto;
}
.ag-picker-field-display {
  flex: 1 1 auto;
}
.ag-picker-field {
  display: flex;
  align-items: center;
}
.ag-picker-field-icon {
  display: flex;
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.ag-picker-field-wrapper {
  overflow: hidden;
}
.ag-label-align-right .ag-label {
  order: 1;
}
.ag-label-align-right > * {
  flex: none;
}
.ag-label-align-top {
  flex-direction: column;
  align-items: flex-start;
}
.ag-label-align-top > * {
  align-self: stretch;
}
.ag-label-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.ag-color-panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.ag-spectrum-color {
  flex: 1 1 auto;
  position: relative;
  overflow: visible;
  cursor: default;
}
.ag-spectrum-fill {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.ag-spectrum-val {
  cursor: pointer;
}
.ag-spectrum-dragger {
  position: absolute;
  pointer-events: none;
  cursor: pointer;
}
.ag-spectrum-hue,
.ag-spectrum-alpha {
  cursor: default;
}
.ag-spectrum-hue-background {
  background: linear-gradient(to left, #ff0000 3%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);
  width: 100%;
  height: 100%;
}
.ag-spectrum-alpha {
  --ag-spectrum-alpha-background-checked: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.ag-spectrum-alpha-background {
  background: linear-gradient(to right, var(--ag-internal-spectrum-alpha-color-from), var(--ag-internal-spectrum-alpha-color-to)), var(--ag-spectrum-alpha-background-checked) top left/4px 4px;
  width: 100%;
  height: 100%;
}
.ag-spectrum-tool {
  cursor: pointer;
  position: relative;
}
.ag-spectrum-slider {
  position: absolute;
  pointer-events: none;
}
.ag-spectrum-alpha .ag-spectrum-slider {
  background: linear-gradient(to bottom, var(--ag-internal-spectrum-alpha-color), var(--ag-internal-spectrum-alpha-color)) white;
}
.ag-recent-colors {
  display: flex;
}
.ag-recent-color {
  cursor: pointer;
}
.ag-pill-select {
  display: flex;
  flex-direction: column;
}
.ag-pill-select .ag-column-drop {
  flex: unset;
}
.ag-ltr {
  direction: ltr;
}
.ag-ltr .ag-body,
.ag-ltr .ag-floating-top,
.ag-ltr .ag-floating-bottom,
.ag-ltr .ag-header,
.ag-ltr .ag-sticky-top,
.ag-ltr .ag-sticky-bottom,
.ag-ltr .ag-body-viewport,
.ag-ltr .ag-body-horizontal-scroll {
  flex-direction: row;
}
.ag-rtl {
  direction: rtl;
}
.ag-rtl .ag-body,
.ag-rtl .ag-floating-top,
.ag-rtl .ag-floating-bottom,
.ag-rtl .ag-header,
.ag-rtl .ag-sticky-top,
.ag-rtl .ag-sticky-bottom,
.ag-rtl .ag-body-viewport,
.ag-rtl .ag-body-horizontal-scroll {
  flex-direction: row-reverse;
}
.ag-rtl .ag-icon-contracted,
.ag-rtl .ag-icon-expanded,
.ag-rtl .ag-icon-tree-closed {
  display: block;
  transform: rotate(180deg);
}
.ag-body .ag-body-viewport {
  -webkit-overflow-scrolling: touch;
}
.ag-measurement-container {
  width: 0;
  overflow: hidden;
  visibility: hidden;
}
.ag-measurement-container div {
  position: absolute;
}
.ag-layout-print.ag-body {
  display: block;
  height: unset;
}
.ag-layout-print.ag-root-wrapper {
  display: inline-block;
}
.ag-layout-print .ag-body-vertical-scroll {
  display: none;
}
.ag-layout-print .ag-body-horizontal-scroll {
  display: none;
}
.ag-layout-print.ag-force-vertical-scroll {
  overflow-y: visible !important;
}
@media print {
.ag-root-wrapper.ag-layout-print {
    display: table;
}
.ag-root-wrapper.ag-layout-print .ag-root-wrapper-body,
  .ag-root-wrapper.ag-layout-print .ag-root,
  .ag-root-wrapper.ag-layout-print .ag-body-viewport,
  .ag-root-wrapper.ag-layout-print .ag-center-cols-container,
  .ag-root-wrapper.ag-layout-print .ag-center-cols-viewport,
  .ag-root-wrapper.ag-layout-print .ag-body-horizontal-scroll-viewport,
  .ag-root-wrapper.ag-layout-print .ag-virtual-list-viewport {
    height: auto !important;
    overflow: hidden !important;
    display: block !important;
}
.ag-root-wrapper.ag-layout-print .ag-row,
  .ag-root-wrapper.ag-layout-print .ag-cell {
    break-inside: avoid;
}
}
[class^=ag-],
[class^=ag-]:focus,
[class^=ag-]:after,
[class^=ag-]:before {
  box-sizing: border-box;
  outline: none;
}
[class^=ag-]::-ms-clear {
  display: none;
}
.ag-checkbox .ag-input-wrapper,
.ag-radio-button .ag-input-wrapper {
  overflow: visible;
}
.ag-range-field .ag-input-wrapper {
  height: 100%;
}
.ag-toggle-button {
  flex: none;
  width: unset;
  min-width: unset;
}
.ag-button {
  border-radius: 0px;
  color: var(--ag-foreground-color);
}
.ag-button:hover {
  background-color: transparent;
}
.ag-ltr .ag-label-align-right .ag-label {
  margin-left: var(--ag-grid-size);
}
.ag-rtl .ag-label-align-right .ag-label {
  margin-right: var(--ag-grid-size);
}
input[class^=ag-] {
  margin: 0;
  background-color: var(--ag-background-color);
}
textarea[class^=ag-],
select[class^=ag-] {
  background-color: var(--ag-background-color);
}
input[class^=ag-]:not([type]),
input[class^=ag-][type=text],
input[class^=ag-][type=number],
input[class^=ag-][type=tel],
input[class^=ag-][type=date],
input[class^=ag-][type=datetime-local],
textarea[class^=ag-] {
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  font-family: inherit;
  border: var(--ag-borders-input) var(--ag-input-border-color);
}
input[class^=ag-]:not([type]):disabled,
input[class^=ag-][type=text]:disabled,
input[class^=ag-][type=number]:disabled,
input[class^=ag-][type=tel]:disabled,
input[class^=ag-][type=date]:disabled,
input[class^=ag-][type=datetime-local]:disabled,
textarea[class^=ag-]:disabled {
  color: var(--ag-disabled-foreground-color);
  background-color: var(--ag-input-disabled-background-color);
  border-color: var(--ag-input-disabled-border-color);
}
input[class^=ag-]:not([type]):focus,
input[class^=ag-][type=text]:focus,
input[class^=ag-][type=number]:focus,
input[class^=ag-][type=tel]:focus,
input[class^=ag-][type=date]:focus,
input[class^=ag-][type=datetime-local]:focus,
textarea[class^=ag-]:focus {
  outline: none;
  box-shadow: var(--ag-input-focus-box-shadow);
  border-color: var(--ag-input-focus-border-color);
}
input[class^=ag-]:not([type]):focus.invalid, input[class^=ag-]:not([type]):focus:invalid,
input[class^=ag-][type=text]:focus.invalid,
input[class^=ag-][type=text]:focus:invalid,
input[class^=ag-][type=number]:focus.invalid,
input[class^=ag-][type=number]:focus:invalid,
input[class^=ag-][type=tel]:focus.invalid,
input[class^=ag-][type=tel]:focus:invalid,
input[class^=ag-][type=date]:focus.invalid,
input[class^=ag-][type=date]:focus:invalid,
input[class^=ag-][type=datetime-local]:focus.invalid,
input[class^=ag-][type=datetime-local]:focus:invalid,
textarea[class^=ag-]:focus.invalid,
textarea[class^=ag-]:focus:invalid {
  box-shadow: var(--ag-input-error-focus-box-shadow);
  border-color: var(--ag-invalid-color);
}
input[class^=ag-]:not([type]):invalid,
input[class^=ag-][type=text]:invalid,
input[class^=ag-][type=number]:invalid,
input[class^=ag-][type=tel]:invalid,
input[class^=ag-][type=date]:invalid,
input[class^=ag-][type=datetime-local]:invalid,
textarea[class^=ag-]:invalid {
  border: var(--ag-borders-input-invalid) var(--ag-input-border-color-invalid);
}
input[class^=ag-][type=number]:not(.ag-number-field-input-stepper) {
  -moz-appearance: textfield;
}
input[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-outer-spin-button, input[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[class^=ag-][type=range] {
  padding: 0;
}
input[class^=ag-][type=button]:focus,
button[class^=ag-]:focus {
  box-shadow: var(--ag-input-focus-box-shadow);
}
input[class^=ag-][type=button]:focus:invalid, input[class^=ag-][type=button]:focus.invalid,
button[class^=ag-]:focus:invalid,
button[class^=ag-]:focus.invalid {
  box-shadow: var(--ag-input-error-focus-box-shadow);
}
.ag-drag-handle {
  color: var(--ag-secondary-foreground-color);
}
.ag-list-item,
.ag-virtual-list-item {
  height: var(--ag-list-item-height);
}
.ag-virtual-list-item:focus-visible {
  outline: none;
}
.ag-virtual-list-item:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-select-list {
  background-color: var(--ag-background-color);
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: var(--ag-border-radius);
  border: var(--ag-borders) var(--ag-border-color);
}
.ag-list-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-list-item.ag-active-item {
  background-color: var(--ag-row-hover-color);
}
.ag-select-list-item {
  -webkit-user-select: none;
  user-select: none;
  cursor: default;
}
.ag-ltr .ag-select-list-item {
  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-rtl .ag-select-list-item {
  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-select-list-item span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ag-row-drag,
.ag-selection-checkbox,
.ag-group-expanded,
.ag-group-contracted {
  color: var(--ag-secondary-foreground-color);
}
.ag-ltr .ag-row-drag,
.ag-ltr .ag-selection-checkbox,
.ag-ltr .ag-group-expanded,
.ag-ltr .ag-group-contracted {
  margin-right: var(--ag-cell-widget-spacing);
}
.ag-rtl .ag-row-drag,
.ag-rtl .ag-selection-checkbox,
.ag-rtl .ag-group-expanded,
.ag-rtl .ag-group-contracted {
  margin-left: var(--ag-cell-widget-spacing);
}
.ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {
  --ag-internal-calculated-line-height: var(
      --ag-line-height,
      calc(var(--ag-row-height) - var(--ag-row-border-width))
  );
  --ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width) - 2px);
  height: min(var(--ag-internal-calculated-line-height), var(--ag-internal-padded-row-height));
  display: flex;
  align-items: center;
  flex: none;
}
.ag-group-expanded,
.ag-group-contracted {
  cursor: pointer;
}
.ag-group-title-bar-icon {
  cursor: pointer;
  flex: none;
  color: var(--ag-secondary-foreground-color);
}
.ag-ltr .ag-group-child-count {
  margin-left: 2px;
}
.ag-rtl .ag-group-child-count {
  margin-right: 2px;
}
.ag-group-title-bar {
  background-color: var(--ag-subheader-background-color);
  padding: var(--ag-grid-size);
}
.ag-group-toolbar {
  padding: var(--ag-grid-size);
  background-color: var(--ag-subheader-toolbar-background-color);
}
.ag-disabled-group-title-bar,
.ag-disabled-group-container {
  opacity: 0.5;
}
.group-item {
  margin: calc(var(--ag-grid-size) * 0.5) 0;
}
.ag-label {
  white-space: nowrap;
}
.ag-ltr .ag-label {
  margin-right: var(--ag-grid-size);
}
.ag-rtl .ag-label {
  margin-left: var(--ag-grid-size);
}
.ag-label-align-top .ag-label {
  margin-bottom: calc(var(--ag-grid-size) * 0.5);
}
.ag-angle-select[disabled] {
  color: var(--ag-disabled-foreground-color);
  pointer-events: none;
}
.ag-angle-select[disabled] .ag-angle-select-field {
  opacity: 0.4;
}
.ag-ltr .ag-slider-field,
.ag-ltr .ag-angle-select-field {
  margin-right: calc(var(--ag-grid-size) * 2);
}
.ag-rtl .ag-slider-field,
.ag-rtl .ag-angle-select-field {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-angle-select-parent-circle {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: solid 1px;
  border-color: var(--ag-border-color);
  background-color: var(--ag-background-color);
}
.ag-angle-select-child-circle {
  top: 4px;
  left: 12px;
  width: 6px;
  height: 6px;
  margin-left: -3px;
  margin-top: -4px;
  border-radius: 3px;
  background-color: var(--ag-secondary-foreground-color);
}
.ag-picker-field-wrapper {
  border: var(--ag-borders);
  border-color: var(--ag-border-color);
  border-radius: 5px;
  background-color: var(--ag-background-color);
}
.ag-picker-field-wrapper:disabled {
  color: var(--ag-disabled-foreground-color);
  background-color: var(--ag-input-disabled-background-color);
  border-color: var(--ag-input-disabled-border-color);
}
.ag-picker-field-wrapper.ag-picker-has-focus, .ag-picker-field-wrapper:focus-within {
  outline: none;
  box-shadow: var(--ag-input-focus-box-shadow);
  border-color: var(--ag-input-focus-border-color);
}
.ag-picker-field-wrapper.ag-picker-has-focus.invalid, .ag-picker-field-wrapper:focus-within.invalid {
  box-shadow: var(--ag-input-error-focus-box-shadow);
}
.ag-picker-field-wrapper.invalid {
  border: var(--ag-borders-input-invalid) var(--ag-input-border-color-invalid);
}
.ag-picker-field-button {
  background-color: var(--ag-background-color);
  color: var(--ag-secondary-foreground-color);
}
.ag-dialog.ag-color-dialog {
  border-radius: 5px;
}
.ag-color-picker .ag-picker-field-wrapper {
  padding-left: var(--ag-grid-size);
  padding-right: var(--ag-grid-size);
}
.ag-color-picker .ag-picker-field-display {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: var(--ag-list-item-height);
}
.ag-ltr .ag-color-picker-color,
.ag-ltr .ag-color-picker-value {
  margin-right: var(--ag-grid-size);
}
.ag-rtl .ag-color-picker-color,
.ag-rtl .ag-color-picker-value {
  margin-left: var(--ag-grid-size);
}
.ag-color-panel {
  padding: var(--ag-grid-size);
}
.ag-spectrum-color {
  background-color: rgb(255, 0, 0);
  border-radius: 2px;
}
.ag-spectrum-tools {
  padding: 10px;
}
.ag-spectrum-sat {
  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));
}
.ag-spectrum-val {
  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));
}
.ag-spectrum-dragger {
  border-radius: 12px;
  height: 12px;
  width: 12px;
  border: 2px solid white;
  background: black;
  box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);
}
.ag-spectrum-hue-background {
  border-radius: 2px;
}
.ag-spectrum-alpha-background {
  border-radius: 2px;
}
.ag-spectrum-tool {
  margin-bottom: 10px;
  height: 11px;
  border-radius: 2px;
}
.ag-spectrum-slider {
  margin-top: -12px;
  width: 13px;
  height: 13px;
  border-radius: 13px;
  border: 2px solid white;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
}
.ag-recent-colors {
  margin-top: 10px;
}
.ag-recent-color {
  margin: 0 3px;
}
.ag-recent-color:first-child {
  margin-left: 0;
}
.ag-recent-color:last-child {
  margin-right: 0;
}
.ag-spectrum-color:focus-visible:not(:disabled):not([readonly]),
.ag-spectrum-slider:focus-visible:not(:disabled):not([readonly]),
.ag-recent-color:focus-visible:not(:disabled):not([readonly]) {
  box-shadow: var(--ag-input-focus-box-shadow);
}
.ag-ltr .ag-color-input input[class^=ag-][type=text].ag-input-field-input {
  padding-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
}
.ag-rtl .ag-color-input input[class^=ag-][type=text].ag-input-field-input {
  padding-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
}
.ag-color-input .ag-color-input-color {
  position: absolute;
}
.ag-ltr .ag-color-input .ag-color-input-color {
  margin-left: var(--ag-grid-size);
}
.ag-rtl .ag-color-input .ag-color-input-color {
  margin-right: var(--ag-grid-size);
}
.ag-color-picker-color,
.ag-color-input-color {
  width: var(--ag-icon-size);
  height: var(--ag-icon-size);
  border: var(--ag-borders-secondary) var(--ag-secondary-border-color);
  border-radius: 2px;
}
.ag-dnd-ghost {
  border: var(--ag-borders) var(--ag-border-color);
  background: var(--ag-background-color);
  border-radius: var(--ag-card-radius);
  box-shadow: var(--ag-card-shadow);
  padding: var(--ag-grid-size);
  overflow: hidden;
  text-overflow: ellipsis;
  border: var(--ag-borders-secondary) var(--ag-secondary-border-color);
  color: var(--ag-secondary-foreground-color);
  height: var(--ag-header-height);
  line-height: var(--ag-header-height);
  margin: 0;
  padding: 0 calc(var(--ag-grid-size) * 2);
  transform: translateY(calc(var(--ag-grid-size) * 2));
}
.ag-dnd-ghost-not-allowed {
  border-color: color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 50%);
}
.ag-dnd-ghost-icon {
  margin-right: var(--ag-grid-size);
  color: var(--ag-foreground-color);
}
.ag-popup-child:not(.ag-tooltip-custom) {
  box-shadow: var(--ag-popup-shadow);
}
.ag-select .ag-picker-field-wrapper {
  min-height: var(--ag-list-item-height);
  cursor: default;
}
.ag-ltr .ag-select .ag-picker-field-wrapper {
  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-rtl .ag-select .ag-picker-field-wrapper {
  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-ltr .ag-select .ag-picker-field-wrapper {
  padding-right: var(--ag-grid-size);
}
.ag-rtl .ag-select .ag-picker-field-wrapper {
  padding-left: var(--ag-grid-size);
}
.ag-select.ag-disabled .ag-picker-field-wrapper:focus {
  box-shadow: none;
}
.ag-select:not(.ag-cell-editor, .ag-label-align-top) {
  min-height: var(--ag-list-item-height);
}
.ag-select .ag-picker-field-display {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-select .ag-picker-field-icon {
  display: flex;
  align-items: center;
}
.ag-select.ag-disabled {
  opacity: 0.5;
}
.ag-rich-select-value,
.ag-rich-select-list {
  background-color: var(--ag-background-color);
}
.ag-rich-select-list {
  width: 100%;
  height: auto;
  border-radius: var(--ag-border-radius);
  border: var(--ag-borders) var(--ag-border-color);
}
.ag-rich-select-list .ag-loading-text {
  padding: var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing);
}
.ag-rich-select-value {
  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);
  padding-top: 0;
  padding-bottom: 0;
}
.ag-ltr .ag-rich-select-value {
  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-rtl .ag-rich-select-value {
  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-ltr .ag-rich-select-value {
  padding-right: var(--ag-grid-size);
}
.ag-rtl .ag-rich-select-value {
  padding-left: var(--ag-grid-size);
}
.ag-ltr .ag-rich-select-field-input {
  left: calc(var(--ag-cell-horizontal-padding));
}
.ag-rtl .ag-rich-select-field-input {
  right: calc(var(--ag-cell-horizontal-padding));
}
.ag-popup-editor .ag-rich-select-value {
  height: var(--ag-row-height);
  min-width: 200px;
}
.ag-rich-select-virtual-list-item {
  cursor: default;
  height: var(--ag-list-item-height);
}
.ag-rich-select-virtual-list-item:focus-visible::after {
  content: none;
}
.ag-ltr .ag-rich-select-row {
  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-rtl .ag-rich-select-row {
  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);
}
.ag-rich-select-row-selected {
  background-color: var(--ag-selected-row-background-color);
}
.ag-rich-select-row:hover,
.ag-rich-select-row-highlighted {
  background-image: linear-gradient(var(--ag-row-hover-color), var(--ag-row-hover-color));
}
.ag-rich-select-row-text-highlight {
  font-weight: bold;
}
.ag-autocomplete {
  width: 100%;
}
.ag-autocomplete-list {
  width: 100%;
  min-width: 200px;
  height: calc(var(--ag-row-height) * 6.5);
}
.ag-autocomplete-virtual-list-item {
  cursor: default;
  height: var(--ag-list-item-height);
}
.ag-autocomplete-virtual-list-item:focus-visible::after {
  content: none;
}
.ag-autocomplete-virtual-list-item:hover {
  background-color: var(--ag-row-hover-color);
}
.ag-autocomplete-row-label {
  margin: 0px var(--ag-widget-container-horizontal-padding);
}
.ag-autocomplete-row-selected {
  background-color: var(--ag-selected-row-background-color);
}
.ag-pill {
  border: 1px solid var(--ag-chip-border-color);
  border-radius: var(--ag-border-radius);
  background-color: var(--ag-chip-background-color);
}
.ag-ltr .ag-pill .ag-pill-button {
  margin-left: var(--ag-grid-size);
}
.ag-rtl .ag-pill .ag-pill-button {
  margin-right: var(--ag-grid-size);
}
.ag-pill:focus-visible {
  border-color: var(--ag-input-focus-border-color);
}
.ag-pill .ag-pill-button:hover {
  cursor: pointer;
}
.ag-dragging-range-handle .ag-dialog,
.ag-dragging-fill-handle .ag-dialog {
  opacity: 0.7;
  pointer-events: none;
}
.ag-dialog {
  border-radius: var(--ag-border-radius);
  border: var(--ag-borders) var(--ag-border-color);
  box-shadow: var(--ag-popup-shadow);
}
.ag-panel {
  background-color: var(--ag-panel-background-color);
  border-color: var(--ag-panel-border-color);
}
.ag-panel-title-bar {
  color: var(--ag-header-foreground-color);
  height: var(--ag-header-height);
  padding: var(--ag-grid-size) var(--ag-cell-horizontal-padding);
  border-bottom: var(--ag-borders) var(--ag-border-color);
}
.ag-ltr .ag-panel-title-bar-button {
  margin-left: var(--ag-grid-size);
}
.ag-rtl .ag-panel-title-bar-button {
  margin-right: var(--ag-grid-size);
}
.ag-tooltip {
  background-color: var(--ag-tooltip-background-color);
  color: var(--ag-foreground-color);
  padding: var(--ag-grid-size);
  border: var(--ag-borders) var(--ag-border-color);
  border-radius: var(--ag-card-radius);
  white-space: normal;
}
.ag-tooltip.ag-cell-editor-tooltip {
  background-color: var(--ag-tooltip-error-background-color);
  color: var(--ag-tooltip-error-text-color);
  border: var(--ag-borders) var(--ag-tooltip-error-border-color);
  font-weight: 500;
}
.ag-tooltip.ag-tooltip-animate,
.ag-tooltip-custom.ag-tooltip-animate {
  transition: opacity 1s;
}
.ag-tooltip.ag-tooltip-animate.ag-tooltip-hiding,
.ag-tooltip-custom.ag-tooltip-animate.ag-tooltip-hiding {
  opacity: 0;
}
.ag-ltr .ag-column-select-column,
.ag-ltr .ag-column-select-column-group {
  padding-left: calc(var(--ag-indentation-level) * var(--ag-column-select-indent-size));
}
.ag-rtl .ag-column-select-column,
.ag-rtl .ag-column-select-column-group {
  padding-right: calc(var(--ag-indentation-level) * var(--ag-column-select-indent-size));
}
.ag-column-select-header-icon {
  cursor: pointer;
}
.ag-column-select-header-icon:focus-visible {
  outline: none;
}
.ag-column-select-header-icon:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-ltr .ag-column-group-icons:not(:last-child),
.ag-ltr .ag-column-select-header-icon:not(:last-child),
.ag-ltr .ag-column-select-header-checkbox:not(:last-child),
.ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child),
.ag-ltr .ag-column-select-checkbox:not(:last-child),
.ag-ltr .ag-column-select-column-drag-handle:not(:last-child),
.ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child),
.ag-ltr .ag-column-select-column-label:not(:last-child) {
  margin-right: var(--ag-widget-horizontal-spacing);
}
.ag-rtl .ag-column-group-icons:not(:last-child),
.ag-rtl .ag-column-select-header-icon:not(:last-child),
.ag-rtl .ag-column-select-header-checkbox:not(:last-child),
.ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child),
.ag-rtl .ag-column-select-checkbox:not(:last-child),
.ag-rtl .ag-column-select-column-drag-handle:not(:last-child),
.ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child),
.ag-rtl .ag-column-select-column-label:not(:last-child) {
  margin-left: var(--ag-widget-horizontal-spacing);
}
.ag-column-select-virtual-list-item:focus-visible {
  outline: none;
}
.ag-column-select-virtual-list-item:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-column-select-column-group:not(:last-child),
.ag-column-select-column:not(:last-child) {
  margin-bottom: var(--ag-widget-vertical-spacing);
}
.ag-column-select-column-readonly,
.ag-column-select-column-group-readonly {
  color: var(--ag-disabled-foreground-color);
  pointer-events: none;
}
.ag-ltr .ag-column-select-add-group-indent {
  margin-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
}
.ag-rtl .ag-column-select-add-group-indent {
  margin-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
}
.ag-column-select-virtual-list-viewport {
  padding: calc(var(--ag-widget-container-vertical-padding) * 0.5) 0px;
}
.ag-column-select-virtual-list-item {
  padding: 0 var(--ag-widget-container-horizontal-padding);
}
.ag-checkbox-edit {
  padding-left: var(--ag-cell-horizontal-padding);
  padding-right: var(--ag-cell-horizontal-padding);
}
.ag-pill-select .ag-column-drop {
  border-bottom: 0;
  min-height: unset;
}
.ag-pill-select .ag-column-drop-list {
  padding: 0;
}
.ag-pill-select .ag-select {
  padding-top: var(--ag-grid-size);
}
.ag-pill-select .ag-picker-field-wrapper {
  background-color: transparent;
  border: 0;
}
.ag-pill-select .ag-picker-field-display {
  cursor: pointer;
}
.ag-rtl {
  text-align: right;
}
.ag-root-wrapper {
  border-radius: var(--ag-wrapper-border-radius);
  border: var(--ag-borders) var(--ag-border-color);
}
.ag-row > .ag-cell-wrapper.ag-row-group {
  padding-left: calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * var(--ag-indentation-level));
}
.ag-cell-wrapper.ag-row-group,
.ag-cell-wrapper.ag-row-group-leaf-indent,
.ag-cell-wrapper.ag-pivot-leaf-group {
  padding-left: calc(var(--ag-indentation-level) * var(--ag-row-group-indent-size));
}
.ag-cell-wrapper > .ag-group-checkbox-spacing {
  width: var(--ag-icon-size);
  margin-right: var(--ag-cell-widget-spacing);
}
.ag-ltr .ag-row-group-leaf-indent {
  margin-left: var(--ag-row-group-indent-size);
}
.ag-rtl .ag-row-group-leaf-indent {
  margin-right: var(--ag-row-group-indent-size);
}
.ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group {
  margin-left: var(--ag-row-group-indent-size);
}
.ag-value-change-delta {
  padding-right: 2px;
}
.ag-value-change-delta-up {
  color: var(--ag-value-change-delta-up-color);
}
.ag-value-change-delta-down {
  color: var(--ag-value-change-delta-down-color);
}
.ag-value-change-value {
  background-color: transparent;
  border-radius: 1px;
  padding-left: 1px;
  padding-right: 1px;
  transition: background-color 1s;
}
.ag-value-change-value-highlight {
  background-color: var(--ag-value-change-value-highlight-background-color);
  transition: background-color 0.1s;
}
.ag-cell-data-changed {
  background-color: var(--ag-value-change-value-highlight-background-color) !important;
}
.ag-cell-data-changed-animation {
  background-color: transparent;
}
.ag-cell-highlight {
  background-color: var(--ag-range-selection-highlight-color) !important;
}
.ag-row,
.ag-spanned-row {
  color: var(--ag-data-color);
}
.ag-row {
  height: var(--ag-row-height);
  background-color: var(--ag-data-background-color);
  border-bottom: var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width);
}
.ag-row.ag-row-editing-invalid {
  background-color: var(--ag-full-row-invalid-background-color);
}
.ag-spanned-cell-wrapper {
  background-color: var(--ag-data-background-color);
  position: absolute;
}
.ag-spanned-cell-wrapper > .ag-spanned-cell {
  display: block;
  position: relative;
}
.ag-row-highlight-above::after,
.ag-row-highlight-inside::after,
.ag-row-highlight-below::after {
  content: "";
  position: absolute;
  width: calc(100% - 1px);
  height: 1px;
  background-color: var(--ag-range-selection-border-color);
  left: 1px;
  pointer-events: none;
}
.ag-row-highlight-above::after {
  top: 0;
}
.ag-row-highlight-below::after {
  bottom: 0;
}
.ag-row-highlight-indent::after {
  display: block;
  width: auto;
  left: calc(2 * (var(--ag-cell-widget-spacing) + var(--ag-icon-size)) + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level) * var(--ag-row-group-indent-size));
  right: 1px;
}
.ag-row-highlight-inside::after {
  display: block;
  width: auto;
  height: auto;
  inset: 0;
  background-color: var(--ag-selected-row-background-color);
  border: 1px solid var(--ag-range-selection-border-color);
}
.ag-body,
.ag-floating-top,
.ag-floating-bottom {
  background-color: var(--ag-data-background-color);
}
.ag-row-odd {
  background-color: var(--ag-odd-row-background-color);
}
.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {
  border-right: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {
  border-left: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-row-selected::before {
  content: "";
  background-color: var(--ag-selected-row-background-color);
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.ag-row-hover:not(.ag-full-width-row)::before,
.ag-row-hover.ag-full-width-row.ag-row-group::before {
  content: "";
  background-color: var(--ag-row-hover-color);
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
.ag-row.ag-full-width-row.ag-row-group > * {
  position: relative;
}
.ag-row-hover.ag-row-selected::before {
  background-color: var(--ag-row-hover-color);
  background-image: linear-gradient(var(--ag-selected-row-background-color), var(--ag-selected-row-background-color));
}
.ag-column-hover {
  background-color: var(--ag-column-hover-color);
}
.ag-header-range-highlight {
  background-color: var(--ag-range-header-highlight-color);
}
.ag-ltr .ag-right-aligned-cell {
  text-align: right;
}
.ag-rtl .ag-right-aligned-cell {
  text-align: left;
}
.ag-ltr .ag-right-aligned-cell .ag-cell-value,
.ag-ltr .ag-right-aligned-cell .ag-group-value {
  margin-left: auto;
}
.ag-rtl .ag-right-aligned-cell .ag-cell-value,
.ag-rtl .ag-right-aligned-cell .ag-group-value {
  margin-right: auto;
}
.ag-ltr .ag-right-aligned-cell .ag-skeleton-effect {
  margin-left: auto;
}
.ag-rtl .ag-right-aligned-cell .ag-skeleton-effect {
  margin-right: auto;
}
.ag-cell,
.ag-full-width-row .ag-cell-wrapper.ag-row-group {
  --ag-internal-calculated-line-height: var(
      --ag-line-height,
      calc(var(--ag-row-height) - var(--ag-row-border-width))
  );
  --ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width) - 2px);
  border: 1px solid transparent;
  line-height: min(var(--ag-internal-calculated-line-height), var(--ag-internal-padded-row-height));
  padding-left: calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size) * var(--ag-indentation-level));
  padding-right: calc(var(--ag-cell-horizontal-padding) - 1px);
  -webkit-font-smoothing: subpixel-antialiased;
}
.ag-row > .ag-cell-wrapper {
  padding-left: calc(var(--ag-cell-horizontal-padding) - 1px);
  padding-right: calc(var(--ag-cell-horizontal-padding) - 1px);
}
.ag-row-dragging {
  cursor: move;
  opacity: 0.5;
}
.ag-cell-inline-editing {
  border: 1px solid var(--ag-border-color);
  border-radius: var(--ag-card-radius);
  box-shadow: var(--ag-card-shadow);
  padding: 0;
  background-color: var(--ag-control-panel-background-color);
}
.ag-popup-editor .ag-large-text,
.ag-autocomplete-list-popup {
  border: var(--ag-borders) var(--ag-border-color);
  background: var(--ag-background-color);
  border-radius: var(--ag-card-radius);
  box-shadow: var(--ag-card-shadow);
  padding: var(--ag-grid-size);
  background-color: var(--ag-control-panel-background-color);
  padding: 0;
}
.ag-large-text-input {
  height: auto;
  padding: var(--ag-cell-horizontal-padding);
}
.ag-rtl .ag-large-text-input textarea {
  resize: none;
}
.ag-details-row {
  padding: calc(var(--ag-grid-size) * 5);
  background-color: var(--ag-data-background-color);
}
.ag-layout-auto-height .ag-center-cols-viewport,
.ag-layout-auto-height .ag-center-cols-container,
.ag-layout-print .ag-center-cols-viewport,
.ag-layout-print .ag-center-cols-container {
  min-height: 50px;
}
.ag-overlay-loading-wrapper {
  background-color: var(--ag-modal-overlay-background-color);
}
.ag-overlay-loading-center {
  border: var(--ag-borders) var(--ag-border-color);
  background: var(--ag-background-color);
  border-radius: var(--ag-card-radius);
  box-shadow: var(--ag-card-shadow);
  padding: var(--ag-grid-size);
}
.ag-skeleton-container {
  width: 100%;
  height: 100%;
  align-content: center;
}
.ag-skeleton-effect {
  background-color: var(--ag-row-loading-skeleton-effect-color);
  width: 100%;
  height: 1em;
  border-radius: 0.25rem;
  animation: ag-skeleton-loading 1.5s ease-in-out 0.5s infinite;
}
@keyframes ag-skeleton-loading {
0% {
    opacity: 1;
}
50% {
    opacity: 0.4;
}
100% {
    opacity: 1;
}
}
.ag-loading {
  display: flex;
  height: 100%;
  align-items: center;
}
.ag-ltr .ag-loading {
  padding-left: var(--ag-cell-horizontal-padding);
}
.ag-rtl .ag-loading {
  padding-right: var(--ag-cell-horizontal-padding);
}
.ag-ltr .ag-loading-icon {
  padding-right: var(--ag-cell-widget-spacing);
}
.ag-rtl .ag-loading-icon {
  padding-left: var(--ag-cell-widget-spacing);
}
.ag-icon-loading {
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
from {
    transform: rotate(0deg);
}
to {
    transform: rotate(360deg);
}
}
.ag-floating-top:not(.ag-invisible) {
  border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-floating-bottom:not(.ag-invisible) {
  border-top: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-find-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-find-match {
  color: var(--ag-find-match-color);
  background-color: var(--ag-find-match-background-color);
}
.ag-find-active-match {
  color: var(--ag-find-active-match-color);
  background-color: var(--ag-find-active-match-background-color);
}
.ag-ltr .ag-cell {
  border-right: var(--ag-cell-horizontal-border);
}
.ag-rtl .ag-cell {
  border-left: var(--ag-cell-horizontal-border);
}
.ag-ltr .ag-cell {
  border-right-width: 1px;
}
.ag-rtl .ag-cell {
  border-left-width: 1px;
}
.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {
  border-left: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {
  border-right: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-cell-range-selected:not(.ag-cell-focus),
.ag-cell-range-selected.ag-cell-range-chart,
.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {
  background-color: var(--ag-range-selection-background-color);
}
.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,
.ag-cell-range-selected.ag-cell-range-chart.ag-cell-range-chart,
.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {
  background-color: var(--ag-range-selection-chart-background-color) !important;
}
.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,
.ag-cell-range-selected.ag-cell-range-chart.ag-cell-range-chart.ag-cell-range-chart-category,
.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {
  background-color: var(--ag-range-selection-chart-category-background-color) !important;
}
.ag-cell-range-selected-1:not(.ag-cell-focus),
.ag-cell-range-selected-1.ag-cell-range-chart,
.ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {
  background-color: var(--ag-range-selection-background-color);
}
.ag-cell-range-selected-2:not(.ag-cell-focus),
.ag-cell-range-selected-2.ag-cell-range-chart,
.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {
  background-color: var(--ag-range-selection-background-color-2);
}
.ag-cell-range-selected-3:not(.ag-cell-focus),
.ag-cell-range-selected-3.ag-cell-range-chart,
.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {
  background-color: var(--ag-range-selection-background-color-3);
}
.ag-cell-range-selected-4:not(.ag-cell-focus),
.ag-cell-range-selected-4.ag-cell-range-chart,
.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {
  background-color: var(--ag-range-selection-background-color-4);
}
.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {
  border-top-color: var(--ag-range-selection-border-color);
  border-top-style: var(--ag-range-selection-border-style);
}
.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {
  border-right-color: var(--ag-range-selection-border-color);
  border-right-style: var(--ag-range-selection-border-style);
}
.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {
  border-bottom-color: var(--ag-range-selection-border-color);
  border-bottom-style: var(--ag-range-selection-border-style);
}
.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {
  border-left-color: var(--ag-range-selection-border-color);
  border-left-style: var(--ag-range-selection-border-style);
}
.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.ag-ltr .ag-cell-range-single-cell,
.ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
.ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.ag-rtl .ag-cell-range-single-cell,
.ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: 1px solid;
  border-color: var(--ag-range-selection-border-color);
  border-style: var(--ag-range-selection-border-style);
  outline: initial;
}
.ag-cell.ag-selection-fill-top,
.ag-cell.ag-selection-fill-top.ag-cell-range-selected {
  border-top: 1px dashed;
  border-top-color: var(--ag-range-selection-border-color);
}
.ag-ltr .ag-cell.ag-selection-fill-right,
.ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-right: 1px dashed var(--ag-range-selection-border-color) !important;
}
.ag-rtl .ag-cell.ag-selection-fill-right,
.ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-left: 1px dashed var(--ag-range-selection-border-color) !important;
}
.ag-cell.ag-selection-fill-bottom,
.ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {
  border-bottom: 1px dashed;
  border-bottom-color: var(--ag-range-selection-border-color);
}
.ag-ltr .ag-cell.ag-selection-fill-left,
.ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-left: 1px dashed var(--ag-range-selection-border-color) !important;
}
.ag-rtl .ag-cell.ag-selection-fill-left,
.ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-right: 1px dashed var(--ag-range-selection-border-color) !important;
}
.ag-fill-handle,
.ag-range-handle {
  position: absolute;
  width: 6px;
  height: 6px;
  bottom: -1px;
  background-color: var(--ag-range-selection-border-color);
}
.ag-ltr .ag-fill-handle,
.ag-ltr .ag-range-handle {
  right: -1px;
}
.ag-rtl .ag-fill-handle,
.ag-rtl .ag-range-handle {
  left: -1px;
}
.ag-fill-handle {
  cursor: crosshair;
}
.ag-range-handle {
  cursor: nwse-resize;
}
.ag-cell-inline-editing {
  border-color: var(--ag-input-focus-border-color) !important;
}
.ag-cell-inline-editing.ag-cell-editing-error {
  border-color: var(--ag-invalid-color) !important;
}
.ag-menu {
  border: var(--ag-borders) var(--ag-border-color);
  background: var(--ag-background-color);
  border-radius: var(--ag-card-radius);
  box-shadow: var(--ag-card-shadow);
  padding: var(--ag-grid-size);
  background-color: var(--ag-menu-background-color);
  border-color: var(--ag-menu-border-color);
  padding: 0;
}
.ag-menu.ag-tabs {
  min-width: var(--ag-tab-min-width);
}
.ag-menu-list {
  cursor: default;
  padding: var(--ag-grid-size) 0;
}
.ag-menu-separator {
  height: calc(var(--ag-grid-size) * 2 + 1px);
}
.ag-menu-separator-part::after {
  content: "";
  display: block;
  border-top: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-menu-option {
  position: relative;
}
.ag-menu-option:focus-visible {
  outline: none;
}
.ag-menu-option:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-menu-option-active,
.ag-compact-menu-option-active {
  background-color: var(--ag-row-hover-color);
}
.ag-menu-option-part,
.ag-compact-menu-option-part {
  line-height: var(--ag-icon-size);
  padding: calc(var(--ag-grid-size) + 2px) 0;
}
.ag-menu-option-disabled,
.ag-compact-menu-option-disabled {
  opacity: 0.5;
}
.ag-menu-option-icon,
.ag-compact-menu-option-icon {
  width: var(--ag-icon-size);
}
.ag-ltr .ag-menu-option-icon,
.ag-ltr .ag-compact-menu-option-icon {
  padding-left: calc(var(--ag-grid-size) * 2);
}
.ag-rtl .ag-menu-option-icon,
.ag-rtl .ag-compact-menu-option-icon {
  padding-right: calc(var(--ag-grid-size) * 2);
}
.ag-menu-option-text,
.ag-compact-menu-option-text {
  padding-left: calc(var(--ag-grid-size) * 2);
  padding-right: calc(var(--ag-grid-size) * 2);
}
.ag-ltr .ag-menu-option-shortcut,
.ag-ltr .ag-compact-menu-option-shortcut {
  padding-right: var(--ag-grid-size);
}
.ag-rtl .ag-menu-option-shortcut,
.ag-rtl .ag-compact-menu-option-shortcut {
  padding-left: var(--ag-grid-size);
}
.ag-ltr .ag-menu-option-popup-pointer,
.ag-ltr .ag-compact-menu-option-popup-pointer {
  padding-right: var(--ag-grid-size);
}
.ag-rtl .ag-menu-option-popup-pointer,
.ag-rtl .ag-compact-menu-option-popup-pointer {
  padding-left: var(--ag-grid-size);
}
.ag-tabs-header {
  display: flex;
}
.ag-tabs-header-wrapper {
  display: flex;
}
.ag-tabs-header-wrapper .ag-tabs-header {
  flex: 1;
}
.ag-tabs-close-button-wrapper {
  border: 0;
  border-right: var(--ag-borders) var(--ag-border-color);
  padding: var(--ag-grid-size);
}
.ag-tabs-close-button {
  border: 0;
  background-color: unset;
  cursor: pointer;
  padding: 0;
}
.ag-tab {
  border-bottom: var(--ag-selected-tab-underline-width) solid transparent;
  transition: border-bottom var(--ag-selected-tab-underline-transition-speed);
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ag-tab:focus-visible {
  outline: none;
}
.ag-tab:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-tab-selected {
  border-bottom-color: var(--ag-selected-tab-underline-color);
}
.ag-menu-header {
  color: var(--ag-secondary-foreground-color);
}
.ag-filter-separator {
  border-top: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-filter-select .ag-picker-field-wrapper {
  width: 0;
}
.ag-filter-condition-operator {
  height: 17px;
}
.ag-ltr .ag-filter-condition-operator-or {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-rtl .ag-filter-condition-operator-or {
  margin-right: calc(var(--ag-grid-size) * 2);
}
.ag-set-filter-select-all {
  padding-top: var(--ag-widget-container-vertical-padding);
}
.ag-set-filter-list,
.ag-filter-no-matches {
  height: calc(var(--ag-list-item-height) * 6);
}
.ag-set-filter-tree-list {
  height: calc(var(--ag-list-item-height) * 10);
}
.ag-set-filter-filter {
  margin-top: var(--ag-widget-container-vertical-padding);
  margin-left: var(--ag-widget-container-horizontal-padding);
  margin-right: var(--ag-widget-container-horizontal-padding);
}
.ag-filter-to {
  margin-top: var(--ag-widget-vertical-spacing);
}
.ag-mini-filter {
  margin: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
}
.ag-set-filter {
  --ag-indentation-level: 0;
}
.ag-ltr .ag-set-filter-item {
  padding-left: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));
}
.ag-rtl .ag-set-filter-item {
  padding-right: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));
}
.ag-ltr .ag-set-filter-add-group-indent {
  margin-left: calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding));
}
.ag-rtl .ag-set-filter-add-group-indent {
  margin-right: calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding));
}
.ag-ltr .ag-set-filter-group-icons {
  margin-right: var(--ag-widget-container-horizontal-padding);
}
.ag-rtl .ag-set-filter-group-icons {
  margin-left: var(--ag-widget-container-horizontal-padding);
}
.ag-filter-menu .ag-set-filter-list {
  min-width: 200px;
}
.ag-filter-virtual-list-item:focus-visible {
  outline: none;
}
.ag-filter-virtual-list-item:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-filter-apply-panel {
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);
}
.ag-filter-apply-panel-button {
  line-height: 1.5;
}
.ag-ltr .ag-filter-apply-panel-button {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-rtl .ag-filter-apply-panel-button {
  margin-right: calc(var(--ag-grid-size) * 2);
}
.ag-simple-filter-body-wrapper {
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));
  overflow-y: auto;
  min-height: calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));
}
.ag-simple-filter-body-wrapper > * {
  margin-bottom: var(--ag-widget-vertical-spacing);
}
.ag-simple-filter-body-wrapper .ag-resizer-wrapper {
  margin: 0;
}
.ag-menu:not(.ag-tabs) .ag-filter .ag-filter-body-wrapper,
.ag-menu:not(.ag-tabs) .ag-filter > *:not(.ag-filter-wrapper) {
  min-width: calc(var(--ag-menu-min-width) - 2px);
}
.ag-filter-no-matches {
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
}
.ag-multi-filter-menu-item {
  margin: var(--ag-grid-size) 0;
}
.ag-multi-filter-group-title-bar {
  padding: calc(var(--ag-grid-size) * 2) var(--ag-grid-size);
  background-color: transparent;
}
.ag-group-filter-field-select-wrapper {
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));
}
.ag-group-filter-field-select-wrapper > * {
  margin-bottom: var(--ag-widget-vertical-spacing);
}
.ag-multi-filter-group-title-bar:focus-visible {
  outline: none;
}
.ag-multi-filter-group-title-bar:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-side-bar {
  position: relative;
}
.ag-tool-panel-wrapper {
  width: var(--ag-side-bar-panel-width);
  background-color: var(--ag-control-panel-background-color);
}
.ag-tool-panel-external {
  display: flex;
  flex-direction: row;
}
:where(.ag-tool-panel-external) .ag-tool-panel-wrapper {
  flex-grow: 1;
}
.ag-side-buttons {
  padding-top: calc(var(--ag-grid-size) * 4);
  width: calc(var(--ag-icon-size) + 4px);
  position: relative;
  overflow: hidden;
}
button.ag-side-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  background: transparent;
  padding: calc(var(--ag-grid-size) * 2) 0 calc(var(--ag-grid-size) * 2) 0;
  width: 100%;
  margin: 0;
  min-height: calc(var(--ag-grid-size) * 18);
  background-position-y: center;
  background-position-x: center;
  background-repeat: no-repeat;
  border: none;
  border-top: var(--ag-borders-side-button) var(--ag-border-color);
  border-bottom: var(--ag-borders-side-button) var(--ag-border-color);
}
button.ag-side-button-button:focus {
  box-shadow: none;
}
.ag-side-button-button:focus-visible {
  outline: none;
}
.ag-side-button-button:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-selected button.ag-side-button-button {
  background-color: var(--ag-side-button-selected-background-color);
}
.ag-side-button-icon-wrapper {
  margin-bottom: 3px;
}
.ag-ltr .ag-side-bar-left,
.ag-rtl .ag-side-bar-right {
  border-right: var(--ag-borders) var(--ag-border-color);
}
.ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,
.ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper {
  border-left: var(--ag-borders) var(--ag-border-color);
}
.ag-ltr .ag-side-bar-left .ag-side-button-button,
.ag-rtl .ag-side-bar-right .ag-side-button-button {
  border-right: var(--ag-selected-tab-underline-width) solid transparent;
  transition: border-right var(--ag-selected-tab-underline-transition-speed);
}
.ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-right-color: var(--ag-selected-tab-underline-color);
}
.ag-rtl .ag-side-bar-left,
.ag-ltr .ag-side-bar-right {
  border-left: var(--ag-borders) var(--ag-border-color);
}
.ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,
.ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper {
  border-right: var(--ag-borders) var(--ag-border-color);
}
.ag-rtl .ag-side-bar-left .ag-side-button-button,
.ag-ltr .ag-side-bar-right .ag-side-button-button {
  border-left: var(--ag-selected-tab-underline-width) solid transparent;
  transition: border-left var(--ag-selected-tab-underline-transition-speed);
}
.ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-left-color: var(--ag-selected-tab-underline-color);
}
.ag-filter-toolpanel-header {
  height: calc(var(--ag-grid-size) * 6);
}
.ag-filter-toolpanel-header,
.ag-filter-toolpanel-search {
  padding: 0 var(--ag-grid-size);
}
.ag-filter-toolpanel-header:focus-visible {
  outline: none;
}
.ag-filter-toolpanel-header:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-filter-toolpanel-group:not(.ag-has-filter) > .ag-group-title-bar .ag-filter-toolpanel-group-instance-header-icon {
  display: none;
}
.ag-filter-toolpanel-group-level-0-header {
  height: calc(var(--ag-grid-size) * 8);
}
.ag-filter-toolpanel-group-item {
  margin-top: calc(var(--ag-grid-size) * 0.5);
  margin-bottom: calc(var(--ag-grid-size) * 0.5);
}
.ag-filter-toolpanel-search {
  height: var(--ag-header-height);
}
.ag-filter-toolpanel-search-input {
  flex-grow: 1;
  height: calc(var(--ag-grid-size) * 4);
}
.ag-ltr .ag-filter-toolpanel-search-input {
  margin-right: var(--ag-grid-size);
}
.ag-rtl .ag-filter-toolpanel-search-input {
  margin-left: var(--ag-grid-size);
}
.ag-filter-toolpanel-group-level-0 {
  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);
}
.ag-ltr .ag-filter-toolpanel-expand,
.ag-ltr .ag-filter-toolpanel-group-title-bar-icon {
  margin-right: var(--ag-grid-size);
}
.ag-rtl .ag-filter-toolpanel-expand,
.ag-rtl .ag-filter-toolpanel-group-title-bar-icon {
  margin-left: var(--ag-grid-size);
}
.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-ltr .ag-filter-toolpanel-header {
  padding-left: calc(var(--ag-filter-tool-panel-group-indent) * var(--ag-indentation-level, 0) + var(--ag-grid-size));
}
.ag-rtl .ag-filter-toolpanel-header {
  padding-right: calc(var(--ag-filter-tool-panel-group-indent) * var(--ag-indentation-level, 0) + var(--ag-grid-size));
}
.ag-filter-toolpanel-instance-filter {
  border-bottom: var(--ag-borders) var(--ag-border-color);
  border-top: var(--ag-borders) var(--ag-border-color);
  margin-top: var(--ag-grid-size);
}
.ag-ltr .ag-filter-toolpanel-group-instance-header-icon,
.ag-ltr .ag-filter-toolpanel-instance-header-icon {
  margin-left: var(--ag-grid-size);
}
.ag-rtl .ag-filter-toolpanel-group-instance-header-icon,
.ag-rtl .ag-filter-toolpanel-instance-header-icon {
  margin-right: var(--ag-grid-size);
}
.ag-set-filter-group-icons {
  color: var(--ag-secondary-foreground-color);
}
.ag-filter-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.ag-filter-panel .ag-simple-filter-body-wrapper {
  padding: var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) 0;
}
.ag-filter-panel .ag-mini-filter {
  margin-top: var(--ag-widget-vertical-spacing);
  margin-left: var(--ag-widget-container-horizontal-padding);
  margin-right: var(--ag-widget-container-horizontal-padding);
}
.ag-filter-panel .ag-standard-button {
  transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out;
}
.ag-filter-panel .ag-simple-filter-body-wrapper > *:last-child,
.ag-filter-panel .ag-set-filter-body-wrapper {
  margin-bottom: var(--ag-widget-container-vertical-padding);
}
.ag-filter-panel-container {
  flex: 1;
  overflow: auto;
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0;
}
.ag-filter-panel-container > *:not(:last-child) {
  margin-bottom: var(--ag-widget-container-vertical-padding);
}
.ag-filter-card {
  border: 1px solid var(--ag-border-color);
  border-radius: var(--ag-border-radius);
  background-color: var(--ag-background-color);
}
.ag-ltr .ag-filter-card .ag-set-filter-item {
  padding-left: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));
  padding-right: var(--ag-widget-container-horizontal-padding);
}
.ag-rtl .ag-filter-card .ag-set-filter-item {
  padding-right: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));
  padding-left: var(--ag-widget-container-horizontal-padding);
}
.ag-filter-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: var(--ag-widget-vertical-spacing);
}
.ag-ltr .ag-filter-card-header > *:not(:last-child) {
  padding-right: var(--ag-grid-size);
}
.ag-rtl .ag-filter-card-header > *:not(:last-child) {
  padding-left: var(--ag-grid-size);
}
.ag-filter-card-heading {
  flex: 1;
  overflow: hidden;
  padding-top: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));
  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));
}
.ag-ltr .ag-filter-card-heading {
  padding-left: var(--ag-widget-horizontal-spacing);
}
.ag-rtl .ag-filter-card-heading {
  padding-right: var(--ag-widget-horizontal-spacing);
}
.ag-filter-card-expand {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.ag-filter-card-title {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-filter-card-expand-icon {
  display: flex;
  flex: 1;
  justify-content: end;
}
.ag-filter-card-editing-icon {
  margin: 0 var(--ag-grid-size);
}
.ag-filter-card-summary,
.ag-filter-card-expand-icon .ag-icon,
.ag-filter-card-delete-icon .ag-icon,
.ag-filter-card-editing-icon .ag-icon {
  color: var(--ag-filter-panel-card-subtle-color);
}
.ag-filter-card-expand-icon .ag-icon,
.ag-filter-card-delete-icon .ag-icon {
  transition: color 0.25s ease-in-out;
}
.ag-filter-card-expand-icon:hover .ag-icon,
.ag-filter-card-delete-icon:hover .ag-icon {
  color: var(--ag-filter-panel-card-subtle-hover-color);
}
.ag-filter-card-heading:hover .ag-filter-card-expand-icon .ag-icon {
  color: var(--ag-filter-panel-card-subtle-hover-color);
}
.ag-filter-card-expand,
.ag-filter-card-delete {
  border-radius: var(--ag-button-border-radius);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.ag-filter-panel .ag-standard-button {
  cursor: pointer;
}
.ag-filter-card-summary,
.ag-filter-type-select {
  margin-left: var(--ag-widget-container-horizontal-padding);
  margin-right: var(--ag-widget-container-horizontal-padding);
}
.ag-ltr .ag-filter-card-delete {
  margin-right: var(--ag-widget-horizontal-spacing);
}
.ag-rtl .ag-filter-card-delete {
  margin-left: var(--ag-widget-horizontal-spacing);
}
.ag-filter-card-summary {
  margin-bottom: var(--ag-widget-container-vertical-padding);
}
.ag-filter-type-select {
  padding-top: var(--ag-widget-vertical-spacing);
}
.ag-filter-card-add {
  padding: 0;
  border: 0;
}
.ag-filter-add-button {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  line-height: 1.5;
}
.ag-ltr .ag-filter-add-button-label {
  margin-left: var(--ag-grid-size);
}
.ag-rtl .ag-filter-add-button-label {
  margin-right: var(--ag-grid-size);
}
.ag-filter-add-select {
  border: 0;
}
.ag-ltr .ag-filter-add-select .ag-text-field-input {
  padding-left: calc(var(--ag-grid-size) * 1.5 + 12px) !important;
}
.ag-rtl .ag-filter-add-select .ag-text-field-input {
  padding-right: calc(var(--ag-grid-size) * 1.5 + 12px) !important;
}
.ag-filter-add-select .ag-rich-select-value {
  padding: calc((1.5 * var(--ag-font-size) + 4 * var(--ag-grid-size) - var(--ag-input-height)) / 2) var(--ag-grid-size);
  border: 0;
}
.ag-pivot-mode-panel {
  min-height: var(--ag-header-height);
  height: var(--ag-header-height);
  display: flex;
}
.ag-pivot-mode-select {
  display: flex;
  align-items: center;
}
.ag-ltr .ag-pivot-mode-select {
  margin-left: var(--ag-widget-container-horizontal-padding);
}
.ag-rtl .ag-pivot-mode-select {
  margin-right: var(--ag-widget-container-horizontal-padding);
}
.ag-column-select-header:focus-visible {
  outline: none;
}
.ag-column-select-header:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-column-select-header {
  height: var(--ag-header-height);
  align-items: center;
  padding: 0 var(--ag-widget-container-horizontal-padding);
  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);
}
.ag-column-panel-column-select {
  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);
  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);
}
.ag-column-group-icons,
.ag-column-select-header-icon {
  color: var(--ag-secondary-foreground-color);
}
.ag-column-select-list .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
}
.ag-column-select-list .ag-item-highlight-top::after {
  top: 0;
}
.ag-column-select-list .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-header,
.ag-advanced-filter-header {
  background-color: var(--ag-header-background-color);
  border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-header-row {
  color: var(--ag-header-foreground-color);
  height: var(--ag-header-height);
}
.ag-pinned-right-header {
  border-left: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-pinned-left-header {
  border-right: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,
.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon {
  margin-left: var(--ag-grid-size);
}
.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,
.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon {
  margin-right: var(--ag-grid-size);
}
.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,
.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon {
  margin-right: var(--ag-grid-size);
}
.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,
.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon {
  margin-left: var(--ag-grid-size);
}
.ag-header-cell,
.ag-header-group-cell {
  padding-left: var(--ag-cell-horizontal-padding);
  padding-right: var(--ag-cell-horizontal-padding);
}
.ag-header-cell.ag-header-cell-moving,
.ag-header-group-cell.ag-header-cell-moving {
  background-color: var(--ag-header-cell-moving-background-color);
}
.ag-ltr .ag-header-group-cell-label.ag-sticky-label {
  left: var(--ag-cell-horizontal-padding);
}
.ag-rtl .ag-header-group-cell-label.ag-sticky-label {
  right: var(--ag-cell-horizontal-padding);
}
.ag-header-cell:focus-visible {
  outline: none;
}
.ag-header-cell:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-header-group-cell:focus-visible {
  outline: none;
}
.ag-header-group-cell:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-advanced-filter-header-cell:focus-visible {
  outline: none;
}
.ag-advanced-filter-header-cell:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-header-icon {
  color: var(--ag-secondary-foreground-color);
}
.ag-header-expand-icon {
  cursor: pointer;
}
.ag-ltr .ag-header-expand-icon {
  margin-left: 4px;
}
.ag-rtl .ag-header-expand-icon {
  margin-right: 4px;
}
.ag-header-row:not(:first-child) .ag-header-cell:not(.ag-header-span-height.ag-header-span-total, .ag-header-parent-hidden),
.ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {
  border-top: var(--ag-borders-critical) var(--ag-border-color);
}
.ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover, .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell:not(.ag-column-hover).ag-column-resizing,
.ag-header-cell:not(.ag-column-resizing) + .ag-header-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover,
.ag-header-cell:not(.ag-column-resizing) + .ag-header-cell:not(.ag-column-hover).ag-column-resizing,
.ag-header-group-cell:first-of-type:not(.ag-header-cell-moving):hover,
.ag-header-group-cell:first-of-type.ag-column-resizing,
.ag-header-cell:not(.ag-column-hover):first-of-type:not(.ag-header-cell-moving):hover,
.ag-header-cell:not(.ag-column-hover):first-of-type.ag-column-resizing {
  background-color: var(--ag-header-cell-hover-background-color);
}
.ag-header-cell::before,
.ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group)::before {
  content: "";
  position: absolute;
  z-index: 1;
  display: var(--ag-header-column-separator-display);
  width: var(--ag-header-column-separator-width);
  height: var(--ag-header-column-separator-height);
  top: calc(50% - var(--ag-header-column-separator-height) * 0.5);
  background-color: var(--ag-header-column-separator-color);
}
.ag-ltr .ag-header-cell::before,
.ag-ltr .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group)::before {
  right: 0;
}
.ag-rtl .ag-header-cell::before,
.ag-rtl .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group)::before {
  left: 0;
}
.ag-header-highlight-before::after,
.ag-header-highlight-after::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
}
.ag-header-highlight-before::after {
  left: 0px;
}
.ag-header-highlight-after::after {
  right: 0px;
}
.ag-pinned-left-header .ag-header-highlight-after::after {
  right: 1px;
}
.ag-header-cell-resize {
  display: flex;
  align-items: center;
}
.ag-header-cell-resize::after {
  content: "";
  position: absolute;
  z-index: 1;
  display: var(--ag-header-column-resize-handle-display);
  width: var(--ag-header-column-resize-handle-width);
  height: var(--ag-header-column-resize-handle-height);
  top: calc(50% - var(--ag-header-column-resize-handle-height) * 0.5);
  background-color: var(--ag-header-column-resize-handle-color);
}
.ag-header-cell.ag-header-span-height .ag-header-cell-resize::after {
  height: calc(100% - var(--ag-grid-size) * 4);
  top: calc(var(--ag-grid-size) * 2);
}
.ag-ltr .ag-header-viewport .ag-header-cell-resize::after {
  left: calc(50% - var(--ag-header-column-resize-handle-width));
}
.ag-rtl .ag-header-viewport .ag-header-cell-resize::after {
  right: calc(50% - var(--ag-header-column-resize-handle-width));
}
.ag-pinned-left-header .ag-header-cell-resize::after {
  left: calc(50% - var(--ag-header-column-resize-handle-width));
}
.ag-pinned-right-header .ag-header-cell-resize::after {
  left: 50%;
}
.ag-ltr .ag-header-select-all {
  margin-right: var(--ag-cell-horizontal-padding);
}
.ag-rtl .ag-header-select-all {
  margin-left: var(--ag-cell-horizontal-padding);
}
.ag-ltr .ag-floating-filter-button {
  margin-left: var(--ag-cell-widget-spacing);
}
.ag-rtl .ag-floating-filter-button {
  margin-right: var(--ag-cell-widget-spacing);
}
.ag-floating-filter-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  -webkit-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  height: var(--ag-icon-size);
  padding: 0;
  width: var(--ag-icon-size);
}
.ag-filter-loading {
  background-color: var(--ag-control-panel-background-color);
  height: 100%;
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
  position: absolute;
  width: 100%;
  z-index: 1;
  align-items: unset;
}
.ag-paging-panel {
  border-top: 1px solid;
  border-top-color: var(--ag-border-color);
  color: var(--ag-secondary-foreground-color);
  height: var(--ag-pagination-panel-height);
}
.ag-paging-panel > * {
  margin: 0 var(--ag-cell-horizontal-padding);
}
.ag-paging-panel > .ag-paging-page-size .ag-wrapper {
  min-width: calc(var(--ag-grid-size) * 10);
}
.ag-paging-button {
  cursor: pointer;
}
.ag-paging-button.ag-disabled {
  cursor: default;
  color: var(--ag-disabled-foreground-color);
}
.ag-paging-button:focus-visible {
  outline: none;
}
.ag-paging-button:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-paging-button,
.ag-paging-description {
  margin: 0 var(--ag-grid-size);
}
.ag-status-bar {
  border-top: var(--ag-borders) var(--ag-border-color);
  color: var(--ag-disabled-foreground-color);
  padding-right: calc(var(--ag-grid-size) * 4);
  padding-left: calc(var(--ag-grid-size) * 4);
  line-height: 1.5;
}
.ag-status-name-value-value {
  color: var(--ag-foreground-color);
}
.ag-status-bar-center {
  text-align: center;
}
.ag-status-name-value {
  margin-left: var(--ag-grid-size);
  margin-right: var(--ag-grid-size);
  padding-top: calc(var(--ag-grid-size) * 2);
  padding-bottom: calc(var(--ag-grid-size) * 2);
}
.ag-column-drop-cell {
  background: var(--ag-chip-background-color);
  border-radius: calc(var(--ag-grid-size) * 4);
  height: calc(var(--ag-grid-size) * 4);
  padding: 0 calc(var(--ag-grid-size) * 0.5);
  border: 1px solid var(--ag-chip-border-color);
}
.ag-column-drop-cell:focus-visible {
  outline: none;
}
.ag-column-drop-cell:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 2px;
  left: 2px;
  display: block;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-column-drop-cell-text {
  margin: 0 var(--ag-grid-size);
}
.ag-column-drop-cell-button {
  min-width: calc(var(--ag-grid-size) * 4);
  margin: 0 calc(var(--ag-grid-size) * 0.5);
  color: var(--ag-secondary-foreground-color);
}
.ag-column-drop-cell-drag-handle {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-column-drop-cell-ghost {
  opacity: 0.5;
}
.ag-column-drop-horizontal {
  background-color: var(--ag-header-background-color);
  color: var(--ag-secondary-foreground-color);
  height: var(--ag-header-height);
  border-bottom: var(--ag-borders) var(--ag-border-color);
}
.ag-ltr .ag-column-drop-horizontal {
  padding-left: var(--ag-cell-horizontal-padding);
}
.ag-rtl .ag-column-drop-horizontal {
  padding-right: var(--ag-cell-horizontal-padding);
}
.ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child) {
  border-right: var(--ag-borders) var(--ag-border-color);
}
.ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child) {
  border-left: var(--ag-borders) var(--ag-border-color);
}
.ag-column-drop-horizontal-cell-separator {
  margin: 0 var(--ag-grid-size);
  color: var(--ag-secondary-foreground-color);
}
.ag-column-drop-horizontal-empty-message {
  color: var(--ag-disabled-foreground-color);
}
.ag-ltr .ag-column-drop-horizontal-icon {
  margin-right: var(--ag-cell-horizontal-padding);
}
.ag-rtl .ag-column-drop-horizontal-icon {
  margin-left: var(--ag-cell-horizontal-padding);
}
.ag-column-drop-vertical-list {
  padding-bottom: var(--ag-grid-size);
  padding-right: var(--ag-grid-size);
  padding-left: var(--ag-grid-size);
}
.ag-column-drop-vertical-cell {
  margin-top: var(--ag-grid-size);
}
.ag-column-drop-vertical {
  min-height: 50px;
  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);
}
.ag-column-drop-vertical.ag-last-column-drop {
  border-bottom: none;
}
.ag-column-drop-vertical-icon {
  margin-left: var(--ag-grid-size);
  margin-right: var(--ag-grid-size);
}
.ag-column-drop-vertical-empty-message {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  color: var(--ag-disabled-foreground-color);
  margin-top: var(--ag-grid-size);
}
.ag-select-agg-func-popup {
  border: var(--ag-borders) var(--ag-border-color);
  background: var(--ag-background-color);
  border-radius: var(--ag-card-radius);
  box-shadow: var(--ag-card-shadow);
  padding: var(--ag-grid-size);
  background: var(--ag-background-color);
  height: calc(var(--ag-grid-size) * 5 * 3.5);
  padding: 0;
}
.ag-select-agg-func-virtual-list-item {
  cursor: default;
}
.ag-ltr .ag-select-agg-func-virtual-list-item {
  padding-left: calc(var(--ag-grid-size) * 2);
}
.ag-rtl .ag-select-agg-func-virtual-list-item {
  padding-right: calc(var(--ag-grid-size) * 2);
}
.ag-select-agg-func-virtual-list-item:hover {
  background-color: var(--ag-selected-row-background-color);
}
.ag-select-agg-func-virtual-list-item:focus-visible {
  outline: none;
}
.ag-select-agg-func-virtual-list-item:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-sort-indicator-container {
  display: flex;
}
.ag-ltr .ag-sort-indicator-icon {
  padding-left: var(--ag-grid-size);
}
.ag-rtl .ag-sort-indicator-icon {
  padding-right: var(--ag-grid-size);
}
.ag-chart {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
}
.ag-chart-components-wrapper {
  position: relative;
  display: flex;
  flex: 1 1 auto;
}
.ag-chart-canvas-wrapper {
  position: relative;
  flex: 1 1 auto;
}
.ag-chart-menu {
  position: absolute;
  top: 16px;
  display: flex;
  flex-direction: column;
}
.ag-ltr .ag-chart-menu {
  right: 20px;
}
.ag-rtl .ag-chart-menu {
  left: 20px;
}
.ag-chart-docked-container {
  position: relative;
  min-width: var(--ag-chart-menu-panel-width);
}
.ag-chart-menu-hidden ~ .ag-chart-docked-container {
  display: none;
}
.ag-chart-tabbed-menu {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ag-chart-tabbed-menu-header {
  flex: none;
  -webkit-user-select: none;
  user-select: none;
  cursor: default;
}
.ag-chart-tabbed-menu-body {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  overflow: hidden;
}
.ag-chart-tab {
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.ag-chart-settings {
  overflow-x: hidden;
}
.ag-chart-settings-wrapper {
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}
.ag-chart-settings-nav-bar {
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  padding: 0 10px;
  -webkit-user-select: none;
  user-select: none;
}
.ag-chart-settings-card-selector {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 1 1 auto;
  height: 100%;
  padding: 0 10px;
}
.ag-chart-settings-card-item {
  cursor: pointer;
  width: 10px;
  height: 10px;
  background-color: #000;
  position: relative;
}
.ag-chart-settings-card-item.ag-not-selected {
  opacity: 0.2;
}
.ag-chart-settings-card-item::before {
  content: " ";
  display: block;
  position: absolute;
  background-color: transparent;
  left: 50%;
  top: 50%;
  margin-left: -10px;
  margin-top: -10px;
  width: 20px;
  height: 20px;
}
.ag-chart-settings-prev,
.ag-chart-settings-next {
  position: relative;
  flex: none;
}
.ag-chart-settings-prev:focus-within,
.ag-chart-settings-next:focus-within {
  box-shadow: var(--ag-input-focus-box-shadow);
  border-radius: 1px;
}
.ag-chart-settings-prev-button,
.ag-chart-settings-next-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ag-chart-settings-mini-charts-container {
  position: relative;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
}
.ag-chart-settings-mini-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
}
.ag-chart-settings-mini-wrapper.ag-animating {
  transition: left 0.3s;
  transition-timing-function: ease-in-out;
}
.ag-chart-mini-thumbnail {
  cursor: pointer;
}
.ag-chart-mini-thumbnail-canvas {
  display: block;
}
.ag-chart-data-wrapper,
.ag-chart-format-wrapper,
.ag-chart-advanced-settings-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
  padding-bottom: 16px;
}
.ag-chart-data-wrapper,
.ag-chart-advanced-settings-wrapper {
  height: 100%;
  overflow-y: auto;
}
.ag-chart-advanced-settings {
  background-color: var(--ag-control-panel-background-color);
}
.ag-chart-advanced-settings-wrapper,
.ag-chart-advanced-settings {
  width: 100%;
}
.ag-chart-advanced-settings-wrapper {
  padding-bottom: 0;
}
.ag-chart-data-section,
.ag-chart-format-section,
.ag-chart-advanced-settings-section {
  display: flex;
  margin: 0;
}
.ag-chart-advanced-settings-section {
  padding-top: var(--ag-grid-size);
  padding-bottom: var(--ag-grid-size);
}
.ag-chart-advanced-settings-section:not(:last-child) {
  border-bottom: 1px solid var(--ag-secondary-border-color);
}
.ag-chart-empty-text {
  display: flex;
  top: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: var(--ag-background-color);
}
.ag-chart .ag-chart-menu-wrapper .ag-chart-menu {
  display: flex;
  flex-direction: row;
  top: 8px;
  gap: 20px;
  width: auto;
}
.ag-ltr .ag-chart .ag-chart-menu-wrapper .ag-chart-menu {
  right: calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);
  justify-content: right;
}
.ag-rtl .ag-chart .ag-chart-menu-wrapper .ag-chart-menu {
  left: calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);
  justify-content: left;
}
.ag-charts-font-size-color {
  display: flex;
  align-self: stretch;
  justify-content: space-between;
}
.ag-charts-data-group-item {
  position: relative;
}
.ag-charts-data-group-item:not(:last-child) {
  margin-bottom: var(--ag-grid-size);
}
.ag-chart-menu {
  border-radius: var(--ag-card-radius);
  background: var(--ag-background-color);
}
.ag-chart-menu-icon {
  opacity: 0.5;
  margin: 2px 0;
  cursor: pointer;
  border-radius: var(--ag-card-radius);
  color: var(--ag-secondary-foreground-color);
}
.ag-chart-menu-icon:hover {
  opacity: 1;
}
.ag-chart-menu-toolbar-button {
  border: 0;
  background-color: unset;
  padding: 0 2px;
  border-radius: 1px;
}
.ag-chart-mini-thumbnail {
  border: 1px solid var(--ag-secondary-border-color);
  border-radius: 5px;
  padding: 1px;
}
.ag-chart-mini-thumbnail.ag-selected {
  border-color: var(--ag-minichart-selected-chart-color);
  border-width: 2px;
  padding: unset;
}
.ag-chart-mini-thumbnail:focus-visible {
  outline: none;
  border-color: var(--ag-minichart-selected-chart-color);
  box-shadow: var(--ag-input-focus-box-shadow);
}
.ag-chart-settings-card-item {
  background: var(--ag-foreground-color);
  width: 8px;
  height: 8px;
  border-radius: 4px;
}
.ag-chart-settings-card-item.ag-selected {
  background-color: var(--ag-minichart-selected-page-color);
}
.ag-chart-data-column-drag-handle {
  margin-left: var(--ag-grid-size);
}
.ag-charts-settings-group-title-bar,
.ag-charts-data-group-title-bar,
.ag-charts-format-top-level-group-title-bar {
  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);
  position: relative;
}
.ag-charts-advanced-settings-top-level-group-title-bar {
  position: relative;
  background-color: unset;
}
.ag-charts-data-group-title-bar:focus-visible {
  outline: none;
}
.ag-charts-data-group-title-bar:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-charts-format-top-level-group-title-bar:focus-visible {
  outline: none;
}
.ag-charts-format-top-level-group-title-bar:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-charts-data-group-title-bar .ag-charts-data-group-title,
.ag-charts-format-top-level-group-title-bar .ag-charts-format-top-level-group-title {
  cursor: pointer;
}
.ag-charts-data-group-container {
  padding: calc(var(--ag-widget-container-vertical-padding) * 0.5) var(--ag-widget-container-horizontal-padding);
}
.ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group):not(.ag-pill-select):not(.ag-select) {
  height: var(--ag-list-item-height);
}
.ag-charts-data-group-container .ag-charts-data-group-item.ag-picker-field {
  margin-top: var(--ag-grid-size);
}
.ag-charts-data-group-container .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
}
.ag-charts-data-group-container .ag-item-highlight-top::after {
  top: 0;
}
.ag-charts-data-group-container .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-charts-format-top-level-group-container,
.ag-charts-advanced-settings-top-level-group-container {
  padding: var(--ag-grid-size);
}
.ag-ltr .ag-charts-format-top-level-group-container,
.ag-ltr .ag-charts-advanced-settings-top-level-group-container {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-rtl .ag-charts-format-top-level-group-container,
.ag-rtl .ag-charts-advanced-settings-top-level-group-container {
  margin-right: calc(var(--ag-grid-size) * 2);
}
.ag-charts-format-top-level-group-item,
.ag-charts-advanced-settings-top-level-group-item {
  margin: var(--ag-grid-size) 0;
}
.ag-charts-format-sub-level-group-container {
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));
}
.ag-charts-format-sub-level-group-container > * {
  margin-bottom: var(--ag-widget-vertical-spacing);
}
.ag-charts-format-sub-level-no-header-group-container > * {
  margin-bottom: var(--ag-widget-vertical-spacing);
}
.ag-charts-format-sub-level-group-container .ag-charts-format-sub-level-group-item.ag-font-panel-no-header {
  margin: 0;
}
.ag-charts-settings-group-container {
  padding: var(--ag-grid-size);
  row-gap: 8px;
  display: grid;
  grid-template-columns: 60px 1fr 60px 1fr 60px;
}
.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+1) {
  grid-column: 1;
}
.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+2) {
  grid-column: 3;
}
.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+3) {
  grid-column: 5;
}
.ag-chart-menu-panel {
  background-color: var(--ag-control-panel-background-color);
}
.ag-ltr .ag-chart-menu-panel {
  border-left: solid 1px var(--ag-border-color);
}
.ag-rtl .ag-chart-menu-panel {
  border-right: solid 1px var(--ag-border-color);
}
.ag-date-time-list-page-title-bar {
  display: flex;
}
.ag-date-time-list-page-title {
  flex-grow: 1;
  text-align: center;
}
.ag-date-time-list-page-column-labels-row,
.ag-date-time-list-page-entries-row {
  display: flex;
}
.ag-date-time-list-page-column-label,
.ag-date-time-list-page-entry {
  flex-basis: 0;
  flex-grow: 1;
}
.ag-date-time-list-page-entry {
  cursor: pointer;
  text-align: center;
}
.ag-date-time-list-page-column-label {
  text-align: center;
}
.ag-advanced-filter-header {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: var(--ag-cell-horizontal-padding);
  padding-right: var(--ag-cell-horizontal-padding);
}
.ag-advanced-filter {
  display: flex;
  align-items: center;
  width: 100%;
}
.ag-advanced-filter-buttons {
  display: contents;
}
.ag-advanced-filter-builder-button {
  display: flex;
  align-items: center;
  border: 0;
  background-color: unset;
  color: var(--ag-foreground-color);
  font-size: var(--ag-font-size);
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
}
.ag-ltr .ag-advanced-filter-builder-button {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-rtl .ag-advanced-filter-builder-button {
  margin-right: calc(var(--ag-grid-size) * 2);
}
.ag-advanced-filter-builder-button:hover:not(:disabled) {
  background-color: var(--ag-row-hover-color);
}
.ag-advanced-filter-builder-button:not(:disabled) {
  cursor: pointer;
}
.ag-advanced-filter-builder-button-label {
  margin-left: var(--ag-grid-size);
}
.ag-advanced-filter-builder {
  -webkit-user-select: none;
  user-select: none;
  width: 100%;
  background-color: var(--ag-control-panel-background-color);
  display: flex;
  flex-direction: column;
}
.ag-advanced-filter-builder-list {
  flex: 1;
  overflow: auto;
}
.ag-advanced-filter-builder-list .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
}
.ag-advanced-filter-builder-list .ag-item-highlight-top::after {
  top: 0;
}
.ag-advanced-filter-builder-list .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-advanced-filter-builder-button-panel {
  display: flex;
  justify-content: flex-end;
  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);
  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);
}
.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-apply-button,
.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-cancel-button {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-advanced-filter-builder-item-wrapper {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  padding-left: calc(var(--ag-icon-size) / 2);
  padding-right: var(--ag-icon-size);
}
.ag-virtual-list-viewport .ag-advanced-filter-builder-item-wrapper .ag-tab-guard {
  position: absolute;
}
.ag-advanced-filter-builder-item-tree-lines > * {
  width: var(--ag-advanced-filter-builder-indent-size);
}
.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root {
  width: var(--ag-icon-size);
}
.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root::before {
  top: 50%;
  height: 50%;
}
.ag-advanced-filter-builder-item-tree-line-horizontal,
.ag-advanced-filter-builder-item-tree-line-vertical,
.ag-advanced-filter-builder-item-tree-line-vertical-top,
.ag-advanced-filter-builder-item-tree-line-vertical-bottom {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}
.ag-advanced-filter-builder-item-tree-line-horizontal::before, .ag-advanced-filter-builder-item-tree-line-horizontal::after,
.ag-advanced-filter-builder-item-tree-line-vertical::before,
.ag-advanced-filter-builder-item-tree-line-vertical::after,
.ag-advanced-filter-builder-item-tree-line-vertical-top::before,
.ag-advanced-filter-builder-item-tree-line-vertical-top::after,
.ag-advanced-filter-builder-item-tree-line-vertical-bottom::before,
.ag-advanced-filter-builder-item-tree-line-vertical-bottom::after {
  content: "";
  position: absolute;
  height: 100%;
}
.ag-advanced-filter-builder-item-tree-line-horizontal::after {
  height: 50%;
  width: calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size));
  top: 0;
  left: calc(var(--ag-icon-size) / 2);
  border-bottom: 1px solid;
  border-color: var(--ag-border-color);
}
.ag-advanced-filter-builder-item-tree-line-vertical::before {
  width: calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);
  top: 0;
  left: calc(var(--ag-icon-size) / 2);
  border-left: 1px solid;
  border-color: var(--ag-border-color);
}
.ag-advanced-filter-builder-item-tree-line-vertical-top::before {
  height: 50%;
  width: calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);
  top: 0;
  left: calc(var(--ag-icon-size) / 2);
  border-left: 1px solid;
  border-color: var(--ag-border-color);
}
.ag-advanced-filter-builder-item-tree-line-vertical-bottom::before {
  height: calc((100% - 1.5 * var(--ag-icon-size)) / 2);
  width: calc(var(--ag-icon-size) / 2);
  top: calc((100% + 1.5 * var(--ag-icon-size)) / 2);
  left: calc(var(--ag-icon-size) / 2);
  border-left: 1px solid;
  border-color: var(--ag-border-color);
}
.ag-advanced-filter-builder-item-condition {
  padding-top: var(--ag-grid-size);
  padding-bottom: var(--ag-grid-size);
}
.ag-advanced-filter-builder-item,
.ag-advanced-filter-builder-item-condition,
.ag-advanced-filter-builder-pill-wrapper,
.ag-advanced-filter-builder-pill,
.ag-advanced-filter-builder-item-buttons,
.ag-advanced-filter-builder-item-tree-lines {
  display: flex;
  align-items: center;
  height: 100%;
}
.ag-advanced-filter-builder-pill-wrapper {
  margin: 0px var(--ag-grid-size);
}
.ag-advanced-filter-builder-pill {
  position: relative;
  border-radius: var(--ag-border-radius);
  padding: var(--ag-grid-size) calc(var(--ag-grid-size) * 2);
  min-height: calc(100% - var(--ag-grid-size) * 3);
  min-width: calc(var(--ag-grid-size) * 2);
}
.ag-advanced-filter-builder-pill .ag-picker-field-display {
  margin-right: var(--ag-grid-size);
}
.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-number {
  font-family: monospace;
  font-weight: 700;
}
.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-empty {
  color: var(--ag-disabled-foreground-color);
}
.ag-advanced-filter-builder-pill:focus-visible {
  outline: none;
}
.ag-advanced-filter-builder-pill:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: -4px;
  left: -4px;
  display: block;
  width: calc(100% - -8px);
  height: calc(100% - -8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-advanced-filter-builder-item-button:focus-visible {
  outline: none;
}
.ag-advanced-filter-builder-item-button:focus-visible::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: -4px;
  left: -4px;
  display: block;
  width: calc(100% - -8px);
  height: calc(100% - -8px);
  border: 1px solid;
  border-color: var(--ag-input-focus-border-color);
}
.ag-advanced-filter-builder-pill-display {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.ag-advanced-filter-builder-join-pill {
  color: var(--ag-foreground-color);
  background-color: var(--ag-advanced-filter-join-pill-color);
  cursor: pointer;
}
.ag-advanced-filter-builder-column-pill {
  color: var(--ag-foreground-color);
  background-color: var(--ag-advanced-filter-column-pill-color);
  cursor: pointer;
}
.ag-advanced-filter-builder-option-pill {
  color: var(--ag-foreground-color);
  background-color: var(--ag-advanced-filter-option-pill-color);
  cursor: pointer;
}
.ag-advanced-filter-builder-value-pill {
  color: var(--ag-foreground-color);
  background-color: var(--ag-advanced-filter-value-pill-color);
  cursor: text;
  max-width: 140px;
}
.ag-advanced-filter-builder-value-pill .ag-advanced-filter-builder-pill-display {
  display: block;
}
.ag-advanced-filter-builder-item-buttons > * {
  margin: 0 calc(var(--ag-grid-size) * 0.5);
}
.ag-advanced-filter-builder-item-button {
  position: relative;
  cursor: pointer;
  color: var(--ag-secondary-foreground-color);
  opacity: 50%;
}
.ag-advanced-filter-builder-item-button-disabled {
  color: var(--ag-disabled-foreground-color);
  cursor: default;
}
.ag-advanced-filter-builder-virtual-list-container {
  top: var(--ag-grid-size);
}
.ag-advanced-filter-builder-virtual-list-item {
  display: flex;
  cursor: default;
  height: var(--ag-list-item-height);
}
.ag-advanced-filter-builder-virtual-list-item:hover {
  background-color: var(--ag-row-hover-color);
}
.ag-advanced-filter-builder-virtual-list-item:hover .ag-advanced-filter-builder-item-button {
  opacity: 100%;
}
.ag-advanced-filter-builder-virtual-list-item-highlight .ag-advanced-filter-builder-item-button:focus-visible,
.ag-advanced-filter-builder-validation .ag-advanced-filter-builder-invalid {
  opacity: 100%;
}
.ag-advanced-filter-builder-invalid {
  margin: 0 var(--ag-grid-size);
  color: var(--ag-invalid-color);
  cursor: default;
}
.ag-row-number-cell {
  background-color: var(--ag-header-background-color);
  color: var(--ag-header-foreground-color);
  font-size: var(--ag-font-size);
  font-family: var(--ag-font-family);
}
.ag-row-number-header.ag-row-number-selection-enabled {
  cursor: cell;
}
.ag-row-number-range-highlight {
  background-color: var(--ag-range-header-highlight-color);
}
.ag-row-number-range-selected {
  background-color: var(--ag-row-numbers-selected-color);
}
.ag-ltr .ag-row-number-header,
.ag-ltr .ag-cell.ag-row-number-cell:not(.ag-cell-last-left-pinned) {
  border-right: var(--ag-pinned-column-border);
}
.ag-ltr .ag-cell.ag-row-number-cell.ag-row-number-selection-enabled {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), auto;
}
.ag-rtl .ag-row-number-header,
.ag-rtl .ag-cell.ag-row-number-cell:not(.ag-cell-first-right-pinned) {
  border-left: var(--ag-pinned-column-border);
}
.ag-rtl .ag-cell.ag-row-number-cell.ag-row-number-selection-enabled {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_3___}), auto;
}
.ag-cell-batch-edit {
  background-color: var(--ag-cell-batch-edit-background-color);
  color: var(--ag-cell-batch-edit-text-color);
}
.ag-cell.ag-cell-inline-editing {
  background-color: var(--ag-background-color);
  background-image: linear-gradient(0deg, var(--ag-input-background-color), var(--ag-input-background-color));
}
.ag-row-batch-edit {
  background-color: var(--ag-row-batch-edit-background-color);
  color: var(--ag-row-batch-edit-text-color);
}
.ag-input-field-input {
  width: 100%;
  min-width: 0;
}
.ag-checkbox-input-wrapper {
  font-family: var(--ag-icon-font-family);
  font-weight: var(--ag-icon-font-weight);
  color: var(--ag-icon-font-color);
  font-size: var(--ag-icon-size);
  line-height: var(--ag-icon-size);
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: var(--ag-icon-size);
  height: var(--ag-icon-size);
  background-color: var(--ag-checkbox-background-color);
  border-radius: var(--ag-checkbox-border-radius);
  display: inline-block;
  vertical-align: middle;
  flex: none;
}
.ag-checkbox-input-wrapper input,
.ag-checkbox-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-checkbox-input-wrapper:focus-within, .ag-checkbox-input-wrapper:active {
  outline: none;
  box-shadow: var(--ag-input-focus-box-shadow);
}
.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within, .ag-cell-editing-error .ag-checkbox-input-wrapper:active {
  box-shadow: var(--ag-input-error-focus-box-shadow);
}
.ag-checkbox-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-checkbox-input-wrapper::after {
  content: var(--ag-icon-font-code-checkbox-unchecked, "\\f108");
  font-family: inherit;
  color: var(--ag-checkbox-unchecked-color);
  display: var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-checkbox-input-wrapper.ag-checked::after {
  content: var(--ag-icon-font-code-checkbox-checked, "\\f106");
  color: var(--ag-checkbox-checked-color);
  display: var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-checkbox-input-wrapper.ag-indeterminate::after {
  content: var(--ag-icon-font-code-checkbox-indeterminate, "\\f107");
  color: var(--ag-checkbox-indeterminate-color);
  display: var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-checkbox-input-wrapper::before {
  content: "";
  background: transparent center/contain no-repeat;
  position: absolute;
  inset: 0;
  background-image: var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));
  display: var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, 0.9));
}
.ag-checkbox-input-wrapper.ag-checked::before {
  background-image: var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));
  display: var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, 0.9));
}
.ag-checkbox-input-wrapper.ag-indeterminate::before {
  background-image: var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));
  display: var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, 0.9));
}
.ag-toggle-button-input-wrapper {
  box-sizing: border-box;
  width: var(--ag-toggle-button-width);
  min-width: var(--ag-toggle-button-width);
  max-width: var(--ag-toggle-button-width);
  height: var(--ag-toggle-button-height);
  background-color: var(--ag-toggle-button-off-background-color);
  border-radius: calc(var(--ag-toggle-button-height) * 0.5);
  position: relative;
  flex: none;
  border: var(--ag-toggle-button-border-width) solid;
  border-color: var(--ag-toggle-button-off-border-color);
}
.ag-toggle-button-input-wrapper input {
  opacity: 0;
  height: 100%;
  width: 100%;
}
.ag-toggle-button-input-wrapper:focus-within {
  outline: none;
  box-shadow: var(--ag-input-focus-box-shadow);
}
.ag-toggle-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-toggle-button-input-wrapper.ag-checked {
  background-color: var(--ag-toggle-button-on-background-color);
  border-color: var(--ag-toggle-button-on-border-color);
}
.ag-toggle-button-input-wrapper::before {
  content: " ";
  position: absolute;
  top: calc(0px - var(--ag-toggle-button-border-width));
  left: calc(0px - var(--ag-toggle-button-border-width));
  display: block;
  box-sizing: border-box;
  height: var(--ag-toggle-button-height);
  width: var(--ag-toggle-button-height);
  background-color: var(--ag-toggle-button-switch-background-color);
  border-radius: 100%;
  transition: left 100ms;
  border: var(--ag-toggle-button-border-width) solid;
  border-color: var(--ag-toggle-button-switch-border-color);
}
.ag-toggle-button-input-wrapper.ag-checked::before {
  left: calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-border-width));
  border-color: var(--ag-toggle-button-on-border-color);
}
.ag-radio-button-input-wrapper {
  font-family: var(--ag-icon-font-family);
  font-weight: var(--ag-icon-font-weight);
  color: var(--ag-icon-font-color);
  font-size: var(--ag-icon-size);
  line-height: var(--ag-icon-size);
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: var(--ag-icon-size);
  height: var(--ag-icon-size);
  background-color: var(--ag-checkbox-background-color);
  border-radius: var(--ag-checkbox-border-radius);
  display: inline-block;
  vertical-align: middle;
  flex: none;
  border-radius: var(--ag-icon-size);
}
.ag-radio-button-input-wrapper input,
.ag-radio-button-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-radio-button-input-wrapper:focus-within, .ag-radio-button-input-wrapper:active {
  outline: none;
  box-shadow: var(--ag-input-focus-box-shadow);
}
.ag-cell-editing-error .ag-radio-button-input-wrapper:focus-within, .ag-cell-editing-error .ag-radio-button-input-wrapper:active {
  box-shadow: var(--ag-input-error-focus-box-shadow);
}
.ag-radio-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-radio-button-input-wrapper::after {
  content: var(--ag-icon-font-code-radio-button-off, "\\f127");
  color: var(--ag-checkbox-unchecked-color);
  display: var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-radio-button-input-wrapper.ag-checked::after {
  content: var(--ag-icon-font-code-radio-button-on, "\\f128");
  color: var(--ag-checkbox-checked-color);
  display: var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-radio-button-input-wrapper::before {
  content: "";
  background: transparent center/contain no-repeat;
  position: absolute;
  inset: 0;
  background-image: var(--ag-icon-image-radio-button-off, var(--ag-icon-image));
  display: var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, 0.9));
}
.ag-radio-button-input-wrapper.ag-checked::before {
  background-image: var(--ag-icon-image-radio-button-on, var(--ag-icon-image));
  display: var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));
  opacity: var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, 0.9));
}
input[class^=ag-][type=range] {
  -webkit-appearance: none;
  width: 100%;
  height: 100%;
  background: none;
  overflow: visible;
}
input[class^=ag-][type=range]::-webkit-slider-runnable-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: var(--ag-border-color);
  border-radius: var(--ag-border-radius);
  border-radius: var(--ag-checkbox-border-radius);
}
input[class^=ag-][type=range]::-moz-range-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: var(--ag-border-color);
  border-radius: var(--ag-border-radius);
  border-radius: var(--ag-checkbox-border-radius);
}
input[class^=ag-][type=range]::-ms-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: var(--ag-border-color);
  border-radius: var(--ag-border-radius);
  border-radius: var(--ag-checkbox-border-radius);
  color: transparent;
  width: calc(100% - 2px);
}
input[class^=ag-][type=range]::-webkit-slider-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: var(--ag-icon-size);
  height: var(--ag-icon-size);
  background-color: var(--ag-background-color);
  border: 1px solid;
  border-color: var(--ag-checkbox-unchecked-color);
  border-radius: var(--ag-icon-size);
  transform: translateY(calc(var(--ag-icon-size) * -0.5 + 1.5px));
}
input[class^=ag-][type=range]::-ms-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: var(--ag-icon-size);
  height: var(--ag-icon-size);
  background-color: var(--ag-background-color);
  border: 1px solid;
  border-color: var(--ag-checkbox-unchecked-color);
  border-radius: var(--ag-icon-size);
}
input[class^=ag-][type=range]::-moz-ag-range-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: var(--ag-icon-size);
  height: var(--ag-icon-size);
  background-color: var(--ag-background-color);
  border: 1px solid;
  border-color: var(--ag-checkbox-unchecked-color);
  border-radius: var(--ag-icon-size);
}
input[class^=ag-][type=range]:focus {
  outline: none;
}
input[class^=ag-][type=range]:focus::-webkit-slider-thumb {
  box-shadow: var(--ag-input-focus-box-shadow);
  border-color: var(--ag-checkbox-checked-color);
}
input[class^=ag-][type=range]:focus::-ms-thumb {
  box-shadow: var(--ag-input-focus-box-shadow);
  border-color: var(--ag-checkbox-checked-color);
}
input[class^=ag-][type=range]:focus::-moz-ag-range-thumb {
  box-shadow: var(--ag-input-focus-box-shadow);
  border-color: var(--ag-checkbox-checked-color);
}
input[class^=ag-][type=range]:active::-webkit-slider-runnable-track {
  background-color: var(--ag-input-focus-border-color);
}
input[class^=ag-][type=range]:active::-moz-ag-range-track {
  background-color: var(--ag-input-focus-border-color);
}
input[class^=ag-][type=range]:active::-ms-track {
  background-color: var(--ag-input-focus-border-color);
}
input[class^=ag-][type=range]:disabled {
  opacity: 0.5;
}
@font-face {
  font-family: "agGridBalham";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: normal;
  font-style: normal;
}
.ag-theme-balham,
.ag-theme-balham-dark,
.ag-theme-balham-auto-dark {
  --ag-balham-active-color: #0091ea;
  --ag-foreground-color: #000;
  --ag-background-color: #fff;
  --ag-header-background-color: #f5f7f7;
  --ag-tooltip-background-color: #cbd0d3;
  --ag-subheader-background-color: #e2e9eb;
  --ag-control-panel-background-color: #f5f7f7;
  --ag-border-color: #bdc3c7;
  --ag-odd-row-background-color: #fcfdfe;
  --ag-row-hover-color: #ecf0f1;
  --ag-column-hover-color: #ecf0f1;
  --ag-input-border-color: #95a5a6;
  --ag-invalid-color: #e02525;
  --ag-input-disabled-background-color: #ebebeb;
  --ag-checkbox-unchecked-color: #7f8c8d;
  --ag-input-focus-border-color: #719ece;
  --ag-advanced-filter-join-pill-color: #f08e8d;
  --ag-advanced-filter-column-pill-color: #a6e194;
  --ag-advanced-filter-option-pill-color: #f3c08b;
  --ag-advanced-filter-value-pill-color: #85c0e4;
  --ag-find-match-color: var(--ag-foreground-color);
  --ag-find-match-background-color: #ffff00;
  --ag-find-active-match-color: var(--ag-foreground-color);
  --ag-find-active-match-background-color: #ffa500;
  --ag-input-focus-box-shadow: 0 0 2px 1px var(--ag-input-focus-border-color);
  --ag-input-error-focus-box-shadow: 0 0 2px 1px var(--ag-invalid-color);
  --ag-range-selection-border-color: var(--ag-balham-active-color);
  --ag-checkbox-checked-color: var(--ag-balham-active-color);
  --ag-checkbox-background-color: var(--ag-background-color);
  --ag-panel-background-color: var(--ag-header-background-color);
  --ag-filter-panel-apply-button-color: var(--ag-background-color);
  --ag-filter-panel-apply-button-background-color: var(--ag-balham-active-color);
  --ag-secondary-foreground-color: rgba(0, 0, 0, 0.54);
  --ag-disabled-foreground-color: rgba(0, 0, 0, 0.38);
  --ag-subheader-toolbar-background-color: rgba(226, 233, 235, 0.5);
  --ag-row-border-color: rgba(189, 195, 199, 0.58);
  --ag-chip-background-color: rgba(0, 0, 0, 0.1);
  --ag-range-selection-background-color: rgba(0, 145, 234, 0.2);
  --ag-range-selection-background-color-2: rgba(0, 145, 234, 0.36);
  --ag-range-selection-background-color-3: rgba(0, 145, 234, 0.49);
  --ag-range-selection-background-color-4: rgba(0, 145, 234, 0.59);
  --ag-selected-row-background-color: rgba(0, 145, 234, 0.28);
  --ag-header-column-separator-color: rgba(189, 195, 199, 0.5);
  --ag-input-disabled-border-color: rgba(149, 165, 166, 0.3);
  --ag-row-numbers-selected-color: color-mix(in srgb, transparent, var(--ag-balham-active-color) 50%);
  --ag-header-column-separator-display: block;
  --ag-header-column-separator-height: 50%;
  --ag-grid-size: 4px;
  --ag-icon-size: 16px;
  --ag-row-height: calc(var(--ag-grid-size) * 7);
  --ag-header-height: calc(var(--ag-grid-size) * 8);
  --ag-list-item-height: calc(var(--ag-grid-size) * 6);
  --ag-row-group-indent-size: calc(var(--ag-grid-size) * 3 + var(--ag-icon-size));
  --ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);
  --ag-input-height: calc(var(--ag-grid-size) * 4);
  --ag-chart-menu-panel-width: 240px;
  --ag-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell,
      "Helvetica Neue", sans-serif;
  --ag-font-size: 12px;
  --ag-icon-font-family: agGridBalham;
  --ag-border-radius: 2px;
  --ag-checkbox-border-radius: 3px;
  --ag-card-shadow: none;
}
.ag-theme-balham-dark {
  --ag-balham-active-color: #00b0ff;
  --ag-foreground-color: #f5f5f5;
  --ag-background-color: #2d3436;
  --ag-header-background-color: #1c1c1c;
  --ag-tooltip-background-color: #1c1f20;
  --ag-subheader-background-color: #111;
  --ag-control-panel-background-color: #202020;
  --ag-border-color: #424242;
  --ag-odd-row-background-color: #262c2e;
  --ag-row-hover-color: #3d4749;
  --ag-column-hover-color: #3d4749;
  --ag-input-border-color: #f0f0f0;
  --ag-input-disabled-background-color: rgba(48, 46, 46, 0.3);
  --ag-modal-overlay-background-color: rgba(45, 52, 54, 0.66);
  --ag-checkbox-unchecked-color: #ecf0f1;
  --ag-advanced-filter-join-pill-color: #7a3a37;
  --ag-advanced-filter-column-pill-color: #355f2d;
  --ag-advanced-filter-option-pill-color: #5a3168;
  --ag-advanced-filter-value-pill-color: #374c86;
  --ag-find-match-color: var(--ag-background-color);
  --ag-find-active-match-color: var(--ag-background-color);
  --ag-filter-panel-apply-button-color: var(--ag-foreground-color);
  --ag-secondary-foreground-color: var(--ag-foreground-color);
  --ag-disabled-foreground-color: rgba(245, 245, 245, 0.38);
  --ag-subheader-toolbar-background-color: rgba(17, 17, 17, 0.5);
  --ag-row-border-color: #5c5c5c;
  --ag-chip-background-color: rgba(245, 245, 245, 0.08);
  --ag-range-selection-background-color: rgba(0, 176, 255, 0.2);
  --ag-range-selection-background-color-2: rgba(0, 176, 255, 0.36);
  --ag-range-selection-background-color-3: rgba(0, 176, 255, 0.49);
  --ag-range-selection-background-color-4: rgba(0, 176, 255, 0.59);
  --ag-selected-row-background-color: rgba(0, 176, 255, 0.28);
  --ag-header-column-separator-color: rgba(66, 66, 66, 0.5);
  --ag-input-disabled-border-color: rgba(240, 240, 240, 0.3);
  --ag-header-foreground-color: rgba(245, 245, 245, 0.64);
  --ag-toggle-button-off-background-color: transparent;
  --ag-toggle-button-off-border-color: var(--ag-foreground-color);
  --ag-range-selection-chart-category-background-color: rgba(26, 177, 74, 0.5);
  --ag-range-selection-chart-background-color: rgba(45, 166, 255, 0.5);
  --ag-input-focus-box-shadow: 0 0 4px 1.5px var(--ag-input-focus-border-color);
  --ag-input-error-focus-box-shadow: 0 0 4px 1.5px
      color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 0.5%);
  --ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, 0.4);
  --ag-cell-batch-edit-text-color: #f3d0b3;
  color-scheme: dark;
}
@media (prefers-color-scheme: dark) {
.ag-theme-balham-auto-dark {
    --ag-balham-active-color: #00b0ff;
    --ag-foreground-color: #f5f5f5;
    --ag-background-color: #2d3436;
    --ag-header-background-color: #1c1c1c;
    --ag-tooltip-background-color: #1c1f20;
    --ag-subheader-background-color: #111;
    --ag-control-panel-background-color: #202020;
    --ag-border-color: #424242;
    --ag-odd-row-background-color: #262c2e;
    --ag-row-hover-color: #3d4749;
    --ag-column-hover-color: #3d4749;
    --ag-input-border-color: #f0f0f0;
    --ag-input-disabled-background-color: rgba(48, 46, 46, 0.3);
    --ag-modal-overlay-background-color: rgba(45, 52, 54, 0.66);
    --ag-checkbox-unchecked-color: #ecf0f1;
    --ag-advanced-filter-join-pill-color: #7a3a37;
    --ag-advanced-filter-column-pill-color: #355f2d;
    --ag-advanced-filter-option-pill-color: #5a3168;
    --ag-advanced-filter-value-pill-color: #374c86;
    --ag-find-match-color: var(--ag-background-color);
    --ag-find-active-match-color: var(--ag-background-color);
    --ag-filter-panel-apply-button-color: var(--ag-foreground-color);
    --ag-secondary-foreground-color: var(--ag-foreground-color);
    --ag-disabled-foreground-color: rgba(245, 245, 245, 0.38);
    --ag-subheader-toolbar-background-color: rgba(17, 17, 17, 0.5);
    --ag-row-border-color: #5c5c5c;
    --ag-chip-background-color: rgba(245, 245, 245, 0.08);
    --ag-range-selection-background-color: rgba(0, 176, 255, 0.2);
    --ag-range-selection-background-color-2: rgba(0, 176, 255, 0.36);
    --ag-range-selection-background-color-3: rgba(0, 176, 255, 0.49);
    --ag-range-selection-background-color-4: rgba(0, 176, 255, 0.59);
    --ag-selected-row-background-color: rgba(0, 176, 255, 0.28);
    --ag-header-column-separator-color: rgba(66, 66, 66, 0.5);
    --ag-input-disabled-border-color: rgba(240, 240, 240, 0.3);
    --ag-header-foreground-color: rgba(245, 245, 245, 0.64);
    --ag-toggle-button-off-background-color: transparent;
    --ag-toggle-button-off-border-color: var(--ag-foreground-color);
    --ag-range-selection-chart-category-background-color: rgba(26, 177, 74, 0.5);
    --ag-range-selection-chart-background-color: rgba(45, 166, 255, 0.5);
    --ag-input-focus-box-shadow: 0 0 4px 1.5px var(--ag-input-focus-border-color);
    --ag-input-error-focus-box-shadow: 0 0 4px 1.5px
        color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 0.5%);
    --ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, 0.4);
    --ag-cell-batch-edit-text-color: #f3d0b3;
    color-scheme: dark;
}
}
.ag-theme-balham .ag-filter-toolpanel-header,
.ag-theme-balham .ag-filter-toolpanel-search,
.ag-theme-balham .ag-status-bar,
.ag-theme-balham .ag-header-row,
.ag-theme-balham .ag-row-number-cell,
.ag-theme-balham .ag-multi-filter-group-title-bar,
.ag-theme-balham-dark .ag-filter-toolpanel-header,
.ag-theme-balham-dark .ag-filter-toolpanel-search,
.ag-theme-balham-dark .ag-status-bar,
.ag-theme-balham-dark .ag-header-row,
.ag-theme-balham-dark .ag-row-number-cell,
.ag-theme-balham-dark .ag-multi-filter-group-title-bar,
.ag-theme-balham-auto-dark .ag-filter-toolpanel-header,
.ag-theme-balham-auto-dark .ag-filter-toolpanel-search,
.ag-theme-balham-auto-dark .ag-status-bar,
.ag-theme-balham-auto-dark .ag-header-row,
.ag-theme-balham-auto-dark .ag-row-number-cell,
.ag-theme-balham-auto-dark .ag-multi-filter-group-title-bar {
  font-weight: 600;
  color: var(--ag-header-foreground-color);
}
.ag-theme-balham .ag-ltr input[class^=ag-]:not([type]), .ag-theme-balham .ag-ltr input[class^=ag-][type=text], .ag-theme-balham .ag-ltr input[class^=ag-][type=number], .ag-theme-balham .ag-ltr input[class^=ag-][type=tel], .ag-theme-balham .ag-ltr input[class^=ag-][type=date], .ag-theme-balham .ag-ltr input[class^=ag-][type=datetime-local], .ag-theme-balham .ag-ltr textarea[class^=ag-], .ag-theme-balham-dark .ag-ltr input[class^=ag-]:not([type]), .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=text], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=number], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=tel], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=date], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=datetime-local], .ag-theme-balham-dark .ag-ltr textarea[class^=ag-], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-]:not([type]), .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=text], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=number], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=tel], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=date], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=datetime-local], .ag-theme-balham-auto-dark .ag-ltr textarea[class^=ag-] {
  padding-left: var(--ag-grid-size);
}
.ag-theme-balham .ag-rtl input[class^=ag-]:not([type]), .ag-theme-balham .ag-rtl input[class^=ag-][type=text], .ag-theme-balham .ag-rtl input[class^=ag-][type=number], .ag-theme-balham .ag-rtl input[class^=ag-][type=tel], .ag-theme-balham .ag-rtl input[class^=ag-][type=date], .ag-theme-balham .ag-rtl input[class^=ag-][type=datetime-local], .ag-theme-balham .ag-rtl textarea[class^=ag-], .ag-theme-balham-dark .ag-rtl input[class^=ag-]:not([type]), .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=text], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=number], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=tel], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=date], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=datetime-local], .ag-theme-balham-dark .ag-rtl textarea[class^=ag-], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-]:not([type]), .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=text], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=number], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=tel], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=date], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=datetime-local], .ag-theme-balham-auto-dark .ag-rtl textarea[class^=ag-] {
  padding-right: var(--ag-grid-size);
}
.ag-theme-balham .ag-column-drop-vertical-empty-message,
.ag-theme-balham .ag-status-bar,
.ag-theme-balham-dark .ag-column-drop-vertical-empty-message,
.ag-theme-balham-dark .ag-status-bar,
.ag-theme-balham-auto-dark .ag-column-drop-vertical-empty-message,
.ag-theme-balham-auto-dark .ag-status-bar {
  font-weight: 600;
  color: var(--ag-disabled-foreground-color);
}
.ag-theme-balham.ag-dnd-ghost,
.ag-theme-balham-dark.ag-dnd-ghost,
.ag-theme-balham-auto-dark.ag-dnd-ghost {
  font-size: var(--ag-font-size);
  font-weight: 600;
}
.ag-theme-balham .ag-tab,
.ag-theme-balham-dark .ag-tab,
.ag-theme-balham-auto-dark .ag-tab {
  border: 1px solid transparent;
  padding: var(--ag-grid-size) calc(var(--ag-grid-size) * 2);
  margin: var(--ag-grid-size);
  margin-bottom: -1px;
}
.ag-theme-balham .ag-tab-selected,
.ag-theme-balham-dark .ag-tab-selected,
.ag-theme-balham-auto-dark .ag-tab-selected {
  background-color: var(--ag-background-color);
  border-color: var(--ag-border-color);
  border-bottom-color: transparent;
}
.ag-theme-balham .ag-tabs-header,
.ag-theme-balham-dark .ag-tabs-header,
.ag-theme-balham-auto-dark .ag-tabs-header {
  border-bottom: 1px solid var(--ag-border-color);
}
.ag-theme-balham .ag-column-drop-cell,
.ag-theme-balham-dark .ag-column-drop-cell,
.ag-theme-balham-auto-dark .ag-column-drop-cell {
  height: calc(var(--ag-grid-size) * 6);
}
.ag-theme-balham .ag-column-drop-vertical-title,
.ag-theme-balham-dark .ag-column-drop-vertical-title,
.ag-theme-balham-auto-dark .ag-column-drop-vertical-title {
  color: var(--ag-foreground-color);
}
.ag-theme-balham .ag-column-drop-vertical-cell,
.ag-theme-balham-dark .ag-column-drop-vertical-cell,
.ag-theme-balham-auto-dark .ag-column-drop-vertical-cell {
  margin-left: calc(var(--ag-grid-size) * 2);
  margin-right: calc(var(--ag-grid-size) * 2);
}
.ag-theme-balham .ag-column-drop-vertical-cell-text,
.ag-theme-balham-dark .ag-column-drop-vertical-cell-text,
.ag-theme-balham-auto-dark .ag-column-drop-vertical-cell-text {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-theme-balham .ag-column-drop-vertical-icon,
.ag-theme-balham-dark .ag-column-drop-vertical-icon,
.ag-theme-balham-auto-dark .ag-column-drop-vertical-icon {
  color: var(--ag-secondary-foreground-color);
}
.ag-theme-balham .ag-ltr .ag-column-drop-vertical-empty-message, .ag-theme-balham-dark .ag-ltr .ag-column-drop-vertical-empty-message, .ag-theme-balham-auto-dark .ag-ltr .ag-column-drop-vertical-empty-message {
  padding-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
  padding-right: var(--ag-grid-size);
}
.ag-theme-balham .ag-rtl .ag-column-drop-vertical-empty-message, .ag-theme-balham-dark .ag-rtl .ag-column-drop-vertical-empty-message, .ag-theme-balham-auto-dark .ag-rtl .ag-column-drop-vertical-empty-message {
  padding-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
  padding-left: var(--ag-grid-size);
}
.ag-theme-balham .ag-column-drop-horizontal,
.ag-theme-balham-dark .ag-column-drop-horizontal,
.ag-theme-balham-auto-dark .ag-column-drop-horizontal {
  height: var(--ag-header-height);
}
.ag-theme-balham .ag-column-drop-empty,
.ag-theme-balham-dark .ag-column-drop-empty,
.ag-theme-balham-auto-dark .ag-column-drop-empty {
  color: var(--ag-disabled-foreground-color);
}
.ag-theme-balham .ag-column-drop-horizontal-cell-text,
.ag-theme-balham-dark .ag-column-drop-horizontal-cell-text,
.ag-theme-balham-auto-dark .ag-column-drop-horizontal-cell-text {
  margin-left: calc(var(--ag-grid-size) * 2);
}
.ag-theme-balham .ag-column-drop-vertical,
.ag-theme-balham-dark .ag-column-drop-vertical,
.ag-theme-balham-auto-dark .ag-column-drop-vertical {
  padding-top: calc(var(--ag-grid-size) * 2);
}
.ag-theme-balham .ag-column-select-column-readonly.ag-icon-grip,
.ag-theme-balham .ag-column-select-column-readonly .ag-icon-grip,
.ag-theme-balham-dark .ag-column-select-column-readonly.ag-icon-grip,
.ag-theme-balham-dark .ag-column-select-column-readonly .ag-icon-grip,
.ag-theme-balham-auto-dark .ag-column-select-column-readonly.ag-icon-grip,
.ag-theme-balham-auto-dark .ag-column-select-column-readonly .ag-icon-grip {
  opacity: 0.35;
}
.ag-theme-balham .ag-menu-header,
.ag-theme-balham-dark .ag-menu-header,
.ag-theme-balham-auto-dark .ag-menu-header {
  background-color: var(--ag-header-background-color);
}
.ag-theme-balham .ag-overlay-loading-center,
.ag-theme-balham-dark .ag-overlay-loading-center,
.ag-theme-balham-auto-dark .ag-overlay-loading-center {
  background-color: var(--ag-background-color);
  border: 1px solid var(--ag-border-color);
  color: var(--ag-foreground-color);
  padding: calc(var(--ag-grid-size) * 4);
}
.ag-theme-balham .ag-tooltip,
.ag-theme-balham-dark .ag-tooltip,
.ag-theme-balham-auto-dark .ag-tooltip {
  border: none;
}
.ag-theme-balham .ag-panel-title-bar-button-icon,
.ag-theme-balham-dark .ag-panel-title-bar-button-icon,
.ag-theme-balham-auto-dark .ag-panel-title-bar-button-icon {
  font-size: calc(var(--ag-icon-size) + var(--ag-grid-size));
}
.ag-theme-balham .ag-panel,
.ag-theme-balham-dark .ag-panel,
.ag-theme-balham-auto-dark .ag-panel {
  background-color: var(--ag-header-background-color);
}
.ag-theme-balham .ag-chart-data-section,
.ag-theme-balham .ag-chart-format-section,
.ag-theme-balham .ag-chart-advanced-settings-section,
.ag-theme-balham-dark .ag-chart-data-section,
.ag-theme-balham-dark .ag-chart-format-section,
.ag-theme-balham-dark .ag-chart-advanced-settings-section,
.ag-theme-balham-auto-dark .ag-chart-data-section,
.ag-theme-balham-auto-dark .ag-chart-format-section,
.ag-theme-balham-auto-dark .ag-chart-advanced-settings-section {
  padding-bottom: calc(var(--ag-grid-size) * 0.5);
}
.ag-theme-balham .ag-group-toolbar,
.ag-theme-balham-dark .ag-group-toolbar,
.ag-theme-balham-auto-dark .ag-group-toolbar {
  background-color: var(--ag-subheader-toolbar-background-color);
}
.ag-theme-balham .ag-chart-tab,
.ag-theme-balham-dark .ag-chart-tab,
.ag-theme-balham-auto-dark .ag-chart-tab {
  padding-top: calc(var(--ag-grid-size) * 0.5);
}
.ag-theme-balham .ag-charts-format-sub-level-group-item,
.ag-theme-balham-dark .ag-charts-format-sub-level-group-item,
.ag-theme-balham-auto-dark .ag-charts-format-sub-level-group-item {
  margin-bottom: calc(var(--ag-grid-size) * 1.5);
}
.ag-theme-balham .ag-filter-active .ag-icon-filter,
.ag-theme-balham-dark .ag-filter-active .ag-icon-filter,
.ag-theme-balham-auto-dark .ag-filter-active .ag-icon-filter {
  color: var(--ag-balham-active-color);
}
.ag-theme-balham .ag-color-input input[class^=ag-][type=text].ag-input-field-input,
.ag-theme-balham-dark .ag-color-input input[class^=ag-][type=text].ag-input-field-input,
.ag-theme-balham-auto-dark .ag-color-input input[class^=ag-][type=text].ag-input-field-input {
  min-height: calc(var(--ag-icon-size) + 4px);
}
.ag-theme-balham .ag-list-item-hovered::after,
.ag-theme-balham-dark .ag-list-item-hovered::after,
.ag-theme-balham-auto-dark .ag-list-item-hovered::after {
  background-color: var(--ag-balham-active-color);
}
.ag-theme-balham .ag-pill .ag-pill-button:hover,
.ag-theme-balham-dark .ag-pill .ag-pill-button:hover,
.ag-theme-balham-auto-dark .ag-pill .ag-pill-button:hover {
  color: var(--ag-balham-active-color);
}
.ag-theme-balham .ag-header-highlight-before::after,
.ag-theme-balham .ag-header-highlight-after::after,
.ag-theme-balham-dark .ag-header-highlight-before::after,
.ag-theme-balham-dark .ag-header-highlight-after::after,
.ag-theme-balham-auto-dark .ag-header-highlight-before::after,
.ag-theme-balham-auto-dark .ag-header-highlight-after::after {
  background-color: var(--ag-balham-active-color);
}
.ag-theme-balham .ag-advanced-filter-builder-item-button-disabled .ag-icon,
.ag-theme-balham .ag-disabled .ag-icon,
.ag-theme-balham .ag-column-select-column-group-readonly .ag-icon,
.ag-theme-balham [disabled] .ag-icon,
.ag-theme-balham-dark .ag-advanced-filter-builder-item-button-disabled .ag-icon,
.ag-theme-balham-dark .ag-disabled .ag-icon,
.ag-theme-balham-dark .ag-column-select-column-group-readonly .ag-icon,
.ag-theme-balham-dark [disabled] .ag-icon,
.ag-theme-balham-auto-dark .ag-advanced-filter-builder-item-button-disabled .ag-icon,
.ag-theme-balham-auto-dark .ag-disabled .ag-icon,
.ag-theme-balham-auto-dark .ag-column-select-column-group-readonly .ag-icon,
.ag-theme-balham-auto-dark [disabled] .ag-icon {
  color: var(--ag-disabled-foreground-color);
}
.ag-theme-balham .ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button:disabled,
.ag-theme-balham-dark .ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button:disabled,
.ag-theme-balham-auto-dark .ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button:disabled {
  color: unset;
  background-color: unset;
}
.ag-theme-balham .ag-filter-card-title,
.ag-theme-balham-dark .ag-filter-card-title,
.ag-theme-balham-auto-dark .ag-filter-card-title {
  font-weight: 600;
}

    /* Cropper JS */

    /*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:02.731Z
 */
.cropper-container {
  direction: ltr;
  font-size: 0;
  line-height: 0;
  position: relative;
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.cropper-container img {
    -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
    display: block;
    height: 100%;
    image-orientation: 0deg;
    max-height: none !important;
    max-width: none !important;
    min-height: 0 !important;
    min-width: 0 !important;
    width: 100%;
}
.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.cropper-wrap-box,
.cropper-canvas {
  overflow: hidden;
}
.cropper-drag-box {
  background-color: #fff;
  opacity: 0;
}
.cropper-modal {
  background-color: #000;
  opacity: 0.5;
}
.cropper-view-box {
  display: block;
  height: 100%;
  outline: 1px solid #39f;
  outline-color: rgba(51, 153, 255, 0.75);
  overflow: hidden;
  width: 100%;
}
.cropper-dashed {
  border: 0 dashed #eee;
  display: block;
  opacity: 0.5;
  position: absolute;
}
.cropper-dashed.dashed-h {
    border-bottom-width: 1px;
    border-top-width: 1px;
    height: calc(100% / 3);
    left: 0;
    top: calc(100% / 3);
    width: 100%;
}
.cropper-dashed.dashed-v {
    border-left-width: 1px;
    border-right-width: 1px;
    height: 100%;
    left: calc(100% / 3);
    top: 0;
    width: calc(100% / 3);
}
.cropper-center {
  display: block;
  height: 0;
  left: 50%;
  opacity: 0.75;
  position: absolute;
  top: 50%;
  width: 0;
}
.cropper-center::before,
  .cropper-center::after {
    background-color: #eee;
    content: ' ';
    display: block;
    position: absolute;
}
.cropper-center::before {
    height: 1px;
    left: -3px;
    top: 0;
    width: 7px;
}
.cropper-center::after {
    height: 7px;
    left: 0;
    top: -3px;
    width: 1px;
}
.cropper-face,
.cropper-line,
.cropper-point {
  display: block;
  height: 100%;
  opacity: 0.1;
  position: absolute;
  width: 100%;
}
.cropper-face {
  background-color: #fff;
  left: 0;
  top: 0;
}
.cropper-line {
  background-color: #39f;
}
.cropper-line.line-e {
    cursor: ew-resize;
    right: -3px;
    top: 0;
    width: 5px;
}
.cropper-line.line-n {
    cursor: ns-resize;
    height: 5px;
    left: 0;
    top: -3px;
}
.cropper-line.line-w {
    cursor: ew-resize;
    left: -3px;
    top: 0;
    width: 5px;
}
.cropper-line.line-s {
    bottom: -3px;
    cursor: ns-resize;
    height: 5px;
    left: 0;
}
.cropper-point {
  background-color: #39f;
  height: 5px;
  opacity: 0.75;
  width: 5px;
}
.cropper-point.point-e {
    cursor: ew-resize;
    margin-top: -3px;
    right: -3px;
    top: 50%;
}
.cropper-point.point-n {
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
    top: -3px;
}
.cropper-point.point-w {
    cursor: ew-resize;
    left: -3px;
    margin-top: -3px;
    top: 50%;
}
.cropper-point.point-s {
    bottom: -3px;
    cursor: s-resize;
    left: 50%;
    margin-left: -3px;
}
.cropper-point.point-ne {
    cursor: nesw-resize;
    right: -3px;
    top: -3px;
}
.cropper-point.point-nw {
    cursor: nwse-resize;
    left: -3px;
    top: -3px;
}
.cropper-point.point-sw {
    bottom: -3px;
    cursor: nesw-resize;
    left: -3px;
}
.cropper-point.point-se {
    bottom: -3px;
    cursor: nwse-resize;
    height: 20px;
    opacity: 1;
    right: -3px;
    width: 20px;
}
@media (min-width: 768px) {
.cropper-point.point-se {
      height: 15px;
      width: 15px;
}
}
@media (min-width: 992px) {
.cropper-point.point-se {
      height: 10px;
      width: 10px;
}
}
@media (min-width: 1200px) {
.cropper-point.point-se {
      height: 5px;
      opacity: 0.75;
      width: 5px;
}
}
.cropper-point.point-se::before {
    background-color: #39f;
    bottom: -50%;
    content: ' ';
    display: block;
    height: 200%;
    opacity: 0;
    position: absolute;
    right: -50%;
    width: 200%;
}
.cropper-invisible {
  opacity: 0;
}
.cropper-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.cropper-hide {
  display: block;
  height: 0;
  position: absolute;
  width: 0;
}
.cropper-hidden {
  display: none !important;
}
.cropper-move {
  cursor: move;
}
.cropper-crop {
  cursor: crosshair;
}
.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}

    /* Vue Virtual Scroller */
.vue-recycle-scroller{position:relative}
.vue-recycle-scroller.direction-vertical:not(.page-mode){overflow-y:auto}
.vue-recycle-scroller.direction-horizontal:not(.page-mode){overflow-x:auto}
.vue-recycle-scroller.direction-horizontal{display:flex}
.vue-recycle-scroller__slot{flex:auto 0 0}
.vue-recycle-scroller__item-wrapper{flex:1;box-sizing:border-box;overflow:hidden;position:relative}
.vue-recycle-scroller.ready .vue-recycle-scroller__item-view{position:absolute;top:0;left:0;will-change:transform}
.vue-recycle-scroller.direction-vertical .vue-recycle-scroller__item-wrapper{width:100%}
.vue-recycle-scroller.direction-horizontal .vue-recycle-scroller__item-wrapper{height:100%}
.vue-recycle-scroller.ready.direction-vertical .vue-recycle-scroller__item-view{width:100%}
.vue-recycle-scroller.ready.direction-horizontal .vue-recycle-scroller__item-view{height:100%}
.resize-observer[data-v-b329ee4c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}
.resize-observer[data-v-b329ee4c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}

    /* Vue Resize */
.vue3-resize-observer{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}
.vue3-resize-observer object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}
`, "",{"version":3,"sources":["webpack://./src/App.vue","webpack://./node_modules/ag-grid-community/styles/ag-grid.css","webpack://./node_modules/ag-grid-community/styles/ag-theme-balham.css","webpack://./node_modules/cropperjs/dist/cropper.css","webpack://./node_modules/vue-virtual-scroller/dist/vue-virtual-scroller.css","webpack://./node_modules/vue3-resize/dist/vue3-resize.css"],"names":[],"mappings":";IAiLI,yBAAyB;;IAEzB,YAAY;ACnLhB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,oGAAoG;EACpG,eAAe;EACf,0EAA0E;AAC5E;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gDAAgD;EAChD,sEAAsE;AACxE;AAEA;EACE,2DAA2D;AAC7D;AAEA;EACE,6CAA6C;EAC7C,8DAA8D;EAC9D,oDAAoD;AACtD;AAEA;EACE,sCAAsC;EACtC,uDAAuD;EACvD,6CAA6C;AAC/C;AAEA;EACE,0CAA0C;AAC5C;AAEA;EACE,uCAAuC;AACzC;AAEA;EACE,iCAAiC;AACnC;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,2EAA2E;EAC3E,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AAEA;EACE,+EAA+E;EAC/E,+EAA+E;EAC/E,uEAAuE;AACzE;AAEA;EACE,sDAAsD;EACtD,6EAA6E;AAC/E;AAEA;EACE,wEAAwE;EACxE,+EAA+E;EAC/E,oFAAoF;AACtF;AAEA;EACE,0EAA0E;EAC1E,0EAA0E;EAC1E,kEAAkE;AACpE;AAEA;EACE,iDAAiD;EACjD,wEAAwE;AAC1E;AAEA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,+EAA+E;AACjF;AAEA;EACE,uEAAuE;EACvE,uEAAuE;EACvE,+DAA+D;AACjE;AAEA;EACE,8CAA8C;EAC9C,qEAAqE;AACvE;AAEA;EACE,gEAAgE;EAChE,uEAAuE;EACvE,4EAA4E;AAC9E;AAEA;EACE,0EAA0E;EAC1E,0EAA0E;EAC1E,kEAAkE;AACpE;AAEA;EACE,iDAAiD;EACjD,wEAAwE;AAC1E;AAEA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,+EAA+E;AACjF;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,oFAAoF;EACpF,oFAAoF;EACpF,4EAA4E;AAC9E;AAEA;EACE,2DAA2D;EAC3D,kFAAkF;AACpF;AAEA;EACE,6EAA6E;EAC7E,oFAAoF;EACpF,yFAAyF;AAC3F;AAEA;EACE,0FAA0F;EAC1F,0FAA0F;EAC1F,kFAAkF;AACpF;AAEA;EACE,iEAAiE;EACjE,wFAAwF;AAC1F;AAEA;EACE,mFAAmF;EACnF,0FAA0F;EAC1F,+FAA+F;AACjG;AAEA;EACE,sFAAsF;EACtF,sFAAsF;EACtF,8EAA8E;AAChF;AAEA;EACE,6DAA6D;EAC7D,oFAAoF;AACtF;AAEA;EACE,+EAA+E;EAC/E,sFAAsF;EACtF,2FAA2F;AAC7F;AAEA;EACE,gFAAgF;EAChF,gFAAgF;EAChF,wEAAwE;AAC1E;AAEA;EACE,uDAAuD;EACvD,8EAA8E;AAChF;AAEA;EACE,yEAAyE;EACzE,gFAAgF;EAChF,qFAAqF;AACvF;AAEA;EACE,2EAA2E;EAC3E,2EAA2E;EAC3E,mEAAmE;AACrE;AAEA;EACE,kDAAkD;EAClD,yEAAyE;AAC3E;AAEA;EACE,oEAAoE;EACpE,2EAA2E;EAC3E,gFAAgF;AAClF;AAEA;EACE,8EAA8E;EAC9E,8EAA8E;EAC9E,sEAAsE;AACxE;AAEA;EACE,qDAAqD;EACrD,4EAA4E;AAC9E;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,mFAAmF;AACrF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,uEAAuE;EACvE,uEAAuE;EACvE,+DAA+D;AACjE;AAEA;EACE,8CAA8C;EAC9C,qEAAqE;AACvE;AAEA;EACE,gEAAgE;EAChE,uEAAuE;EACvE,4EAA4E;AAC9E;AAEA;EACE,uEAAuE;EACvE,uEAAuE;EACvE,+DAA+D;AACjE;AAEA;EACE,8CAA8C;EAC9C,qEAAqE;AACvE;AAEA;EACE,gEAAgE;EAChE,uEAAuE;EACvE,4EAA4E;AAC9E;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,6EAA6E;EAC7E,6EAA6E;EAC7E,qEAAqE;AACvE;AAEA;EACE,oDAAoD;EACpD,2EAA2E;AAC7E;AAEA;EACE,sEAAsE;EACtE,6EAA6E;EAC7E,kFAAkF;AACpF;AAEA;EACE,uEAAuE;EACvE,uEAAuE;EACvE,+DAA+D;AACjE;AAEA;EACE,8CAA8C;EAC9C,qEAAqE;AACvE;AAEA;EACE,gEAAgE;EAChE,uEAAuE;EACvE,4EAA4E;AAC9E;AAEA;EACE,0EAA0E;EAC1E,0EAA0E;EAC1E,kEAAkE;AACpE;AAEA;EACE,iDAAiD;EACjD,wEAAwE;AAC1E;AAEA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,+EAA+E;AACjF;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,0EAA0E;EAC1E,0EAA0E;EAC1E,kEAAkE;AACpE;AAEA;EACE,iDAAiD;EACjD,wEAAwE;AAC1E;AAEA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,+EAA+E;AACjF;AAEA;EACE,2EAA2E;EAC3E,2EAA2E;EAC3E,mEAAmE;AACrE;AAEA;EACE,kDAAkD;EAClD,yEAAyE;AAC3E;AAEA;EACE,oEAAoE;EACpE,2EAA2E;EAC3E,gFAAgF;AAClF;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,+EAA+E;EAC/E,+EAA+E;EAC/E,uEAAuE;AACzE;AAEA;EACE,sDAAsD;EACtD,6EAA6E;AAC/E;AAEA;EACE,wEAAwE;EACxE,+EAA+E;EAC/E,oFAAoF;AACtF;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,uEAAuE;EACvE,uEAAuE;EACvE,+DAA+D;AACjE;AAEA;EACE,8CAA8C;EAC9C,qEAAqE;AACvE;AAEA;EACE,gEAAgE;EAChE,uEAAuE;EACvE,4EAA4E;AAC9E;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,oFAAoF;EACpF,oFAAoF;EACpF,4EAA4E;AAC9E;AAEA;EACE,2DAA2D;EAC3D,kFAAkF;AACpF;AAEA;EACE,6EAA6E;EAC7E,oFAAoF;EACpF,yFAAyF;AAC3F;AAEA;EACE,mFAAmF;EACnF,mFAAmF;EACnF,2EAA2E;AAC7E;AAEA;EACE,0DAA0D;EAC1D,iFAAiF;AACnF;AAEA;EACE,4EAA4E;EAC5E,mFAAmF;EACnF,wFAAwF;AAC1F;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,8EAA8E;EAC9E,8EAA8E;EAC9E,sEAAsE;AACxE;AAEA;EACE,qDAAqD;EACrD,4EAA4E;AAC9E;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,mFAAmF;AACrF;AAEA;EACE,8EAA8E;EAC9E,8EAA8E;EAC9E,sEAAsE;AACxE;AAEA;EACE,qDAAqD;EACrD,4EAA4E;AAC9E;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,mFAAmF;AACrF;AAEA;EACE,+EAA+E;EAC/E,+EAA+E;EAC/E,uEAAuE;AACzE;AAEA;EACE,sDAAsD;EACtD,6EAA6E;AAC/E;AAEA;EACE,wEAAwE;EACxE,+EAA+E;EAC/E,oFAAoF;AACtF;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,+EAA+E;EAC/E,+EAA+E;EAC/E,uEAAuE;AACzE;AAEA;EACE,sDAAsD;EACtD,6EAA6E;AAC/E;AAEA;EACE,wEAAwE;EACxE,+EAA+E;EAC/E,oFAAoF;AACtF;AAEA;EACE,sFAAsF;EACtF,sFAAsF;EACtF,8EAA8E;AAChF;AAEA;EACE,6DAA6D;EAC7D,oFAAoF;AACtF;AAEA;EACE,+EAA+E;EAC/E,sFAAsF;EACtF,2FAA2F;AAC7F;AAEA;EACE,6EAA6E;EAC7E,6EAA6E;EAC7E,qEAAqE;AACvE;AAEA;EACE,oDAAoD;EACpD,2EAA2E;AAC7E;AAEA;EACE,sEAAsE;EACtE,6EAA6E;EAC7E,kFAAkF;AACpF;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,sEAAsE;EACtE,sEAAsE;EACtE,8DAA8D;AAChE;AAEA;EACE,6CAA6C;EAC7C,oEAAoE;AACtE;AAEA;EACE,+DAA+D;EAC/D,sEAAsE;EACtE,2EAA2E;AAC7E;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,yEAAyE;EACzE,yEAAyE;EACzE,iEAAiE;AACnE;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,8EAA8E;AAChF;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,4EAA4E;EAC5E,4EAA4E;EAC5E,oEAAoE;AACtE;AAEA;EACE,mDAAmD;EACnD,0EAA0E;AAC5E;AAEA;EACE,qEAAqE;EACrE,4EAA4E;EAC5E,iFAAiF;AACnF;AAEA;EACE,gFAAgF;EAChF,gFAAgF;EAChF,wEAAwE;AAC1E;AAEA;EACE,uDAAuD;EACvD,8EAA8E;AAChF;AAEA;EACE,yEAAyE;EACzE,gFAAgF;EAChF,qFAAqF;AACvF;AAEA;EACE,0EAA0E;EAC1E,0EAA0E;EAC1E,kEAAkE;AACpE;AAEA;EACE,iDAAiD;EACjD,wEAAwE;AAC1E;AAEA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,+EAA+E;AACjF;AAEA;EACE,iFAAiF;EACjF,iFAAiF;EACjF,yEAAyE;AAC3E;AAEA;EACE,wDAAwD;EACxD,+EAA+E;AACjF;AAEA;EACE,0EAA0E;EAC1E,iFAAiF;EACjF,sFAAsF;AACxF;AAEA;EACE,8EAA8E;EAC9E,8EAA8E;EAC9E,sEAAsE;AACxE;AAEA;EACE,qDAAqD;EACrD,4EAA4E;AAC9E;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,mFAAmF;AACrF;AAEA;EACE,8EAA8E;EAC9E,8EAA8E;EAC9E,sEAAsE;AACxE;AAEA;EACE,qDAAqD;EACrD,4EAA4E;AAC9E;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,mFAAmF;AACrF;AAEA;EACE,gFAAgF;EAChF,gFAAgF;EAChF,wEAAwE;AAC1E;AAEA;EACE,uDAAuD;EACvD,8EAA8E;AAChF;AAEA;EACE,yEAAyE;EACzE,gFAAgF;EAChF,qFAAqF;AACvF;AAEA;EACE,gFAAgF;EAChF,gFAAgF;EAChF,wEAAwE;AAC1E;AAEA;EACE,uDAAuD;EACvD,8EAA8E;AAChF;AAEA;EACE,yEAAyE;EACzE,gFAAgF;EAChF,qFAAqF;AACvF;AAEA;EACE,iFAAiF;EACjF,iFAAiF;EACjF,yEAAyE;AAC3E;AAEA;EACE,wDAAwD;EACxD,+EAA+E;AACjF;AAEA;EACE,0EAA0E;EAC1E,iFAAiF;EACjF,sFAAsF;AACxF;AAEA;EACE,8EAA8E;EAC9E,8EAA8E;EAC9E,sEAAsE;AACxE;AAEA;EACE,qDAAqD;EACrD,4EAA4E;AAC9E;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,mFAAmF;AACrF;AAEA;EACE,wEAAwE;EACxE,wEAAwE;EACxE,gEAAgE;AAClE;AAEA;EACE,+CAA+C;EAC/C,sEAAsE;AACxE;AAEA;EACE,iEAAiE;EACjE,wEAAwE;EACxE,6EAA6E;AAC/E;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,uCAAuC;AACzC;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,2DAA2D;EAC3D,kEAAkE;EAClE,kDAAkD;EAClD,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;EAC1C;;;;GAIC;EACD,sDAAsD;EACtD,4GAA4G;EAC5G,4CAA4C;EAC5C,oDAAoD;EACpD,gDAAgD;EAChD,oFAAoF;EACpF,wCAAwC;EACxC,sDAAsD;EACtD,8DAA8D;EAC9D,8DAA8D;EAC9D,sDAAsD;EACtD,8CAA8C;EAC9C,uDAAuD;EACvD,+CAA+C;EAC/C,iCAAiC;EACjC,oCAAoC;EACpC,6DAA6D;EAC7D,wCAAwC;EACxC,yDAAyD;EACzD,mFAAmF;EACnF,mFAAmF;EACnF,mFAAmF;EACnF,4EAA4E;EAC5E;;;;GAIC;EACD,yEAAyE;EACzE,oCAAoC;EACpC,gDAAgD;EAChD,4EAA4E;EAC5E,kEAAkE;EAClE,oDAAoD;EACpD,oEAAoE;EACpE,2EAA2E;EAC3E,yCAAyC;EACzC,2CAA2C;EAC3C,6DAA6D;EAC7D,uCAAuC;EACvC,uDAAuD;EACvD,uBAAuB;EACvB,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,mDAAmD;EACnD,4BAA4B;EAC5B,uDAAuD;EACvD,0BAA0B;EAC1B,8CAA8C;EAC9C,+CAA+C;EAC/C,yDAAyD;EACzD,qCAAqC;EACrC,wDAAwD;EACxD;;;;GAIC;EACD,2CAA2C;EAC3C,uBAAuB;EACvB,mDAAmD;EACnD,uDAAuD;EACvD,0CAA0C;EAC1C,yCAAyC;EACzC,uCAAuC;EACvC,oEAAoE;EACpE,8CAA8C;EAC9C,4CAA4C;EAC5C,2CAA2C;EAC3C,wEAAwE;EACxE,uBAAuB;EACvB,8DAA8D;EAC9D,iDAAiD;EACjD,2CAA2C;EAC3C,oDAAoD;EACpD,uDAAuD;EACvD,yDAAyD;EACzD,qEAAqE;EACrE,uEAAuE;EACvE,2EAA2E;EAC3E,oEAAoE;EACpE,wEAAwE;EACxE,sEAAsE;EACtE,gFAAgF;EAChF,oCAAoC;EACpC,8CAA8C;EAC9C,kEAAkE;EAClE,iCAAiC;EACjC,uCAAuC;EACvC,mCAAmC;EACnC,qEAAqE;EACrE,oEAAoE;EACpE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,gDAAgD;EAChD,8BAA8B;EAC9B,yEAAyE;EACzE,uEAAuE;EACvE,6DAA6D;EAC7D,iDAAiD;EACjD,2DAA2D;EAC3D,2DAA2D;EAC3D,oDAAoD;EACpD,wCAAwC;EACxC,qDAAqD;EACrD,oDAAoD;EACpD,+EAA+E;EAC/E,4EAA4E;EAC5E,6FAA6F;EAC7F,qFAAqF;EACrF,qCAAqC;EACrC,yCAAyC;EACzC,yBAAyB;EACzB,oDAAoD;EACpD,0BAA0B;EAC1B,gCAAgC;EAChC,8CAA8C;EAC9C,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;EACtB,kDAAkD;EAClD,6CAA6C;EAC7C,+CAA+C;EAC/C,+CAA+C;EAC/C,8CAA8C;EAC9C,iDAAiD;EACjD,wDAAwD;EACxD,yCAAyC;EACzC,gDAAgD;EAChD,6DAA6D;EAC7D,wCAAwC;EACxC,gFAAgF;EAChF,oEAAoE;EACpE,gEAAgE;EAChE,2EAA2E;EAC3E,+DAA+D;EAC/D,qEAAqE;AACvE;AAEA;;EAEE,4CAA4C;AAC9C;AAEA;;EAEE,iDAAiD;AACnD;AAEA;EACE,4FAA4F;AAC9F;AAEA;;EAEE,yBAAyB;AAC3B;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;AAEA;;;;;EAKE,cAAc;AAChB;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,wBAAwB;AAC1B;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,YAAY;AACd;AAEA;EACE,aAAa;AACf;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AAEA;EAEE,yBAAyB;EAEzB,iBAAiB;AACnB;AAEA;EAEE,yBAAyB;EAEzB,iBAAiB;AACnB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;AAClB;AAEA;EACE,QAAQ;AACV;AAEA;EACE,WAAW;AACb;AAEA;EACE,kBAAkB;AACpB;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;EACnC,sCAAsC;AACxC;AAEA;AACE;IACE,iBAAiB;IACjB,kBAAkB;AACpB;AACA;IACE,iBAAiB;IACjB,kBAAkB;AACpB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,WAAW;EACX,yDAAi2M;EACj2M,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;AACtB;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,SAAS;EACT,aAAa;AACf;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,QAAQ;AACV;AACA;EACE,YAAY;AACd;AAEA;;;;;;;;;;EAUE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AAEA;;;;;;;EAOE,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;AAClC;AACA;;;;;;;EAOE,wBAAwB;AAC1B;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;AAEA;;;;EAIE,eAAe;AACjB;AAEA;;EAEE,UAAU;AACZ;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,cAAc;EACd,WAAW;AACb;AAEA;;;;;;;;;;;;;;EAcE,kBAAkB;AACpB;AAEA;;;;;;;;;EASE,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,YAAY;AACd;AAEA;EACE,WAAW;AACb;AAEA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;AACA;;;;;EAKE,OAAO;AACT;AACA;;;;;EAKE,QAAQ;AACV;AAEA;EACE,WAAW;AACb;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,aAAa;AACf;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,SAAS;AACX;AACA;;EAEE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;;EAGE,mBAAmB;EACnB,UAAU;AACZ;AAEA;EACE,WAAW;AACb;AACA;EACE,OAAO;EACP,QAAQ;AACV;AAEA;EACE,YAAY;AACd;AACA;EACE,MAAM;EACN,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,OAAO;AACT;AAEA;EACE,6BAA6B;AAC/B;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AAEA;;;EAGE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;AACd;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AAEA;;EAEE,UAAU;AACZ;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,uBAAuB;AACzB;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;AAEA;EACE,aAAa;AACf;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,WAAW;AACb;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,MAAM;EACN,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AAEA;EACE,WAAW;AACb;AAEA;EACE,UAAU;AACZ;AAEA;EACE,aAAa;AACf;AAEA;;;;;EAKE,eAAe;AACjB;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,WAAW;AACb;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,YAAY;AACd;AAEA;EACE,kBAAkB;AACpB;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AAEA;EACE,kDAAkD;AACpD;AAEA;EACE,+DAA+D;AACjE;AAEA;;EAEE,2BAA2B;AAC7B;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AAEA;EACE,UAAU;AACZ;AAEA;EACE,UAAU;AACZ;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,cAAc;AAChB;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;AACd;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,oBAAoB;AACtB;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,UAAU;AACZ;AACA;;;;;EAKE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AAEA;EACE,YAAY;AACd;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AAEA;EACE,aAAa;AACf;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;AACd;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;AAChB;AAEA;EACE,aAAa;EACb,UAAU;AACZ;AAEA;EACE,aAAa;AACf;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,UAAU;EACV,MAAM;AACR;AAEA;EACE,kBAAkB;EAElB,yBAAyB;EAEzB,iBAAiB;AACnB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;AAEA;;;;EAIE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,kCAAkC;AACpC;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,aAAa;AACf;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EAEV,yBAAyB;EAEzB,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AAEA;;EAEE,oBAAoB;AACtB;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,uCAAuC;EACvC,kCAAkC;AACpC;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAElB,yBAAyB;EAEzB,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;AACd;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;AAEA;EACE,cAAc;EACd,WAAW;AACb;AAEA;;EAEE,kBAAkB;AACpB;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AAEA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AAEA;EACE,kBAAkB;EAElB,yBAAyB;EAEzB,iBAAiB;AACnB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EAEf,yBAAyB;EAEzB,iBAAiB;AACnB;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;AACA;;;EAGE,UAAU;AACZ;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,aAAa;AACf;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;AACZ;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AAEA;EACE,WAAW;AACb;AAEA;EACE,YAAY;AACd;AAEA;EACE,WAAW;AACb;AAEA;EACE,YAAY;AACd;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,aAAa;AACf;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AAEA;;EAEE,gBAAgB;AAClB;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AAEA;;EAEE,oBAAoB;AACtB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,SAAS;AACX;AAEA;EACE,cAAc;EACd,WAAW;AACb;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,aAAa;AACf;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,uBAAuB;AACzB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AAEA;EACE,cAAc;AAChB;AAEA;;EAEE,UAAU;AACZ;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,aAAa;AACf;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AAEA;EACE,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AAEA;;EAEE,eAAe;AACjB;AAEA;EACE,+HAA+H;EAC/H,WAAW;EACX,YAAY;AACd;AAEA;EACE,+EAAoR;AACtR;AAEA;EACE,6LAA6L;EAC7L,WAAW;EACX,YAAY;AACd;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AAEA;EACE,8HAA8H;AAChI;AAEA;EACE,aAAa;AACf;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AAEA;EACE,cAAc;AAChB;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AAEA;EACE,cAAc;AAChB;AACA;;;;;;;;EAQE,2BAA2B;AAC7B;AACA;;;EAGE,cAAc;EACd,yBAAyB;AAC3B;AAEA;EACE,iCAAiC;AACnC;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AAEA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AAEA;AACE;IACE,cAAc;AAChB;AACA;;;;;;;IAOE,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;AAC3B;AACA;;IAEE,mBAAmB;AACrB;AACF;AACA;;;;EAIE,sBAAsB;EACtB,aAAa;AACf;AAEA;EACE,aAAa;AACf;AAEA;;EAEE,iBAAiB;AACnB;AAEA;EACE,YAAY;AACd;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,SAAS;EACT,4CAA4C;AAC9C;AAEA;;EAEE,4CAA4C;AAC9C;AAEA;;;;;;;EAOE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,4DAA4D;AAC9D;AACA;;;;;;;EAOE,0CAA0C;EAC1C,2DAA2D;EAC3D,mDAAmD;AACrD;AACA;;;;;;;EAOE,aAAa;EACb,4CAA4C;EAC5C,gDAAgD;AAClD;AACA;;;;;;;;;;;;;EAaE,kDAAkD;EAClD,qCAAqC;AACvC;AACA;;;;;;;EAOE,4EAA4E;AAC9E;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,SAAS;AACX;AAEA;EACE,UAAU;AACZ;AAEA;;EAEE,4CAA4C;AAC9C;AACA;;;EAGE,kDAAkD;AACpD;AAEA;EACE,2CAA2C;AAC7C;AAEA;;EAEE,kCAAkC;AACpC;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,gDAAgD;AAClD;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,2CAA2C;AAC7C;AAEA;EAEE,yBAAyB;EAEzB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AAEA;;;;EAIE,2CAA2C;AAC7C;AACA;;;;EAIE,2CAA2C;AAC7C;AACA;;;;EAIE,0CAA0C;AAC5C;AAEA;EACE;;;GAGC;EACD,8FAA8F;EAC9F,4FAA4F;EAC5F,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AAEA;;EAEE,eAAe;AACjB;AAEA;EACE,eAAe;EACf,UAAU;EACV,2CAA2C;AAC7C;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AAEA;EACE,sDAAsD;EACtD,4BAA4B;AAC9B;AAEA;EACE,4BAA4B;EAC5B,8DAA8D;AAChE;AAEA;;EAEE,YAAY;AACd;AAEA;EACE,yCAAyC;AAC3C;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AAEA;EACE,8CAA8C;AAChD;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AAEA;;EAEE,2CAA2C;AAC7C;AACA;;EAEE,0CAA0C;AAC5C;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,4CAA4C;AAC9C;AAEA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;AACxD;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,0CAA0C;EAC1C,2DAA2D;EAC3D,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,gDAAgD;AAClD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,4EAA4E;AAC9E;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;AAC7C;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;AAEA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,gCAAgC;AAClC;AAEA;EACE,4BAA4B;AAC9B;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AAEA;EACE,0EAA0E;AAC5E;AAEA;EACE,wEAAwE;AAC1E;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;AAC7C;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AAEA;;;EAGE,4CAA4C;AAC9C;AAEA;EACE,iEAAiE;AACnE;AACA;EACE,kEAAkE;AACpE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,oEAAoE;EACpE,kBAAkB;AACpB;AAEA;EACE,gDAAgD;EAChD,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,oEAAoE;EACpE,2CAA2C;EAC3C,+BAA+B;EAC/B,oCAAoC;EACpC,SAAS;EACT,wCAAwC;EACxC,oDAAoD;AACtD;AAEA;EACE,yFAAyF;AAC3F;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;AAEA;EACE,kCAAkC;AACpC;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AAEA;;EAEE,4CAA4C;AAC9C;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,gDAAgD;AAClD;AACA;EACE,8EAA8E;AAChF;AAEA;EACE,2EAA2E;EAC3E,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,8CAA8C;AAChD;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AAEA;EACE,yDAAyD;AAC3D;AACA;EACE,0DAA0D;AAC5D;AAEA;EACE,yDAAyD;AAC3D;AAEA;;EAEE,uFAAuF;AACzF;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,WAAW;AACb;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wCAAwC;AAC1C;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,2CAA2C;AAC7C;AAEA;EACE,yDAAyD;AAC3D;AAEA;EACE,yDAAyD;AAC3D;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,iDAAiD;AACnD;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,gDAAgD;AAClD;AAEA;EACE,eAAe;AACjB;AAEA;;EAEE,YAAY;EACZ,oBAAoB;AACtB;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,kCAAkC;AACpC;AAEA;EACE,kDAAkD;EAClD,0CAA0C;AAC5C;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,8DAA8D;EAC9D,uDAAuD;AACzD;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,oDAAoD;EACpD,iCAAiC;EACjC,4BAA4B;EAC5B,gDAAgD;EAChD,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,0DAA0D;EAC1D,yCAAyC;EACzC,8DAA8D;EAC9D,gBAAgB;AAClB;AAEA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,UAAU;AACZ;AAEA;;EAEE,qFAAqF;AACvF;AACA;;EAEE,sFAAsF;AACxF;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;;;;;;;;EAQE,iDAAiD;AACnD;AACA;;;;;;;;EAQE,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;;EAEE,gDAAgD;AAClD;AAEA;;EAEE,0CAA0C;EAC1C,oBAAoB;AACtB;AAEA;EACE,gEAAgE;AAClE;AACA;EACE,iEAAiE;AACnE;AAEA;EACE,oEAAoE;AACtE;AAEA;EACE,wDAAwD;AAC1D;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,eAAe;AACjB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;AAClD;AAEA;EACE,qHAAqH;AACvH;AAEA;;;EAGE,iFAAiF;AACnF;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,6CAA6C;AAC/C;AAEA;EACE,4CAA4C;AAC9C;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,4CAA4C;AAC9C;AAEA;EACE,8CAA8C;AAChD;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;AAEA;EACE,yEAAyE;EACzE,iCAAiC;AACnC;AAEA;EACE,oFAAoF;AACtF;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,sEAAsE;AACxE;AAEA;;EAEE,2BAA2B;AAC7B;AAEA;EACE,4BAA4B;EAC5B,iDAAiD;EACjD,+FAA+F;AACjG;AACA;EACE,6DAA6D;AAC/D;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,wDAAwD;EACxD,SAAS;EACT,oBAAoB;AACtB;AAEA;EACE,MAAM;AACR;AAEA;EACE,SAAS;AACX;AAEA;EACE,cAAc;EACd,WAAW;EACX,2KAA2K;EAC3K,UAAU;AACZ;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,yDAAyD;EACzD,wDAAwD;AAC1D;AAEA;;;EAGE,iDAAiD;AACnD;AAEA;EACE,oDAAoD;AACtD;AAEA;EACE,+DAA+D;AACjE;AACA;EACE,8DAA8D;AAChE;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AAEA;;EAEE,WAAW;EACX,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,2CAA2C;EAC3C,mHAAmH;AACrH;AAEA;EACE,8CAA8C;AAChD;AAEA;EACE,wDAAwD;AAC1D;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AAEA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AAEA;;EAEE;;;GAGC;EACD,8FAA8F;EAC9F,6BAA6B;EAC7B,iGAAiG;EACjG,2HAA2H;EAC3H,4DAA4D;EAC5D,4CAA4C;AAC9C;AAEA;EACE,2DAA2D;EAC3D,4DAA4D;AAC9D;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,iCAAiC;EACjC,UAAU;EACV,0DAA0D;AAC5D;AAEA;;EAEE,gDAAgD;EAChD,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,0DAA0D;EAC1D,UAAU;AACZ;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;AAEA;EACE,YAAY;AACd;AAEA;EACE,sCAAsC;EACtC,iDAAiD;AACnD;AAEA;;;;EAIE,gBAAgB;AAClB;AAEA;EACE,0DAA0D;AAC5D;AAEA;EACE,gDAAgD;EAChD,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,6DAA6D;AAC/D;AAEA;AACE;IACE,UAAU;AACZ;AACA;IACE,YAAY;AACd;AACA;IACE,UAAU;AACZ;AACF;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;EACnC,iCAAiC;AACnC;AAEA;AACE;IACE,uBAAuB;AACzB;AACA;IACE,yBAAyB;AAC3B;AACF;AACA;EACE,gEAAgE;AAClE;AAEA;EACE,6DAA6D;AAC/D;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,iCAAiC;EACjC,uDAAuD;AACzD;AAEA;EACE,wCAAwC;EACxC,8DAA8D;AAChE;AAEA;EACE,8CAA8C;AAChD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AAEA;EACE,8DAA8D;AAChE;AAEA;EACE,+DAA+D;AACjE;AAEA;;;EAGE,4DAA4D;AAC9D;AACA;;;EAGE,6EAA6E;AAC/E;AACA;;;EAGE,sFAAsF;AACxF;AAEA;;;EAGE,4DAA4D;AAC9D;AAEA;;;EAGE,8DAA8D;AAChE;AAEA;;;EAGE,8DAA8D;AAChE;AAEA;;;EAGE,8DAA8D;AAChE;AAEA;EACE,wDAAwD;EACxD,wDAAwD;AAC1D;AACA;EACE,0DAA0D;EAC1D,0DAA0D;AAC5D;AACA;EACE,2DAA2D;EAC3D,2DAA2D;AAC7D;AACA;EACE,yDAAyD;EACzD,yDAAyD;AAC3D;AAEA;;;;;;;;;;EAUE,iBAAiB;EACjB,oDAAoD;EACpD,oDAAoD;EACpD,gBAAgB;AAClB;AAEA;;EAEE,sBAAsB;EACtB,wDAAwD;AAC1D;AAEA;;EAEE,0EAA0E;AAC5E;AACA;;EAEE,yEAAyE;AAC3E;AAEA;;EAEE,yBAAyB;EACzB,2DAA2D;AAC7D;AAEA;;EAEE,yEAAyE;AAC3E;AACA;;EAEE,0EAA0E;AAC5E;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,wDAAwD;AAC1D;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,UAAU;AACZ;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,2DAA2D;AAC7D;AACA;EACE,gDAAgD;AAClD;AAEA;EACE,gDAAgD;EAChD,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,iDAAiD;EACjD,yCAAyC;EACzC,UAAU;AACZ;AAEA;EACE,kCAAkC;AACpC;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;AAEA;EACE,2CAA2C;AAC7C;AAEA;EACE,WAAW;EACX,cAAc;EACd,6DAA6D;AAC/D;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;;EAEE,2CAA2C;AAC7C;AAEA;;EAEE,gCAAgC;EAChC,0CAA0C;AAC5C;AAEA;;EAEE,YAAY;AACd;AAEA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,2CAA2C;AAC7C;AACA;;EAEE,4CAA4C;AAC9C;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;AAEA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,iCAAiC;AACnC;AAEA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,iCAAiC;AACnC;AAEA;EACE,aAAa;AACf;AAEA;EACE,aAAa;AACf;AACA;EACE,OAAO;AACT;AAEA;EACE,SAAS;EACT,sDAAsD;EACtD,4BAA4B;AAC9B;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;AAEA;EACE,uEAAuE;EACvE,2EAA2E;EAC3E,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,2DAA2D;AAC7D;AAEA;EACE,2CAA2C;AAC7C;AAEA;EACE,6DAA6D;AAC/D;AAEA;EACE,QAAQ;AACV;AAEA;EACE,YAAY;AACd;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AAEA;EACE,wDAAwD;AAC1D;AAEA;;EAEE,4CAA4C;AAC9C;AAEA;EACE,6CAA6C;AAC/C;AAEA;EACE,uDAAuD;EACvD,0DAA0D;EAC1D,2DAA2D;AAC7D;AAEA;EACE,6CAA6C;AAC/C;AAEA;EACE,iGAAiG;AACnG;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,kIAAkI;AACpI;AACA;EACE,mIAAmI;AACrI;AAEA;EACE,sFAAsF;AACxF;AACA;EACE,uFAAuF;AACzF;AAEA;EACE,2DAA2D;AAC7D;AACA;EACE,0DAA0D;AAC5D;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,kGAAkG;EAClG,wEAAwE;AAC1E;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AAEA;EACE,kGAAkG;EAClG,qGAAqG;EACrG,gBAAgB;EAChB,8HAA8H;AAChI;AACA;EACE,gDAAgD;AAClD;AACA;EACE,SAAS;AACX;AAEA;;EAEE,+CAA+C;AACjD;AAEA;EACE,kGAAkG;AACpG;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,0DAA0D;EAC1D,6BAA6B;AAC/B;AAEA;EACE,kGAAkG;EAClG,qGAAqG;AACvG;AACA;EACE,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,qCAAqC;EACrC,0DAA0D;AAC5D;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,YAAY;AACd;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,wEAAwE;EACxE,WAAW;EACX,SAAS;EACT,0CAA0C;EAC1C,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;EACZ,gEAAgE;EAChE,mEAAmE;AACrE;AACA;EACE,gBAAgB;AAClB;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,iEAAiE;AACnE;AAEA;EACE,kBAAkB;AACpB;AAEA;;EAEE,sDAAsD;AACxD;AACA;;EAEE,qDAAqD;AACvD;AACA;;EAEE,sEAAsE;EACtE,0EAA0E;AAC5E;AACA;;EAEE,0DAA0D;AAC5D;AAEA;;EAEE,qDAAqD;AACvD;AACA;;EAEE,sDAAsD;AACxD;AACA;;EAEE,qEAAqE;EACrE,yEAAyE;AAC3E;AACA;;EAEE,yDAAyD;AAC3D;AAEA;EACE,qCAAqC;AACvC;AAEA;;EAEE,8BAA8B;AAChC;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AAEA;EACE,qCAAqC;AACvC;AAEA;EACE,2CAA2C;EAC3C,8CAA8C;AAChD;AAEA;EACE,+BAA+B;AACjC;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AAEA;EACE,wEAAwE;AAC1E;AAEA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,gCAAgC;AAClC;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,mHAAmH;AACrH;AACA;EACE,oHAAoH;AACtH;AAEA;EACE,uDAAuD;EACvD,oDAAoD;EACpD,+BAA+B;AACjC;AAEA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AAEA;EACE,2CAA2C;AAC7C;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,0FAA0F;AAC5F;AACA;EACE,6CAA6C;EAC7C,0DAA0D;EAC1D,2DAA2D;AAC7D;AACA;EACE,uEAAuE;AACzE;AACA;;EAEE,0DAA0D;AAC5D;AAEA;EACE,OAAO;EACP,cAAc;EACd,oGAAoG;AACtG;AAEA;EACE,0DAA0D;AAC5D;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,4CAA4C;AAC9C;AACA;EACE,kIAAkI;EAClI,4DAA4D;AAC9D;AACA;EACE,mIAAmI;EACnI,2DAA2D;AAC7D;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kGAAkG;EAClG,qGAAqG;AACvG;AACA;EACE,iDAAiD;AACnD;AACA;EACE,kDAAkD;AACpD;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,aAAa;EACb,OAAO;EACP,oBAAoB;AACtB;AAEA;EACE,6BAA6B;AAC/B;AAEA;;;;EAIE,+CAA+C;AACjD;AAEA;;EAEE,mCAAmC;AACrC;AAEA;;EAEE,qDAAqD;AACvD;AAEA;EACE,qDAAqD;AACvD;AAEA;;EAEE,6CAA6C;EAC7C,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AAEA;EACE,eAAe;AACjB;AAEA;;EAEE,0DAA0D;EAC1D,2DAA2D;AAC7D;AAEA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AAEA;EACE,0DAA0D;AAC5D;AAEA;EACE,8CAA8C;AAChD;AAEA;EACE,UAAU;EACV,SAAS;AACX;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,SAAS;AACX;AACA;EACE,+DAA+D;AACjE;AACA;EACE,gEAAgE;AAClE;AACA;EACE,qHAAqH;EACrH,SAAS;AACX;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;AACf;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,2DAA2D;AAC7D;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,wDAAwD;EACxD,2EAA2E;AAC7E;AAEA;EACE,2EAA2E;EAC3E,wEAAwE;AAC1E;AAEA;;EAEE,2CAA2C;AAC7C;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;AACb;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AAEA;;EAEE,mDAAmD;EACnD,gEAAgE;AAClE;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;AAEA;EACE,8DAA8D;AAChE;AAEA;EACE,+DAA+D;AACjE;AAEA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AAEA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,gCAAgC;AAClC;AAEA;;EAEE,+CAA+C;EAC/C,gDAAgD;AAClD;AACA;;EAEE,+DAA+D;AACjE;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,2CAA2C;AAC7C;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AAEA;;EAEE,6DAA6D;AAC/D;AAEA;;;;;;;EAOE,8DAA8D;AAChE;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kDAAkD;EAClD,8CAA8C;EAC9C,gDAAgD;EAChD,+DAA+D;EAC/D,yDAAyD;AAC3D;AACA;;EAEE,QAAQ;AACV;AACA;;EAEE,OAAO;AACT;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AAEA;EACE,SAAS;AACX;AAEA;EACE,UAAU;AACZ;AAEA;EACE,UAAU;AACZ;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sDAAsD;EACtD,kDAAkD;EAClD,oDAAoD;EACpD,mEAAmE;EACnE,6DAA6D;AAC/D;AACA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;AAEA;EACE,6DAA6D;AAC/D;AACA;EACE,8DAA8D;AAChE;AAEA;EACE,6DAA6D;AAC/D;AAEA;EACE,SAAS;AACX;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,UAAU;EACV,0BAA0B;AAC5B;AAEA;EACE,0DAA0D;EAC1D,YAAY;EACZ,kGAAkG;EAClG,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;;EAEE,6BAA6B;AAC/B;AAEA;EACE,oDAAoD;EACpD,0CAA0C;EAC1C,4CAA4C;EAC5C,2CAA2C;EAC3C,gBAAgB;AAClB;AAEA;EACE,iCAAiC;AACnC;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,0CAA0C;EAC1C,6CAA6C;AAC/C;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,qCAAqC;EACrC,0CAA0C;EAC1C,6CAA6C;AAC/C;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;AAC7C;AAEA;EACE,0CAA0C;AAC5C;AAEA;EACE,YAAY;AACd;AAEA;EACE,mDAAmD;EACnD,2CAA2C;EAC3C,+BAA+B;EAC/B,uDAAuD;AACzD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AAEA;EACE,sDAAsD;AACxD;AACA;EACE,qDAAqD;AACvD;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;AAC7C;AAEA;EACE,0CAA0C;AAC5C;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;AACnC;AAEA;EACE,+BAA+B;AACjC;AAEA;EACE,gBAAgB;EAChB,2EAA2E;AAC7E;AACA;EACE,mBAAmB;AACrB;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;AACjC;AAEA;EACE,gDAAgD;EAChD,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,sCAAsC;EACtC,2CAA2C;EAC3C,UAAU;AACZ;AAEA;EACE,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yDAAyD;AAC3D;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;AACd;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;AAEA;EACE,aAAa;AACf;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AAEA;EACE,UAAU;EAEV,yBAAyB;EAEzB,iBAAiB;EACjB,eAAe;AACjB;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EAEf,yBAAyB;EAEzB,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,4CAA4C;EAC5C,kBAAkB;AACpB;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;AAEA;EACE,eAAe;AACjB;AAEA;EACE,cAAc;AAChB;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAElB,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;AACtB;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AAEA;EACE,0DAA0D;AAC5D;AAEA;;EAEE,WAAW;AACb;AAEA;EACE,iBAAiB;AACnB;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,yDAAyD;AAC3D;AAEA;EACE,aAAa;EACb,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,0EAA0E;EAC1E,sBAAsB;AACxB;AACA;EACE,yEAAyE;EACzE,qBAAqB;AACvB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kCAAkC;AACpC;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;EACE,UAAU;AACZ;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,sDAAsD;EACtD,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sDAAsD;EACtD,4CAA4C;AAC9C;AAEA;EACE,sCAAsC;EACtC,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yDAAyD;AAC3D;AAEA;EACE,gCAAgC;AAClC;AAEA;;;EAGE,wEAAwE;EACxE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;;EAEE,eAAe;AACjB;AAEA;EACE,8GAA8G;AAChH;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;AACb;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AAEA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,2CAA2C;AAC7C;AAEA;;EAEE,6BAA6B;AAC/B;AAEA;EACE,kGAAkG;EAClG,qGAAqG;AACvG;AACA;EACE,gDAAgD;AAClD;AAEA;EACE,gDAAgD;AAClD;AAEA;EACE,SAAS;AACX;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,6CAA6C;AAC/C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AAEA;EACE,0DAA0D;AAC5D;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,8CAA8C;AAChD;AAEA;EACE,aAAa;AACf;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AAEA;;EAEE,aAAa;AACf;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,gDAAgD;AAClD;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB;AAEA;EACE,gCAAgC;AAClC;AAEA;EAEE,yBAAyB;EAEzB,iBAAiB;EACjB,WAAW;EACX,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;AACxB;AAEA;EACE,OAAO;EACP,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;AACb;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kGAAkG;EAClG,wEAAwE;AAC1E;AAEA;;EAEE,0CAA0C;AAC5C;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,2CAA2C;EAC3C,kCAAkC;AACpC;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,oDAAoD;AACtD;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,QAAQ;EACR,WAAW;AACb;AAEA;;;;EAIE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;;EAOE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AAEA;EACE,WAAW;EACX,gFAAgF;EAChF,MAAM;EACN,mCAAmC;EACnC,wBAAwB;EACxB,oCAAoC;AACtC;AAEA;EACE,oFAAoF;EACpF,MAAM;EACN,mCAAmC;EACnC,sBAAsB;EACtB,oCAAoC;AACtC;AAEA;EACE,WAAW;EACX,oFAAoF;EACpF,MAAM;EACN,mCAAmC;EACnC,sBAAsB;EACtB,oCAAoC;AACtC;AAEA;EACE,oDAAoD;EACpD,oCAAoC;EACpC,iDAAiD;EACjD,mCAAmC;EACnC,sBAAsB;EACtB,oCAAoC;AACtC;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,+BAA+B;AACjC;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,0DAA0D;EAC1D,gDAAgD;EAChD,wCAAwC;AAC1C;AACA;EACE,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,gDAAgD;AAClD;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,iCAAiC;EACjC,2DAA2D;EAC3D,eAAe;AACjB;AAEA;EACE,iCAAiC;EACjC,6DAA6D;EAC7D,eAAe;AACjB;AAEA;EACE,iCAAiC;EACjC,6DAA6D;EAC7D,eAAe;AACjB;AAEA;EACE,iCAAiC;EACjC,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AAEA;EACE,yCAAyC;AAC3C;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,YAAY;AACd;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;AAEA;EACE,wBAAwB;AAC1B;AAEA;EACE,aAAa;EACb,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AAEA;;EAEE,aAAa;AACf;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;AACjB;AAEA;EACE,mDAAmD;EACnD,wCAAwC;EACxC,8BAA8B;EAC9B,kCAAkC;AACpC;AAEA;EACE,YAAY;AACd;AAEA;EACE,wDAAwD;AAC1D;AAEA;EACE,sDAAsD;AACxD;AAEA;;EAEE,4CAA4C;AAC9C;AACA;EACE,qDAA+rB;AACjsB;AAEA;;EAEE,2CAA2C;AAC7C;AACA;EACE,qDAAmsB;AACrsB;AAEA;EACE,4DAA4D;EAC5D,2CAA2C;AAC7C;AAEA;EACE,4CAA4C;EAC5C,2GAA2G;AAC7G;AAEA;EACE,2DAA2D;EAC3D,0CAA0C;AAC5C;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,qDAAqD;EACrD,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;AACA;;EAEE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,kDAAkD;AACpD;AACA;EACE,YAAY;AACd;AACA;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,yCAAyC;EACzC,oFAAoF;EACpF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,2DAA2D;EAC3D,uCAAuC;EACvC,kFAAkF;EAClF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,wFAAwF;EACxF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,QAAQ;EACR,+EAA+E;EAC/E,sFAAsF;EACtF,2FAA2F;AAC7F;AACA;EACE,6EAA6E;EAC7E,oFAAoF;EACpF,yFAAyF;AAC3F;AACA;EACE,mFAAmF;EACnF,0FAA0F;EAC1F,+FAA+F;AACjG;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,wCAAwC;EACxC,wCAAwC;EACxC,sCAAsC;EACtC,8DAA8D;EAC9D,yDAAyD;EACzD,kBAAkB;EAClB,UAAU;EACV,kDAAkD;EAClD,sDAAsD;AACxD;AACA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,YAAY;AACd;AACA;EACE,6DAA6D;EAC7D,qDAAqD;AACvD;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,sDAAsD;EACtD,cAAc;EACd,sBAAsB;EACtB,sCAAsC;EACtC,qCAAqC;EACrC,iEAAiE;EACjE,mBAAmB;EACnB,sBAAsB;EACtB,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;EACE,wFAAwF;EACxF,qDAAqD;AACvD;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,qDAAqD;EACrD,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,kCAAkC;AACpC;AACA;;EAEE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,kDAAkD;AACpD;AACA;EACE,YAAY;AACd;AACA;EACE,2DAA2D;EAC3D,yCAAyC;EACzC,kFAAkF;EAClF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,0DAA0D;EAC1D,uCAAuC;EACvC,iFAAiF;EACjF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,QAAQ;EACR,6EAA6E;EAC7E,oFAAoF;EACpF,yFAAyF;AAC3F;AACA;EACE,4EAA4E;EAC5E,mFAAmF;EACnF,wFAAwF;AAC1F;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,sCAAsC;EACtC,+CAA+C;AACjD;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,sCAAsC;EACtC,+CAA+C;AACjD;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,sCAAsC;EACtC,+CAA+C;EAC/C,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;EAC5C,iBAAiB;EACjB,gDAAgD;EAChD,kCAAkC;EAClC,+DAA+D;AACjE;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;EAC5C,iBAAiB;EACjB,gDAAgD;EAChD,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;EAC5C,iBAAiB;EACjB,gDAAgD;EAChD,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;AACA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;AACA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,YAAY;AACd;ACp3NA;EACE,2BAA2B;EAC3B,4CAA+7Q;EAC/7Q,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;EAGE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;EACxC,4CAA4C;EAC5C,0BAA0B;EAC1B,sCAAsC;EACtC,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;EACtC,sCAAsC;EACtC,6CAA6C;EAC7C,+CAA+C;EAC/C,+CAA+C;EAC/C,8CAA8C;EAC9C,iDAAiD;EACjD,yCAAyC;EACzC,wDAAwD;EACxD,gDAAgD;EAChD,2EAA2E;EAC3E,sEAAsE;EACtE,gEAAgE;EAChE,0DAA0D;EAC1D,0DAA0D;EAC1D,8DAA8D;EAC9D,gEAAgE;EAChE,8EAA8E;EAC9E,oDAAoD;EACpD,mDAAmD;EACnD,iEAAiE;EACjE,gDAAgD;EAChD,8CAA8C;EAC9C,6DAA6D;EAC7D,gEAAgE;EAChE,gEAAgE;EAChE,gEAAgE;EAChE,2DAA2D;EAC3D,4DAA4D;EAC5D,0DAA0D;EAC1D,mGAAmG;EACnG,2CAA2C;EAC3C,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,iDAAiD;EACjD,oDAAoD;EACpD,+EAA+E;EAC/E,2DAA2D;EAC3D,gDAAgD;EAChD,kCAAkC;EAClC;kCACgC;EAChC,oBAAoB;EACpB,mCAAmC;EACnC,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;AACxB;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,8BAA8B;EAC9B,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;EACrC,4CAA4C;EAC5C,0BAA0B;EAC1B,sCAAsC;EACtC,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,2DAA2D;EAC3D,2DAA2D;EAC3D,sCAAsC;EACtC,6CAA6C;EAC7C,+CAA+C;EAC/C,+CAA+C;EAC/C,8CAA8C;EAC9C,iDAAiD;EACjD,wDAAwD;EACxD,gEAAgE;EAChE,2DAA2D;EAC3D,yDAAyD;EACzD,8DAA8D;EAC9D,8BAA8B;EAC9B,qDAAqD;EACrD,6DAA6D;EAC7D,gEAAgE;EAChE,gEAAgE;EAChE,gEAAgE;EAChE,2DAA2D;EAC3D,yDAAyD;EACzD,0DAA0D;EAC1D,uDAAuD;EACvD,oDAAoD;EACpD,+DAA+D;EAC/D,4EAA4E;EAC5E,oEAAoE;EACpE,6EAA6E;EAC7E;kFACgF;EAChF,gEAAgE;EAChE,wCAAwC;EACxC,kBAAkB;AACpB;AAEA;AACE;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,8BAA8B;IAC9B,qCAAqC;IACrC,sCAAsC;IACtC,qCAAqC;IACrC,4CAA4C;IAC5C,0BAA0B;IAC1B,sCAAsC;IACtC,6BAA6B;IAC7B,gCAAgC;IAChC,gCAAgC;IAChC,2DAA2D;IAC3D,2DAA2D;IAC3D,sCAAsC;IACtC,6CAA6C;IAC7C,+CAA+C;IAC/C,+CAA+C;IAC/C,8CAA8C;IAC9C,iDAAiD;IACjD,wDAAwD;IACxD,gEAAgE;IAChE,2DAA2D;IAC3D,yDAAyD;IACzD,8DAA8D;IAC9D,8BAA8B;IAC9B,qDAAqD;IACrD,6DAA6D;IAC7D,gEAAgE;IAChE,gEAAgE;IAChE,gEAAgE;IAChE,2DAA2D;IAC3D,yDAAyD;IACzD,0DAA0D;IAC1D,uDAAuD;IACvD,oDAAoD;IACpD,+DAA+D;IAC/D,4EAA4E;IAC5E,oEAAoE;IACpE,6EAA6E;IAC7E;oFACgF;IAChF,gEAAgE;IAChE,wCAAwC;IACxC,kBAAkB;AACpB;AACF;AACA;;;;;;;;;;;;;;;;;;EAkBE,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,iCAAiC;AACnC;AAEA;EACE,kCAAkC;AACpC;AAEA;;;;;;EAME,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;;;EAGE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;;;EAGE,6BAA6B;EAC7B,0DAA0D;EAC1D,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;;;EAGE,4CAA4C;EAC5C,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;EAGE,+CAA+C;AACjD;AACA;;;EAGE,qCAAqC;AACvC;AACA;;;EAGE,iCAAiC;AACnC;AACA;;;EAGE,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,2CAA2C;AAC7C;AACA;EACE,iEAAiE;EACjE,kCAAkC;AACpC;AAEA;EACE,kEAAkE;EAClE,iCAAiC;AACnC;AAEA;;;EAGE,+BAA+B;AACjC;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;;;;EAME,aAAa;AACf;AACA;;;EAGE,mDAAmD;AACrD;AACA;;;EAGE,4CAA4C;EAC5C,wCAAwC;EACxC,iCAAiC;EACjC,sCAAsC;AACxC;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,0DAA0D;AAC5D;AACA;;;EAGE,mDAAmD;AACrD;AACA;;;;;;;;;EASE,+CAA+C;AACjD;AACA;;;EAGE,8DAA8D;AAChE;AACA;;;EAGE,4CAA4C;AAC9C;AACA;;;EAGE,8CAA8C;AAChD;AACA;;;EAGE,oCAAoC;AACtC;AACA;;;EAGE,2CAA2C;AAC7C;AACA;;;EAGE,+CAA+C;AACjD;AACA;;;EAGE,oCAAoC;AACtC;AACA;;;;;;EAME,+CAA+C;AACjD;AACA;;;;;;;;;;;;EAYE,0CAA0C;AAC5C;AACA;;;EAGE,YAAY;EACZ,uBAAuB;AACzB;AACA;;;EAGE,gBAAgB;AAClB;;IF9NI,eAAe;;IGvLnB;;;;;;;;EAQE;AAEF;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,kBAAkB;EAEd,kBAAkB;EACtB,2BAA2B;EAC3B,yBAAyB;UAGjB,iBAAiB;AAC3B;AAEA;IACI,mCAA2B;YAA3B,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,uBAAuB;IACvB,WAAW;AACb;AAEF;;;;;EAKE,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AAEA;;EAEE,gBAAgB;AAClB;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,OAAO;IACP,mBAAmB;IACnB,WAAW;AACb;AAEF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,MAAM;IACN,qBAAqB;AACvB;AAEF;EACE,cAAc;EACd,SAAS;EACT,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,kBAAkB;AACpB;AAEF;IACI,WAAW;IACX,UAAU;IACV,MAAM;IACN,UAAU;AACZ;AAEF;IACI,WAAW;IACX,OAAO;IACP,SAAS;IACT,UAAU;AACZ;AAEF;;;EAGE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,MAAM;AACR;AAEA;EACE,sBAAsB;AACxB;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,MAAM;IACN,UAAU;AACZ;AAEF;IACI,iBAAiB;IACjB,WAAW;IACX,OAAO;IACP,SAAS;AACX;AAEF;IACI,iBAAiB;IACjB,UAAU;IACV,MAAM;IACN,UAAU;AACZ;AAEF;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,OAAO;AACT;AAEF;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,UAAU;AACZ;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,QAAQ;AACV;AAEF;IACI,iBAAiB;IACjB,SAAS;IACT,iBAAiB;IACjB,SAAS;AACX;AAEF;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,QAAQ;AACV;AAEF;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,iBAAiB;AACnB;AAEF;IACI,mBAAmB;IACnB,WAAW;IACX,SAAS;AACX;AAEF;IACI,mBAAmB;IACnB,UAAU;IACV,SAAS;AACX;AAEF;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;AACZ;AAEF;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,WAAW;AACb;AAEF;AAEA;MACM,YAAY;MACZ,WAAW;AACf;AACE;AAEJ;AAEA;MACM,YAAY;MACZ,WAAW;AACf;AACE;AAEJ;AAEA;MACM,WAAW;MACX,aAAa;MACb,UAAU;AACd;AACE;AAEJ;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,WAAW;AACb;AAEF;EACE,UAAU;AACZ;AAEA;EACE,yDAA+Q;AACjR;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,QAAQ;AACV;AAEA;EACE,wBAAwB;AAC1B;AAEA;EACE,YAAY;AACd;AAEA;EACE,iBAAiB;AACnB;AAEA;;;;EAIE,mBAAmB;AACrB;;IH1HI,yBAAyB;AI1L7B,sBAAsB,iBAAiB;AAAC,yDAAyD,eAAe;AAAC,2DAA2D,eAAe;AAAC,2CAA2C,YAAY;AAAC,4BAA4B,aAAa;AAAC,oCAAoC,MAAM,CAAC,qBAAqB,CAAC,eAAe,CAAC,iBAAiB;AAAC,6DAA6D,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,qBAAqB;AAAC,6EAA6E,UAAU;AAAC,+EAA+E,WAAW;AAAC,gFAAgF,UAAU;AAAC,kFAAkF,WAAW;AAAC,kCAAkC,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU,CAAC,UAAU,CAAC,WAAW,CAAC,WAAW,CAAC,4BAA4B,CAAC,mBAAmB,CAAC,aAAa,CAAC,eAAe,CAAC,SAAS;AAAC,yCAAyC,aAAa,CAAC,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,WAAW,CAAC,UAAU,CAAC,eAAe,CAAC,mBAAmB,CAAC,UAAU;;IJ6L9rC,eAAe;AK7LnB,sBAAsB,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU,CAAC,UAAU,CAAC,WAAW,CAAC,WAAW,CAAC,4BAA4B,CAAC,mBAAmB,CAAC,aAAa,CAAC,eAAe,CAAC,SAAS;AAAC,6BAA6B,aAAa,CAAC,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,WAAW,CAAC,UAAU,CAAC,eAAe,CAAC,mBAAmB,CAAC,UAAU","sourcesContent":["<template>\n    <v-app\n        id=\"app\">\n        <router-view v-if=\"!browserObj.isBlocked\"/>\n        <!-- Browser block -->\n        <div v-else class=\"blocked-browser\">\n          <div class=\"blocked-content\">\n              <h1 class=\"text-h3\">You're using an unsupported browser.</h1>\n              <p>We built It's the S using the latest tchnologies to enhance your experience and make the site faster and easier to use. Unfortunately, your browser doesn't support thos technologies</p>\n              <p>To access It's the S please <a href=\"https://bestvpn.org/outdatedbrowser/en\">click here</a> to upgrade your browser to the latest version.</p>\n          </div>\n        </div>\n      <!-- Toast Container -->\n      <ToastContainer />\n      <!-- Global Action Prompt -->\n      <GlobalActionPrompt/>\n    </v-app>\n</template>\n\n<script>\nimport { mapState, mapActions } from 'vuex'\nimport bowser from 'bowser'\nimport supportedBrowsers from '../ua_supportedBrowsers'\n\nimport ToastContainer from '@/components/_core/Containers/Toast_Container'\nimport GlobalActionPrompt from '@/components/_core/GlobalActionPrompt/Global_Action_Prompt'\n\nimport {\n  VUEX_ALERT_DIALOG_SHOW,\n  VUEX_ALERT_DIALOG_HIDE\n} from '@/store/constants/ui/alertDialog'\n\nconst browserDetect = bowser.getParser(navigator.userAgent)\n\nexport default {\n  name: 'app-root',\n\n  data: () => ({\n    browserObj: {}\n  }),\n\n  components: {\n    ToastContainer,\n    GlobalActionPrompt\n  },\n\n  computed: {\n    ...mapState({\n      userDismissedAlerDialog: state => state.alertDialog.userDismissed\n    })\n  },\n\n  created: async function () {\n    // Define and add client info to store\n    this.browserObj = {\n      isSupported: browserDetect.parsedResult.browser.name !== 'Internet Explorer' &&\n                   supportedBrowsers.test(navigator.userAgent),\n      // isBlocked: matchesUA(browserDetect._ua, { browsers: blockedBrowsers }),\n      isBlocked: this.blockedBrowser(),\n      isMobile: (browserDetect.parsedResult.platform.type === 'mobile' || browserDetect.parsedResult.platform.type === 'tablet'),\n      isTablet: (browserDetect.parsedResult.platform.type === 'tablet'),\n      // supportsGrid: (modernizr.cssgrid || modernizr.cssgridlegacy),\n      // supportsOrientation: modernizr.devicemotiondeviceorientation,\n      info: {\n        width: window.innerWidth,\n        height: window.innerHeight,\n        ...browserDetect.parsedResult,\n        _ua: browserDetect._ua\n      },\n      scrollData: {\n        retainScrollPosition: false,\n        scrollPosition: null\n      }\n    }\n\n    this.setBodyBrowserClass()\n    this.$store.commit('setBrowser', this.browserObj)\n    window.addEventListener('resize', this.updateWindowSize)\n\n    if (browserDetect.parsedResult.os.name !== 'macOS' && browserDetect.parsedResult.os.name !== 'iOS') {\n      if ('ondeviceorientation' in window) {\n        window.addEventListener('deviceorientation', this.rotationHandler, true)\n      }\n    } else {\n      if (window.innerWidth < 1024 && (browserDetect.parsedResult.platform.type === 'tablet')) {\n        this.showAlertDialog({\n          content: '_core/Dialogs/Alerts/Dialog_Alert_Orientation.vue'\n        })\n      }\n    }\n\n    await this.$store.dispatch('init')\n  },\n\n  methods: {\n    ...mapActions({\n      showAlertDialog: VUEX_ALERT_DIALOG_SHOW,\n      hideAlertDialog: VUEX_ALERT_DIALOG_HIDE\n    }),\n\n    setBodyBrowserClass () {\n      let name = browserDetect.parsedResult.browser.name\n      let version = parseInt(browserDetect.parsedResult.browser.version)\n      let browserClass\n\n      switch (name) {\n        case 'Chrome':\n          break\n        case 'Firefox':\n          break\n        case 'Safari':\n          browserClass = version === 10 ? 'safari-10' : undefined\n          break\n        case 'Microsoft Edge':\n          browserClass = version === 15 ? 'edge-15' : undefined\n          break\n        default:\n          break\n      }\n\n      if (browserClass) document.body.classList.add(browserClass)\n    },\n\n    blockedBrowser: () => {\n      let name = browserDetect.parsedResult.browser.name\n      let version = parseInt(browserDetect.parsedResult.browser.version)\n      let isBlocked\n\n      switch (name) {\n        case 'Microsoft Edge':\n          isBlocked = version < 16\n          break\n        case 'Safari':\n          isBlocked = version < 11\n          break\n        default:\n          isBlocked = false\n          break\n      }\n\n      if (isBlocked) document.body.classList.add('blocked')\n      return isBlocked\n    },\n\n    updateWindowSize (evt) {\n      this.$store.commit('setWindowDims', {\n        width: evt.currentTarget.innerWidth,\n        height: evt.currentTarget.innerHeight\n      })\n    },\n\n    rotationHandler (evt) {\n      if (!this.userDismissedAlerDialog && window.innerWidth < 1024) {\n        if (evt.target.screen.orientation.type.startsWith('portrait')) {\n          this.showAlertDialog({\n            content: '_core/Dialogs/Alerts/Dialog_Alert_Orientation.vue'\n          })\n        } else if (evt.target.screen.orientation.type.startsWith('landscape')) {\n          this.hideAlertDialog()\n        }\n      }\n    }\n  },\n\n  mounted () {\n    let checkReady = setInterval(() => {\n      if (document.readyState === 'complete') {\n        clearInterval(checkReady)\n        const vueLoaded = document.getElementById('vue-loaded-hook')\n        vueLoaded && vueLoaded.remove()\n      }\n    }, 500)\n  }\n}\n</script>\n\n<style lang=\"css\">\n    /* Dependancy CSS Files */\n\n    /* AG Grid */\n    @import \"ag-grid-community/styles/ag-grid.css\";\n    @import \"ag-grid-community/styles/ag-theme-balham.css\";\n\n    /* Cropper JS */\n    @import 'cropperjs/dist/cropper.css';\n\n    /* Vue Virtual Scroller */\n    @import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';\n\n    /* Vue Resize */\n    @import 'vue3-resize/dist/vue3-resize.css';\n</style>\n\n<style lang=\"scss\">\n    /* App SCSS Files */\n    @import \"@/styles/global-styles.scss\";\n\n    #app {\n      position: relative;\n      min-height: 100vh;\n      background: {\n        color: $app-color-background;\n      }\n\n    .blocked-browser {\n      position: relative;\n      width: 100vw;\n      height: 100vh;\n      display: none;\n\n      .blocked-content {\n        @include center-content();\n        background: #FFF;\n        max-width: 750px;\n        padding: 3rem;\n\n        h1,\n        p {\n          color: #222;\n          background: #FFF;\n        }\n\n        h1{\n          padding: {\n            bottom: 1rem;\n          }\n        }\n\n        a {\n          background: #FFF;\n        }\n      }\n    }\n  }\n\n  /* Broswer specific overrides */\n  .edge-15 {\n    @extend .edge-15-styles;\n  }\n  .safari-10 {\n    @extend .safari-10-styles;\n  }\n</style>\n",".ag-filter-panel-buttons {\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0;\n  flex-wrap: wrap;\n  gap: var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing);\n}\n\n.ag-filter-panel-buttons-button {\n  line-height: 1.5;\n}\n\n.ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button {\n  color: var(--ag-filter-panel-apply-button-color);\n  background-color: var(--ag-filter-panel-apply-button-background-color);\n}\n\n.ag-filter-panel > *:where(:last-child) {\n  padding-bottom: var(--ag-widget-container-vertical-padding);\n}\n\n.ag-row.ag-row-pinned-source {\n  color: var(--ag-pinned-source-row-text-color);\n  background-color: var(--ag-pinned-source-row-background-color);\n  font-weight: var(--ag-pinned-source-row-font-weight);\n}\n\n.ag-row.ag-row-pinned {\n  color: var(--ag-pinned-row-text-color);\n  background-color: var(--ag-pinned-row-background-color);\n  font-weight: var(--ag-pinned-row-font-weight);\n}\n\n.ag-floating-top-viewport {\n  border-bottom: var(--ag-pinned-row-border);\n}\n\n.ag-floating-bottom-viewport {\n  border-top: var(--ag-pinned-row-border);\n}\n\n.ag-measurement-container {\n  --ag-legacy-styles-loaded: \"true\";\n}\n\n.ag-icon {\n  font-family: var(--ag-icon-font-family);\n  font-weight: var(--ag-icon-font-weight);\n  color: var(--ag-icon-font-color);\n  font-size: var(--ag-icon-size);\n  line-height: var(--ag-icon-size);\n  font-style: normal;\n  font-variant: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: var(--ag-icon-size);\n  height: var(--ag-icon-size);\n  position: relative;\n}\n.ag-icon::before {\n  content: \"\";\n  font-family: inherit;\n}\n.ag-icon::after {\n  background: transparent var(--ag-icon-image, none) center/contain no-repeat;\n  display: var(--ag-icon-image-display);\n  opacity: var(--ag-icon-image-opacity, 0.9);\n  position: absolute;\n  inset: 0;\n  content: \"\";\n}\n\n.ag-icon-aggregation {\n  font-family: var(--ag-icon-font-family-aggregation, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-aggregation, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-aggregation, var(--ag-icon-font-color));\n}\n\n.ag-icon-aggregation::before {\n  content: var(--ag-icon-font-code-aggregation, \"\\f101\");\n  display: var(--ag-icon-font-display-aggregation, var(--ag-icon-font-display));\n}\n\n.ag-icon-aggregation::after {\n  background-image: var(--ag-icon-image-aggregation, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-aggregation, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-aggregation, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-arrows {\n  font-family: var(--ag-icon-font-family-arrows, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-arrows, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-arrows, var(--ag-icon-font-color));\n}\n\n.ag-icon-arrows::before {\n  content: var(--ag-icon-font-code-arrows, \"\\f102\");\n  display: var(--ag-icon-font-display-arrows, var(--ag-icon-font-display));\n}\n\n.ag-icon-arrows::after {\n  background-image: var(--ag-icon-image-arrows, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-arrows, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-arrows, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-asc {\n  font-family: var(--ag-icon-font-family-asc, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-asc, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-asc, var(--ag-icon-font-color));\n}\n\n.ag-icon-asc::before {\n  content: var(--ag-icon-font-code-asc, \"\\f103\");\n  display: var(--ag-icon-font-display-asc, var(--ag-icon-font-display));\n}\n\n.ag-icon-asc::after {\n  background-image: var(--ag-icon-image-asc, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-asc, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-asc, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-cancel {\n  font-family: var(--ag-icon-font-family-cancel, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-cancel, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-cancel, var(--ag-icon-font-color));\n}\n\n.ag-icon-cancel::before {\n  content: var(--ag-icon-font-code-cancel, \"\\f104\");\n  display: var(--ag-icon-font-display-cancel, var(--ag-icon-font-display));\n}\n\n.ag-icon-cancel::after {\n  background-image: var(--ag-icon-image-cancel, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-cancel, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-cancel, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-chart {\n  font-family: var(--ag-icon-font-family-chart, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-chart, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-chart, var(--ag-icon-font-color));\n}\n\n.ag-icon-chart::before {\n  content: var(--ag-icon-font-code-chart, \"\\f105\");\n  display: var(--ag-icon-font-display-chart, var(--ag-icon-font-display));\n}\n\n.ag-icon-chart::after {\n  background-image: var(--ag-icon-image-chart, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-chart, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-chart, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-checkbox-checked {\n  font-family: var(--ag-icon-font-family-checkbox-checked, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-checkbox-checked, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-checkbox-checked, var(--ag-icon-font-color));\n}\n\n.ag-icon-checkbox-checked::before {\n  content: var(--ag-icon-font-code-checkbox-checked, \"\\f106\");\n  display: var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display));\n}\n\n.ag-icon-checkbox-checked::after {\n  background-image: var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-checkbox-indeterminate {\n  font-family: var(--ag-icon-font-family-checkbox-indeterminate, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-checkbox-indeterminate, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-checkbox-indeterminate, var(--ag-icon-font-color));\n}\n\n.ag-icon-checkbox-indeterminate::before {\n  content: var(--ag-icon-font-code-checkbox-indeterminate, \"\\f107\");\n  display: var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display));\n}\n\n.ag-icon-checkbox-indeterminate::after {\n  background-image: var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-checkbox-unchecked {\n  font-family: var(--ag-icon-font-family-checkbox-unchecked, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-checkbox-unchecked, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-checkbox-unchecked, var(--ag-icon-font-color));\n}\n\n.ag-icon-checkbox-unchecked::before {\n  content: var(--ag-icon-font-code-checkbox-unchecked, \"\\f108\");\n  display: var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display));\n}\n\n.ag-icon-checkbox-unchecked::after {\n  background-image: var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-color-picker {\n  font-family: var(--ag-icon-font-family-color-picker, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-color-picker, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-color-picker, var(--ag-icon-font-color));\n}\n\n.ag-icon-color-picker::before {\n  content: var(--ag-icon-font-code-color-picker, \"\\f109\");\n  display: var(--ag-icon-font-display-color-picker, var(--ag-icon-font-display));\n}\n\n.ag-icon-color-picker::after {\n  background-image: var(--ag-icon-image-color-picker, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-color-picker, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-color-picker, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-columns {\n  font-family: var(--ag-icon-font-family-columns, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-columns, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-columns, var(--ag-icon-font-color));\n}\n\n.ag-icon-columns::before {\n  content: var(--ag-icon-font-code-columns, \"\\f10a\");\n  display: var(--ag-icon-font-display-columns, var(--ag-icon-font-display));\n}\n\n.ag-icon-columns::after {\n  background-image: var(--ag-icon-image-columns, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-columns, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-columns, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-contracted {\n  font-family: var(--ag-icon-font-family-contracted, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-contracted, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-contracted, var(--ag-icon-font-color));\n}\n\n.ag-icon-contracted::before {\n  content: var(--ag-icon-font-code-contracted, \"\\f10b\");\n  display: var(--ag-icon-font-display-contracted, var(--ag-icon-font-display));\n}\n\n.ag-icon-contracted::after {\n  background-image: var(--ag-icon-image-contracted, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-contracted, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-contracted, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-copy {\n  font-family: var(--ag-icon-font-family-copy, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-copy, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-copy, var(--ag-icon-font-color));\n}\n\n.ag-icon-copy::before {\n  content: var(--ag-icon-font-code-copy, \"\\f10c\");\n  display: var(--ag-icon-font-display-copy, var(--ag-icon-font-display));\n}\n\n.ag-icon-copy::after {\n  background-image: var(--ag-icon-image-copy, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-copy, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-copy, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-cross {\n  font-family: var(--ag-icon-font-family-cross, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-cross, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-cross, var(--ag-icon-font-color));\n}\n\n.ag-icon-cross::before {\n  content: var(--ag-icon-font-code-cross, \"\\f10d\");\n  display: var(--ag-icon-font-display-cross, var(--ag-icon-font-display));\n}\n\n.ag-icon-cross::after {\n  background-image: var(--ag-icon-image-cross, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-cross, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-cross, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-csv {\n  font-family: var(--ag-icon-font-family-csv, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-csv, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-csv, var(--ag-icon-font-color));\n}\n\n.ag-icon-csv::before {\n  content: var(--ag-icon-font-code-csv, \"\\f10e\");\n  display: var(--ag-icon-font-display-csv, var(--ag-icon-font-display));\n}\n\n.ag-icon-csv::after {\n  background-image: var(--ag-icon-image-csv, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-csv, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-csv, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-cut {\n  font-family: var(--ag-icon-font-family-cut, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-cut, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-cut, var(--ag-icon-font-color));\n}\n\n.ag-icon-cut::before {\n  content: var(--ag-icon-font-code-cut, \"\\f10f\");\n  display: var(--ag-icon-font-display-cut, var(--ag-icon-font-display));\n}\n\n.ag-icon-cut::after {\n  background-image: var(--ag-icon-image-cut, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-cut, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-cut, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-desc {\n  font-family: var(--ag-icon-font-family-desc, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-desc, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-desc, var(--ag-icon-font-color));\n}\n\n.ag-icon-desc::before {\n  content: var(--ag-icon-font-code-desc, \"\\f110\");\n  display: var(--ag-icon-font-display-desc, var(--ag-icon-font-display));\n}\n\n.ag-icon-desc::after {\n  background-image: var(--ag-icon-image-desc, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-desc, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-desc, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-excel {\n  font-family: var(--ag-icon-font-family-excel, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-excel, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-excel, var(--ag-icon-font-color));\n}\n\n.ag-icon-excel::before {\n  content: var(--ag-icon-font-code-excel, \"\\f111\");\n  display: var(--ag-icon-font-display-excel, var(--ag-icon-font-display));\n}\n\n.ag-icon-excel::after {\n  background-image: var(--ag-icon-image-excel, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-excel, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-excel, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-expanded {\n  font-family: var(--ag-icon-font-family-expanded, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-expanded, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-expanded, var(--ag-icon-font-color));\n}\n\n.ag-icon-expanded::before {\n  content: var(--ag-icon-font-code-expanded, \"\\f112\");\n  display: var(--ag-icon-font-display-expanded, var(--ag-icon-font-display));\n}\n\n.ag-icon-expanded::after {\n  background-image: var(--ag-icon-image-expanded, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-expanded, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-expanded, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-eye-slash {\n  font-family: var(--ag-icon-font-family-eye-slash, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-eye-slash, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-eye-slash, var(--ag-icon-font-color));\n}\n\n.ag-icon-eye-slash::before {\n  content: var(--ag-icon-font-code-eye-slash, \"\\f113\");\n  display: var(--ag-icon-font-display-eye-slash, var(--ag-icon-font-display));\n}\n\n.ag-icon-eye-slash::after {\n  background-image: var(--ag-icon-image-eye-slash, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-eye-slash, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-eye-slash, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-eye {\n  font-family: var(--ag-icon-font-family-eye, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-eye, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-eye, var(--ag-icon-font-color));\n}\n\n.ag-icon-eye::before {\n  content: var(--ag-icon-font-code-eye, \"\\f114\");\n  display: var(--ag-icon-font-display-eye, var(--ag-icon-font-display));\n}\n\n.ag-icon-eye::after {\n  background-image: var(--ag-icon-image-eye, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-eye, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-eye, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-filter {\n  font-family: var(--ag-icon-font-family-filter, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-filter, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-filter, var(--ag-icon-font-color));\n}\n\n.ag-icon-filter::before {\n  content: var(--ag-icon-font-code-filter, \"\\f115\");\n  display: var(--ag-icon-font-display-filter, var(--ag-icon-font-display));\n}\n\n.ag-icon-filter::after {\n  background-image: var(--ag-icon-image-filter, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-filter, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-filter, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-first {\n  font-family: var(--ag-icon-font-family-first, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-first, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-first, var(--ag-icon-font-color));\n}\n\n.ag-icon-first::before {\n  content: var(--ag-icon-font-code-first, \"\\f116\");\n  display: var(--ag-icon-font-display-first, var(--ag-icon-font-display));\n}\n\n.ag-icon-first::after {\n  background-image: var(--ag-icon-image-first, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-first, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-first, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-grip {\n  font-family: var(--ag-icon-font-family-grip, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-grip, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-grip, var(--ag-icon-font-color));\n}\n\n.ag-icon-grip::before {\n  content: var(--ag-icon-font-code-grip, \"\\f117\");\n  display: var(--ag-icon-font-display-grip, var(--ag-icon-font-display));\n}\n\n.ag-icon-grip::after {\n  background-image: var(--ag-icon-image-grip, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-grip, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-grip, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-group {\n  font-family: var(--ag-icon-font-family-group, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-group, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-group, var(--ag-icon-font-color));\n}\n\n.ag-icon-group::before {\n  content: var(--ag-icon-font-code-group, \"\\f118\");\n  display: var(--ag-icon-font-display-group, var(--ag-icon-font-display));\n}\n\n.ag-icon-group::after {\n  background-image: var(--ag-icon-image-group, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-group, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-group, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-last {\n  font-family: var(--ag-icon-font-family-last, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-last, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-last, var(--ag-icon-font-color));\n}\n\n.ag-icon-last::before {\n  content: var(--ag-icon-font-code-last, \"\\f119\");\n  display: var(--ag-icon-font-display-last, var(--ag-icon-font-display));\n}\n\n.ag-icon-last::after {\n  background-image: var(--ag-icon-image-last, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-last, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-last, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-left {\n  font-family: var(--ag-icon-font-family-left, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-left, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-left, var(--ag-icon-font-color));\n}\n\n.ag-icon-left::before {\n  content: var(--ag-icon-font-code-left, \"\\f11a\");\n  display: var(--ag-icon-font-display-left, var(--ag-icon-font-display));\n}\n\n.ag-icon-left::after {\n  background-image: var(--ag-icon-image-left, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-left, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-left, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-linked {\n  font-family: var(--ag-icon-font-family-linked, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-linked, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-linked, var(--ag-icon-font-color));\n}\n\n.ag-icon-linked::before {\n  content: var(--ag-icon-font-code-linked, \"\\f11b\");\n  display: var(--ag-icon-font-display-linked, var(--ag-icon-font-display));\n}\n\n.ag-icon-linked::after {\n  background-image: var(--ag-icon-image-linked, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-linked, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-linked, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-loading {\n  font-family: var(--ag-icon-font-family-loading, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-loading, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-loading, var(--ag-icon-font-color));\n}\n\n.ag-icon-loading::before {\n  content: var(--ag-icon-font-code-loading, \"\\f11c\");\n  display: var(--ag-icon-font-display-loading, var(--ag-icon-font-display));\n}\n\n.ag-icon-loading::after {\n  background-image: var(--ag-icon-image-loading, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-loading, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-loading, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-maximize {\n  font-family: var(--ag-icon-font-family-maximize, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-maximize, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-maximize, var(--ag-icon-font-color));\n}\n\n.ag-icon-maximize::before {\n  content: var(--ag-icon-font-code-maximize, \"\\f11d\");\n  display: var(--ag-icon-font-display-maximize, var(--ag-icon-font-display));\n}\n\n.ag-icon-maximize::after {\n  background-image: var(--ag-icon-image-maximize, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-maximize, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-maximize, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-menu {\n  font-family: var(--ag-icon-font-family-menu, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-menu, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-menu, var(--ag-icon-font-color));\n}\n\n.ag-icon-menu::before {\n  content: var(--ag-icon-font-code-menu, \"\\f11e\");\n  display: var(--ag-icon-font-display-menu, var(--ag-icon-font-display));\n}\n\n.ag-icon-menu::after {\n  background-image: var(--ag-icon-image-menu, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-menu, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-menu, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-minimize {\n  font-family: var(--ag-icon-font-family-minimize, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-minimize, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-minimize, var(--ag-icon-font-color));\n}\n\n.ag-icon-minimize::before {\n  content: var(--ag-icon-font-code-minimize, \"\\f11f\");\n  display: var(--ag-icon-font-display-minimize, var(--ag-icon-font-display));\n}\n\n.ag-icon-minimize::after {\n  background-image: var(--ag-icon-image-minimize, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-minimize, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-minimize, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-next {\n  font-family: var(--ag-icon-font-family-next, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-next, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-next, var(--ag-icon-font-color));\n}\n\n.ag-icon-next::before {\n  content: var(--ag-icon-font-code-next, \"\\f120\");\n  display: var(--ag-icon-font-display-next, var(--ag-icon-font-display));\n}\n\n.ag-icon-next::after {\n  background-image: var(--ag-icon-image-next, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-next, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-next, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-none {\n  font-family: var(--ag-icon-font-family-none, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-none, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-none, var(--ag-icon-font-color));\n}\n\n.ag-icon-none::before {\n  content: var(--ag-icon-font-code-none, \"\\f121\");\n  display: var(--ag-icon-font-display-none, var(--ag-icon-font-display));\n}\n\n.ag-icon-none::after {\n  background-image: var(--ag-icon-image-none, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-none, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-none, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-not-allowed {\n  font-family: var(--ag-icon-font-family-not-allowed, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-not-allowed, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-not-allowed, var(--ag-icon-font-color));\n}\n\n.ag-icon-not-allowed::before {\n  content: var(--ag-icon-font-code-not-allowed, \"\\f122\");\n  display: var(--ag-icon-font-display-not-allowed, var(--ag-icon-font-display));\n}\n\n.ag-icon-not-allowed::after {\n  background-image: var(--ag-icon-image-not-allowed, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-not-allowed, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-not-allowed, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-paste {\n  font-family: var(--ag-icon-font-family-paste, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-paste, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-paste, var(--ag-icon-font-color));\n}\n\n.ag-icon-paste::before {\n  content: var(--ag-icon-font-code-paste, \"\\f123\");\n  display: var(--ag-icon-font-display-paste, var(--ag-icon-font-display));\n}\n\n.ag-icon-paste::after {\n  background-image: var(--ag-icon-image-paste, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-paste, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-paste, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-pin {\n  font-family: var(--ag-icon-font-family-pin, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-pin, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-pin, var(--ag-icon-font-color));\n}\n\n.ag-icon-pin::before {\n  content: var(--ag-icon-font-code-pin, \"\\f124\");\n  display: var(--ag-icon-font-display-pin, var(--ag-icon-font-display));\n}\n\n.ag-icon-pin::after {\n  background-image: var(--ag-icon-image-pin, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-pin, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-pin, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-pivot {\n  font-family: var(--ag-icon-font-family-pivot, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-pivot, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-pivot, var(--ag-icon-font-color));\n}\n\n.ag-icon-pivot::before {\n  content: var(--ag-icon-font-code-pivot, \"\\f125\");\n  display: var(--ag-icon-font-display-pivot, var(--ag-icon-font-display));\n}\n\n.ag-icon-pivot::after {\n  background-image: var(--ag-icon-image-pivot, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-pivot, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-pivot, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-previous {\n  font-family: var(--ag-icon-font-family-previous, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-previous, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-previous, var(--ag-icon-font-color));\n}\n\n.ag-icon-previous::before {\n  content: var(--ag-icon-font-code-previous, \"\\f126\");\n  display: var(--ag-icon-font-display-previous, var(--ag-icon-font-display));\n}\n\n.ag-icon-previous::after {\n  background-image: var(--ag-icon-image-previous, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-previous, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-previous, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-radio-button-off {\n  font-family: var(--ag-icon-font-family-radio-button-off, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-radio-button-off, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-radio-button-off, var(--ag-icon-font-color));\n}\n\n.ag-icon-radio-button-off::before {\n  content: var(--ag-icon-font-code-radio-button-off, \"\\f127\");\n  display: var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display));\n}\n\n.ag-icon-radio-button-off::after {\n  background-image: var(--ag-icon-image-radio-button-off, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-radio-button-on {\n  font-family: var(--ag-icon-font-family-radio-button-on, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-radio-button-on, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-radio-button-on, var(--ag-icon-font-color));\n}\n\n.ag-icon-radio-button-on::before {\n  content: var(--ag-icon-font-code-radio-button-on, \"\\f128\");\n  display: var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display));\n}\n\n.ag-icon-radio-button-on::after {\n  background-image: var(--ag-icon-image-radio-button-on, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-right {\n  font-family: var(--ag-icon-font-family-right, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-right, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-right, var(--ag-icon-font-color));\n}\n\n.ag-icon-right::before {\n  content: var(--ag-icon-font-code-right, \"\\f129\");\n  display: var(--ag-icon-font-display-right, var(--ag-icon-font-display));\n}\n\n.ag-icon-right::after {\n  background-image: var(--ag-icon-image-right, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-right, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-right, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-save {\n  font-family: var(--ag-icon-font-family-save, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-save, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-save, var(--ag-icon-font-color));\n}\n\n.ag-icon-save::before {\n  content: var(--ag-icon-font-code-save, \"\\f12a\");\n  display: var(--ag-icon-font-display-save, var(--ag-icon-font-display));\n}\n\n.ag-icon-save::after {\n  background-image: var(--ag-icon-image-save, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-save, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-save, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-small-down {\n  font-family: var(--ag-icon-font-family-small-down, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-small-down, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-small-down, var(--ag-icon-font-color));\n}\n\n.ag-icon-small-down::before {\n  content: var(--ag-icon-font-code-small-down, \"\\f12b\");\n  display: var(--ag-icon-font-display-small-down, var(--ag-icon-font-display));\n}\n\n.ag-icon-small-down::after {\n  background-image: var(--ag-icon-image-small-down, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-small-down, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-small-down, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-small-left {\n  font-family: var(--ag-icon-font-family-small-left, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-small-left, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-small-left, var(--ag-icon-font-color));\n}\n\n.ag-icon-small-left::before {\n  content: var(--ag-icon-font-code-small-left, \"\\f12c\");\n  display: var(--ag-icon-font-display-small-left, var(--ag-icon-font-display));\n}\n\n.ag-icon-small-left::after {\n  background-image: var(--ag-icon-image-small-left, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-small-left, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-small-left, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-small-right {\n  font-family: var(--ag-icon-font-family-small-right, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-small-right, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-small-right, var(--ag-icon-font-color));\n}\n\n.ag-icon-small-right::before {\n  content: var(--ag-icon-font-code-small-right, \"\\f12d\");\n  display: var(--ag-icon-font-display-small-right, var(--ag-icon-font-display));\n}\n\n.ag-icon-small-right::after {\n  background-image: var(--ag-icon-image-small-right, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-small-right, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-small-right, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-small-up {\n  font-family: var(--ag-icon-font-family-small-up, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-small-up, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-small-up, var(--ag-icon-font-color));\n}\n\n.ag-icon-small-up::before {\n  content: var(--ag-icon-font-code-small-up, \"\\f12e\");\n  display: var(--ag-icon-font-display-small-up, var(--ag-icon-font-display));\n}\n\n.ag-icon-small-up::after {\n  background-image: var(--ag-icon-image-small-up, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-small-up, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-small-up, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-tick {\n  font-family: var(--ag-icon-font-family-tick, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-tick, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-tick, var(--ag-icon-font-color));\n}\n\n.ag-icon-tick::before {\n  content: var(--ag-icon-font-code-tick, \"\\f12f\");\n  display: var(--ag-icon-font-display-tick, var(--ag-icon-font-display));\n}\n\n.ag-icon-tick::after {\n  background-image: var(--ag-icon-image-tick, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-tick, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-tick, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-tree-closed {\n  font-family: var(--ag-icon-font-family-tree-closed, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-tree-closed, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-tree-closed, var(--ag-icon-font-color));\n}\n\n.ag-icon-tree-closed::before {\n  content: var(--ag-icon-font-code-tree-closed, \"\\f130\");\n  display: var(--ag-icon-font-display-tree-closed, var(--ag-icon-font-display));\n}\n\n.ag-icon-tree-closed::after {\n  background-image: var(--ag-icon-image-tree-closed, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-tree-closed, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-tree-closed, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-tree-indeterminate {\n  font-family: var(--ag-icon-font-family-tree-indeterminate, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-tree-indeterminate, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-tree-indeterminate, var(--ag-icon-font-color));\n}\n\n.ag-icon-tree-indeterminate::before {\n  content: var(--ag-icon-font-code-tree-indeterminate, \"\\f131\");\n  display: var(--ag-icon-font-display-tree-indeterminate, var(--ag-icon-font-display));\n}\n\n.ag-icon-tree-indeterminate::after {\n  background-image: var(--ag-icon-image-tree-indeterminate, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-tree-indeterminate, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-tree-indeterminate, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-tree-open {\n  font-family: var(--ag-icon-font-family-tree-open, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-tree-open, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-tree-open, var(--ag-icon-font-color));\n}\n\n.ag-icon-tree-open::before {\n  content: var(--ag-icon-font-code-tree-open, \"\\f132\");\n  display: var(--ag-icon-font-display-tree-open, var(--ag-icon-font-display));\n}\n\n.ag-icon-tree-open::after {\n  background-image: var(--ag-icon-image-tree-open, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-tree-open, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-tree-open, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-unlinked {\n  font-family: var(--ag-icon-font-family-unlinked, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-unlinked, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-unlinked, var(--ag-icon-font-color));\n}\n\n.ag-icon-unlinked::before {\n  content: var(--ag-icon-font-code-unlinked, \"\\f133\");\n  display: var(--ag-icon-font-display-unlinked, var(--ag-icon-font-display));\n}\n\n.ag-icon-unlinked::after {\n  background-image: var(--ag-icon-image-unlinked, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-unlinked, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-unlinked, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-up {\n  font-family: var(--ag-icon-font-family-up, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-up, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-up, var(--ag-icon-font-color));\n}\n\n.ag-icon-up::before {\n  content: var(--ag-icon-font-code-up, \"\\f134\");\n  display: var(--ag-icon-font-display-up, var(--ag-icon-font-display));\n}\n\n.ag-icon-up::after {\n  background-image: var(--ag-icon-image-up, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-up, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-up, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-down {\n  font-family: var(--ag-icon-font-family-down, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-down, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-down, var(--ag-icon-font-color));\n}\n\n.ag-icon-down::before {\n  content: var(--ag-icon-font-code-down, \"\\f135\");\n  display: var(--ag-icon-font-display-down, var(--ag-icon-font-display));\n}\n\n.ag-icon-down::after {\n  background-image: var(--ag-icon-image-down, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-down, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-down, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-plus {\n  font-family: var(--ag-icon-font-family-plus, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-plus, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-plus, var(--ag-icon-font-color));\n}\n\n.ag-icon-plus::before {\n  content: var(--ag-icon-font-code-plus, \"\\f136\");\n  display: var(--ag-icon-font-display-plus, var(--ag-icon-font-display));\n}\n\n.ag-icon-plus::after {\n  background-image: var(--ag-icon-image-plus, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-plus, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-plus, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-minus {\n  font-family: var(--ag-icon-font-family-minus, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-minus, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-minus, var(--ag-icon-font-color));\n}\n\n.ag-icon-minus::before {\n  content: var(--ag-icon-font-code-minus, \"\\f137\");\n  display: var(--ag-icon-font-display-minus, var(--ag-icon-font-display));\n}\n\n.ag-icon-minus::after {\n  background-image: var(--ag-icon-image-minus, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-minus, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-minus, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-menu-alt {\n  font-family: var(--ag-icon-font-family-menu-alt, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-menu-alt, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-menu-alt, var(--ag-icon-font-color));\n}\n\n.ag-icon-menu-alt::before {\n  content: var(--ag-icon-font-code-menu-alt, \"\\f138\");\n  display: var(--ag-icon-font-display-menu-alt, var(--ag-icon-font-display));\n}\n\n.ag-icon-menu-alt::after {\n  background-image: var(--ag-icon-image-menu-alt, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-menu-alt, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-menu-alt, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-settings {\n  font-family: var(--ag-icon-font-family-settings, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-settings, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-settings, var(--ag-icon-font-color));\n}\n\n.ag-icon-settings::before {\n  content: var(--ag-icon-font-code-settings, \"\\f139\");\n  display: var(--ag-icon-font-display-settings, var(--ag-icon-font-display));\n}\n\n.ag-icon-settings::after {\n  background-image: var(--ag-icon-image-settings, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-settings, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-settings, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-column-arrow {\n  font-family: var(--ag-icon-font-family-column-arrow, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-column-arrow, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-column-arrow, var(--ag-icon-font-color));\n}\n\n.ag-icon-column-arrow::before {\n  content: var(--ag-icon-font-code-column-arrow, \"\\f13a\");\n  display: var(--ag-icon-font-display-column-arrow, var(--ag-icon-font-display));\n}\n\n.ag-icon-column-arrow::after {\n  background-image: var(--ag-icon-image-column-arrow, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-column-arrow, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-column-arrow, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-un-pin {\n  font-family: var(--ag-icon-font-family-un-pin, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-un-pin, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-un-pin, var(--ag-icon-font-color));\n}\n\n.ag-icon-un-pin::before {\n  content: var(--ag-icon-font-code-un-pin, \"\\f13b\");\n  display: var(--ag-icon-font-display-un-pin, var(--ag-icon-font-display));\n}\n\n.ag-icon-un-pin::after {\n  background-image: var(--ag-icon-image-un-pin, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-un-pin, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-un-pin, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-pinned-bottom {\n  font-family: var(--ag-icon-font-family-pinned-bottom, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-pinned-bottom, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-pinned-bottom, var(--ag-icon-font-color));\n}\n\n.ag-icon-pinned-bottom::before {\n  content: var(--ag-icon-font-code-pinned-bottom, \"\\f13e\");\n  display: var(--ag-icon-font-display-pinned-bottom, var(--ag-icon-font-display));\n}\n\n.ag-icon-pinned-bottom::after {\n  background-image: var(--ag-icon-image-pinned-bottom, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-pinned-bottom, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-pinned-bottom, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-pinned-top {\n  font-family: var(--ag-icon-font-family-pinned-top, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-pinned-top, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-pinned-top, var(--ag-icon-font-color));\n}\n\n.ag-icon-pinned-top::before {\n  content: var(--ag-icon-font-code-pinned-top, \"\\f13f\");\n  display: var(--ag-icon-font-display-pinned-top, var(--ag-icon-font-display));\n}\n\n.ag-icon-pinned-top::after {\n  background-image: var(--ag-icon-image-pinned-top, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-pinned-top, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-pinned-top, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-chevron-up {\n  font-family: var(--ag-icon-font-family-chevron-up, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-chevron-up, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-chevron-up, var(--ag-icon-font-color));\n}\n\n.ag-icon-chevron-up::before {\n  content: var(--ag-icon-font-code-chevron-up, \"\\f140\");\n  display: var(--ag-icon-font-display-chevron-up, var(--ag-icon-font-display));\n}\n\n.ag-icon-chevron-up::after {\n  background-image: var(--ag-icon-image-chevron-up, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-chevron-up, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-chevron-up, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-chevron-down {\n  font-family: var(--ag-icon-font-family-chevron-down, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-chevron-down, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-chevron-down, var(--ag-icon-font-color));\n}\n\n.ag-icon-chevron-down::before {\n  content: var(--ag-icon-font-code-chevron-down, \"\\f141\");\n  display: var(--ag-icon-font-display-chevron-down, var(--ag-icon-font-display));\n}\n\n.ag-icon-chevron-down::after {\n  background-image: var(--ag-icon-image-chevron-down, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-chevron-down, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-chevron-down, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-chevron-left {\n  font-family: var(--ag-icon-font-family-chevron-left, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-chevron-left, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-chevron-left, var(--ag-icon-font-color));\n}\n\n.ag-icon-chevron-left::before {\n  content: var(--ag-icon-font-code-chevron-left, \"\\f142\");\n  display: var(--ag-icon-font-display-chevron-left, var(--ag-icon-font-display));\n}\n\n.ag-icon-chevron-left::after {\n  background-image: var(--ag-icon-image-chevron-left, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-chevron-left, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-chevron-left, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-chevron-right {\n  font-family: var(--ag-icon-font-family-chevron-right, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-chevron-right, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-chevron-right, var(--ag-icon-font-color));\n}\n\n.ag-icon-chevron-right::before {\n  content: var(--ag-icon-font-code-chevron-right, \"\\f143\");\n  display: var(--ag-icon-font-display-chevron-right, var(--ag-icon-font-display));\n}\n\n.ag-icon-chevron-right::after {\n  background-image: var(--ag-icon-image-chevron-right, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-chevron-right, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-chevron-right, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-filter-add {\n  font-family: var(--ag-icon-font-family-filter-add, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-filter-add, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-filter-add, var(--ag-icon-font-color));\n}\n\n.ag-icon-filter-add::before {\n  content: var(--ag-icon-font-code-filter-add, \"\\f144\");\n  display: var(--ag-icon-font-display-filter-add, var(--ag-icon-font-display));\n}\n\n.ag-icon-filter-add::after {\n  background-image: var(--ag-icon-image-filter-add, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-filter-add, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-filter-add, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-edit {\n  font-family: var(--ag-icon-font-family-edit, var(--ag-icon-font-family));\n  font-weight: var(--ag-icon-font-weight-edit, var(--ag-icon-font-weight));\n  color: var(--ag-icon-font-color-edit, var(--ag-icon-font-color));\n}\n\n.ag-icon-edit::before {\n  content: var(--ag-icon-font-code-edit, \"\\f145\");\n  display: var(--ag-icon-font-display-edit, var(--ag-icon-font-display));\n}\n\n.ag-icon-edit::after {\n  background-image: var(--ag-icon-image-edit, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-edit, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-edit, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-icon-row-drag::before {\n  content: var(--ag-icon-font-code-grip);\n}\n\n.ag-left-arrow::before {\n  content: var(--ag-icon-font-code-left);\n}\n\n.ag-right-arrow::before {\n  content: var(--ag-icon-font-code-right);\n}\n\n[class*=ag-theme-] {\n  --ag-foreground-color: #000;\n  --ag-data-color: var(--ag-foreground-color);\n  --ag-secondary-foreground-color: var(--ag-foreground-color);\n  --ag-header-foreground-color: var(--ag-secondary-foreground-color);\n  --ag-disabled-foreground-color: rgba(0, 0, 0, 0.5);\n  --ag-background-color: #fff;\n  --ag-header-background-color: transparent;\n  --ag-tooltip-background-color: transparent;\n  --ag-tooltip-error-background-color: color-mix(\n      in srgb,\n      var(--ag-background-color),\n      var(--ag-invalid-color) 10%\n  );\n  --ag-tooltip-error-text-color: var(--ag-invalid-color);\n  --ag-tooltip-error-border-color: color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 25%);\n  --ag-subheader-background-color: transparent;\n  --ag-subheader-toolbar-background-color: transparent;\n  --ag-control-panel-background-color: transparent;\n  --ag-side-button-selected-background-color: var(--ag-control-panel-background-color);\n  --ag-selected-row-background-color: #bbb;\n  --ag-data-background-color: var(--ag-background-color);\n  --ag-odd-row-background-color: var(--ag-data-background-color);\n  --ag-modal-overlay-background-color: rgba(255, 255, 255, 0.66);\n  --ag-menu-background-color: var(--ag-background-color);\n  --ag-menu-border-color: var(--ag-border-color);\n  --ag-panel-background-color: var(--ag-background-color);\n  --ag-panel-border-color: var(--ag-border-color);\n  --ag-row-hover-color: transparent;\n  --ag-column-hover-color: transparent;\n  --ag-range-selection-border-color: var(--ag-foreground-color);\n  --ag-range-selection-border-style: solid;\n  --ag-range-selection-background-color: rgba(0, 0, 0, 0.2);\n  --ag-range-selection-background-color-2: var(--ag-range-selection-background-color);\n  --ag-range-selection-background-color-3: var(--ag-range-selection-background-color);\n  --ag-range-selection-background-color-4: var(--ag-range-selection-background-color);\n  --ag-range-selection-highlight-color: var(--ag-range-selection-border-color);\n  --ag-range-header-highlight-color: color-mix(\n      in srgb,\n      var(--ag-header-background-color),\n      var(--ag-foreground-color) 8%\n  );\n  --ag-selected-tab-underline-color: var(--ag-range-selection-border-color);\n  --ag-selected-tab-underline-width: 0;\n  --ag-selected-tab-underline-transition-speed: 0s;\n  --ag-range-selection-chart-category-background-color: rgba(0, 255, 132, 0.1);\n  --ag-range-selection-chart-background-color: rgba(0, 88, 255, 0.1);\n  --ag-header-cell-hover-background-color: transparent;\n  --ag-header-cell-moving-background-color: var(--ag-background-color);\n  --ag-value-change-value-highlight-background-color: rgba(22, 160, 133, 0.5);\n  --ag-value-change-delta-up-color: #43a047;\n  --ag-value-change-delta-down-color: #e53935;\n  --ag-row-loading-skeleton-effect-color: rgba(66, 66, 66, 0.2);\n  --ag-chip-background-color: transparent;\n  --ag-chip-border-color: var(--ag-chip-background-color);\n  --ag-borders: solid 1px;\n  --ag-border-color: rgba(0, 0, 0, 0.25);\n  --ag-borders-critical: var(--ag-borders);\n  --ag-borders-secondary: var(--ag-borders);\n  --ag-secondary-border-color: var(--ag-border-color);\n  --ag-row-border-style: solid;\n  --ag-row-border-color: var(--ag-secondary-border-color);\n  --ag-row-border-width: 1px;\n  --ag-cell-horizontal-border: solid transparent;\n  --ag-borders-input: var(--ag-borders-secondary);\n  --ag-input-border-color: var(--ag-secondary-border-color);\n  --ag-borders-input-invalid: solid 2px;\n  --ag-input-border-color-invalid: var(--ag-invalid-color);\n  --ag-full-row-invalid-background-color: color-mix(\n      in srgb,\n      var(--ag-background-color),\n      var(--ag-invalid-color) 25%\n  );\n  --ag-borders-side-button: var(--ag-borders);\n  --ag-border-radius: 0px;\n  --ag-wrapper-border-radius: var(--ag-border-radius);\n  --ag-row-border-color: var(--ag-secondary-border-color);\n  --ag-header-column-separator-display: none;\n  --ag-header-column-separator-height: 100%;\n  --ag-header-column-separator-width: 1px;\n  --ag-header-column-separator-color: var(--ag-secondary-border-color);\n  --ag-header-column-resize-handle-display: none;\n  --ag-header-column-resize-handle-height: 50%;\n  --ag-header-column-resize-handle-width: 1px;\n  --ag-header-column-resize-handle-color: var(--ag-secondary-border-color);\n  --ag-invalid-color: red;\n  --ag-input-disabled-border-color: var(--ag-input-border-color);\n  --ag-input-disabled-background-color: transparent;\n  --ag-checkbox-background-color: transparent;\n  --ag-checkbox-border-radius: var(--ag-border-radius);\n  --ag-checkbox-checked-color: var(--ag-foreground-color);\n  --ag-checkbox-unchecked-color: var(--ag-foreground-color);\n  --ag-checkbox-indeterminate-color: var(--ag-checkbox-unchecked-color);\n  --ag-toggle-button-off-border-color: var(--ag-checkbox-unchecked-color);\n  --ag-toggle-button-off-background-color: var(--ag-checkbox-unchecked-color);\n  --ag-toggle-button-on-border-color: var(--ag-checkbox-checked-color);\n  --ag-toggle-button-on-background-color: var(--ag-checkbox-checked-color);\n  --ag-toggle-button-switch-background-color: var(--ag-background-color);\n  --ag-toggle-button-switch-border-color: var(--ag-toggle-button-off-border-color);\n  --ag-toggle-button-border-width: 1px;\n  --ag-toggle-button-height: var(--ag-icon-size);\n  --ag-toggle-button-width: calc(var(--ag-toggle-button-height) * 2);\n  --ag-input-focus-box-shadow: none;\n  --ag-input-error-focus-box-shadow: none;\n  --ag-input-focus-border-color: none;\n  --ag-minichart-selected-chart-color: var(--ag-checkbox-checked-color);\n  --ag-minichart-selected-page-color: var(--ag-checkbox-checked-color);\n  --ag-grid-size: 4px;\n  --ag-icon-size: 12px;\n  --ag-icon-font-weight: normal;\n  --ag-icon-font-color: var(--ag-foreground-color);\n  --ag-icon-image-display: block;\n  --ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 1.5);\n  --ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 1.5);\n  --ag-widget-horizontal-spacing: calc(var(--ag-grid-size) * 2);\n  --ag-widget-vertical-spacing: var(--ag-grid-size);\n  --ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);\n  --ag-cell-widget-spacing: var(--ag-cell-horizontal-padding);\n  --ag-row-height: calc(var(--ag-grid-size) * 6 + 1px);\n  --ag-header-height: var(--ag-row-height);\n  --ag-pagination-panel-height: var(--ag-header-height);\n  --ag-list-item-height: calc(var(--ag-grid-size) * 5);\n  --ag-column-select-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));\n  --ag-set-filter-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));\n  --ag-advanced-filter-builder-indent-size: calc(var(--ag-grid-size) * 2 + var(--ag-icon-size));\n  --ag-row-group-indent-size: calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size));\n  --ag-row-numbers-selected-color: #bbb;\n  --ag-filter-tool-panel-group-indent: 16px;\n  --ag-tab-min-width: 220px;\n  --ag-chart-menu-panel-width: var(--ag-tab-min-width);\n  --ag-menu-min-width: 181px;\n  --ag-side-bar-panel-width: 200px;\n  --ag-font-family: \"Helvetica Neue\", sans-serif;\n  --ag-font-size: 14px;\n  --ag-card-radius: var(--ag-border-radius);\n  --ag-card-shadow: none;\n  --ag-popup-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);\n  --ag-advanced-filter-join-pill-color: #f08e8d;\n  --ag-advanced-filter-column-pill-color: #a6e194;\n  --ag-advanced-filter-option-pill-color: #f3c08b;\n  --ag-advanced-filter-value-pill-color: #85c0e4;\n  --ag-find-match-color: var(--ag-foreground-color);\n  --ag-find-active-match-color: var(--ag-foreground-color);\n  --ag-find-match-background-color: #ffff00;\n  --ag-find-active-match-background-color: #ffa500;\n  --ag-cell-batch-edit-background-color: rgb(220 181 139 / 16%);\n  --ag-cell-batch-edit-text-color: #422f00;\n  --ag-row-batch-edit-background-color: var(--ag-cell-batch-edit-background-color);\n  --ag-row-batch-edit-text-color: var(--ag-cell-batch-edit-text-color);\n  --ag-filter-panel-apply-button-color: var(--ag-foreground-color);\n  --ag-filter-panel-apply-button-background-color: var(--ag-background-color);\n  --ag-filter-panel-card-subtle-color: var(--ag-foreground-color);\n  --ag-filter-panel-card-subtle-hover-color: var(--ag-foreground-color);\n}\n\n.ag-root-wrapper,\n.ag-dnd-ghost {\n  background-color: var(--ag-background-color);\n}\n\n.ag-sticky-top,\n.ag-sticky-bottom {\n  background-color: var(--ag-data-background-color);\n}\n\n.ag-sticky-bottom {\n  border-top: var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width);\n}\n\n.ag-root-wrapper,\n.ag-popup {\n  --ag-indentation-level: 0;\n}\n\n[class*=ag-theme-] {\n  -webkit-font-smoothing: antialiased;\n  font-family: var(--ag-font-family);\n  font-size: var(--ag-font-size);\n  line-height: normal;\n  color: var(--ag-foreground-color);\n}\n\nag-grid,\nag-grid-angular,\nag-grid-ng2,\nag-grid-polymer,\nag-grid-aurelia {\n  display: block;\n}\n\n.ag-aria-description-container {\n  z-index: 9999;\n  border: 0px;\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  width: 1px;\n  position: absolute;\n  overflow: hidden;\n  padding: 0px;\n  white-space: nowrap;\n}\n\n.ag-hidden {\n  display: none !important;\n}\n\n.ag-invisible {\n  visibility: hidden !important;\n}\n\n.ag-drag-handle {\n  cursor: grab;\n}\n\n.ag-column-drop-wrapper {\n  display: flex;\n}\n\n.ag-column-drop-horizontal-half-width {\n  display: inline-block;\n  width: 50% !important;\n}\n\n.ag-unselectable {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ag-selectable {\n  -moz-user-select: text;\n  -webkit-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.ag-tab {\n  position: relative;\n}\n\n.ag-tab-guard {\n  position: absolute;\n  width: 0;\n  height: 0;\n  display: block;\n}\n\n.ag-virtual-list-viewport .ag-tab-guard {\n  position: sticky;\n}\n\n.ag-tab-guard-top {\n  top: 1px;\n}\n\n.ag-tab-guard-bottom {\n  bottom: 1px;\n}\n\n.ag-select-agg-func-popup {\n  position: absolute;\n}\n\n.ag-input-wrapper,\n.ag-picker-field-wrapper {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  line-height: normal;\n  position: relative;\n}\n\n.ag-shake-left-to-right {\n  animation-direction: alternate;\n  animation-duration: 0.2s;\n  animation-iteration-count: infinite;\n  animation-name: ag-shake-left-to-right;\n}\n\n@keyframes ag-shake-left-to-right {\n  from {\n    padding-left: 6px;\n    padding-right: 2px;\n  }\n  to {\n    padding-left: 2px;\n    padding-right: 6px;\n  }\n}\n.ag-root-wrapper {\n  cursor: default;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: normal;\n}\n.ag-root-wrapper.ag-layout-normal {\n  height: 100%;\n}\n\n.ag-watermark {\n  position: absolute;\n  bottom: 20px;\n  right: 25px;\n  opacity: 0.7;\n  transition: opacity 1s ease-out 3s;\n  color: #9b9b9b;\n}\n.ag-watermark::before {\n  content: \"\";\n  background-image: url(data:image/svg+xml;base64,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);\n  background-repeat: no-repeat;\n  background-size: 170px 40px;\n  display: block;\n  height: 40px;\n  width: 170px;\n}\n\n.ag-watermark-text {\n  opacity: 0.5;\n  font-weight: bold;\n  font-family: Impact, sans-serif;\n  font-size: 19px;\n  padding-left: 0.7rem;\n}\n\n.ag-root-wrapper-body {\n  display: flex;\n  flex-direction: row;\n}\n.ag-root-wrapper-body.ag-layout-normal {\n  flex: 1 1 auto;\n  height: 0;\n  min-height: 0;\n}\n\n.ag-root {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.ag-root.ag-layout-normal, .ag-root.ag-layout-auto-height {\n  overflow: hidden;\n  flex: 1 1 auto;\n  width: 0;\n}\n.ag-root.ag-layout-normal {\n  height: 100%;\n}\n\n.ag-header-viewport,\n.ag-floating-top-viewport,\n.ag-body-viewport,\n.ag-center-cols-viewport,\n.ag-floating-bottom-viewport,\n.ag-body-horizontal-scroll-viewport,\n.ag-body-vertical-scroll-viewport,\n.ag-virtual-list-viewport,\n.ag-sticky-top-viewport,\n.ag-sticky-bottom-viewport {\n  position: relative;\n  height: 100%;\n  min-width: 0px;\n  overflow: hidden;\n  flex: 1 1 auto;\n}\n\n.ag-body-viewport,\n.ag-center-cols-viewport,\n.ag-header-viewport,\n.ag-floating-top-viewport,\n.ag-floating-bottom-viewport,\n.ag-sticky-top-viewport,\n.ag-sticky-bottom-viewport {\n  overflow-x: auto;\n  -ms-overflow-style: none !important;\n  scrollbar-width: none !important;\n}\n.ag-body-viewport::-webkit-scrollbar,\n.ag-center-cols-viewport::-webkit-scrollbar,\n.ag-header-viewport::-webkit-scrollbar,\n.ag-floating-top-viewport::-webkit-scrollbar,\n.ag-floating-bottom-viewport::-webkit-scrollbar,\n.ag-sticky-top-viewport::-webkit-scrollbar,\n.ag-sticky-bottom-viewport::-webkit-scrollbar {\n  display: none !important;\n}\n\n.ag-body-viewport {\n  display: flex;\n  overflow-x: hidden;\n}\n.ag-body-viewport.ag-layout-normal {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ag-viewport {\n  position: relative;\n}\n\n.ag-spanning-container {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n}\n\n.ag-sticky-top-container,\n.ag-sticky-bottom-container,\n.ag-floating-top-container,\n.ag-floating-bottom-container {\n  min-height: 1px;\n}\n\n.ag-sticky-top,\n.ag-sticky-bottom {\n  z-index: 1;\n}\n\n.ag-center-cols-viewport {\n  min-height: 100%;\n  width: 100%;\n}\n\n.ag-body-horizontal-scroll-viewport {\n  overflow-x: scroll;\n}\n\n.ag-body-vertical-scroll-viewport {\n  overflow-y: scroll;\n}\n\n.ag-virtual-list-viewport {\n  overflow: auto;\n  width: 100%;\n}\n\n.ag-header-container,\n.ag-floating-top-container,\n.ag-body-container,\n.ag-pinned-right-cols-container,\n.ag-center-cols-container,\n.ag-pinned-left-cols-container,\n.ag-floating-bottom-container,\n.ag-body-horizontal-scroll-container,\n.ag-body-vertical-scroll-container,\n.ag-full-width-container,\n.ag-floating-bottom-full-width-container,\n.ag-virtual-list-container,\n.ag-sticky-top-container,\n.ag-sticky-bottom-container {\n  position: relative;\n}\n\n.ag-header-container,\n.ag-floating-top-container,\n.ag-pinned-left-floating-top,\n.ag-pinned-right-floating-top,\n.ag-floating-bottom-container,\n.ag-pinned-left-floating-bottom,\n.ag-pinned-right-floating-bottom,\n.ag-sticky-top-container,\n.ag-sticky-bottom-container {\n  height: 100%;\n  white-space: nowrap;\n}\n\n.ag-center-cols-container {\n  display: block;\n}\n\n.ag-pinned-right-cols-container {\n  display: block;\n}\n\n.ag-body-horizontal-scroll-container {\n  height: 100%;\n}\n\n.ag-body-vertical-scroll-container {\n  width: 100%;\n}\n\n.ag-full-width-container,\n.ag-floating-top-full-width-container,\n.ag-floating-bottom-full-width-container,\n.ag-sticky-top-full-width-container,\n.ag-sticky-bottom-full-width-container {\n  position: absolute;\n  top: 0px;\n  pointer-events: none;\n}\n.ag-ltr .ag-full-width-container,\n.ag-ltr .ag-floating-top-full-width-container,\n.ag-ltr .ag-floating-bottom-full-width-container,\n.ag-ltr .ag-sticky-top-full-width-container,\n.ag-ltr .ag-sticky-bottom-full-width-container {\n  left: 0;\n}\n.ag-rtl .ag-full-width-container,\n.ag-rtl .ag-floating-top-full-width-container,\n.ag-rtl .ag-floating-bottom-full-width-container,\n.ag-rtl .ag-sticky-top-full-width-container,\n.ag-rtl .ag-sticky-bottom-full-width-container {\n  right: 0;\n}\n\n.ag-full-width-container {\n  width: 100%;\n}\n\n.ag-floating-bottom-full-width-container,\n.ag-floating-top-full-width-container {\n  display: inline-block;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n\n.ag-virtual-list-container {\n  overflow: hidden;\n}\n\n.ag-body {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row !important;\n  min-height: 0;\n}\n\n.ag-body-horizontal-scroll,\n.ag-body-vertical-scroll {\n  min-height: 0;\n  min-width: 0;\n  display: flex;\n  position: relative;\n}\n.ag-body-horizontal-scroll.ag-scrollbar-invisible,\n.ag-body-vertical-scroll.ag-scrollbar-invisible {\n  position: absolute;\n  bottom: 0;\n}\n.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar,\n.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar {\n  opacity: 0;\n  transition: opacity 400ms;\n  visibility: hidden;\n}\n.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling, .ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active,\n.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling,\n.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active {\n  visibility: visible;\n  opacity: 1;\n}\n\n.ag-body-horizontal-scroll {\n  width: 100%;\n}\n.ag-body-horizontal-scroll.ag-scrollbar-invisible {\n  left: 0;\n  right: 0;\n}\n\n.ag-body-vertical-scroll {\n  height: 100%;\n}\n.ag-body-vertical-scroll.ag-scrollbar-invisible {\n  top: 0;\n  z-index: 10;\n}\n.ag-ltr .ag-body-vertical-scroll.ag-scrollbar-invisible {\n  right: 0;\n}\n.ag-rtl .ag-body-vertical-scroll.ag-scrollbar-invisible {\n  left: 0;\n}\n\n.ag-force-vertical-scroll {\n  overflow-y: scroll !important;\n}\n\n.ag-horizontal-left-spacer,\n.ag-horizontal-right-spacer {\n  height: 100%;\n  min-width: 0;\n  overflow-x: scroll;\n}\n.ag-horizontal-left-spacer.ag-scroller-corner,\n.ag-horizontal-right-spacer.ag-scroller-corner {\n  overflow-x: hidden;\n}\n\n.ag-header,\n.ag-pinned-left-header,\n.ag-pinned-right-header {\n  display: inline-block;\n  overflow: hidden;\n  position: relative;\n}\n\n.ag-header-cell-sortable .ag-header-cell-label {\n  cursor: pointer;\n}\n\n.ag-header {\n  display: flex;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.ag-pinned-left-header {\n  height: 100%;\n}\n\n.ag-pinned-right-header {\n  height: 100%;\n}\n\n.ag-header-row {\n  position: absolute;\n}\n\n.ag-header-row:not(.ag-header-row-column-group) {\n  overflow: hidden;\n}\n\n.ag-header.ag-header-allow-overflow .ag-header-row {\n  overflow: visible;\n}\n\n.ag-header-cell {\n  display: inline-flex;\n  align-items: center;\n  position: absolute;\n  height: 100%;\n  overflow: hidden;\n}\n\n.ag-header-cell.ag-header-active .ag-header-cell-menu-button,\n.ag-header-cell-filter-button {\n  opacity: 1;\n}\n\n.ag-header-cell-menu-button:not(.ag-header-menu-always-show) {\n  transition: opacity 0.2s;\n  opacity: 0;\n}\n\n.ag-header-group-cell-label,\n.ag-header-cell-label {\n  display: flex;\n  flex: 1 1 auto;\n  align-self: stretch;\n  align-items: center;\n  overflow: hidden;\n}\n\n.ag-header-cell-label {\n  text-overflow: ellipsis;\n}\n\n.ag-header-group-cell-label.ag-sticky-label {\n  position: sticky;\n  flex: none;\n  max-width: 100%;\n  overflow: visible;\n}\n\n.ag-header-group-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ag-header-cell-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n}\n\n.ag-header-group-cell .ag-header-cell-comp-wrapper {\n  display: flex;\n}\n\n.ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.ag-header-cell-comp-wrapper {\n  width: 100%;\n}\n\n.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper {\n  white-space: normal;\n}\n\n.ag-header-cell-comp-wrapper-limited-height > div {\n  overflow: hidden;\n}\n\n.ag-right-aligned-header .ag-header-cell-label {\n  flex-direction: row-reverse;\n}\n\n.ag-header-cell-resize {\n  position: absolute;\n  z-index: 2;\n  height: 100%;\n  width: 8px;\n  top: 0;\n  cursor: ew-resize;\n}\n.ag-ltr .ag-header-cell-resize {\n  right: -3px;\n}\n.ag-rtl .ag-header-cell-resize {\n  left: -3px;\n}\n\n.ag-pinned-left-header .ag-header-cell-resize {\n  right: -3px;\n}\n\n.ag-pinned-right-header .ag-header-cell-resize {\n  left: -3px;\n}\n\n.ag-header-select-all {\n  display: flex;\n}\n\n.ag-header-cell-menu-button,\n.ag-header-cell-filter-button,\n.ag-side-button-button,\n.ag-panel-title-bar-button,\n.ag-floating-filter-button-button {\n  cursor: pointer;\n}\n\n.ag-column-moving .ag-cell {\n  transition: left 0.2s;\n}\n.ag-column-moving .ag-header-cell {\n  transition: left 0.2s;\n}\n.ag-column-moving .ag-spanned-cell-wrapper {\n  transition: left 0.2s;\n}\n.ag-column-moving .ag-header-group-cell {\n  transition: left 0.2s, width 0.2s;\n}\n\n.ag-column-panel {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1 1 auto;\n}\n\n.ag-column-select {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 3 1 0px;\n}\n\n.ag-column-select-header {\n  position: relative;\n  display: flex;\n  flex: none;\n}\n\n.ag-column-select-header-icon {\n  position: relative;\n}\n\n.ag-column-select-header-filter-wrapper {\n  flex: 1 1 auto;\n}\n\n.ag-column-select-header-filter {\n  width: 100%;\n}\n\n.ag-column-select-list {\n  flex: 1 1 0px;\n  overflow: hidden;\n}\n\n.ag-column-drop {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  overflow: auto;\n  width: 100%;\n}\n\n.ag-column-drop-list {\n  display: flex;\n  align-items: center;\n}\n\n.ag-column-drop-cell {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.ag-column-drop-cell-text {\n  overflow: hidden;\n  flex: 1 1 auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ag-column-drop-vertical {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  align-items: stretch;\n  flex: 1 1 0px;\n}\n\n.ag-column-drop-vertical-title-bar {\n  display: flex;\n  align-items: center;\n  flex: none;\n}\n\n.ag-column-drop-vertical-list {\n  position: relative;\n  align-items: stretch;\n  flex-grow: 1;\n  flex-direction: column;\n  overflow-x: auto;\n}\n.ag-column-drop-vertical-list > * {\n  flex: none;\n}\n\n.ag-column-drop-empty .ag-column-drop-vertical-list {\n  overflow: hidden;\n}\n\n.ag-column-drop-vertical-empty-message {\n  display: block;\n}\n\n.ag-column-drop.ag-column-drop-horizontal {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.ag-column-drop-cell-button {\n  cursor: pointer;\n}\n\n.ag-filter-toolpanel {\n  flex: 1 1 0px;\n  min-width: 0;\n}\n\n.ag-filter-toolpanel-header {\n  position: relative;\n}\n\n.ag-filter-toolpanel-header,\n.ag-filter-toolpanel-search {\n  display: flex;\n  align-items: center;\n}\n.ag-filter-toolpanel-header > *,\n.ag-filter-toolpanel-search > * {\n  display: flex;\n  align-items: center;\n}\n\n.ag-filter-apply-panel {\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.ag-row-animation .ag-row {\n  transition: transform 0.4s, top 0.4s, opacity 0.2s;\n}\n\n.ag-row-animation .ag-row.ag-after-created {\n  transition: transform 0.4s, top 0.4s, height 0.4s, opacity 0.2s;\n}\n\n.ag-row-animation.ag-prevent-animation .ag-row,\n.ag-row-animation.ag-prevent-animation .ag-row.ag-after-created {\n  transition: none !important;\n}\n\n.ag-row-no-animation .ag-row {\n  transition: none;\n}\n\n.ag-row {\n  white-space: nowrap;\n  width: 100%;\n}\n\n.ag-row-loading {\n  display: flex;\n  align-items: center;\n}\n\n.ag-row-position-absolute {\n  position: absolute;\n}\n\n.ag-row-position-relative {\n  position: relative;\n}\n\n.ag-full-width-row {\n  overflow: hidden;\n  pointer-events: all;\n}\n\n.ag-row-inline-editing {\n  z-index: 1;\n}\n\n.ag-row-dragging {\n  z-index: 2;\n}\n\n.ag-stub-cell {\n  display: flex;\n  align-items: center;\n}\n\n.ag-cell {\n  display: inline-block;\n  position: absolute;\n  white-space: nowrap;\n  height: 100%;\n}\n\n.ag-cell-value {\n  flex: 1 1 auto;\n}\n\n.ag-cell-value:not(.ag-allow-overflow),\n.ag-group-value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ag-cell-wrapper {\n  display: flex;\n  align-items: center;\n}\n.ag-cell-wrapper.ag-row-group {\n  align-items: flex-start;\n}\n\n.ag-cell-wrap-text {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.ag-cell-wrap-text:not(.ag-cell-auto-height) .ag-cell-wrapper {\n  align-items: normal;\n  height: 100%;\n}\n.ag-cell-wrap-text:not(.ag-cell-auto-height) .ag-cell-wrapper .ag-cell-value {\n  height: 100%;\n}\n\n.ag-sparkline-wrapper {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  line-height: initial;\n}\n\n.ag-full-width-row .ag-cell-wrapper.ag-row-group {\n  height: 100%;\n  align-items: center;\n}\n\n.ag-cell-inline-editing {\n  z-index: 1;\n}\n.ag-cell-inline-editing .ag-cell-wrapper,\n.ag-cell-inline-editing .ag-cell-edit-wrapper,\n.ag-cell-inline-editing .ag-cell-editor,\n.ag-cell-inline-editing .ag-cell-editor .ag-wrapper,\n.ag-cell-inline-editing .ag-cell-editor.ag-cell-editor.ag-cell-editor input {\n  height: 100%;\n  min-height: 100%;\n  width: 100%;\n  line-height: normal;\n}\n\n.ag-row.ag-row-editing-invalid .ag-cell-inline-editing {\n  opacity: 0.8;\n}\n\n.ag-cell .ag-icon {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.ag-set-filter-item {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.ag-set-filter-item-checkbox {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.ag-set-filter-group-icons {\n  display: block;\n}\n.ag-set-filter-group-icons > * {\n  cursor: pointer;\n}\n\n.ag-filter-body-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.ag-filter-filter {\n  flex: 1 1 0px;\n}\n\n.ag-filter-condition {\n  display: flex;\n  justify-content: center;\n}\n\n.ag-floating-filter-body {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  height: 100%;\n}\n\n.ag-floating-filter-full-body {\n  display: flex;\n  flex: 1 1 auto;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  overflow: hidden;\n}\n\n.ag-floating-filter-full-body > div {\n  flex: 1 1 auto;\n}\n\n.ag-floating-filter-input {\n  align-items: center;\n  display: flex;\n  width: 100%;\n}\n.ag-floating-filter-input > * {\n  flex: 1 1 auto;\n}\n\n.ag-floating-filter-button {\n  display: flex;\n  flex: none;\n}\n\n.ag-date-floating-filter-wrapper {\n  display: flex;\n}\n\n.ag-set-floating-filter-input input[disabled] {\n  pointer-events: none;\n}\n\n.ag-dnd-ghost {\n  display: inline-flex;\n  align-items: center;\n  cursor: move;\n  white-space: nowrap;\n}\n\n.ag-overlay {\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n}\n\n.ag-overlay-panel {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.ag-overlay-wrapper {\n  display: flex;\n  flex: none;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.ag-overlay-loading-wrapper {\n  pointer-events: all;\n}\n\n.ag-popup-child {\n  z-index: 5;\n  top: 0;\n}\n\n.ag-popup-editor {\n  position: absolute;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ag-large-text-input {\n  display: block;\n}\n\n.ag-virtual-list-item {\n  position: absolute;\n  width: 100%;\n}\n\n.ag-floating-top,\n.ag-floating-bottom {\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  position: relative;\n  display: flex;\n}\n\n.ag-pinned-left-floating-top,\n.ag-pinned-right-floating-top,\n.ag-pinned-left-floating-bottom,\n.ag-pinned-right-floating-bottom {\n  overflow: hidden;\n  position: relative;\n  min-width: 0px;\n}\n\n.ag-sticky-top,\n.ag-sticky-bottom {\n  position: absolute;\n  display: flex;\n  width: 100%;\n  overflow: hidden;\n  height: 0px;\n}\n\n.ag-sticky-bottom {\n  box-sizing: content-box !important;\n}\n\n.ag-pinned-left-sticky-top,\n.ag-pinned-right-sticky-top {\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n}\n\n.ag-sticky-top-full-width-container,\n.ag-sticky-bottom-full-width-container {\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n.ag-dialog,\n.ag-panel {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.ag-panel-title-bar {\n  display: flex;\n  flex: none;\n  align-items: center;\n  cursor: default;\n}\n\n.ag-panel-title-bar-title {\n  flex: 1 1 auto;\n}\n\n.ag-panel-title-bar-buttons {\n  display: flex;\n}\n\n.ag-panel-title-bar-button {\n  cursor: pointer;\n}\n\n.ag-panel-content-wrapper {\n  display: flex;\n  flex: 1 1 auto;\n  position: relative;\n  overflow: hidden;\n}\n\n.ag-dialog {\n  position: absolute;\n}\n\n.ag-resizer {\n  position: absolute;\n  pointer-events: none;\n  z-index: 1;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ag-resizer.ag-resizer-topLeft {\n  top: 0;\n  left: 0;\n  height: 5px;\n  width: 5px;\n  cursor: nwse-resize;\n}\n.ag-resizer.ag-resizer-top {\n  top: 0;\n  left: 5px;\n  right: 5px;\n  height: 5px;\n  cursor: ns-resize;\n}\n.ag-resizer.ag-resizer-topRight {\n  top: 0;\n  right: 0;\n  height: 5px;\n  width: 5px;\n  cursor: nesw-resize;\n}\n.ag-resizer.ag-resizer-right {\n  top: 5px;\n  right: 0;\n  bottom: 5px;\n  width: 5px;\n  cursor: ew-resize;\n}\n.ag-resizer.ag-resizer-bottomRight {\n  bottom: 0;\n  right: 0;\n  height: 5px;\n  width: 5px;\n  cursor: nwse-resize;\n}\n.ag-resizer.ag-resizer-bottom {\n  bottom: 0;\n  left: 5px;\n  right: 5px;\n  height: 5px;\n  cursor: ns-resize;\n}\n.ag-resizer.ag-resizer-bottomLeft {\n  bottom: 0;\n  left: 0;\n  height: 5px;\n  width: 5px;\n  cursor: nesw-resize;\n}\n.ag-resizer.ag-resizer-left {\n  left: 0;\n  top: 5px;\n  bottom: 5px;\n  width: 5px;\n  cursor: ew-resize;\n}\n\n.ag-tooltip {\n  position: absolute;\n  z-index: 99999;\n}\n\n.ag-tooltip-custom {\n  position: absolute;\n  z-index: 99999;\n}\n\n.ag-tooltip:not(.ag-tooltip-interactive),\n.ag-tooltip-custom:not(.ag-tooltip-interactive) {\n  pointer-events: none;\n}\n\n.ag-value-slide-out {\n  margin-right: 5px;\n  opacity: 1;\n  transition: opacity 3s, margin-right 3s;\n  transition-timing-function: linear;\n}\n\n.ag-value-slide-out-end {\n  margin-right: 10px;\n  opacity: 0;\n}\n\n.ag-opacity-zero {\n  opacity: 0 !important;\n}\n\n.ag-menu {\n  max-height: 100%;\n  overflow-y: auto;\n  position: absolute;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ag-menu-column-select-wrapper {\n  height: 265px;\n  overflow: auto;\n}\n.ag-menu-column-select-wrapper .ag-column-select {\n  height: 100%;\n}\n\n.ag-dialog .ag-panel-content-wrapper .ag-column-select {\n  user-select: none;\n}\n\n.ag-menu-list {\n  display: table;\n  width: 100%;\n}\n\n.ag-menu-option,\n.ag-menu-separator {\n  display: table-row;\n}\n\n.ag-menu-option-part,\n.ag-menu-separator-part {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.ag-menu-option-text {\n  white-space: nowrap;\n}\n\n.ag-menu-option-custom {\n  display: contents;\n}\n\n.ag-compact-menu-option {\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.ag-compact-menu-option-text {\n  white-space: nowrap;\n  flex: 1 1 auto;\n}\n\n.ag-context-menu-loading-icon {\n  position: absolute;\n  pointer-events: none;\n}\n\n.ag-pill-container {\n  display: flex;\n  gap: 0.25rem;\n  flex-wrap: nowrap;\n}\n\n.ag-pill {\n  display: flex;\n  white-space: nowrap;\n  padding: 0 0.25rem;\n  align-items: center;\n}\n\n.ag-pill .ag-pill-button {\n  border: none;\n  padding: 0;\n}\n\n.ag-rich-select {\n  cursor: default;\n  outline: none;\n  height: 100%;\n}\n\n.ag-rich-select-value {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.ag-rich-select-value .ag-picker-field-display {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-rich-select-value .ag-picker-field-display.ag-display-as-placeholder {\n  opacity: 0.5;\n}\n\n.ag-rich-select-list {\n  position: relative;\n}\n.ag-rich-select-list .ag-loading-text {\n  min-height: 2rem;\n}\n\n.ag-rich-select-row {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  height: 100%;\n}\n\n.ag-rich-select-field-input {\n  flex: 1 1 auto;\n}\n.ag-rich-select-field-input .ag-input-field-input {\n  padding: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n  text-overflow: ellipsis;\n}\n.ag-rich-select-field-input .ag-input-field-input::placeholder {\n  opacity: 0.8;\n}\n\n.ag-autocomplete {\n  align-items: center;\n  display: flex;\n}\n.ag-autocomplete > * {\n  flex: 1 1 auto;\n}\n\n.ag-autocomplete-list-popup {\n  position: absolute;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ag-autocomplete-list {\n  position: relative;\n}\n\n.ag-autocomplete-virtual-list-item {\n  display: flex;\n}\n\n.ag-autocomplete-row {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  overflow: hidden;\n}\n\n.ag-autocomplete-row-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ag-paging-panel {\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.ag-paging-page-summary-panel {\n  display: flex;\n  align-items: center;\n}\n\n.ag-paging-button {\n  position: relative;\n}\n\n.ag-disabled .ag-paging-page-summary-panel {\n  pointer-events: none;\n}\n\n.ag-tool-panel-wrapper {\n  display: flex;\n  overflow-y: auto;\n  overflow-x: hidden;\n  cursor: default;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ag-column-select-column,\n.ag-column-select-column-group,\n.ag-select-agg-func-item {\n  position: relative;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  height: 100%;\n}\n.ag-column-select-column > *,\n.ag-column-select-column-group > *,\n.ag-select-agg-func-item > * {\n  flex: none;\n}\n\n.ag-select-agg-func-item,\n.ag-column-select-column-label {\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ag-column-select-checkbox {\n  display: flex;\n}\n\n.ag-tool-panel-horizontal-resize {\n  cursor: ew-resize;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  width: 5px;\n  z-index: 1;\n}\n\n.ag-ltr .ag-side-bar-left .ag-tool-panel-horizontal-resize {\n  right: -3px;\n}\n.ag-rtl .ag-side-bar-left .ag-tool-panel-horizontal-resize {\n  left: -3px;\n}\n\n.ag-ltr .ag-side-bar-right .ag-tool-panel-horizontal-resize {\n  left: -3px;\n}\n.ag-rtl .ag-side-bar-right .ag-tool-panel-horizontal-resize {\n  right: -3px;\n}\n\n.ag-details-row {\n  width: 100%;\n}\n\n.ag-details-row-fixed-height {\n  height: 100%;\n}\n\n.ag-details-grid {\n  width: 100%;\n}\n\n.ag-details-grid-fixed-height {\n  height: 100%;\n}\n\n.ag-header-group-cell {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  position: absolute;\n  contain: paint;\n}\n\n.ag-header-group-cell-no-group.ag-header-span-height {\n  display: none;\n}\n\n.ag-cell-label-container {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.ag-header-group-cell-label,\n.ag-cell-label-container {\n  padding: 5px 0px;\n}\n\n.ag-right-aligned-header .ag-cell-label-container {\n  flex-direction: row;\n}\n.ag-right-aligned-header .ag-header-cell-text {\n  text-align: end;\n}\n\n.ag-side-bar {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.ag-side-bar-left {\n  order: -1;\n  flex-direction: row;\n}\n\n.ag-side-button-button {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  outline: none;\n  cursor: pointer;\n}\n\n.ag-side-button-label {\n  writing-mode: vertical-lr;\n}\n\n.ag-status-bar {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.ag-status-panel,\n.ag-status-panel.ag-status-panel-aggregations .ag-status-name-value {\n  display: inline-flex;\n}\n\n.ag-status-name-value {\n  white-space: nowrap;\n}\n\n.ag-status-bar-left {\n  display: inline-flex;\n}\n\n.ag-status-bar-center {\n  display: inline-flex;\n}\n\n.ag-status-bar-right {\n  display: inline-flex;\n}\n\n.ag-row-number-cell {\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  user-select: none;\n}\n.ag-ltr .ag-row-number-cell {\n  text-align: right;\n}\n.ag-rtl .ag-row-number-cell {\n  text-align: left;\n}\n\n.ag-row-numbers-resizer {\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  height: 4px;\n  width: 100%;\n  cursor: ns-resize;\n}\n\n.ag-floating-bottom .ag-row-numbers-resizer {\n  bottom: unset;\n  top: -2px;\n}\n\n.ag-icon {\n  display: block;\n  speak: none;\n}\n\n.ag-group {\n  position: relative;\n  width: 100%;\n}\n\n.ag-group-title-bar {\n  display: flex;\n  align-items: center;\n}\n\n.ag-group-title {\n  display: inline;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.ag-group-title-bar .ag-group-title {\n  cursor: default;\n}\n\n.ag-group-toolbar {\n  display: flex;\n  align-items: center;\n}\n\n.ag-group-container {\n  display: flex;\n}\n\n.ag-disabled .ag-group-container {\n  pointer-events: none;\n}\n\n.ag-group-container-horizontal {\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.ag-group-container-vertical {\n  flex-direction: column;\n}\n\n.ag-column-group-icons {\n  display: block;\n}\n.ag-column-group-icons > * {\n  cursor: pointer;\n}\n\n.ag-group-item-alignment-stretch .ag-group-item {\n  align-items: stretch;\n}\n\n.ag-group-item-alignment-start .ag-group-item {\n  align-items: flex-start;\n}\n\n.ag-group-item-alignment-end .ag-group-item {\n  align-items: flex-end;\n}\n\n.ag-toggle-button-icon {\n  transition: right 0.3s;\n  position: absolute;\n  top: -1px;\n}\n\n.ag-input-field,\n.ag-select {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.ag-input-field-input {\n  flex: 1 1 auto;\n}\n\n.ag-floating-filter-input .ag-input-field-input[type=date],\n.ag-floating-filter-input .ag-input-field-input[type=datetime-local] {\n  width: 1px;\n}\n\n.ag-range-field {\n  display: flex;\n  align-items: center;\n}\n\n.ag-angle-select {\n  display: flex;\n  align-items: center;\n}\n\n.ag-angle-select-wrapper {\n  display: flex;\n}\n\n.ag-angle-select-parent-circle {\n  display: block;\n  position: relative;\n}\n\n.ag-angle-select-child-circle {\n  position: absolute;\n}\n\n.ag-slider-wrapper {\n  display: flex;\n}\n.ag-slider-wrapper .ag-input-field {\n  flex: 1 1 auto;\n}\n\n.ag-picker-field-display {\n  flex: 1 1 auto;\n}\n\n.ag-picker-field {\n  display: flex;\n  align-items: center;\n}\n\n.ag-picker-field-icon {\n  display: flex;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n}\n\n.ag-picker-field-wrapper {\n  overflow: hidden;\n}\n\n.ag-label-align-right .ag-label {\n  order: 1;\n}\n.ag-label-align-right > * {\n  flex: none;\n}\n\n.ag-label-align-top {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.ag-label-align-top > * {\n  align-self: stretch;\n}\n\n.ag-label-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.ag-color-panel {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n.ag-spectrum-color {\n  flex: 1 1 auto;\n  position: relative;\n  overflow: visible;\n  cursor: default;\n}\n\n.ag-spectrum-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.ag-spectrum-val {\n  cursor: pointer;\n}\n\n.ag-spectrum-dragger {\n  position: absolute;\n  pointer-events: none;\n  cursor: pointer;\n}\n\n.ag-spectrum-hue,\n.ag-spectrum-alpha {\n  cursor: default;\n}\n\n.ag-spectrum-hue-background {\n  background: linear-gradient(to left, #ff0000 3%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);\n  width: 100%;\n  height: 100%;\n}\n\n.ag-spectrum-alpha {\n  --ag-spectrum-alpha-background-checked: url(\"data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%224%22 height=%224%22><rect x=%220%22 y=%220%22 width=%224%22 height=%224%22 fill=%22%23fff%22/><path d=%22M0 0H2V4H4V2H0Z%22 fill=%22%23b2b2b2%22/></svg>\");\n}\n\n.ag-spectrum-alpha-background {\n  background: linear-gradient(to right, var(--ag-internal-spectrum-alpha-color-from), var(--ag-internal-spectrum-alpha-color-to)), var(--ag-spectrum-alpha-background-checked) top left/4px 4px;\n  width: 100%;\n  height: 100%;\n}\n\n.ag-spectrum-tool {\n  cursor: pointer;\n  position: relative;\n}\n\n.ag-spectrum-slider {\n  position: absolute;\n  pointer-events: none;\n}\n\n.ag-spectrum-alpha .ag-spectrum-slider {\n  background: linear-gradient(to bottom, var(--ag-internal-spectrum-alpha-color), var(--ag-internal-spectrum-alpha-color)) white;\n}\n\n.ag-recent-colors {\n  display: flex;\n}\n\n.ag-recent-color {\n  cursor: pointer;\n}\n\n.ag-pill-select {\n  display: flex;\n  flex-direction: column;\n}\n.ag-pill-select .ag-column-drop {\n  flex: unset;\n}\n\n.ag-ltr {\n  direction: ltr;\n}\n.ag-ltr .ag-body,\n.ag-ltr .ag-floating-top,\n.ag-ltr .ag-floating-bottom,\n.ag-ltr .ag-header,\n.ag-ltr .ag-sticky-top,\n.ag-ltr .ag-sticky-bottom,\n.ag-ltr .ag-body-viewport,\n.ag-ltr .ag-body-horizontal-scroll {\n  flex-direction: row;\n}\n\n.ag-rtl {\n  direction: rtl;\n}\n.ag-rtl .ag-body,\n.ag-rtl .ag-floating-top,\n.ag-rtl .ag-floating-bottom,\n.ag-rtl .ag-header,\n.ag-rtl .ag-sticky-top,\n.ag-rtl .ag-sticky-bottom,\n.ag-rtl .ag-body-viewport,\n.ag-rtl .ag-body-horizontal-scroll {\n  flex-direction: row-reverse;\n}\n.ag-rtl .ag-icon-contracted,\n.ag-rtl .ag-icon-expanded,\n.ag-rtl .ag-icon-tree-closed {\n  display: block;\n  transform: rotate(180deg);\n}\n\n.ag-body .ag-body-viewport {\n  -webkit-overflow-scrolling: touch;\n}\n\n.ag-measurement-container {\n  width: 0;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ag-measurement-container div {\n  position: absolute;\n}\n\n.ag-layout-print.ag-body {\n  display: block;\n  height: unset;\n}\n.ag-layout-print.ag-root-wrapper {\n  display: inline-block;\n}\n.ag-layout-print .ag-body-vertical-scroll {\n  display: none;\n}\n.ag-layout-print .ag-body-horizontal-scroll {\n  display: none;\n}\n.ag-layout-print.ag-force-vertical-scroll {\n  overflow-y: visible !important;\n}\n\n@media print {\n  .ag-root-wrapper.ag-layout-print {\n    display: table;\n  }\n  .ag-root-wrapper.ag-layout-print .ag-root-wrapper-body,\n  .ag-root-wrapper.ag-layout-print .ag-root,\n  .ag-root-wrapper.ag-layout-print .ag-body-viewport,\n  .ag-root-wrapper.ag-layout-print .ag-center-cols-container,\n  .ag-root-wrapper.ag-layout-print .ag-center-cols-viewport,\n  .ag-root-wrapper.ag-layout-print .ag-body-horizontal-scroll-viewport,\n  .ag-root-wrapper.ag-layout-print .ag-virtual-list-viewport {\n    height: auto !important;\n    overflow: hidden !important;\n    display: block !important;\n  }\n  .ag-root-wrapper.ag-layout-print .ag-row,\n  .ag-root-wrapper.ag-layout-print .ag-cell {\n    break-inside: avoid;\n  }\n}\n[class^=ag-],\n[class^=ag-]:focus,\n[class^=ag-]:after,\n[class^=ag-]:before {\n  box-sizing: border-box;\n  outline: none;\n}\n\n[class^=ag-]::-ms-clear {\n  display: none;\n}\n\n.ag-checkbox .ag-input-wrapper,\n.ag-radio-button .ag-input-wrapper {\n  overflow: visible;\n}\n\n.ag-range-field .ag-input-wrapper {\n  height: 100%;\n}\n\n.ag-toggle-button {\n  flex: none;\n  width: unset;\n  min-width: unset;\n}\n\n.ag-button {\n  border-radius: 0px;\n  color: var(--ag-foreground-color);\n}\n\n.ag-button:hover {\n  background-color: transparent;\n}\n\n.ag-ltr .ag-label-align-right .ag-label {\n  margin-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-label-align-right .ag-label {\n  margin-right: var(--ag-grid-size);\n}\n\ninput[class^=ag-] {\n  margin: 0;\n  background-color: var(--ag-background-color);\n}\n\ntextarea[class^=ag-],\nselect[class^=ag-] {\n  background-color: var(--ag-background-color);\n}\n\ninput[class^=ag-]:not([type]),\ninput[class^=ag-][type=text],\ninput[class^=ag-][type=number],\ninput[class^=ag-][type=tel],\ninput[class^=ag-][type=date],\ninput[class^=ag-][type=datetime-local],\ntextarea[class^=ag-] {\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  font-family: inherit;\n  border: var(--ag-borders-input) var(--ag-input-border-color);\n}\ninput[class^=ag-]:not([type]):disabled,\ninput[class^=ag-][type=text]:disabled,\ninput[class^=ag-][type=number]:disabled,\ninput[class^=ag-][type=tel]:disabled,\ninput[class^=ag-][type=date]:disabled,\ninput[class^=ag-][type=datetime-local]:disabled,\ntextarea[class^=ag-]:disabled {\n  color: var(--ag-disabled-foreground-color);\n  background-color: var(--ag-input-disabled-background-color);\n  border-color: var(--ag-input-disabled-border-color);\n}\ninput[class^=ag-]:not([type]):focus,\ninput[class^=ag-][type=text]:focus,\ninput[class^=ag-][type=number]:focus,\ninput[class^=ag-][type=tel]:focus,\ninput[class^=ag-][type=date]:focus,\ninput[class^=ag-][type=datetime-local]:focus,\ntextarea[class^=ag-]:focus {\n  outline: none;\n  box-shadow: var(--ag-input-focus-box-shadow);\n  border-color: var(--ag-input-focus-border-color);\n}\ninput[class^=ag-]:not([type]):focus.invalid, input[class^=ag-]:not([type]):focus:invalid,\ninput[class^=ag-][type=text]:focus.invalid,\ninput[class^=ag-][type=text]:focus:invalid,\ninput[class^=ag-][type=number]:focus.invalid,\ninput[class^=ag-][type=number]:focus:invalid,\ninput[class^=ag-][type=tel]:focus.invalid,\ninput[class^=ag-][type=tel]:focus:invalid,\ninput[class^=ag-][type=date]:focus.invalid,\ninput[class^=ag-][type=date]:focus:invalid,\ninput[class^=ag-][type=datetime-local]:focus.invalid,\ninput[class^=ag-][type=datetime-local]:focus:invalid,\ntextarea[class^=ag-]:focus.invalid,\ntextarea[class^=ag-]:focus:invalid {\n  box-shadow: var(--ag-input-error-focus-box-shadow);\n  border-color: var(--ag-invalid-color);\n}\ninput[class^=ag-]:not([type]):invalid,\ninput[class^=ag-][type=text]:invalid,\ninput[class^=ag-][type=number]:invalid,\ninput[class^=ag-][type=tel]:invalid,\ninput[class^=ag-][type=date]:invalid,\ninput[class^=ag-][type=datetime-local]:invalid,\ntextarea[class^=ag-]:invalid {\n  border: var(--ag-borders-input-invalid) var(--ag-input-border-color-invalid);\n}\n\ninput[class^=ag-][type=number]:not(.ag-number-field-input-stepper) {\n  -moz-appearance: textfield;\n}\ninput[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-outer-spin-button, input[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[class^=ag-][type=range] {\n  padding: 0;\n}\n\ninput[class^=ag-][type=button]:focus,\nbutton[class^=ag-]:focus {\n  box-shadow: var(--ag-input-focus-box-shadow);\n}\ninput[class^=ag-][type=button]:focus:invalid, input[class^=ag-][type=button]:focus.invalid,\nbutton[class^=ag-]:focus:invalid,\nbutton[class^=ag-]:focus.invalid {\n  box-shadow: var(--ag-input-error-focus-box-shadow);\n}\n\n.ag-drag-handle {\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-list-item,\n.ag-virtual-list-item {\n  height: var(--ag-list-item-height);\n}\n\n.ag-virtual-list-item:focus-visible {\n  outline: none;\n}\n.ag-virtual-list-item:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-select-list {\n  background-color: var(--ag-background-color);\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: var(--ag-border-radius);\n  border: var(--ag-borders) var(--ag-border-color);\n}\n\n.ag-list-item {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-list-item.ag-active-item {\n  background-color: var(--ag-row-hover-color);\n}\n\n.ag-select-list-item {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: default;\n}\n.ag-ltr .ag-select-list-item {\n  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n.ag-rtl .ag-select-list-item {\n  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n.ag-select-list-item span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ag-row-drag,\n.ag-selection-checkbox,\n.ag-group-expanded,\n.ag-group-contracted {\n  color: var(--ag-secondary-foreground-color);\n}\n.ag-ltr .ag-row-drag,\n.ag-ltr .ag-selection-checkbox,\n.ag-ltr .ag-group-expanded,\n.ag-ltr .ag-group-contracted {\n  margin-right: var(--ag-cell-widget-spacing);\n}\n.ag-rtl .ag-row-drag,\n.ag-rtl .ag-selection-checkbox,\n.ag-rtl .ag-group-expanded,\n.ag-rtl .ag-group-contracted {\n  margin-left: var(--ag-cell-widget-spacing);\n}\n\n.ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {\n  --ag-internal-calculated-line-height: var(\n      --ag-line-height,\n      calc(var(--ag-row-height) - var(--ag-row-border-width))\n  );\n  --ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width) - 2px);\n  height: min(var(--ag-internal-calculated-line-height), var(--ag-internal-padded-row-height));\n  display: flex;\n  align-items: center;\n  flex: none;\n}\n\n.ag-group-expanded,\n.ag-group-contracted {\n  cursor: pointer;\n}\n\n.ag-group-title-bar-icon {\n  cursor: pointer;\n  flex: none;\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-ltr .ag-group-child-count {\n  margin-left: 2px;\n}\n.ag-rtl .ag-group-child-count {\n  margin-right: 2px;\n}\n\n.ag-group-title-bar {\n  background-color: var(--ag-subheader-background-color);\n  padding: var(--ag-grid-size);\n}\n\n.ag-group-toolbar {\n  padding: var(--ag-grid-size);\n  background-color: var(--ag-subheader-toolbar-background-color);\n}\n\n.ag-disabled-group-title-bar,\n.ag-disabled-group-container {\n  opacity: 0.5;\n}\n\n.group-item {\n  margin: calc(var(--ag-grid-size) * 0.5) 0;\n}\n\n.ag-label {\n  white-space: nowrap;\n}\n.ag-ltr .ag-label {\n  margin-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-label {\n  margin-left: var(--ag-grid-size);\n}\n\n.ag-label-align-top .ag-label {\n  margin-bottom: calc(var(--ag-grid-size) * 0.5);\n}\n\n.ag-angle-select[disabled] {\n  color: var(--ag-disabled-foreground-color);\n  pointer-events: none;\n}\n.ag-angle-select[disabled] .ag-angle-select-field {\n  opacity: 0.4;\n}\n\n.ag-ltr .ag-slider-field,\n.ag-ltr .ag-angle-select-field {\n  margin-right: calc(var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-slider-field,\n.ag-rtl .ag-angle-select-field {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-angle-select-parent-circle {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: solid 1px;\n  border-color: var(--ag-border-color);\n  background-color: var(--ag-background-color);\n}\n\n.ag-angle-select-child-circle {\n  top: 4px;\n  left: 12px;\n  width: 6px;\n  height: 6px;\n  margin-left: -3px;\n  margin-top: -4px;\n  border-radius: 3px;\n  background-color: var(--ag-secondary-foreground-color);\n}\n\n.ag-picker-field-wrapper {\n  border: var(--ag-borders);\n  border-color: var(--ag-border-color);\n  border-radius: 5px;\n  background-color: var(--ag-background-color);\n}\n.ag-picker-field-wrapper:disabled {\n  color: var(--ag-disabled-foreground-color);\n  background-color: var(--ag-input-disabled-background-color);\n  border-color: var(--ag-input-disabled-border-color);\n}\n.ag-picker-field-wrapper.ag-picker-has-focus, .ag-picker-field-wrapper:focus-within {\n  outline: none;\n  box-shadow: var(--ag-input-focus-box-shadow);\n  border-color: var(--ag-input-focus-border-color);\n}\n.ag-picker-field-wrapper.ag-picker-has-focus.invalid, .ag-picker-field-wrapper:focus-within.invalid {\n  box-shadow: var(--ag-input-error-focus-box-shadow);\n}\n.ag-picker-field-wrapper.invalid {\n  border: var(--ag-borders-input-invalid) var(--ag-input-border-color-invalid);\n}\n\n.ag-picker-field-button {\n  background-color: var(--ag-background-color);\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-dialog.ag-color-dialog {\n  border-radius: 5px;\n}\n\n.ag-color-picker .ag-picker-field-wrapper {\n  padding-left: var(--ag-grid-size);\n  padding-right: var(--ag-grid-size);\n}\n.ag-color-picker .ag-picker-field-display {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: var(--ag-list-item-height);\n}\n\n.ag-ltr .ag-color-picker-color,\n.ag-ltr .ag-color-picker-value {\n  margin-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-color-picker-color,\n.ag-rtl .ag-color-picker-value {\n  margin-left: var(--ag-grid-size);\n}\n\n.ag-color-panel {\n  padding: var(--ag-grid-size);\n}\n\n.ag-spectrum-color {\n  background-color: rgb(255, 0, 0);\n  border-radius: 2px;\n}\n\n.ag-spectrum-tools {\n  padding: 10px;\n}\n\n.ag-spectrum-sat {\n  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));\n}\n\n.ag-spectrum-val {\n  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));\n}\n\n.ag-spectrum-dragger {\n  border-radius: 12px;\n  height: 12px;\n  width: 12px;\n  border: 2px solid white;\n  background: black;\n  box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);\n}\n\n.ag-spectrum-hue-background {\n  border-radius: 2px;\n}\n\n.ag-spectrum-alpha-background {\n  border-radius: 2px;\n}\n\n.ag-spectrum-tool {\n  margin-bottom: 10px;\n  height: 11px;\n  border-radius: 2px;\n}\n\n.ag-spectrum-slider {\n  margin-top: -12px;\n  width: 13px;\n  height: 13px;\n  border-radius: 13px;\n  border: 2px solid white;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n\n.ag-recent-colors {\n  margin-top: 10px;\n}\n\n.ag-recent-color {\n  margin: 0 3px;\n}\n.ag-recent-color:first-child {\n  margin-left: 0;\n}\n.ag-recent-color:last-child {\n  margin-right: 0;\n}\n\n.ag-spectrum-color:focus-visible:not(:disabled):not([readonly]),\n.ag-spectrum-slider:focus-visible:not(:disabled):not([readonly]),\n.ag-recent-color:focus-visible:not(:disabled):not([readonly]) {\n  box-shadow: var(--ag-input-focus-box-shadow);\n}\n\n.ag-ltr .ag-color-input input[class^=ag-][type=text].ag-input-field-input {\n  padding-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-color-input input[class^=ag-][type=text].ag-input-field-input {\n  padding-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n}\n.ag-color-input .ag-color-input-color {\n  position: absolute;\n}\n.ag-ltr .ag-color-input .ag-color-input-color {\n  margin-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-color-input .ag-color-input-color {\n  margin-right: var(--ag-grid-size);\n}\n\n.ag-color-picker-color,\n.ag-color-input-color {\n  width: var(--ag-icon-size);\n  height: var(--ag-icon-size);\n  border: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n  border-radius: 2px;\n}\n\n.ag-dnd-ghost {\n  border: var(--ag-borders) var(--ag-border-color);\n  background: var(--ag-background-color);\n  border-radius: var(--ag-card-radius);\n  box-shadow: var(--ag-card-shadow);\n  padding: var(--ag-grid-size);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n  color: var(--ag-secondary-foreground-color);\n  height: var(--ag-header-height);\n  line-height: var(--ag-header-height);\n  margin: 0;\n  padding: 0 calc(var(--ag-grid-size) * 2);\n  transform: translateY(calc(var(--ag-grid-size) * 2));\n}\n\n.ag-dnd-ghost-not-allowed {\n  border-color: color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 50%);\n}\n\n.ag-dnd-ghost-icon {\n  margin-right: var(--ag-grid-size);\n  color: var(--ag-foreground-color);\n}\n\n.ag-popup-child:not(.ag-tooltip-custom) {\n  box-shadow: var(--ag-popup-shadow);\n}\n\n.ag-select .ag-picker-field-wrapper {\n  min-height: var(--ag-list-item-height);\n  cursor: default;\n}\n.ag-ltr .ag-select .ag-picker-field-wrapper {\n  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n.ag-rtl .ag-select .ag-picker-field-wrapper {\n  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n.ag-ltr .ag-select .ag-picker-field-wrapper {\n  padding-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-select .ag-picker-field-wrapper {\n  padding-left: var(--ag-grid-size);\n}\n.ag-select.ag-disabled .ag-picker-field-wrapper:focus {\n  box-shadow: none;\n}\n.ag-select:not(.ag-cell-editor, .ag-label-align-top) {\n  min-height: var(--ag-list-item-height);\n}\n.ag-select .ag-picker-field-display {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-select .ag-picker-field-icon {\n  display: flex;\n  align-items: center;\n}\n.ag-select.ag-disabled {\n  opacity: 0.5;\n}\n\n.ag-rich-select-value,\n.ag-rich-select-list {\n  background-color: var(--ag-background-color);\n}\n\n.ag-rich-select-list {\n  width: 100%;\n  height: auto;\n  border-radius: var(--ag-border-radius);\n  border: var(--ag-borders) var(--ag-border-color);\n}\n.ag-rich-select-list .ag-loading-text {\n  padding: var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing);\n}\n\n.ag-rich-select-value {\n  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ag-ltr .ag-rich-select-value {\n  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n.ag-rtl .ag-rich-select-value {\n  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n.ag-ltr .ag-rich-select-value {\n  padding-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-rich-select-value {\n  padding-left: var(--ag-grid-size);\n}\n\n.ag-ltr .ag-rich-select-field-input {\n  left: calc(var(--ag-cell-horizontal-padding));\n}\n.ag-rtl .ag-rich-select-field-input {\n  right: calc(var(--ag-cell-horizontal-padding));\n}\n\n.ag-popup-editor .ag-rich-select-value {\n  height: var(--ag-row-height);\n  min-width: 200px;\n}\n\n.ag-rich-select-virtual-list-item {\n  cursor: default;\n  height: var(--ag-list-item-height);\n}\n.ag-rich-select-virtual-list-item:focus-visible::after {\n  content: none;\n}\n\n.ag-ltr .ag-rich-select-row {\n  padding-left: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n.ag-rtl .ag-rich-select-row {\n  padding-right: calc(var(--ag-cell-horizontal-padding) / 2);\n}\n\n.ag-rich-select-row-selected {\n  background-color: var(--ag-selected-row-background-color);\n}\n\n.ag-rich-select-row:hover,\n.ag-rich-select-row-highlighted {\n  background-image: linear-gradient(var(--ag-row-hover-color), var(--ag-row-hover-color));\n}\n\n.ag-rich-select-row-text-highlight {\n  font-weight: bold;\n}\n\n.ag-autocomplete {\n  width: 100%;\n}\n\n.ag-autocomplete-list {\n  width: 100%;\n  min-width: 200px;\n  height: calc(var(--ag-row-height) * 6.5);\n}\n\n.ag-autocomplete-virtual-list-item {\n  cursor: default;\n  height: var(--ag-list-item-height);\n}\n.ag-autocomplete-virtual-list-item:focus-visible::after {\n  content: none;\n}\n.ag-autocomplete-virtual-list-item:hover {\n  background-color: var(--ag-row-hover-color);\n}\n\n.ag-autocomplete-row-label {\n  margin: 0px var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-autocomplete-row-selected {\n  background-color: var(--ag-selected-row-background-color);\n}\n\n.ag-pill {\n  border: 1px solid var(--ag-chip-border-color);\n  border-radius: var(--ag-border-radius);\n  background-color: var(--ag-chip-background-color);\n}\n\n.ag-ltr .ag-pill .ag-pill-button {\n  margin-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-pill .ag-pill-button {\n  margin-right: var(--ag-grid-size);\n}\n\n.ag-pill:focus-visible {\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-pill .ag-pill-button:hover {\n  cursor: pointer;\n}\n\n.ag-dragging-range-handle .ag-dialog,\n.ag-dragging-fill-handle .ag-dialog {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.ag-dialog {\n  border-radius: var(--ag-border-radius);\n  border: var(--ag-borders) var(--ag-border-color);\n  box-shadow: var(--ag-popup-shadow);\n}\n\n.ag-panel {\n  background-color: var(--ag-panel-background-color);\n  border-color: var(--ag-panel-border-color);\n}\n\n.ag-panel-title-bar {\n  color: var(--ag-header-foreground-color);\n  height: var(--ag-header-height);\n  padding: var(--ag-grid-size) var(--ag-cell-horizontal-padding);\n  border-bottom: var(--ag-borders) var(--ag-border-color);\n}\n\n.ag-ltr .ag-panel-title-bar-button {\n  margin-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-panel-title-bar-button {\n  margin-right: var(--ag-grid-size);\n}\n\n.ag-tooltip {\n  background-color: var(--ag-tooltip-background-color);\n  color: var(--ag-foreground-color);\n  padding: var(--ag-grid-size);\n  border: var(--ag-borders) var(--ag-border-color);\n  border-radius: var(--ag-card-radius);\n  white-space: normal;\n}\n.ag-tooltip.ag-cell-editor-tooltip {\n  background-color: var(--ag-tooltip-error-background-color);\n  color: var(--ag-tooltip-error-text-color);\n  border: var(--ag-borders) var(--ag-tooltip-error-border-color);\n  font-weight: 500;\n}\n\n.ag-tooltip.ag-tooltip-animate,\n.ag-tooltip-custom.ag-tooltip-animate {\n  transition: opacity 1s;\n}\n.ag-tooltip.ag-tooltip-animate.ag-tooltip-hiding,\n.ag-tooltip-custom.ag-tooltip-animate.ag-tooltip-hiding {\n  opacity: 0;\n}\n\n.ag-ltr .ag-column-select-column,\n.ag-ltr .ag-column-select-column-group {\n  padding-left: calc(var(--ag-indentation-level) * var(--ag-column-select-indent-size));\n}\n.ag-rtl .ag-column-select-column,\n.ag-rtl .ag-column-select-column-group {\n  padding-right: calc(var(--ag-indentation-level) * var(--ag-column-select-indent-size));\n}\n\n.ag-column-select-header-icon {\n  cursor: pointer;\n}\n\n.ag-column-select-header-icon:focus-visible {\n  outline: none;\n}\n.ag-column-select-header-icon:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-ltr .ag-column-group-icons:not(:last-child),\n.ag-ltr .ag-column-select-header-icon:not(:last-child),\n.ag-ltr .ag-column-select-header-checkbox:not(:last-child),\n.ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child),\n.ag-ltr .ag-column-select-checkbox:not(:last-child),\n.ag-ltr .ag-column-select-column-drag-handle:not(:last-child),\n.ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child),\n.ag-ltr .ag-column-select-column-label:not(:last-child) {\n  margin-right: var(--ag-widget-horizontal-spacing);\n}\n.ag-rtl .ag-column-group-icons:not(:last-child),\n.ag-rtl .ag-column-select-header-icon:not(:last-child),\n.ag-rtl .ag-column-select-header-checkbox:not(:last-child),\n.ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child),\n.ag-rtl .ag-column-select-checkbox:not(:last-child),\n.ag-rtl .ag-column-select-column-drag-handle:not(:last-child),\n.ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child),\n.ag-rtl .ag-column-select-column-label:not(:last-child) {\n  margin-left: var(--ag-widget-horizontal-spacing);\n}\n\n.ag-column-select-virtual-list-item:focus-visible {\n  outline: none;\n}\n.ag-column-select-virtual-list-item:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-column-select-column-group:not(:last-child),\n.ag-column-select-column:not(:last-child) {\n  margin-bottom: var(--ag-widget-vertical-spacing);\n}\n\n.ag-column-select-column-readonly,\n.ag-column-select-column-group-readonly {\n  color: var(--ag-disabled-foreground-color);\n  pointer-events: none;\n}\n\n.ag-ltr .ag-column-select-add-group-indent {\n  margin-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-column-select-add-group-indent {\n  margin-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n}\n\n.ag-column-select-virtual-list-viewport {\n  padding: calc(var(--ag-widget-container-vertical-padding) * 0.5) 0px;\n}\n\n.ag-column-select-virtual-list-item {\n  padding: 0 var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-checkbox-edit {\n  padding-left: var(--ag-cell-horizontal-padding);\n  padding-right: var(--ag-cell-horizontal-padding);\n}\n\n.ag-pill-select .ag-column-drop {\n  border-bottom: 0;\n  min-height: unset;\n}\n.ag-pill-select .ag-column-drop-list {\n  padding: 0;\n}\n.ag-pill-select .ag-select {\n  padding-top: var(--ag-grid-size);\n}\n.ag-pill-select .ag-picker-field-wrapper {\n  background-color: transparent;\n  border: 0;\n}\n.ag-pill-select .ag-picker-field-display {\n  cursor: pointer;\n}\n\n.ag-rtl {\n  text-align: right;\n}\n\n.ag-root-wrapper {\n  border-radius: var(--ag-wrapper-border-radius);\n  border: var(--ag-borders) var(--ag-border-color);\n}\n\n.ag-row > .ag-cell-wrapper.ag-row-group {\n  padding-left: calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * var(--ag-indentation-level));\n}\n\n.ag-cell-wrapper.ag-row-group,\n.ag-cell-wrapper.ag-row-group-leaf-indent,\n.ag-cell-wrapper.ag-pivot-leaf-group {\n  padding-left: calc(var(--ag-indentation-level) * var(--ag-row-group-indent-size));\n}\n\n.ag-cell-wrapper > .ag-group-checkbox-spacing {\n  width: var(--ag-icon-size);\n  margin-right: var(--ag-cell-widget-spacing);\n}\n\n.ag-ltr .ag-row-group-leaf-indent {\n  margin-left: var(--ag-row-group-indent-size);\n}\n.ag-rtl .ag-row-group-leaf-indent {\n  margin-right: var(--ag-row-group-indent-size);\n}\n\n.ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group {\n  margin-left: var(--ag-row-group-indent-size);\n}\n\n.ag-value-change-delta {\n  padding-right: 2px;\n}\n\n.ag-value-change-delta-up {\n  color: var(--ag-value-change-delta-up-color);\n}\n\n.ag-value-change-delta-down {\n  color: var(--ag-value-change-delta-down-color);\n}\n\n.ag-value-change-value {\n  background-color: transparent;\n  border-radius: 1px;\n  padding-left: 1px;\n  padding-right: 1px;\n  transition: background-color 1s;\n}\n\n.ag-value-change-value-highlight {\n  background-color: var(--ag-value-change-value-highlight-background-color);\n  transition: background-color 0.1s;\n}\n\n.ag-cell-data-changed {\n  background-color: var(--ag-value-change-value-highlight-background-color) !important;\n}\n\n.ag-cell-data-changed-animation {\n  background-color: transparent;\n}\n\n.ag-cell-highlight {\n  background-color: var(--ag-range-selection-highlight-color) !important;\n}\n\n.ag-row,\n.ag-spanned-row {\n  color: var(--ag-data-color);\n}\n\n.ag-row {\n  height: var(--ag-row-height);\n  background-color: var(--ag-data-background-color);\n  border-bottom: var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width);\n}\n.ag-row.ag-row-editing-invalid {\n  background-color: var(--ag-full-row-invalid-background-color);\n}\n\n.ag-spanned-cell-wrapper {\n  background-color: var(--ag-data-background-color);\n  position: absolute;\n}\n\n.ag-spanned-cell-wrapper > .ag-spanned-cell {\n  display: block;\n  position: relative;\n}\n\n.ag-row-highlight-above::after,\n.ag-row-highlight-inside::after,\n.ag-row-highlight-below::after {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - 1px);\n  height: 1px;\n  background-color: var(--ag-range-selection-border-color);\n  left: 1px;\n  pointer-events: none;\n}\n\n.ag-row-highlight-above::after {\n  top: 0;\n}\n\n.ag-row-highlight-below::after {\n  bottom: 0;\n}\n\n.ag-row-highlight-indent::after {\n  display: block;\n  width: auto;\n  left: calc(2 * (var(--ag-cell-widget-spacing) + var(--ag-icon-size)) + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level) * var(--ag-row-group-indent-size));\n  right: 1px;\n}\n\n.ag-row-highlight-inside::after {\n  display: block;\n  width: auto;\n  height: auto;\n  inset: 0;\n  background-color: var(--ag-selected-row-background-color);\n  border: 1px solid var(--ag-range-selection-border-color);\n}\n\n.ag-body,\n.ag-floating-top,\n.ag-floating-bottom {\n  background-color: var(--ag-data-background-color);\n}\n\n.ag-row-odd {\n  background-color: var(--ag-odd-row-background-color);\n}\n\n.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {\n  border-right: var(--ag-borders-critical) var(--ag-border-color);\n}\n.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {\n  border-left: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-row-selected::before {\n  content: \"\";\n  background-color: var(--ag-selected-row-background-color);\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.ag-row-hover:not(.ag-full-width-row)::before,\n.ag-row-hover.ag-full-width-row.ag-row-group::before {\n  content: \"\";\n  background-color: var(--ag-row-hover-color);\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n}\n\n.ag-row.ag-full-width-row.ag-row-group > * {\n  position: relative;\n}\n\n.ag-row-hover.ag-row-selected::before {\n  background-color: var(--ag-row-hover-color);\n  background-image: linear-gradient(var(--ag-selected-row-background-color), var(--ag-selected-row-background-color));\n}\n\n.ag-column-hover {\n  background-color: var(--ag-column-hover-color);\n}\n\n.ag-header-range-highlight {\n  background-color: var(--ag-range-header-highlight-color);\n}\n\n.ag-ltr .ag-right-aligned-cell {\n  text-align: right;\n}\n.ag-rtl .ag-right-aligned-cell {\n  text-align: left;\n}\n\n.ag-ltr .ag-right-aligned-cell .ag-cell-value,\n.ag-ltr .ag-right-aligned-cell .ag-group-value {\n  margin-left: auto;\n}\n.ag-rtl .ag-right-aligned-cell .ag-cell-value,\n.ag-rtl .ag-right-aligned-cell .ag-group-value {\n  margin-right: auto;\n}\n\n.ag-ltr .ag-right-aligned-cell .ag-skeleton-effect {\n  margin-left: auto;\n}\n.ag-rtl .ag-right-aligned-cell .ag-skeleton-effect {\n  margin-right: auto;\n}\n\n.ag-cell,\n.ag-full-width-row .ag-cell-wrapper.ag-row-group {\n  --ag-internal-calculated-line-height: var(\n      --ag-line-height,\n      calc(var(--ag-row-height) - var(--ag-row-border-width))\n  );\n  --ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width) - 2px);\n  border: 1px solid transparent;\n  line-height: min(var(--ag-internal-calculated-line-height), var(--ag-internal-padded-row-height));\n  padding-left: calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size) * var(--ag-indentation-level));\n  padding-right: calc(var(--ag-cell-horizontal-padding) - 1px);\n  -webkit-font-smoothing: subpixel-antialiased;\n}\n\n.ag-row > .ag-cell-wrapper {\n  padding-left: calc(var(--ag-cell-horizontal-padding) - 1px);\n  padding-right: calc(var(--ag-cell-horizontal-padding) - 1px);\n}\n\n.ag-row-dragging {\n  cursor: move;\n  opacity: 0.5;\n}\n\n.ag-cell-inline-editing {\n  border: 1px solid var(--ag-border-color);\n  border-radius: var(--ag-card-radius);\n  box-shadow: var(--ag-card-shadow);\n  padding: 0;\n  background-color: var(--ag-control-panel-background-color);\n}\n\n.ag-popup-editor .ag-large-text,\n.ag-autocomplete-list-popup {\n  border: var(--ag-borders) var(--ag-border-color);\n  background: var(--ag-background-color);\n  border-radius: var(--ag-card-radius);\n  box-shadow: var(--ag-card-shadow);\n  padding: var(--ag-grid-size);\n  background-color: var(--ag-control-panel-background-color);\n  padding: 0;\n}\n\n.ag-large-text-input {\n  height: auto;\n  padding: var(--ag-cell-horizontal-padding);\n}\n\n.ag-rtl .ag-large-text-input textarea {\n  resize: none;\n}\n\n.ag-details-row {\n  padding: calc(var(--ag-grid-size) * 5);\n  background-color: var(--ag-data-background-color);\n}\n\n.ag-layout-auto-height .ag-center-cols-viewport,\n.ag-layout-auto-height .ag-center-cols-container,\n.ag-layout-print .ag-center-cols-viewport,\n.ag-layout-print .ag-center-cols-container {\n  min-height: 50px;\n}\n\n.ag-overlay-loading-wrapper {\n  background-color: var(--ag-modal-overlay-background-color);\n}\n\n.ag-overlay-loading-center {\n  border: var(--ag-borders) var(--ag-border-color);\n  background: var(--ag-background-color);\n  border-radius: var(--ag-card-radius);\n  box-shadow: var(--ag-card-shadow);\n  padding: var(--ag-grid-size);\n}\n\n.ag-skeleton-container {\n  width: 100%;\n  height: 100%;\n  align-content: center;\n}\n\n.ag-skeleton-effect {\n  background-color: var(--ag-row-loading-skeleton-effect-color);\n  width: 100%;\n  height: 1em;\n  border-radius: 0.25rem;\n  animation: ag-skeleton-loading 1.5s ease-in-out 0.5s infinite;\n}\n\n@keyframes ag-skeleton-loading {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ag-loading {\n  display: flex;\n  height: 100%;\n  align-items: center;\n}\n.ag-ltr .ag-loading {\n  padding-left: var(--ag-cell-horizontal-padding);\n}\n.ag-rtl .ag-loading {\n  padding-right: var(--ag-cell-horizontal-padding);\n}\n\n.ag-ltr .ag-loading-icon {\n  padding-right: var(--ag-cell-widget-spacing);\n}\n.ag-rtl .ag-loading-icon {\n  padding-left: var(--ag-cell-widget-spacing);\n}\n\n.ag-icon-loading {\n  animation-name: spin;\n  animation-duration: 1000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.ag-floating-top:not(.ag-invisible) {\n  border-bottom: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-floating-bottom:not(.ag-invisible) {\n  border-top: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-find-cell {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ag-find-match {\n  color: var(--ag-find-match-color);\n  background-color: var(--ag-find-match-background-color);\n}\n\n.ag-find-active-match {\n  color: var(--ag-find-active-match-color);\n  background-color: var(--ag-find-active-match-background-color);\n}\n\n.ag-ltr .ag-cell {\n  border-right: var(--ag-cell-horizontal-border);\n}\n.ag-rtl .ag-cell {\n  border-left: var(--ag-cell-horizontal-border);\n}\n.ag-ltr .ag-cell {\n  border-right-width: 1px;\n}\n.ag-rtl .ag-cell {\n  border-left-width: 1px;\n}\n\n.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {\n  border-left: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {\n  border-right: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-cell-range-selected:not(.ag-cell-focus),\n.ag-cell-range-selected.ag-cell-range-chart,\n.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {\n  background-color: var(--ag-range-selection-background-color);\n}\n.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,\n.ag-cell-range-selected.ag-cell-range-chart.ag-cell-range-chart,\n.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {\n  background-color: var(--ag-range-selection-chart-background-color) !important;\n}\n.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,\n.ag-cell-range-selected.ag-cell-range-chart.ag-cell-range-chart.ag-cell-range-chart-category,\n.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {\n  background-color: var(--ag-range-selection-chart-category-background-color) !important;\n}\n\n.ag-cell-range-selected-1:not(.ag-cell-focus),\n.ag-cell-range-selected-1.ag-cell-range-chart,\n.ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {\n  background-color: var(--ag-range-selection-background-color);\n}\n\n.ag-cell-range-selected-2:not(.ag-cell-focus),\n.ag-cell-range-selected-2.ag-cell-range-chart,\n.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {\n  background-color: var(--ag-range-selection-background-color-2);\n}\n\n.ag-cell-range-selected-3:not(.ag-cell-focus),\n.ag-cell-range-selected-3.ag-cell-range-chart,\n.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {\n  background-color: var(--ag-range-selection-background-color-3);\n}\n\n.ag-cell-range-selected-4:not(.ag-cell-focus),\n.ag-cell-range-selected-4.ag-cell-range-chart,\n.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {\n  background-color: var(--ag-range-selection-background-color-4);\n}\n\n.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {\n  border-top-color: var(--ag-range-selection-border-color);\n  border-top-style: var(--ag-range-selection-border-style);\n}\n.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {\n  border-right-color: var(--ag-range-selection-border-color);\n  border-right-style: var(--ag-range-selection-border-style);\n}\n.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {\n  border-bottom-color: var(--ag-range-selection-border-color);\n  border-bottom-style: var(--ag-range-selection-border-style);\n}\n.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {\n  border-left-color: var(--ag-range-selection-border-color);\n  border-left-style: var(--ag-range-selection-border-style);\n}\n\n.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,\n.ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,\n.ag-ltr .ag-cell-range-single-cell,\n.ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,\n.ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,\n.ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,\n.ag-rtl .ag-cell-range-single-cell,\n.ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {\n  border: 1px solid;\n  border-color: var(--ag-range-selection-border-color);\n  border-style: var(--ag-range-selection-border-style);\n  outline: initial;\n}\n\n.ag-cell.ag-selection-fill-top,\n.ag-cell.ag-selection-fill-top.ag-cell-range-selected {\n  border-top: 1px dashed;\n  border-top-color: var(--ag-range-selection-border-color);\n}\n\n.ag-ltr .ag-cell.ag-selection-fill-right,\n.ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-right: 1px dashed var(--ag-range-selection-border-color) !important;\n}\n.ag-rtl .ag-cell.ag-selection-fill-right,\n.ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-left: 1px dashed var(--ag-range-selection-border-color) !important;\n}\n\n.ag-cell.ag-selection-fill-bottom,\n.ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {\n  border-bottom: 1px dashed;\n  border-bottom-color: var(--ag-range-selection-border-color);\n}\n\n.ag-ltr .ag-cell.ag-selection-fill-left,\n.ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-left: 1px dashed var(--ag-range-selection-border-color) !important;\n}\n.ag-rtl .ag-cell.ag-selection-fill-left,\n.ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-right: 1px dashed var(--ag-range-selection-border-color) !important;\n}\n\n.ag-fill-handle,\n.ag-range-handle {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  bottom: -1px;\n  background-color: var(--ag-range-selection-border-color);\n}\n.ag-ltr .ag-fill-handle,\n.ag-ltr .ag-range-handle {\n  right: -1px;\n}\n.ag-rtl .ag-fill-handle,\n.ag-rtl .ag-range-handle {\n  left: -1px;\n}\n\n.ag-fill-handle {\n  cursor: crosshair;\n}\n\n.ag-range-handle {\n  cursor: nwse-resize;\n}\n\n.ag-cell-inline-editing {\n  border-color: var(--ag-input-focus-border-color) !important;\n}\n.ag-cell-inline-editing.ag-cell-editing-error {\n  border-color: var(--ag-invalid-color) !important;\n}\n\n.ag-menu {\n  border: var(--ag-borders) var(--ag-border-color);\n  background: var(--ag-background-color);\n  border-radius: var(--ag-card-radius);\n  box-shadow: var(--ag-card-shadow);\n  padding: var(--ag-grid-size);\n  background-color: var(--ag-menu-background-color);\n  border-color: var(--ag-menu-border-color);\n  padding: 0;\n}\n\n.ag-menu.ag-tabs {\n  min-width: var(--ag-tab-min-width);\n}\n\n.ag-menu-list {\n  cursor: default;\n  padding: var(--ag-grid-size) 0;\n}\n\n.ag-menu-separator {\n  height: calc(var(--ag-grid-size) * 2 + 1px);\n}\n\n.ag-menu-separator-part::after {\n  content: \"\";\n  display: block;\n  border-top: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-menu-option {\n  position: relative;\n}\n\n.ag-menu-option:focus-visible {\n  outline: none;\n}\n.ag-menu-option:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-menu-option-active,\n.ag-compact-menu-option-active {\n  background-color: var(--ag-row-hover-color);\n}\n\n.ag-menu-option-part,\n.ag-compact-menu-option-part {\n  line-height: var(--ag-icon-size);\n  padding: calc(var(--ag-grid-size) + 2px) 0;\n}\n\n.ag-menu-option-disabled,\n.ag-compact-menu-option-disabled {\n  opacity: 0.5;\n}\n\n.ag-menu-option-icon,\n.ag-compact-menu-option-icon {\n  width: var(--ag-icon-size);\n}\n.ag-ltr .ag-menu-option-icon,\n.ag-ltr .ag-compact-menu-option-icon {\n  padding-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-menu-option-icon,\n.ag-rtl .ag-compact-menu-option-icon {\n  padding-right: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-menu-option-text,\n.ag-compact-menu-option-text {\n  padding-left: calc(var(--ag-grid-size) * 2);\n  padding-right: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-ltr .ag-menu-option-shortcut,\n.ag-ltr .ag-compact-menu-option-shortcut {\n  padding-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-menu-option-shortcut,\n.ag-rtl .ag-compact-menu-option-shortcut {\n  padding-left: var(--ag-grid-size);\n}\n\n.ag-ltr .ag-menu-option-popup-pointer,\n.ag-ltr .ag-compact-menu-option-popup-pointer {\n  padding-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-menu-option-popup-pointer,\n.ag-rtl .ag-compact-menu-option-popup-pointer {\n  padding-left: var(--ag-grid-size);\n}\n\n.ag-tabs-header {\n  display: flex;\n}\n\n.ag-tabs-header-wrapper {\n  display: flex;\n}\n.ag-tabs-header-wrapper .ag-tabs-header {\n  flex: 1;\n}\n\n.ag-tabs-close-button-wrapper {\n  border: 0;\n  border-right: var(--ag-borders) var(--ag-border-color);\n  padding: var(--ag-grid-size);\n}\n\n.ag-tabs-close-button {\n  border: 0;\n  background-color: unset;\n  cursor: pointer;\n  padding: 0;\n}\n\n.ag-tab {\n  border-bottom: var(--ag-selected-tab-underline-width) solid transparent;\n  transition: border-bottom var(--ag-selected-tab-underline-transition-speed);\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.ag-tab:focus-visible {\n  outline: none;\n}\n.ag-tab:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-tab-selected {\n  border-bottom-color: var(--ag-selected-tab-underline-color);\n}\n\n.ag-menu-header {\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-filter-separator {\n  border-top: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-filter-select .ag-picker-field-wrapper {\n  width: 0;\n}\n\n.ag-filter-condition-operator {\n  height: 17px;\n}\n\n.ag-ltr .ag-filter-condition-operator-or {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-filter-condition-operator-or {\n  margin-right: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-set-filter-select-all {\n  padding-top: var(--ag-widget-container-vertical-padding);\n}\n\n.ag-set-filter-list,\n.ag-filter-no-matches {\n  height: calc(var(--ag-list-item-height) * 6);\n}\n\n.ag-set-filter-tree-list {\n  height: calc(var(--ag-list-item-height) * 10);\n}\n\n.ag-set-filter-filter {\n  margin-top: var(--ag-widget-container-vertical-padding);\n  margin-left: var(--ag-widget-container-horizontal-padding);\n  margin-right: var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-filter-to {\n  margin-top: var(--ag-widget-vertical-spacing);\n}\n\n.ag-mini-filter {\n  margin: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-set-filter {\n  --ag-indentation-level: 0;\n}\n\n.ag-ltr .ag-set-filter-item {\n  padding-left: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));\n}\n.ag-rtl .ag-set-filter-item {\n  padding-right: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));\n}\n\n.ag-ltr .ag-set-filter-add-group-indent {\n  margin-left: calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding));\n}\n.ag-rtl .ag-set-filter-add-group-indent {\n  margin-right: calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding));\n}\n\n.ag-ltr .ag-set-filter-group-icons {\n  margin-right: var(--ag-widget-container-horizontal-padding);\n}\n.ag-rtl .ag-set-filter-group-icons {\n  margin-left: var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-filter-menu .ag-set-filter-list {\n  min-width: 200px;\n}\n\n.ag-filter-virtual-list-item:focus-visible {\n  outline: none;\n}\n.ag-filter-virtual-list-item:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-filter-apply-panel {\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n}\n\n.ag-filter-apply-panel-button {\n  line-height: 1.5;\n}\n.ag-ltr .ag-filter-apply-panel-button {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-filter-apply-panel-button {\n  margin-right: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-simple-filter-body-wrapper {\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));\n  overflow-y: auto;\n  min-height: calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));\n}\n.ag-simple-filter-body-wrapper > * {\n  margin-bottom: var(--ag-widget-vertical-spacing);\n}\n.ag-simple-filter-body-wrapper .ag-resizer-wrapper {\n  margin: 0;\n}\n\n.ag-menu:not(.ag-tabs) .ag-filter .ag-filter-body-wrapper,\n.ag-menu:not(.ag-tabs) .ag-filter > *:not(.ag-filter-wrapper) {\n  min-width: calc(var(--ag-menu-min-width) - 2px);\n}\n\n.ag-filter-no-matches {\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-multi-filter-menu-item {\n  margin: var(--ag-grid-size) 0;\n}\n\n.ag-multi-filter-group-title-bar {\n  padding: calc(var(--ag-grid-size) * 2) var(--ag-grid-size);\n  background-color: transparent;\n}\n\n.ag-group-filter-field-select-wrapper {\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));\n}\n.ag-group-filter-field-select-wrapper > * {\n  margin-bottom: var(--ag-widget-vertical-spacing);\n}\n\n.ag-multi-filter-group-title-bar:focus-visible {\n  outline: none;\n}\n.ag-multi-filter-group-title-bar:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-side-bar {\n  position: relative;\n}\n\n.ag-tool-panel-wrapper {\n  width: var(--ag-side-bar-panel-width);\n  background-color: var(--ag-control-panel-background-color);\n}\n\n.ag-tool-panel-external {\n  display: flex;\n  flex-direction: row;\n}\n\n:where(.ag-tool-panel-external) .ag-tool-panel-wrapper {\n  flex-grow: 1;\n}\n\n.ag-side-buttons {\n  padding-top: calc(var(--ag-grid-size) * 4);\n  width: calc(var(--ag-icon-size) + 4px);\n  position: relative;\n  overflow: hidden;\n}\n\nbutton.ag-side-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  background: transparent;\n  padding: calc(var(--ag-grid-size) * 2) 0 calc(var(--ag-grid-size) * 2) 0;\n  width: 100%;\n  margin: 0;\n  min-height: calc(var(--ag-grid-size) * 18);\n  background-position-y: center;\n  background-position-x: center;\n  background-repeat: no-repeat;\n  border: none;\n  border-top: var(--ag-borders-side-button) var(--ag-border-color);\n  border-bottom: var(--ag-borders-side-button) var(--ag-border-color);\n}\nbutton.ag-side-button-button:focus {\n  box-shadow: none;\n}\n\n.ag-side-button-button:focus-visible {\n  outline: none;\n}\n.ag-side-button-button:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-selected button.ag-side-button-button {\n  background-color: var(--ag-side-button-selected-background-color);\n}\n\n.ag-side-button-icon-wrapper {\n  margin-bottom: 3px;\n}\n\n.ag-ltr .ag-side-bar-left,\n.ag-rtl .ag-side-bar-right {\n  border-right: var(--ag-borders) var(--ag-border-color);\n}\n.ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,\n.ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper {\n  border-left: var(--ag-borders) var(--ag-border-color);\n}\n.ag-ltr .ag-side-bar-left .ag-side-button-button,\n.ag-rtl .ag-side-bar-right .ag-side-button-button {\n  border-right: var(--ag-selected-tab-underline-width) solid transparent;\n  transition: border-right var(--ag-selected-tab-underline-transition-speed);\n}\n.ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-right-color: var(--ag-selected-tab-underline-color);\n}\n\n.ag-rtl .ag-side-bar-left,\n.ag-ltr .ag-side-bar-right {\n  border-left: var(--ag-borders) var(--ag-border-color);\n}\n.ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,\n.ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper {\n  border-right: var(--ag-borders) var(--ag-border-color);\n}\n.ag-rtl .ag-side-bar-left .ag-side-button-button,\n.ag-ltr .ag-side-bar-right .ag-side-button-button {\n  border-left: var(--ag-selected-tab-underline-width) solid transparent;\n  transition: border-left var(--ag-selected-tab-underline-transition-speed);\n}\n.ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-left-color: var(--ag-selected-tab-underline-color);\n}\n\n.ag-filter-toolpanel-header {\n  height: calc(var(--ag-grid-size) * 6);\n}\n\n.ag-filter-toolpanel-header,\n.ag-filter-toolpanel-search {\n  padding: 0 var(--ag-grid-size);\n}\n\n.ag-filter-toolpanel-header:focus-visible {\n  outline: none;\n}\n.ag-filter-toolpanel-header:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-filter-toolpanel-group:not(.ag-has-filter) > .ag-group-title-bar .ag-filter-toolpanel-group-instance-header-icon {\n  display: none;\n}\n\n.ag-filter-toolpanel-group-level-0-header {\n  height: calc(var(--ag-grid-size) * 8);\n}\n\n.ag-filter-toolpanel-group-item {\n  margin-top: calc(var(--ag-grid-size) * 0.5);\n  margin-bottom: calc(var(--ag-grid-size) * 0.5);\n}\n\n.ag-filter-toolpanel-search {\n  height: var(--ag-header-height);\n}\n\n.ag-filter-toolpanel-search-input {\n  flex-grow: 1;\n  height: calc(var(--ag-grid-size) * 4);\n}\n.ag-ltr .ag-filter-toolpanel-search-input {\n  margin-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-filter-toolpanel-search-input {\n  margin-left: var(--ag-grid-size);\n}\n\n.ag-filter-toolpanel-group-level-0 {\n  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n}\n\n.ag-ltr .ag-filter-toolpanel-expand,\n.ag-ltr .ag-filter-toolpanel-group-title-bar-icon {\n  margin-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-filter-toolpanel-expand,\n.ag-rtl .ag-filter-toolpanel-group-title-bar-icon {\n  margin-left: var(--ag-grid-size);\n}\n\n.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n\n.ag-ltr .ag-filter-toolpanel-header {\n  padding-left: calc(var(--ag-filter-tool-panel-group-indent) * var(--ag-indentation-level, 0) + var(--ag-grid-size));\n}\n.ag-rtl .ag-filter-toolpanel-header {\n  padding-right: calc(var(--ag-filter-tool-panel-group-indent) * var(--ag-indentation-level, 0) + var(--ag-grid-size));\n}\n\n.ag-filter-toolpanel-instance-filter {\n  border-bottom: var(--ag-borders) var(--ag-border-color);\n  border-top: var(--ag-borders) var(--ag-border-color);\n  margin-top: var(--ag-grid-size);\n}\n\n.ag-ltr .ag-filter-toolpanel-group-instance-header-icon,\n.ag-ltr .ag-filter-toolpanel-instance-header-icon {\n  margin-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-filter-toolpanel-group-instance-header-icon,\n.ag-rtl .ag-filter-toolpanel-instance-header-icon {\n  margin-right: var(--ag-grid-size);\n}\n\n.ag-set-filter-group-icons {\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-filter-panel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.ag-filter-panel .ag-simple-filter-body-wrapper {\n  padding: var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) 0;\n}\n.ag-filter-panel .ag-mini-filter {\n  margin-top: var(--ag-widget-vertical-spacing);\n  margin-left: var(--ag-widget-container-horizontal-padding);\n  margin-right: var(--ag-widget-container-horizontal-padding);\n}\n.ag-filter-panel .ag-standard-button {\n  transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out;\n}\n.ag-filter-panel .ag-simple-filter-body-wrapper > *:last-child,\n.ag-filter-panel .ag-set-filter-body-wrapper {\n  margin-bottom: var(--ag-widget-container-vertical-padding);\n}\n\n.ag-filter-panel-container {\n  flex: 1;\n  overflow: auto;\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0;\n}\n\n.ag-filter-panel-container > *:not(:last-child) {\n  margin-bottom: var(--ag-widget-container-vertical-padding);\n}\n\n.ag-filter-card {\n  border: 1px solid var(--ag-border-color);\n  border-radius: var(--ag-border-radius);\n  background-color: var(--ag-background-color);\n}\n.ag-ltr .ag-filter-card .ag-set-filter-item {\n  padding-left: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));\n  padding-right: var(--ag-widget-container-horizontal-padding);\n}\n.ag-rtl .ag-filter-card .ag-set-filter-item {\n  padding-right: calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size));\n  padding-left: var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-filter-card-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-top: var(--ag-widget-vertical-spacing);\n}\n.ag-ltr .ag-filter-card-header > *:not(:last-child) {\n  padding-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-filter-card-header > *:not(:last-child) {\n  padding-left: var(--ag-grid-size);\n}\n\n.ag-filter-card-heading {\n  flex: 1;\n  overflow: hidden;\n  padding-top: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));\n  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));\n}\n.ag-ltr .ag-filter-card-heading {\n  padding-left: var(--ag-widget-horizontal-spacing);\n}\n.ag-rtl .ag-filter-card-heading {\n  padding-right: var(--ag-widget-horizontal-spacing);\n}\n\n.ag-filter-card-expand {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ag-filter-card-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ag-filter-card-expand-icon {\n  display: flex;\n  flex: 1;\n  justify-content: end;\n}\n\n.ag-filter-card-editing-icon {\n  margin: 0 var(--ag-grid-size);\n}\n\n.ag-filter-card-summary,\n.ag-filter-card-expand-icon .ag-icon,\n.ag-filter-card-delete-icon .ag-icon,\n.ag-filter-card-editing-icon .ag-icon {\n  color: var(--ag-filter-panel-card-subtle-color);\n}\n\n.ag-filter-card-expand-icon .ag-icon,\n.ag-filter-card-delete-icon .ag-icon {\n  transition: color 0.25s ease-in-out;\n}\n\n.ag-filter-card-expand-icon:hover .ag-icon,\n.ag-filter-card-delete-icon:hover .ag-icon {\n  color: var(--ag-filter-panel-card-subtle-hover-color);\n}\n\n.ag-filter-card-heading:hover .ag-filter-card-expand-icon .ag-icon {\n  color: var(--ag-filter-panel-card-subtle-hover-color);\n}\n\n.ag-filter-card-expand,\n.ag-filter-card-delete {\n  border-radius: var(--ag-button-border-radius);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.ag-filter-panel .ag-standard-button {\n  cursor: pointer;\n}\n\n.ag-filter-card-summary,\n.ag-filter-type-select {\n  margin-left: var(--ag-widget-container-horizontal-padding);\n  margin-right: var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-ltr .ag-filter-card-delete {\n  margin-right: var(--ag-widget-horizontal-spacing);\n}\n.ag-rtl .ag-filter-card-delete {\n  margin-left: var(--ag-widget-horizontal-spacing);\n}\n\n.ag-filter-card-summary {\n  margin-bottom: var(--ag-widget-container-vertical-padding);\n}\n\n.ag-filter-type-select {\n  padding-top: var(--ag-widget-vertical-spacing);\n}\n\n.ag-filter-card-add {\n  padding: 0;\n  border: 0;\n}\n\n.ag-filter-add-button {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  line-height: 1.5;\n}\n\n.ag-ltr .ag-filter-add-button-label {\n  margin-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-filter-add-button-label {\n  margin-right: var(--ag-grid-size);\n}\n\n.ag-filter-add-select {\n  border: 0;\n}\n.ag-ltr .ag-filter-add-select .ag-text-field-input {\n  padding-left: calc(var(--ag-grid-size) * 1.5 + 12px) !important;\n}\n.ag-rtl .ag-filter-add-select .ag-text-field-input {\n  padding-right: calc(var(--ag-grid-size) * 1.5 + 12px) !important;\n}\n.ag-filter-add-select .ag-rich-select-value {\n  padding: calc((1.5 * var(--ag-font-size) + 4 * var(--ag-grid-size) - var(--ag-input-height)) / 2) var(--ag-grid-size);\n  border: 0;\n}\n\n.ag-pivot-mode-panel {\n  min-height: var(--ag-header-height);\n  height: var(--ag-header-height);\n  display: flex;\n}\n\n.ag-pivot-mode-select {\n  display: flex;\n  align-items: center;\n}\n.ag-ltr .ag-pivot-mode-select {\n  margin-left: var(--ag-widget-container-horizontal-padding);\n}\n.ag-rtl .ag-pivot-mode-select {\n  margin-right: var(--ag-widget-container-horizontal-padding);\n}\n\n.ag-column-select-header:focus-visible {\n  outline: none;\n}\n.ag-column-select-header:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-column-select-header {\n  height: var(--ag-header-height);\n  align-items: center;\n  padding: 0 var(--ag-widget-container-horizontal-padding);\n  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n}\n\n.ag-column-panel-column-select {\n  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n}\n\n.ag-column-group-icons,\n.ag-column-select-header-icon {\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-column-select-list .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n}\n.ag-column-select-list .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-column-select-list .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n\n.ag-header,\n.ag-advanced-filter-header {\n  background-color: var(--ag-header-background-color);\n  border-bottom: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-header-row {\n  color: var(--ag-header-foreground-color);\n  height: var(--ag-header-height);\n}\n\n.ag-pinned-right-header {\n  border-left: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-pinned-left-header {\n  border-right: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,\n.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon {\n  margin-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,\n.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon {\n  margin-right: var(--ag-grid-size);\n}\n\n.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,\n.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon {\n  margin-right: var(--ag-grid-size);\n}\n.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,\n.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon {\n  margin-left: var(--ag-grid-size);\n}\n\n.ag-header-cell,\n.ag-header-group-cell {\n  padding-left: var(--ag-cell-horizontal-padding);\n  padding-right: var(--ag-cell-horizontal-padding);\n}\n.ag-header-cell.ag-header-cell-moving,\n.ag-header-group-cell.ag-header-cell-moving {\n  background-color: var(--ag-header-cell-moving-background-color);\n}\n\n.ag-ltr .ag-header-group-cell-label.ag-sticky-label {\n  left: var(--ag-cell-horizontal-padding);\n}\n.ag-rtl .ag-header-group-cell-label.ag-sticky-label {\n  right: var(--ag-cell-horizontal-padding);\n}\n\n.ag-header-cell:focus-visible {\n  outline: none;\n}\n.ag-header-cell:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-header-group-cell:focus-visible {\n  outline: none;\n}\n.ag-header-group-cell:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-advanced-filter-header-cell:focus-visible {\n  outline: none;\n}\n.ag-advanced-filter-header-cell:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-header-icon {\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-header-expand-icon {\n  cursor: pointer;\n}\n.ag-ltr .ag-header-expand-icon {\n  margin-left: 4px;\n}\n.ag-rtl .ag-header-expand-icon {\n  margin-right: 4px;\n}\n\n.ag-header-row:not(:first-child) .ag-header-cell:not(.ag-header-span-height.ag-header-span-total, .ag-header-parent-hidden),\n.ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {\n  border-top: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover, .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell:not(.ag-column-hover).ag-column-resizing,\n.ag-header-cell:not(.ag-column-resizing) + .ag-header-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover,\n.ag-header-cell:not(.ag-column-resizing) + .ag-header-cell:not(.ag-column-hover).ag-column-resizing,\n.ag-header-group-cell:first-of-type:not(.ag-header-cell-moving):hover,\n.ag-header-group-cell:first-of-type.ag-column-resizing,\n.ag-header-cell:not(.ag-column-hover):first-of-type:not(.ag-header-cell-moving):hover,\n.ag-header-cell:not(.ag-column-hover):first-of-type.ag-column-resizing {\n  background-color: var(--ag-header-cell-hover-background-color);\n}\n\n.ag-header-cell::before,\n.ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group)::before {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  display: var(--ag-header-column-separator-display);\n  width: var(--ag-header-column-separator-width);\n  height: var(--ag-header-column-separator-height);\n  top: calc(50% - var(--ag-header-column-separator-height) * 0.5);\n  background-color: var(--ag-header-column-separator-color);\n}\n.ag-ltr .ag-header-cell::before,\n.ag-ltr .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group)::before {\n  right: 0;\n}\n.ag-rtl .ag-header-cell::before,\n.ag-rtl .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group)::before {\n  left: 0;\n}\n\n.ag-header-highlight-before::after,\n.ag-header-highlight-after::after {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 1px;\n}\n\n.ag-header-highlight-before::after {\n  left: 0px;\n}\n\n.ag-header-highlight-after::after {\n  right: 0px;\n}\n\n.ag-pinned-left-header .ag-header-highlight-after::after {\n  right: 1px;\n}\n\n.ag-header-cell-resize {\n  display: flex;\n  align-items: center;\n}\n\n.ag-header-cell-resize::after {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  display: var(--ag-header-column-resize-handle-display);\n  width: var(--ag-header-column-resize-handle-width);\n  height: var(--ag-header-column-resize-handle-height);\n  top: calc(50% - var(--ag-header-column-resize-handle-height) * 0.5);\n  background-color: var(--ag-header-column-resize-handle-color);\n}\n.ag-header-cell.ag-header-span-height .ag-header-cell-resize::after {\n  height: calc(100% - var(--ag-grid-size) * 4);\n  top: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-ltr .ag-header-viewport .ag-header-cell-resize::after {\n  left: calc(50% - var(--ag-header-column-resize-handle-width));\n}\n.ag-rtl .ag-header-viewport .ag-header-cell-resize::after {\n  right: calc(50% - var(--ag-header-column-resize-handle-width));\n}\n\n.ag-pinned-left-header .ag-header-cell-resize::after {\n  left: calc(50% - var(--ag-header-column-resize-handle-width));\n}\n\n.ag-pinned-right-header .ag-header-cell-resize::after {\n  left: 50%;\n}\n\n.ag-ltr .ag-header-select-all {\n  margin-right: var(--ag-cell-horizontal-padding);\n}\n.ag-rtl .ag-header-select-all {\n  margin-left: var(--ag-cell-horizontal-padding);\n}\n\n.ag-ltr .ag-floating-filter-button {\n  margin-left: var(--ag-cell-widget-spacing);\n}\n.ag-rtl .ag-floating-filter-button {\n  margin-right: var(--ag-cell-widget-spacing);\n}\n\n.ag-floating-filter-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  appearance: none;\n  background: transparent;\n  border: none;\n  height: var(--ag-icon-size);\n  padding: 0;\n  width: var(--ag-icon-size);\n}\n\n.ag-filter-loading {\n  background-color: var(--ag-control-panel-background-color);\n  height: 100%;\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n  align-items: unset;\n}\n\n.ag-paging-panel {\n  border-top: 1px solid;\n  border-top-color: var(--ag-border-color);\n  color: var(--ag-secondary-foreground-color);\n  height: var(--ag-pagination-panel-height);\n}\n.ag-paging-panel > * {\n  margin: 0 var(--ag-cell-horizontal-padding);\n}\n.ag-paging-panel > .ag-paging-page-size .ag-wrapper {\n  min-width: calc(var(--ag-grid-size) * 10);\n}\n\n.ag-paging-button {\n  cursor: pointer;\n}\n\n.ag-paging-button.ag-disabled {\n  cursor: default;\n  color: var(--ag-disabled-foreground-color);\n}\n\n.ag-paging-button:focus-visible {\n  outline: none;\n}\n.ag-paging-button:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-paging-button,\n.ag-paging-description {\n  margin: 0 var(--ag-grid-size);\n}\n\n.ag-status-bar {\n  border-top: var(--ag-borders) var(--ag-border-color);\n  color: var(--ag-disabled-foreground-color);\n  padding-right: calc(var(--ag-grid-size) * 4);\n  padding-left: calc(var(--ag-grid-size) * 4);\n  line-height: 1.5;\n}\n\n.ag-status-name-value-value {\n  color: var(--ag-foreground-color);\n}\n\n.ag-status-bar-center {\n  text-align: center;\n}\n\n.ag-status-name-value {\n  margin-left: var(--ag-grid-size);\n  margin-right: var(--ag-grid-size);\n  padding-top: calc(var(--ag-grid-size) * 2);\n  padding-bottom: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-column-drop-cell {\n  background: var(--ag-chip-background-color);\n  border-radius: calc(var(--ag-grid-size) * 4);\n  height: calc(var(--ag-grid-size) * 4);\n  padding: 0 calc(var(--ag-grid-size) * 0.5);\n  border: 1px solid var(--ag-chip-border-color);\n}\n\n.ag-column-drop-cell:focus-visible {\n  outline: none;\n}\n.ag-column-drop-cell:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 2px;\n  left: 2px;\n  display: block;\n  width: calc(100% - 4px);\n  height: calc(100% - 4px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-column-drop-cell-text {\n  margin: 0 var(--ag-grid-size);\n}\n\n.ag-column-drop-cell-button {\n  min-width: calc(var(--ag-grid-size) * 4);\n  margin: 0 calc(var(--ag-grid-size) * 0.5);\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-column-drop-cell-drag-handle {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-column-drop-cell-ghost {\n  opacity: 0.5;\n}\n\n.ag-column-drop-horizontal {\n  background-color: var(--ag-header-background-color);\n  color: var(--ag-secondary-foreground-color);\n  height: var(--ag-header-height);\n  border-bottom: var(--ag-borders) var(--ag-border-color);\n}\n.ag-ltr .ag-column-drop-horizontal {\n  padding-left: var(--ag-cell-horizontal-padding);\n}\n.ag-rtl .ag-column-drop-horizontal {\n  padding-right: var(--ag-cell-horizontal-padding);\n}\n\n.ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child) {\n  border-right: var(--ag-borders) var(--ag-border-color);\n}\n.ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child) {\n  border-left: var(--ag-borders) var(--ag-border-color);\n}\n\n.ag-column-drop-horizontal-cell-separator {\n  margin: 0 var(--ag-grid-size);\n  color: var(--ag-secondary-foreground-color);\n}\n\n.ag-column-drop-horizontal-empty-message {\n  color: var(--ag-disabled-foreground-color);\n}\n\n.ag-ltr .ag-column-drop-horizontal-icon {\n  margin-right: var(--ag-cell-horizontal-padding);\n}\n.ag-rtl .ag-column-drop-horizontal-icon {\n  margin-left: var(--ag-cell-horizontal-padding);\n}\n\n.ag-column-drop-vertical-list {\n  padding-bottom: var(--ag-grid-size);\n  padding-right: var(--ag-grid-size);\n  padding-left: var(--ag-grid-size);\n}\n\n.ag-column-drop-vertical-cell {\n  margin-top: var(--ag-grid-size);\n}\n\n.ag-column-drop-vertical {\n  min-height: 50px;\n  border-bottom: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n}\n.ag-column-drop-vertical.ag-last-column-drop {\n  border-bottom: none;\n}\n\n.ag-column-drop-vertical-icon {\n  margin-left: var(--ag-grid-size);\n  margin-right: var(--ag-grid-size);\n}\n\n.ag-column-drop-vertical-empty-message {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  color: var(--ag-disabled-foreground-color);\n  margin-top: var(--ag-grid-size);\n}\n\n.ag-select-agg-func-popup {\n  border: var(--ag-borders) var(--ag-border-color);\n  background: var(--ag-background-color);\n  border-radius: var(--ag-card-radius);\n  box-shadow: var(--ag-card-shadow);\n  padding: var(--ag-grid-size);\n  background: var(--ag-background-color);\n  height: calc(var(--ag-grid-size) * 5 * 3.5);\n  padding: 0;\n}\n\n.ag-select-agg-func-virtual-list-item {\n  cursor: default;\n}\n.ag-ltr .ag-select-agg-func-virtual-list-item {\n  padding-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-select-agg-func-virtual-list-item {\n  padding-right: calc(var(--ag-grid-size) * 2);\n}\n.ag-select-agg-func-virtual-list-item:hover {\n  background-color: var(--ag-selected-row-background-color);\n}\n\n.ag-select-agg-func-virtual-list-item:focus-visible {\n  outline: none;\n}\n.ag-select-agg-func-virtual-list-item:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-sort-indicator-container {\n  display: flex;\n}\n\n.ag-ltr .ag-sort-indicator-icon {\n  padding-left: var(--ag-grid-size);\n}\n.ag-rtl .ag-sort-indicator-icon {\n  padding-right: var(--ag-grid-size);\n}\n\n.ag-chart {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.ag-chart-components-wrapper {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n}\n\n.ag-chart-canvas-wrapper {\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.ag-chart-menu {\n  position: absolute;\n  top: 16px;\n  display: flex;\n  flex-direction: column;\n}\n.ag-ltr .ag-chart-menu {\n  right: 20px;\n}\n.ag-rtl .ag-chart-menu {\n  left: 20px;\n}\n\n.ag-chart-docked-container {\n  position: relative;\n  min-width: var(--ag-chart-menu-panel-width);\n}\n\n.ag-chart-menu-hidden ~ .ag-chart-docked-container {\n  display: none;\n}\n\n.ag-chart-tabbed-menu {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.ag-chart-tabbed-menu-header {\n  flex: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: default;\n}\n\n.ag-chart-tabbed-menu-body {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: stretch;\n  overflow: hidden;\n}\n\n.ag-chart-tab {\n  width: 100%;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.ag-chart-settings {\n  overflow-x: hidden;\n}\n\n.ag-chart-settings-wrapper {\n  position: relative;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  overflow: hidden;\n}\n\n.ag-chart-settings-nav-bar {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 30px;\n  padding: 0 10px;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ag-chart-settings-card-selector {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex: 1 1 auto;\n  height: 100%;\n  padding: 0 10px;\n}\n\n.ag-chart-settings-card-item {\n  cursor: pointer;\n  width: 10px;\n  height: 10px;\n  background-color: #000;\n  position: relative;\n}\n.ag-chart-settings-card-item.ag-not-selected {\n  opacity: 0.2;\n}\n.ag-chart-settings-card-item::before {\n  content: \" \";\n  display: block;\n  position: absolute;\n  background-color: transparent;\n  left: 50%;\n  top: 50%;\n  margin-left: -10px;\n  margin-top: -10px;\n  width: 20px;\n  height: 20px;\n}\n\n.ag-chart-settings-prev,\n.ag-chart-settings-next {\n  position: relative;\n  flex: none;\n}\n.ag-chart-settings-prev:focus-within,\n.ag-chart-settings-next:focus-within {\n  box-shadow: var(--ag-input-focus-box-shadow);\n  border-radius: 1px;\n}\n\n.ag-chart-settings-prev-button,\n.ag-chart-settings-next-button {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.ag-chart-settings-mini-charts-container {\n  position: relative;\n  flex: 1 1 auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ag-chart-settings-mini-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100%;\n  overflow: hidden;\n}\n.ag-chart-settings-mini-wrapper.ag-animating {\n  transition: left 0.3s;\n  transition-timing-function: ease-in-out;\n}\n\n.ag-chart-mini-thumbnail {\n  cursor: pointer;\n}\n\n.ag-chart-mini-thumbnail-canvas {\n  display: block;\n}\n\n.ag-chart-data-wrapper,\n.ag-chart-format-wrapper,\n.ag-chart-advanced-settings-wrapper {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  padding-bottom: 16px;\n}\n\n.ag-chart-data-wrapper,\n.ag-chart-advanced-settings-wrapper {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.ag-chart-advanced-settings {\n  background-color: var(--ag-control-panel-background-color);\n}\n\n.ag-chart-advanced-settings-wrapper,\n.ag-chart-advanced-settings {\n  width: 100%;\n}\n\n.ag-chart-advanced-settings-wrapper {\n  padding-bottom: 0;\n}\n\n.ag-chart-data-section,\n.ag-chart-format-section,\n.ag-chart-advanced-settings-section {\n  display: flex;\n  margin: 0;\n}\n\n.ag-chart-advanced-settings-section {\n  padding-top: var(--ag-grid-size);\n  padding-bottom: var(--ag-grid-size);\n}\n.ag-chart-advanced-settings-section:not(:last-child) {\n  border-bottom: 1px solid var(--ag-secondary-border-color);\n}\n\n.ag-chart-empty-text {\n  display: flex;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--ag-background-color);\n}\n\n.ag-chart .ag-chart-menu-wrapper .ag-chart-menu {\n  display: flex;\n  flex-direction: row;\n  top: 8px;\n  gap: 20px;\n  width: auto;\n}\n.ag-ltr .ag-chart .ag-chart-menu-wrapper .ag-chart-menu {\n  right: calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);\n  justify-content: right;\n}\n.ag-rtl .ag-chart .ag-chart-menu-wrapper .ag-chart-menu {\n  left: calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);\n  justify-content: left;\n}\n\n.ag-charts-font-size-color {\n  display: flex;\n  align-self: stretch;\n  justify-content: space-between;\n}\n\n.ag-charts-data-group-item {\n  position: relative;\n}\n\n.ag-charts-data-group-item:not(:last-child) {\n  margin-bottom: var(--ag-grid-size);\n}\n\n.ag-chart-menu {\n  border-radius: var(--ag-card-radius);\n  background: var(--ag-background-color);\n}\n\n.ag-chart-menu-icon {\n  opacity: 0.5;\n  margin: 2px 0;\n  cursor: pointer;\n  border-radius: var(--ag-card-radius);\n  color: var(--ag-secondary-foreground-color);\n}\n.ag-chart-menu-icon:hover {\n  opacity: 1;\n}\n\n.ag-chart-menu-toolbar-button {\n  border: 0;\n  background-color: unset;\n  padding: 0 2px;\n  border-radius: 1px;\n}\n\n.ag-chart-mini-thumbnail {\n  border: 1px solid var(--ag-secondary-border-color);\n  border-radius: 5px;\n  padding: 1px;\n}\n.ag-chart-mini-thumbnail.ag-selected {\n  border-color: var(--ag-minichart-selected-chart-color);\n  border-width: 2px;\n  padding: unset;\n}\n.ag-chart-mini-thumbnail:focus-visible {\n  outline: none;\n  border-color: var(--ag-minichart-selected-chart-color);\n  box-shadow: var(--ag-input-focus-box-shadow);\n}\n\n.ag-chart-settings-card-item {\n  background: var(--ag-foreground-color);\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n}\n.ag-chart-settings-card-item.ag-selected {\n  background-color: var(--ag-minichart-selected-page-color);\n}\n\n.ag-chart-data-column-drag-handle {\n  margin-left: var(--ag-grid-size);\n}\n\n.ag-charts-settings-group-title-bar,\n.ag-charts-data-group-title-bar,\n.ag-charts-format-top-level-group-title-bar {\n  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n  position: relative;\n}\n\n.ag-charts-advanced-settings-top-level-group-title-bar {\n  position: relative;\n  background-color: unset;\n}\n\n.ag-charts-data-group-title-bar:focus-visible {\n  outline: none;\n}\n.ag-charts-data-group-title-bar:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-charts-format-top-level-group-title-bar:focus-visible {\n  outline: none;\n}\n.ag-charts-format-top-level-group-title-bar:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-charts-data-group-title-bar .ag-charts-data-group-title,\n.ag-charts-format-top-level-group-title-bar .ag-charts-format-top-level-group-title {\n  cursor: pointer;\n}\n\n.ag-charts-data-group-container {\n  padding: calc(var(--ag-widget-container-vertical-padding) * 0.5) var(--ag-widget-container-horizontal-padding);\n}\n.ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group):not(.ag-pill-select):not(.ag-select) {\n  height: var(--ag-list-item-height);\n}\n.ag-charts-data-group-container .ag-charts-data-group-item.ag-picker-field {\n  margin-top: var(--ag-grid-size);\n}\n.ag-charts-data-group-container .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n}\n.ag-charts-data-group-container .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-charts-data-group-container .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n\n.ag-charts-format-top-level-group-container,\n.ag-charts-advanced-settings-top-level-group-container {\n  padding: var(--ag-grid-size);\n}\n.ag-ltr .ag-charts-format-top-level-group-container,\n.ag-ltr .ag-charts-advanced-settings-top-level-group-container {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-charts-format-top-level-group-container,\n.ag-rtl .ag-charts-advanced-settings-top-level-group-container {\n  margin-right: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-charts-format-top-level-group-item,\n.ag-charts-advanced-settings-top-level-group-item {\n  margin: var(--ag-grid-size) 0;\n}\n\n.ag-charts-format-sub-level-group-container {\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n  padding-bottom: calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));\n}\n.ag-charts-format-sub-level-group-container > * {\n  margin-bottom: var(--ag-widget-vertical-spacing);\n}\n\n.ag-charts-format-sub-level-no-header-group-container > * {\n  margin-bottom: var(--ag-widget-vertical-spacing);\n}\n\n.ag-charts-format-sub-level-group-container .ag-charts-format-sub-level-group-item.ag-font-panel-no-header {\n  margin: 0;\n}\n\n.ag-charts-settings-group-container {\n  padding: var(--ag-grid-size);\n  row-gap: 8px;\n  display: grid;\n  grid-template-columns: 60px 1fr 60px 1fr 60px;\n}\n.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+1) {\n  grid-column: 1;\n}\n.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+2) {\n  grid-column: 3;\n}\n.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+3) {\n  grid-column: 5;\n}\n\n.ag-chart-menu-panel {\n  background-color: var(--ag-control-panel-background-color);\n}\n.ag-ltr .ag-chart-menu-panel {\n  border-left: solid 1px var(--ag-border-color);\n}\n.ag-rtl .ag-chart-menu-panel {\n  border-right: solid 1px var(--ag-border-color);\n}\n\n.ag-date-time-list-page-title-bar {\n  display: flex;\n}\n\n.ag-date-time-list-page-title {\n  flex-grow: 1;\n  text-align: center;\n}\n\n.ag-date-time-list-page-column-labels-row,\n.ag-date-time-list-page-entries-row {\n  display: flex;\n}\n\n.ag-date-time-list-page-column-label,\n.ag-date-time-list-page-entry {\n  flex-basis: 0;\n  flex-grow: 1;\n}\n\n.ag-date-time-list-page-entry {\n  cursor: pointer;\n  text-align: center;\n}\n\n.ag-date-time-list-page-column-label {\n  text-align: center;\n}\n\n.ag-advanced-filter-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding-left: var(--ag-cell-horizontal-padding);\n  padding-right: var(--ag-cell-horizontal-padding);\n}\n\n.ag-advanced-filter {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.ag-advanced-filter-buttons {\n  display: contents;\n}\n\n.ag-advanced-filter-builder-button {\n  display: flex;\n  align-items: center;\n  border: 0;\n  background-color: unset;\n  color: var(--ag-foreground-color);\n  font-size: var(--ag-font-size);\n  font-weight: 600;\n  line-height: normal;\n  white-space: nowrap;\n}\n.ag-ltr .ag-advanced-filter-builder-button {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-rtl .ag-advanced-filter-builder-button {\n  margin-right: calc(var(--ag-grid-size) * 2);\n}\n.ag-advanced-filter-builder-button:hover:not(:disabled) {\n  background-color: var(--ag-row-hover-color);\n}\n.ag-advanced-filter-builder-button:not(:disabled) {\n  cursor: pointer;\n}\n\n.ag-advanced-filter-builder-button-label {\n  margin-left: var(--ag-grid-size);\n}\n\n.ag-advanced-filter-builder {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 100%;\n  background-color: var(--ag-control-panel-background-color);\n  display: flex;\n  flex-direction: column;\n}\n\n.ag-advanced-filter-builder-list {\n  flex: 1;\n  overflow: auto;\n}\n.ag-advanced-filter-builder-list .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n}\n.ag-advanced-filter-builder-list .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-advanced-filter-builder-list .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n\n.ag-advanced-filter-builder-button-panel {\n  display: flex;\n  justify-content: flex-end;\n  padding: var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);\n  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n}\n\n.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-apply-button,\n.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-cancel-button {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n\n.ag-advanced-filter-builder-item-wrapper {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n  padding-left: calc(var(--ag-icon-size) / 2);\n  padding-right: var(--ag-icon-size);\n}\n\n.ag-virtual-list-viewport .ag-advanced-filter-builder-item-wrapper .ag-tab-guard {\n  position: absolute;\n}\n\n.ag-advanced-filter-builder-item-tree-lines > * {\n  width: var(--ag-advanced-filter-builder-indent-size);\n}\n\n.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root {\n  width: var(--ag-icon-size);\n}\n.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root::before {\n  top: 50%;\n  height: 50%;\n}\n\n.ag-advanced-filter-builder-item-tree-line-horizontal,\n.ag-advanced-filter-builder-item-tree-line-vertical,\n.ag-advanced-filter-builder-item-tree-line-vertical-top,\n.ag-advanced-filter-builder-item-tree-line-vertical-bottom {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.ag-advanced-filter-builder-item-tree-line-horizontal::before, .ag-advanced-filter-builder-item-tree-line-horizontal::after,\n.ag-advanced-filter-builder-item-tree-line-vertical::before,\n.ag-advanced-filter-builder-item-tree-line-vertical::after,\n.ag-advanced-filter-builder-item-tree-line-vertical-top::before,\n.ag-advanced-filter-builder-item-tree-line-vertical-top::after,\n.ag-advanced-filter-builder-item-tree-line-vertical-bottom::before,\n.ag-advanced-filter-builder-item-tree-line-vertical-bottom::after {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n}\n\n.ag-advanced-filter-builder-item-tree-line-horizontal::after {\n  height: 50%;\n  width: calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size));\n  top: 0;\n  left: calc(var(--ag-icon-size) / 2);\n  border-bottom: 1px solid;\n  border-color: var(--ag-border-color);\n}\n\n.ag-advanced-filter-builder-item-tree-line-vertical::before {\n  width: calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);\n  top: 0;\n  left: calc(var(--ag-icon-size) / 2);\n  border-left: 1px solid;\n  border-color: var(--ag-border-color);\n}\n\n.ag-advanced-filter-builder-item-tree-line-vertical-top::before {\n  height: 50%;\n  width: calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);\n  top: 0;\n  left: calc(var(--ag-icon-size) / 2);\n  border-left: 1px solid;\n  border-color: var(--ag-border-color);\n}\n\n.ag-advanced-filter-builder-item-tree-line-vertical-bottom::before {\n  height: calc((100% - 1.5 * var(--ag-icon-size)) / 2);\n  width: calc(var(--ag-icon-size) / 2);\n  top: calc((100% + 1.5 * var(--ag-icon-size)) / 2);\n  left: calc(var(--ag-icon-size) / 2);\n  border-left: 1px solid;\n  border-color: var(--ag-border-color);\n}\n\n.ag-advanced-filter-builder-item-condition {\n  padding-top: var(--ag-grid-size);\n  padding-bottom: var(--ag-grid-size);\n}\n\n.ag-advanced-filter-builder-item,\n.ag-advanced-filter-builder-item-condition,\n.ag-advanced-filter-builder-pill-wrapper,\n.ag-advanced-filter-builder-pill,\n.ag-advanced-filter-builder-item-buttons,\n.ag-advanced-filter-builder-item-tree-lines {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.ag-advanced-filter-builder-pill-wrapper {\n  margin: 0px var(--ag-grid-size);\n}\n\n.ag-advanced-filter-builder-pill {\n  position: relative;\n  border-radius: var(--ag-border-radius);\n  padding: var(--ag-grid-size) calc(var(--ag-grid-size) * 2);\n  min-height: calc(100% - var(--ag-grid-size) * 3);\n  min-width: calc(var(--ag-grid-size) * 2);\n}\n.ag-advanced-filter-builder-pill .ag-picker-field-display {\n  margin-right: var(--ag-grid-size);\n}\n.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-number {\n  font-family: monospace;\n  font-weight: 700;\n}\n.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-empty {\n  color: var(--ag-disabled-foreground-color);\n}\n\n.ag-advanced-filter-builder-pill:focus-visible {\n  outline: none;\n}\n.ag-advanced-filter-builder-pill:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: -4px;\n  left: -4px;\n  display: block;\n  width: calc(100% - -8px);\n  height: calc(100% - -8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-advanced-filter-builder-item-button:focus-visible {\n  outline: none;\n}\n.ag-advanced-filter-builder-item-button:focus-visible::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: -4px;\n  left: -4px;\n  display: block;\n  width: calc(100% - -8px);\n  height: calc(100% - -8px);\n  border: 1px solid;\n  border-color: var(--ag-input-focus-border-color);\n}\n\n.ag-advanced-filter-builder-pill-display {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.ag-advanced-filter-builder-join-pill {\n  color: var(--ag-foreground-color);\n  background-color: var(--ag-advanced-filter-join-pill-color);\n  cursor: pointer;\n}\n\n.ag-advanced-filter-builder-column-pill {\n  color: var(--ag-foreground-color);\n  background-color: var(--ag-advanced-filter-column-pill-color);\n  cursor: pointer;\n}\n\n.ag-advanced-filter-builder-option-pill {\n  color: var(--ag-foreground-color);\n  background-color: var(--ag-advanced-filter-option-pill-color);\n  cursor: pointer;\n}\n\n.ag-advanced-filter-builder-value-pill {\n  color: var(--ag-foreground-color);\n  background-color: var(--ag-advanced-filter-value-pill-color);\n  cursor: text;\n  max-width: 140px;\n}\n.ag-advanced-filter-builder-value-pill .ag-advanced-filter-builder-pill-display {\n  display: block;\n}\n\n.ag-advanced-filter-builder-item-buttons > * {\n  margin: 0 calc(var(--ag-grid-size) * 0.5);\n}\n\n.ag-advanced-filter-builder-item-button {\n  position: relative;\n  cursor: pointer;\n  color: var(--ag-secondary-foreground-color);\n  opacity: 50%;\n}\n\n.ag-advanced-filter-builder-item-button-disabled {\n  color: var(--ag-disabled-foreground-color);\n  cursor: default;\n}\n\n.ag-advanced-filter-builder-virtual-list-container {\n  top: var(--ag-grid-size);\n}\n\n.ag-advanced-filter-builder-virtual-list-item {\n  display: flex;\n  cursor: default;\n  height: var(--ag-list-item-height);\n}\n.ag-advanced-filter-builder-virtual-list-item:hover {\n  background-color: var(--ag-row-hover-color);\n}\n.ag-advanced-filter-builder-virtual-list-item:hover .ag-advanced-filter-builder-item-button {\n  opacity: 100%;\n}\n\n.ag-advanced-filter-builder-virtual-list-item-highlight .ag-advanced-filter-builder-item-button:focus-visible,\n.ag-advanced-filter-builder-validation .ag-advanced-filter-builder-invalid {\n  opacity: 100%;\n}\n\n.ag-advanced-filter-builder-invalid {\n  margin: 0 var(--ag-grid-size);\n  color: var(--ag-invalid-color);\n  cursor: default;\n}\n\n.ag-row-number-cell {\n  background-color: var(--ag-header-background-color);\n  color: var(--ag-header-foreground-color);\n  font-size: var(--ag-font-size);\n  font-family: var(--ag-font-family);\n}\n\n.ag-row-number-header.ag-row-number-selection-enabled {\n  cursor: cell;\n}\n\n.ag-row-number-range-highlight {\n  background-color: var(--ag-range-header-highlight-color);\n}\n\n.ag-row-number-range-selected {\n  background-color: var(--ag-row-numbers-selected-color);\n}\n\n.ag-ltr .ag-row-number-header,\n.ag-ltr .ag-cell.ag-row-number-cell:not(.ag-cell-last-left-pinned) {\n  border-right: var(--ag-pinned-column-border);\n}\n.ag-ltr .ag-cell.ag-row-number-cell.ag-row-number-selection-enabled {\n  cursor: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjU7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEuNTc4NCwwLDAsMS44NjQyOSwtNC40MTM0OSwtNy4yMTIxMikiPgogICAgICAgIDxwYXRoIGQ9Ik0zLjQ0NSw4LjkxMUwzLjQ0NSw3LjQwOUw5Ljc1LDcuNDA5TDkuNzUsNi4wMTRMMTIuMjg1LDguMTZMOS43NSwxMC4zMDZMOS43NSw4LjkxMUwzLjQ0NSw4LjkxMVoiIHN0eWxlPSJzdHJva2U6d2hpdGU7c3Ryb2tlLXdpZHRoOjAuNDFweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==\"), auto;\n}\n\n.ag-rtl .ag-row-number-header,\n.ag-rtl .ag-cell.ag-row-number-cell:not(.ag-cell-first-right-pinned) {\n  border-left: var(--ag-pinned-column-border);\n}\n.ag-rtl .ag-cell.ag-row-number-cell.ag-row-number-selection-enabled {\n  cursor: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjU7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEuNTc4NCwwLDAsMS44NjQyOSwtNC40MTM0OSwtNy4yMTIxMikiPgogICAgICAgIDxwYXRoIGQ9Ik01Ljk3OSw4LjkxMUw1Ljk3OSwxMC4zMDZMMy40NDUsOC4xNkw1Ljk3OSw2LjAxNEw1Ljk3OSw3LjQwOUwxMi4yODUsNy40MDlMMTIuMjg1LDguOTExTDUuOTc5LDguOTExWiIgc3R5bGU9InN0cm9rZTp3aGl0ZTtzdHJva2Utd2lkdGg6MC40MXB4OyIvPgogICAgPC9nPgo8L3N2Zz4K\"), auto;\n}\n\n.ag-cell-batch-edit {\n  background-color: var(--ag-cell-batch-edit-background-color);\n  color: var(--ag-cell-batch-edit-text-color);\n}\n\n.ag-cell.ag-cell-inline-editing {\n  background-color: var(--ag-background-color);\n  background-image: linear-gradient(0deg, var(--ag-input-background-color), var(--ag-input-background-color));\n}\n\n.ag-row-batch-edit {\n  background-color: var(--ag-row-batch-edit-background-color);\n  color: var(--ag-row-batch-edit-text-color);\n}\n\n.ag-input-field-input {\n  width: 100%;\n  min-width: 0;\n}\n\n.ag-checkbox-input-wrapper {\n  font-family: var(--ag-icon-font-family);\n  font-weight: var(--ag-icon-font-weight);\n  color: var(--ag-icon-font-color);\n  font-size: var(--ag-icon-size);\n  line-height: var(--ag-icon-size);\n  font-style: normal;\n  font-variant: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: var(--ag-icon-size);\n  height: var(--ag-icon-size);\n  background-color: var(--ag-checkbox-background-color);\n  border-radius: var(--ag-checkbox-border-radius);\n  display: inline-block;\n  vertical-align: middle;\n  flex: none;\n}\n.ag-checkbox-input-wrapper input,\n.ag-checkbox-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-checkbox-input-wrapper:focus-within, .ag-checkbox-input-wrapper:active {\n  outline: none;\n  box-shadow: var(--ag-input-focus-box-shadow);\n}\n.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within, .ag-cell-editing-error .ag-checkbox-input-wrapper:active {\n  box-shadow: var(--ag-input-error-focus-box-shadow);\n}\n.ag-checkbox-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-checkbox-input-wrapper::after {\n  content: var(--ag-icon-font-code-checkbox-unchecked, \"\\f108\");\n  font-family: inherit;\n  color: var(--ag-checkbox-unchecked-color);\n  display: var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-checkbox-input-wrapper.ag-checked::after {\n  content: var(--ag-icon-font-code-checkbox-checked, \"\\f106\");\n  color: var(--ag-checkbox-checked-color);\n  display: var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-checkbox-input-wrapper.ag-indeterminate::after {\n  content: var(--ag-icon-font-code-checkbox-indeterminate, \"\\f107\");\n  color: var(--ag-checkbox-indeterminate-color);\n  display: var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-checkbox-input-wrapper::before {\n  content: \"\";\n  background: transparent center/contain no-repeat;\n  position: absolute;\n  inset: 0;\n  background-image: var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, 0.9));\n}\n.ag-checkbox-input-wrapper.ag-checked::before {\n  background-image: var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, 0.9));\n}\n.ag-checkbox-input-wrapper.ag-indeterminate::before {\n  background-image: var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, 0.9));\n}\n\n.ag-toggle-button-input-wrapper {\n  box-sizing: border-box;\n  width: var(--ag-toggle-button-width);\n  min-width: var(--ag-toggle-button-width);\n  max-width: var(--ag-toggle-button-width);\n  height: var(--ag-toggle-button-height);\n  background-color: var(--ag-toggle-button-off-background-color);\n  border-radius: calc(var(--ag-toggle-button-height) * 0.5);\n  position: relative;\n  flex: none;\n  border: var(--ag-toggle-button-border-width) solid;\n  border-color: var(--ag-toggle-button-off-border-color);\n}\n.ag-toggle-button-input-wrapper input {\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n}\n.ag-toggle-button-input-wrapper:focus-within {\n  outline: none;\n  box-shadow: var(--ag-input-focus-box-shadow);\n}\n.ag-toggle-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-toggle-button-input-wrapper.ag-checked {\n  background-color: var(--ag-toggle-button-on-background-color);\n  border-color: var(--ag-toggle-button-on-border-color);\n}\n.ag-toggle-button-input-wrapper::before {\n  content: \" \";\n  position: absolute;\n  top: calc(0px - var(--ag-toggle-button-border-width));\n  left: calc(0px - var(--ag-toggle-button-border-width));\n  display: block;\n  box-sizing: border-box;\n  height: var(--ag-toggle-button-height);\n  width: var(--ag-toggle-button-height);\n  background-color: var(--ag-toggle-button-switch-background-color);\n  border-radius: 100%;\n  transition: left 100ms;\n  border: var(--ag-toggle-button-border-width) solid;\n  border-color: var(--ag-toggle-button-switch-border-color);\n}\n.ag-toggle-button-input-wrapper.ag-checked::before {\n  left: calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-border-width));\n  border-color: var(--ag-toggle-button-on-border-color);\n}\n\n.ag-radio-button-input-wrapper {\n  font-family: var(--ag-icon-font-family);\n  font-weight: var(--ag-icon-font-weight);\n  color: var(--ag-icon-font-color);\n  font-size: var(--ag-icon-size);\n  line-height: var(--ag-icon-size);\n  font-style: normal;\n  font-variant: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: var(--ag-icon-size);\n  height: var(--ag-icon-size);\n  background-color: var(--ag-checkbox-background-color);\n  border-radius: var(--ag-checkbox-border-radius);\n  display: inline-block;\n  vertical-align: middle;\n  flex: none;\n  border-radius: var(--ag-icon-size);\n}\n.ag-radio-button-input-wrapper input,\n.ag-radio-button-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-radio-button-input-wrapper:focus-within, .ag-radio-button-input-wrapper:active {\n  outline: none;\n  box-shadow: var(--ag-input-focus-box-shadow);\n}\n.ag-cell-editing-error .ag-radio-button-input-wrapper:focus-within, .ag-cell-editing-error .ag-radio-button-input-wrapper:active {\n  box-shadow: var(--ag-input-error-focus-box-shadow);\n}\n.ag-radio-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-radio-button-input-wrapper::after {\n  content: var(--ag-icon-font-code-radio-button-off, \"\\f127\");\n  color: var(--ag-checkbox-unchecked-color);\n  display: var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-radio-button-input-wrapper.ag-checked::after {\n  content: var(--ag-icon-font-code-radio-button-on, \"\\f128\");\n  color: var(--ag-checkbox-checked-color);\n  display: var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-radio-button-input-wrapper::before {\n  content: \"\";\n  background: transparent center/contain no-repeat;\n  position: absolute;\n  inset: 0;\n  background-image: var(--ag-icon-image-radio-button-off, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, 0.9));\n}\n.ag-radio-button-input-wrapper.ag-checked::before {\n  background-image: var(--ag-icon-image-radio-button-on, var(--ag-icon-image));\n  display: var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));\n  opacity: var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, 0.9));\n}\n\ninput[class^=ag-][type=range] {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 100%;\n  background: none;\n  overflow: visible;\n}\ninput[class^=ag-][type=range]::-webkit-slider-runnable-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: var(--ag-border-color);\n  border-radius: var(--ag-border-radius);\n  border-radius: var(--ag-checkbox-border-radius);\n}\ninput[class^=ag-][type=range]::-moz-range-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: var(--ag-border-color);\n  border-radius: var(--ag-border-radius);\n  border-radius: var(--ag-checkbox-border-radius);\n}\ninput[class^=ag-][type=range]::-ms-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: var(--ag-border-color);\n  border-radius: var(--ag-border-radius);\n  border-radius: var(--ag-checkbox-border-radius);\n  color: transparent;\n  width: calc(100% - 2px);\n}\ninput[class^=ag-][type=range]::-webkit-slider-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: var(--ag-icon-size);\n  height: var(--ag-icon-size);\n  background-color: var(--ag-background-color);\n  border: 1px solid;\n  border-color: var(--ag-checkbox-unchecked-color);\n  border-radius: var(--ag-icon-size);\n  transform: translateY(calc(var(--ag-icon-size) * -0.5 + 1.5px));\n}\ninput[class^=ag-][type=range]::-ms-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: var(--ag-icon-size);\n  height: var(--ag-icon-size);\n  background-color: var(--ag-background-color);\n  border: 1px solid;\n  border-color: var(--ag-checkbox-unchecked-color);\n  border-radius: var(--ag-icon-size);\n}\ninput[class^=ag-][type=range]::-moz-ag-range-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: var(--ag-icon-size);\n  height: var(--ag-icon-size);\n  background-color: var(--ag-background-color);\n  border: 1px solid;\n  border-color: var(--ag-checkbox-unchecked-color);\n  border-radius: var(--ag-icon-size);\n}\ninput[class^=ag-][type=range]:focus {\n  outline: none;\n}\ninput[class^=ag-][type=range]:focus::-webkit-slider-thumb {\n  box-shadow: var(--ag-input-focus-box-shadow);\n  border-color: var(--ag-checkbox-checked-color);\n}\ninput[class^=ag-][type=range]:focus::-ms-thumb {\n  box-shadow: var(--ag-input-focus-box-shadow);\n  border-color: var(--ag-checkbox-checked-color);\n}\ninput[class^=ag-][type=range]:focus::-moz-ag-range-thumb {\n  box-shadow: var(--ag-input-focus-box-shadow);\n  border-color: var(--ag-checkbox-checked-color);\n}\ninput[class^=ag-][type=range]:active::-webkit-slider-runnable-track {\n  background-color: var(--ag-input-focus-border-color);\n}\ninput[class^=ag-][type=range]:active::-moz-ag-range-track {\n  background-color: var(--ag-input-focus-border-color);\n}\ninput[class^=ag-][type=range]:active::-ms-track {\n  background-color: var(--ag-input-focus-border-color);\n}\ninput[class^=ag-][type=range]:disabled {\n  opacity: 0.5;\n}\n","@font-face {\n  font-family: \"agGridBalham\";\n  src: url(data:font/woff2;charset=utf-8;base64,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);\n  font-weight: normal;\n  font-style: normal;\n}\n.ag-theme-balham,\n.ag-theme-balham-dark,\n.ag-theme-balham-auto-dark {\n  --ag-balham-active-color: #0091ea;\n  --ag-foreground-color: #000;\n  --ag-background-color: #fff;\n  --ag-header-background-color: #f5f7f7;\n  --ag-tooltip-background-color: #cbd0d3;\n  --ag-subheader-background-color: #e2e9eb;\n  --ag-control-panel-background-color: #f5f7f7;\n  --ag-border-color: #bdc3c7;\n  --ag-odd-row-background-color: #fcfdfe;\n  --ag-row-hover-color: #ecf0f1;\n  --ag-column-hover-color: #ecf0f1;\n  --ag-input-border-color: #95a5a6;\n  --ag-invalid-color: #e02525;\n  --ag-input-disabled-background-color: #ebebeb;\n  --ag-checkbox-unchecked-color: #7f8c8d;\n  --ag-input-focus-border-color: #719ece;\n  --ag-advanced-filter-join-pill-color: #f08e8d;\n  --ag-advanced-filter-column-pill-color: #a6e194;\n  --ag-advanced-filter-option-pill-color: #f3c08b;\n  --ag-advanced-filter-value-pill-color: #85c0e4;\n  --ag-find-match-color: var(--ag-foreground-color);\n  --ag-find-match-background-color: #ffff00;\n  --ag-find-active-match-color: var(--ag-foreground-color);\n  --ag-find-active-match-background-color: #ffa500;\n  --ag-input-focus-box-shadow: 0 0 2px 1px var(--ag-input-focus-border-color);\n  --ag-input-error-focus-box-shadow: 0 0 2px 1px var(--ag-invalid-color);\n  --ag-range-selection-border-color: var(--ag-balham-active-color);\n  --ag-checkbox-checked-color: var(--ag-balham-active-color);\n  --ag-checkbox-background-color: var(--ag-background-color);\n  --ag-panel-background-color: var(--ag-header-background-color);\n  --ag-filter-panel-apply-button-color: var(--ag-background-color);\n  --ag-filter-panel-apply-button-background-color: var(--ag-balham-active-color);\n  --ag-secondary-foreground-color: rgba(0, 0, 0, 0.54);\n  --ag-disabled-foreground-color: rgba(0, 0, 0, 0.38);\n  --ag-subheader-toolbar-background-color: rgba(226, 233, 235, 0.5);\n  --ag-row-border-color: rgba(189, 195, 199, 0.58);\n  --ag-chip-background-color: rgba(0, 0, 0, 0.1);\n  --ag-range-selection-background-color: rgba(0, 145, 234, 0.2);\n  --ag-range-selection-background-color-2: rgba(0, 145, 234, 0.36);\n  --ag-range-selection-background-color-3: rgba(0, 145, 234, 0.49);\n  --ag-range-selection-background-color-4: rgba(0, 145, 234, 0.59);\n  --ag-selected-row-background-color: rgba(0, 145, 234, 0.28);\n  --ag-header-column-separator-color: rgba(189, 195, 199, 0.5);\n  --ag-input-disabled-border-color: rgba(149, 165, 166, 0.3);\n  --ag-row-numbers-selected-color: color-mix(in srgb, transparent, var(--ag-balham-active-color) 50%);\n  --ag-header-column-separator-display: block;\n  --ag-header-column-separator-height: 50%;\n  --ag-grid-size: 4px;\n  --ag-icon-size: 16px;\n  --ag-row-height: calc(var(--ag-grid-size) * 7);\n  --ag-header-height: calc(var(--ag-grid-size) * 8);\n  --ag-list-item-height: calc(var(--ag-grid-size) * 6);\n  --ag-row-group-indent-size: calc(var(--ag-grid-size) * 3 + var(--ag-icon-size));\n  --ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);\n  --ag-input-height: calc(var(--ag-grid-size) * 4);\n  --ag-chart-menu-panel-width: 240px;\n  --ag-font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell,\n      \"Helvetica Neue\", sans-serif;\n  --ag-font-size: 12px;\n  --ag-icon-font-family: agGridBalham;\n  --ag-border-radius: 2px;\n  --ag-checkbox-border-radius: 3px;\n  --ag-card-shadow: none;\n}\n\n.ag-theme-balham-dark {\n  --ag-balham-active-color: #00b0ff;\n  --ag-foreground-color: #f5f5f5;\n  --ag-background-color: #2d3436;\n  --ag-header-background-color: #1c1c1c;\n  --ag-tooltip-background-color: #1c1f20;\n  --ag-subheader-background-color: #111;\n  --ag-control-panel-background-color: #202020;\n  --ag-border-color: #424242;\n  --ag-odd-row-background-color: #262c2e;\n  --ag-row-hover-color: #3d4749;\n  --ag-column-hover-color: #3d4749;\n  --ag-input-border-color: #f0f0f0;\n  --ag-input-disabled-background-color: rgba(48, 46, 46, 0.3);\n  --ag-modal-overlay-background-color: rgba(45, 52, 54, 0.66);\n  --ag-checkbox-unchecked-color: #ecf0f1;\n  --ag-advanced-filter-join-pill-color: #7a3a37;\n  --ag-advanced-filter-column-pill-color: #355f2d;\n  --ag-advanced-filter-option-pill-color: #5a3168;\n  --ag-advanced-filter-value-pill-color: #374c86;\n  --ag-find-match-color: var(--ag-background-color);\n  --ag-find-active-match-color: var(--ag-background-color);\n  --ag-filter-panel-apply-button-color: var(--ag-foreground-color);\n  --ag-secondary-foreground-color: var(--ag-foreground-color);\n  --ag-disabled-foreground-color: rgba(245, 245, 245, 0.38);\n  --ag-subheader-toolbar-background-color: rgba(17, 17, 17, 0.5);\n  --ag-row-border-color: #5c5c5c;\n  --ag-chip-background-color: rgba(245, 245, 245, 0.08);\n  --ag-range-selection-background-color: rgba(0, 176, 255, 0.2);\n  --ag-range-selection-background-color-2: rgba(0, 176, 255, 0.36);\n  --ag-range-selection-background-color-3: rgba(0, 176, 255, 0.49);\n  --ag-range-selection-background-color-4: rgba(0, 176, 255, 0.59);\n  --ag-selected-row-background-color: rgba(0, 176, 255, 0.28);\n  --ag-header-column-separator-color: rgba(66, 66, 66, 0.5);\n  --ag-input-disabled-border-color: rgba(240, 240, 240, 0.3);\n  --ag-header-foreground-color: rgba(245, 245, 245, 0.64);\n  --ag-toggle-button-off-background-color: transparent;\n  --ag-toggle-button-off-border-color: var(--ag-foreground-color);\n  --ag-range-selection-chart-category-background-color: rgba(26, 177, 74, 0.5);\n  --ag-range-selection-chart-background-color: rgba(45, 166, 255, 0.5);\n  --ag-input-focus-box-shadow: 0 0 4px 1.5px var(--ag-input-focus-border-color);\n  --ag-input-error-focus-box-shadow: 0 0 4px 1.5px\n      color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 0.5%);\n  --ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, 0.4);\n  --ag-cell-batch-edit-text-color: #f3d0b3;\n  color-scheme: dark;\n}\n\n@media (prefers-color-scheme: dark) {\n  .ag-theme-balham-auto-dark {\n    --ag-balham-active-color: #00b0ff;\n    --ag-foreground-color: #f5f5f5;\n    --ag-background-color: #2d3436;\n    --ag-header-background-color: #1c1c1c;\n    --ag-tooltip-background-color: #1c1f20;\n    --ag-subheader-background-color: #111;\n    --ag-control-panel-background-color: #202020;\n    --ag-border-color: #424242;\n    --ag-odd-row-background-color: #262c2e;\n    --ag-row-hover-color: #3d4749;\n    --ag-column-hover-color: #3d4749;\n    --ag-input-border-color: #f0f0f0;\n    --ag-input-disabled-background-color: rgba(48, 46, 46, 0.3);\n    --ag-modal-overlay-background-color: rgba(45, 52, 54, 0.66);\n    --ag-checkbox-unchecked-color: #ecf0f1;\n    --ag-advanced-filter-join-pill-color: #7a3a37;\n    --ag-advanced-filter-column-pill-color: #355f2d;\n    --ag-advanced-filter-option-pill-color: #5a3168;\n    --ag-advanced-filter-value-pill-color: #374c86;\n    --ag-find-match-color: var(--ag-background-color);\n    --ag-find-active-match-color: var(--ag-background-color);\n    --ag-filter-panel-apply-button-color: var(--ag-foreground-color);\n    --ag-secondary-foreground-color: var(--ag-foreground-color);\n    --ag-disabled-foreground-color: rgba(245, 245, 245, 0.38);\n    --ag-subheader-toolbar-background-color: rgba(17, 17, 17, 0.5);\n    --ag-row-border-color: #5c5c5c;\n    --ag-chip-background-color: rgba(245, 245, 245, 0.08);\n    --ag-range-selection-background-color: rgba(0, 176, 255, 0.2);\n    --ag-range-selection-background-color-2: rgba(0, 176, 255, 0.36);\n    --ag-range-selection-background-color-3: rgba(0, 176, 255, 0.49);\n    --ag-range-selection-background-color-4: rgba(0, 176, 255, 0.59);\n    --ag-selected-row-background-color: rgba(0, 176, 255, 0.28);\n    --ag-header-column-separator-color: rgba(66, 66, 66, 0.5);\n    --ag-input-disabled-border-color: rgba(240, 240, 240, 0.3);\n    --ag-header-foreground-color: rgba(245, 245, 245, 0.64);\n    --ag-toggle-button-off-background-color: transparent;\n    --ag-toggle-button-off-border-color: var(--ag-foreground-color);\n    --ag-range-selection-chart-category-background-color: rgba(26, 177, 74, 0.5);\n    --ag-range-selection-chart-background-color: rgba(45, 166, 255, 0.5);\n    --ag-input-focus-box-shadow: 0 0 4px 1.5px var(--ag-input-focus-border-color);\n    --ag-input-error-focus-box-shadow: 0 0 4px 1.5px\n        color-mix(in srgb, var(--ag-background-color), var(--ag-invalid-color) 0.5%);\n    --ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, 0.4);\n    --ag-cell-batch-edit-text-color: #f3d0b3;\n    color-scheme: dark;\n  }\n}\n.ag-theme-balham .ag-filter-toolpanel-header,\n.ag-theme-balham .ag-filter-toolpanel-search,\n.ag-theme-balham .ag-status-bar,\n.ag-theme-balham .ag-header-row,\n.ag-theme-balham .ag-row-number-cell,\n.ag-theme-balham .ag-multi-filter-group-title-bar,\n.ag-theme-balham-dark .ag-filter-toolpanel-header,\n.ag-theme-balham-dark .ag-filter-toolpanel-search,\n.ag-theme-balham-dark .ag-status-bar,\n.ag-theme-balham-dark .ag-header-row,\n.ag-theme-balham-dark .ag-row-number-cell,\n.ag-theme-balham-dark .ag-multi-filter-group-title-bar,\n.ag-theme-balham-auto-dark .ag-filter-toolpanel-header,\n.ag-theme-balham-auto-dark .ag-filter-toolpanel-search,\n.ag-theme-balham-auto-dark .ag-status-bar,\n.ag-theme-balham-auto-dark .ag-header-row,\n.ag-theme-balham-auto-dark .ag-row-number-cell,\n.ag-theme-balham-auto-dark .ag-multi-filter-group-title-bar {\n  font-weight: 600;\n  color: var(--ag-header-foreground-color);\n}\n.ag-theme-balham .ag-ltr input[class^=ag-]:not([type]), .ag-theme-balham .ag-ltr input[class^=ag-][type=text], .ag-theme-balham .ag-ltr input[class^=ag-][type=number], .ag-theme-balham .ag-ltr input[class^=ag-][type=tel], .ag-theme-balham .ag-ltr input[class^=ag-][type=date], .ag-theme-balham .ag-ltr input[class^=ag-][type=datetime-local], .ag-theme-balham .ag-ltr textarea[class^=ag-], .ag-theme-balham-dark .ag-ltr input[class^=ag-]:not([type]), .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=text], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=number], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=tel], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=date], .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=datetime-local], .ag-theme-balham-dark .ag-ltr textarea[class^=ag-], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-]:not([type]), .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=text], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=number], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=tel], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=date], .ag-theme-balham-auto-dark .ag-ltr input[class^=ag-][type=datetime-local], .ag-theme-balham-auto-dark .ag-ltr textarea[class^=ag-] {\n  padding-left: var(--ag-grid-size);\n}\n\n.ag-theme-balham .ag-rtl input[class^=ag-]:not([type]), .ag-theme-balham .ag-rtl input[class^=ag-][type=text], .ag-theme-balham .ag-rtl input[class^=ag-][type=number], .ag-theme-balham .ag-rtl input[class^=ag-][type=tel], .ag-theme-balham .ag-rtl input[class^=ag-][type=date], .ag-theme-balham .ag-rtl input[class^=ag-][type=datetime-local], .ag-theme-balham .ag-rtl textarea[class^=ag-], .ag-theme-balham-dark .ag-rtl input[class^=ag-]:not([type]), .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=text], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=number], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=tel], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=date], .ag-theme-balham-dark .ag-rtl input[class^=ag-][type=datetime-local], .ag-theme-balham-dark .ag-rtl textarea[class^=ag-], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-]:not([type]), .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=text], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=number], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=tel], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=date], .ag-theme-balham-auto-dark .ag-rtl input[class^=ag-][type=datetime-local], .ag-theme-balham-auto-dark .ag-rtl textarea[class^=ag-] {\n  padding-right: var(--ag-grid-size);\n}\n\n.ag-theme-balham .ag-column-drop-vertical-empty-message,\n.ag-theme-balham .ag-status-bar,\n.ag-theme-balham-dark .ag-column-drop-vertical-empty-message,\n.ag-theme-balham-dark .ag-status-bar,\n.ag-theme-balham-auto-dark .ag-column-drop-vertical-empty-message,\n.ag-theme-balham-auto-dark .ag-status-bar {\n  font-weight: 600;\n  color: var(--ag-disabled-foreground-color);\n}\n.ag-theme-balham.ag-dnd-ghost,\n.ag-theme-balham-dark.ag-dnd-ghost,\n.ag-theme-balham-auto-dark.ag-dnd-ghost {\n  font-size: var(--ag-font-size);\n  font-weight: 600;\n}\n.ag-theme-balham .ag-tab,\n.ag-theme-balham-dark .ag-tab,\n.ag-theme-balham-auto-dark .ag-tab {\n  border: 1px solid transparent;\n  padding: var(--ag-grid-size) calc(var(--ag-grid-size) * 2);\n  margin: var(--ag-grid-size);\n  margin-bottom: -1px;\n}\n.ag-theme-balham .ag-tab-selected,\n.ag-theme-balham-dark .ag-tab-selected,\n.ag-theme-balham-auto-dark .ag-tab-selected {\n  background-color: var(--ag-background-color);\n  border-color: var(--ag-border-color);\n  border-bottom-color: transparent;\n}\n.ag-theme-balham .ag-tabs-header,\n.ag-theme-balham-dark .ag-tabs-header,\n.ag-theme-balham-auto-dark .ag-tabs-header {\n  border-bottom: 1px solid var(--ag-border-color);\n}\n.ag-theme-balham .ag-column-drop-cell,\n.ag-theme-balham-dark .ag-column-drop-cell,\n.ag-theme-balham-auto-dark .ag-column-drop-cell {\n  height: calc(var(--ag-grid-size) * 6);\n}\n.ag-theme-balham .ag-column-drop-vertical-title,\n.ag-theme-balham-dark .ag-column-drop-vertical-title,\n.ag-theme-balham-auto-dark .ag-column-drop-vertical-title {\n  color: var(--ag-foreground-color);\n}\n.ag-theme-balham .ag-column-drop-vertical-cell,\n.ag-theme-balham-dark .ag-column-drop-vertical-cell,\n.ag-theme-balham-auto-dark .ag-column-drop-vertical-cell {\n  margin-left: calc(var(--ag-grid-size) * 2);\n  margin-right: calc(var(--ag-grid-size) * 2);\n}\n.ag-theme-balham .ag-column-drop-vertical-cell-text,\n.ag-theme-balham-dark .ag-column-drop-vertical-cell-text,\n.ag-theme-balham-auto-dark .ag-column-drop-vertical-cell-text {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-theme-balham .ag-column-drop-vertical-icon,\n.ag-theme-balham-dark .ag-column-drop-vertical-icon,\n.ag-theme-balham-auto-dark .ag-column-drop-vertical-icon {\n  color: var(--ag-secondary-foreground-color);\n}\n.ag-theme-balham .ag-ltr .ag-column-drop-vertical-empty-message, .ag-theme-balham-dark .ag-ltr .ag-column-drop-vertical-empty-message, .ag-theme-balham-auto-dark .ag-ltr .ag-column-drop-vertical-empty-message {\n  padding-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n  padding-right: var(--ag-grid-size);\n}\n\n.ag-theme-balham .ag-rtl .ag-column-drop-vertical-empty-message, .ag-theme-balham-dark .ag-rtl .ag-column-drop-vertical-empty-message, .ag-theme-balham-auto-dark .ag-rtl .ag-column-drop-vertical-empty-message {\n  padding-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n  padding-left: var(--ag-grid-size);\n}\n\n.ag-theme-balham .ag-column-drop-horizontal,\n.ag-theme-balham-dark .ag-column-drop-horizontal,\n.ag-theme-balham-auto-dark .ag-column-drop-horizontal {\n  height: var(--ag-header-height);\n}\n.ag-theme-balham .ag-column-drop-empty,\n.ag-theme-balham-dark .ag-column-drop-empty,\n.ag-theme-balham-auto-dark .ag-column-drop-empty {\n  color: var(--ag-disabled-foreground-color);\n}\n.ag-theme-balham .ag-column-drop-horizontal-cell-text,\n.ag-theme-balham-dark .ag-column-drop-horizontal-cell-text,\n.ag-theme-balham-auto-dark .ag-column-drop-horizontal-cell-text {\n  margin-left: calc(var(--ag-grid-size) * 2);\n}\n.ag-theme-balham .ag-column-drop-vertical,\n.ag-theme-balham-dark .ag-column-drop-vertical,\n.ag-theme-balham-auto-dark .ag-column-drop-vertical {\n  padding-top: calc(var(--ag-grid-size) * 2);\n}\n.ag-theme-balham .ag-column-select-column-readonly.ag-icon-grip,\n.ag-theme-balham .ag-column-select-column-readonly .ag-icon-grip,\n.ag-theme-balham-dark .ag-column-select-column-readonly.ag-icon-grip,\n.ag-theme-balham-dark .ag-column-select-column-readonly .ag-icon-grip,\n.ag-theme-balham-auto-dark .ag-column-select-column-readonly.ag-icon-grip,\n.ag-theme-balham-auto-dark .ag-column-select-column-readonly .ag-icon-grip {\n  opacity: 0.35;\n}\n.ag-theme-balham .ag-menu-header,\n.ag-theme-balham-dark .ag-menu-header,\n.ag-theme-balham-auto-dark .ag-menu-header {\n  background-color: var(--ag-header-background-color);\n}\n.ag-theme-balham .ag-overlay-loading-center,\n.ag-theme-balham-dark .ag-overlay-loading-center,\n.ag-theme-balham-auto-dark .ag-overlay-loading-center {\n  background-color: var(--ag-background-color);\n  border: 1px solid var(--ag-border-color);\n  color: var(--ag-foreground-color);\n  padding: calc(var(--ag-grid-size) * 4);\n}\n.ag-theme-balham .ag-tooltip,\n.ag-theme-balham-dark .ag-tooltip,\n.ag-theme-balham-auto-dark .ag-tooltip {\n  border: none;\n}\n.ag-theme-balham .ag-panel-title-bar-button-icon,\n.ag-theme-balham-dark .ag-panel-title-bar-button-icon,\n.ag-theme-balham-auto-dark .ag-panel-title-bar-button-icon {\n  font-size: calc(var(--ag-icon-size) + var(--ag-grid-size));\n}\n.ag-theme-balham .ag-panel,\n.ag-theme-balham-dark .ag-panel,\n.ag-theme-balham-auto-dark .ag-panel {\n  background-color: var(--ag-header-background-color);\n}\n.ag-theme-balham .ag-chart-data-section,\n.ag-theme-balham .ag-chart-format-section,\n.ag-theme-balham .ag-chart-advanced-settings-section,\n.ag-theme-balham-dark .ag-chart-data-section,\n.ag-theme-balham-dark .ag-chart-format-section,\n.ag-theme-balham-dark .ag-chart-advanced-settings-section,\n.ag-theme-balham-auto-dark .ag-chart-data-section,\n.ag-theme-balham-auto-dark .ag-chart-format-section,\n.ag-theme-balham-auto-dark .ag-chart-advanced-settings-section {\n  padding-bottom: calc(var(--ag-grid-size) * 0.5);\n}\n.ag-theme-balham .ag-group-toolbar,\n.ag-theme-balham-dark .ag-group-toolbar,\n.ag-theme-balham-auto-dark .ag-group-toolbar {\n  background-color: var(--ag-subheader-toolbar-background-color);\n}\n.ag-theme-balham .ag-chart-tab,\n.ag-theme-balham-dark .ag-chart-tab,\n.ag-theme-balham-auto-dark .ag-chart-tab {\n  padding-top: calc(var(--ag-grid-size) * 0.5);\n}\n.ag-theme-balham .ag-charts-format-sub-level-group-item,\n.ag-theme-balham-dark .ag-charts-format-sub-level-group-item,\n.ag-theme-balham-auto-dark .ag-charts-format-sub-level-group-item {\n  margin-bottom: calc(var(--ag-grid-size) * 1.5);\n}\n.ag-theme-balham .ag-filter-active .ag-icon-filter,\n.ag-theme-balham-dark .ag-filter-active .ag-icon-filter,\n.ag-theme-balham-auto-dark .ag-filter-active .ag-icon-filter {\n  color: var(--ag-balham-active-color);\n}\n.ag-theme-balham .ag-color-input input[class^=ag-][type=text].ag-input-field-input,\n.ag-theme-balham-dark .ag-color-input input[class^=ag-][type=text].ag-input-field-input,\n.ag-theme-balham-auto-dark .ag-color-input input[class^=ag-][type=text].ag-input-field-input {\n  min-height: calc(var(--ag-icon-size) + 4px);\n}\n.ag-theme-balham .ag-list-item-hovered::after,\n.ag-theme-balham-dark .ag-list-item-hovered::after,\n.ag-theme-balham-auto-dark .ag-list-item-hovered::after {\n  background-color: var(--ag-balham-active-color);\n}\n.ag-theme-balham .ag-pill .ag-pill-button:hover,\n.ag-theme-balham-dark .ag-pill .ag-pill-button:hover,\n.ag-theme-balham-auto-dark .ag-pill .ag-pill-button:hover {\n  color: var(--ag-balham-active-color);\n}\n.ag-theme-balham .ag-header-highlight-before::after,\n.ag-theme-balham .ag-header-highlight-after::after,\n.ag-theme-balham-dark .ag-header-highlight-before::after,\n.ag-theme-balham-dark .ag-header-highlight-after::after,\n.ag-theme-balham-auto-dark .ag-header-highlight-before::after,\n.ag-theme-balham-auto-dark .ag-header-highlight-after::after {\n  background-color: var(--ag-balham-active-color);\n}\n.ag-theme-balham .ag-advanced-filter-builder-item-button-disabled .ag-icon,\n.ag-theme-balham .ag-disabled .ag-icon,\n.ag-theme-balham .ag-column-select-column-group-readonly .ag-icon,\n.ag-theme-balham [disabled] .ag-icon,\n.ag-theme-balham-dark .ag-advanced-filter-builder-item-button-disabled .ag-icon,\n.ag-theme-balham-dark .ag-disabled .ag-icon,\n.ag-theme-balham-dark .ag-column-select-column-group-readonly .ag-icon,\n.ag-theme-balham-dark [disabled] .ag-icon,\n.ag-theme-balham-auto-dark .ag-advanced-filter-builder-item-button-disabled .ag-icon,\n.ag-theme-balham-auto-dark .ag-disabled .ag-icon,\n.ag-theme-balham-auto-dark .ag-column-select-column-group-readonly .ag-icon,\n.ag-theme-balham-auto-dark [disabled] .ag-icon {\n  color: var(--ag-disabled-foreground-color);\n}\n.ag-theme-balham .ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button:disabled,\n.ag-theme-balham-dark .ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button:disabled,\n.ag-theme-balham-auto-dark .ag-filter-panel .ag-standard-button.ag-filter-panel-buttons-apply-button:disabled {\n  color: unset;\n  background-color: unset;\n}\n.ag-theme-balham .ag-filter-card-title,\n.ag-theme-balham-dark .ag-filter-card-title,\n.ag-theme-balham-auto-dark .ag-filter-card-title {\n  font-weight: 600;\n}\n","/*!\n * Cropper.js v1.6.2\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2024-04-21T07:43:02.731Z\n */\n\n.cropper-container {\n  direction: ltr;\n  font-size: 0;\n  line-height: 0;\n  position: relative;\n  -ms-touch-action: none;\n      touch-action: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.cropper-container img {\n    backface-visibility: hidden;\n    display: block;\n    height: 100%;\n    image-orientation: 0deg;\n    max-height: none !important;\n    max-width: none !important;\n    min-height: 0 !important;\n    min-width: 0 !important;\n    width: 100%;\n  }\n\n.cropper-wrap-box,\n.cropper-canvas,\n.cropper-drag-box,\n.cropper-crop-box,\n.cropper-modal {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.cropper-wrap-box,\n.cropper-canvas {\n  overflow: hidden;\n}\n\n.cropper-drag-box {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper-modal {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper-view-box {\n  display: block;\n  height: 100%;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n  overflow: hidden;\n  width: 100%;\n}\n\n.cropper-dashed {\n  border: 0 dashed #eee;\n  display: block;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.cropper-dashed.dashed-h {\n    border-bottom-width: 1px;\n    border-top-width: 1px;\n    height: calc(100% / 3);\n    left: 0;\n    top: calc(100% / 3);\n    width: 100%;\n  }\n\n.cropper-dashed.dashed-v {\n    border-left-width: 1px;\n    border-right-width: 1px;\n    height: 100%;\n    left: calc(100% / 3);\n    top: 0;\n    width: calc(100% / 3);\n  }\n\n.cropper-center {\n  display: block;\n  height: 0;\n  left: 50%;\n  opacity: 0.75;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n\n.cropper-center::before,\n  .cropper-center::after {\n    background-color: #eee;\n    content: ' ';\n    display: block;\n    position: absolute;\n  }\n\n.cropper-center::before {\n    height: 1px;\n    left: -3px;\n    top: 0;\n    width: 7px;\n  }\n\n.cropper-center::after {\n    height: 7px;\n    left: 0;\n    top: -3px;\n    width: 1px;\n  }\n\n.cropper-face,\n.cropper-line,\n.cropper-point {\n  display: block;\n  height: 100%;\n  opacity: 0.1;\n  position: absolute;\n  width: 100%;\n}\n\n.cropper-face {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n\n.cropper-line {\n  background-color: #39f;\n}\n\n.cropper-line.line-e {\n    cursor: ew-resize;\n    right: -3px;\n    top: 0;\n    width: 5px;\n  }\n\n.cropper-line.line-n {\n    cursor: ns-resize;\n    height: 5px;\n    left: 0;\n    top: -3px;\n  }\n\n.cropper-line.line-w {\n    cursor: ew-resize;\n    left: -3px;\n    top: 0;\n    width: 5px;\n  }\n\n.cropper-line.line-s {\n    bottom: -3px;\n    cursor: ns-resize;\n    height: 5px;\n    left: 0;\n  }\n\n.cropper-point {\n  background-color: #39f;\n  height: 5px;\n  opacity: 0.75;\n  width: 5px;\n}\n\n.cropper-point.point-e {\n    cursor: ew-resize;\n    margin-top: -3px;\n    right: -3px;\n    top: 50%;\n  }\n\n.cropper-point.point-n {\n    cursor: ns-resize;\n    left: 50%;\n    margin-left: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-w {\n    cursor: ew-resize;\n    left: -3px;\n    margin-top: -3px;\n    top: 50%;\n  }\n\n.cropper-point.point-s {\n    bottom: -3px;\n    cursor: s-resize;\n    left: 50%;\n    margin-left: -3px;\n  }\n\n.cropper-point.point-ne {\n    cursor: nesw-resize;\n    right: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-nw {\n    cursor: nwse-resize;\n    left: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-sw {\n    bottom: -3px;\n    cursor: nesw-resize;\n    left: -3px;\n  }\n\n.cropper-point.point-se {\n    bottom: -3px;\n    cursor: nwse-resize;\n    height: 20px;\n    opacity: 1;\n    right: -3px;\n    width: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.cropper-point.point-se {\n      height: 15px;\n      width: 15px;\n  }\n    }\n\n@media (min-width: 992px) {\n\n.cropper-point.point-se {\n      height: 10px;\n      width: 10px;\n  }\n    }\n\n@media (min-width: 1200px) {\n\n.cropper-point.point-se {\n      height: 5px;\n      opacity: 0.75;\n      width: 5px;\n  }\n    }\n\n.cropper-point.point-se::before {\n    background-color: #39f;\n    bottom: -50%;\n    content: ' ';\n    display: block;\n    height: 200%;\n    opacity: 0;\n    position: absolute;\n    right: -50%;\n    width: 200%;\n  }\n\n.cropper-invisible {\n  opacity: 0;\n}\n\n.cropper-bg {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');\n}\n\n.cropper-hide {\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n\n.cropper-hidden {\n  display: none !important;\n}\n\n.cropper-move {\n  cursor: move;\n}\n\n.cropper-crop {\n  cursor: crosshair;\n}\n\n.cropper-disabled .cropper-drag-box,\n.cropper-disabled .cropper-face,\n.cropper-disabled .cropper-line,\n.cropper-disabled .cropper-point {\n  cursor: not-allowed;\n}\n",".vue-recycle-scroller{position:relative}.vue-recycle-scroller.direction-vertical:not(.page-mode){overflow-y:auto}.vue-recycle-scroller.direction-horizontal:not(.page-mode){overflow-x:auto}.vue-recycle-scroller.direction-horizontal{display:flex}.vue-recycle-scroller__slot{flex:auto 0 0}.vue-recycle-scroller__item-wrapper{flex:1;box-sizing:border-box;overflow:hidden;position:relative}.vue-recycle-scroller.ready .vue-recycle-scroller__item-view{position:absolute;top:0;left:0;will-change:transform}.vue-recycle-scroller.direction-vertical .vue-recycle-scroller__item-wrapper{width:100%}.vue-recycle-scroller.direction-horizontal .vue-recycle-scroller__item-wrapper{height:100%}.vue-recycle-scroller.ready.direction-vertical .vue-recycle-scroller__item-view{width:100%}.vue-recycle-scroller.ready.direction-horizontal .vue-recycle-scroller__item-view{height:100%}.resize-observer[data-v-b329ee4c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-b329ee4c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}",".vue3-resize-observer{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.vue3-resize-observer object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
